/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Merchant.pages', [
            'ui.router',

            // 'Merchant.pages.dashboard',
            'Merchant.pages.ui',
            'Merchant.pages.components',
            'Merchant.pages.form',
            'Merchant.pages.tables',
            'Merchant.pages.charts',
            'Merchant.pages.maps',
            'Merchant.pages.profile',
            // 'Merchant.pages.account',
            // 'Merchant.pages.support',
            // 'Merchant.pages.visitor',
            'Merchant.pages.myOutlet',
            'Merchant.pages.offermanagement',
            'Merchant.pages.mangevendor',
            'Merchant.pages.payment',
            'Merchant.pages.report',
            'Merchant.pages.globalsetting',  
            'Merchant.pages.customersection',  
                      
            'Merchant.pages.vendorcontract',
            'Merchant.pages.reservation',
            // 'Merchant.pages.pinperformance',
            'Merchant.pages.review',
            'Merchant.pages.dashboard',
           
            
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($urlRouterProvider, baSidebarServiceProvider) {
        $urlRouterProvider.otherwise('/dashboard');

        // baSidebarServiceProvider.addStaticItem({
        //     title: 'Pages',
        //     icon: 'ion-document',
        //     subMenu: [{
        //         title: 'Sign In',
        //         fixedHref: 'auth.html',
        //         blank: true
        //     }, {
        //         title: 'Sign Up',
        //         fixedHref: 'reg.html',
        //         blank: true
        //     }, {
        //         title: 'User Profile',
        //         stateRef: 'profile'
        //     }, {
        //         title: '404 Page',
        //         fixedHref: '404.html',
        //         blank: true
        //     }]
        // });
        // baSidebarServiceProvider.addStaticItem({
        //     title: 'Menu Level 1',
        //     icon: 'ion-ios-more',
        //     subMenu: [{
        //         title: 'Menu Level 1.1',
        //         disabled: true
        //     }, {
        //         title: 'Menu Level 1.2',
        //         subMenu: [{
        //             title: 'Menu Level 1.2.1',
        //             disabled: true
        //         }]
        //     }]
        // });
    }

})();
/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'Merchant.theme.components',
      'Merchant.theme.inputs'
  ]);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.charts', [
      'Merchant.pages.charts.amCharts',
      'Merchant.pages.charts.chartJs',
      'Merchant.pages.charts.chartist',
      'Merchant.pages.charts.morris'
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts', {
          url: '/charts',
          abstract: true,
          template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
          title: 'Charts',
          // sidebarMeta: {
          //   icon: 'ion-stats-bars',
          //   order: 1000,
          // },
        });
  }

})();

/**
 * @author k.danovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.components', [
    'Merchant.pages.components.mail',
    'Merchant.pages.components.timeline',
    'Merchant.pages.components.tree',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components', {
          url: '/components',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Components',
          // sidebarMeta: {
          //   icon: 'ion-gear-a',
          //   order: 1000,
          // },
        });
  }

})();

(function() {
    'use strict';

    angular.module('Merchant.pages.customersection', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('customersection', {
                url: '/customersection',
                templateUrl: 'app/pages/customersection/customersection.html',
                // abstract: true,
                controller: 'customersectionPageCtrl',
                title: 'CUSTOMER SECTION',
                sidebarMeta: {
                    icon: 'Menuvisitor.png',
                    order: 800,
                },
            });
    }
})();
(function() {
    'use strict';

    angular.module('Merchant.pages.dashboard', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard', {
                url: '/dashboard',
                templateUrl: 'app/pages/dash-board/dashboardvu.html',
                title: 'DASHBOARD',
                controller: 'DashboardvuPageCtrl',
                sidebarMeta: {
                    icon: 'Menudashboard.png',
                    order: 0,
                },
            });
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    // angular.module('Merchant.pages.dashboard', [])
    //     .config(routeConfig)
    //     .controller('DashboardController', function ($scope) {
    //         $scope.value = "text test";
    //     })

    /** @ngInject */
    // function routeConfig($stateProvider) {
    //     $stateProvider
    //         .state('dashboard', {
    //             url: '/dashboard',
    //             templateUrl: 'app/pages/dashboard/dashboard.html',
    //             title: 'Dashboard',
    //             // sidebarMeta: {
    //             //     icon: 'ion-android-home',
    //             //     order: 0,
    //             // },
    //             controller: "DashboardController"
    //         });
    // }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.form', ['ui.select', 'ngSanitize'])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('form', {
          url: '/form',
          template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Form Elements',
          // sidebarMeta: {
          //   icon: 'ion-compose',
          //   order: 1000,
          // },
        })
        .state('form.inputs', {
          url: '/inputs',
          templateUrl: 'app/pages/form/inputs/inputs.html',
          title: 'Form Inputs',
          sidebarMeta: {
            order: 0,
          },
        })
        .state('form.layouts', {
          url: '/layouts',
          templateUrl: 'app/pages/form/layouts/layouts.html',
          title: 'Form Layouts',
          sidebarMeta: {
            order: 100,
          },
        })
        .state('form.wizard',
        {
          url: '/wizard',
          templateUrl: 'app/pages/form/wizard/wizard.html',
          controller: 'WizardCtrl',
          controllerAs: 'vm',
          title: 'Form Wizard',
          sidebarMeta: {
            order: 200,
          },
        });
  }
})();

(function() {
    'use strict';

    angular.module('Merchant.pages.globalsetting', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('globalsetting', {
                url: '/globalsetting',
                templateUrl: 'app/pages/globalsetting/globalsetting.html',
                // abstract: true,
                controller: 'globalsettingPageCtrl',
                title: 'GLOBAL SETTING',
                sidebarMeta: {
                    icon: 'Menuaccount.png',
                    order: 800,
                },
            });
    }
})();
(function() {
    'use strict';

    angular.module('Merchant.pages.mangevendor', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('mangevendor', {
                url: '/mangevendor',
                templateUrl: 'app/pages/mangevendor/mangevendor.html',
                // abstract: true,
                controller: 'mangevendorCtrl',
                title: 'MANAGE VENDORS',
                sidebarMeta: {
                    icon: 'manage_vendors.png',
                    order: 300,
                },
                // ion-gear-a
            })
            .state('mangevendor.outlet', {
                url: '/outlet',
                // templateUrl: 'app/pages/mangevendor/Outlet/Outlet.html',
                templateUrl: 'app/pages/mangevendor/outlet/outlet.html',
                title: 'OUTLET',
                controller: 'outletPageCtrl',
            })
            .state('mangevendor.vendordetails', {
                url: '/vendordetails',
                // templateUrl: 'app/pages/mangevendor/Outlet/Outlet.html',
                templateUrl: 'app/pages/mangevendor/vendordetails/vendordetails.html',
                title: 'VENDOR',
                controller: 'vendordetailsPageCtrl',
            })
            .state('mangevendor.message', {
                url: '/message',
                // templateUrl: 'app/pages/mangevendor/Outlet/Outlet.html',
                templateUrl: 'app/pages/mangevendor/message/message.html',
                title: 'MESSAGE',
                controller: 'messagePageCtrl',
            })
           
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.maps', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('maps', {
          url: '/maps',
          templateUrl: 'app/pages/maps/maps.html',
          abstract: true,
          title: 'Maps',
          // sidebarMeta: {
          //   icon: 'ion-ios-location-outline',
          //   order: 1000,
          // },
        })
        .state('maps.gmap', {
          url: '/gmap',
          templateUrl: 'app/pages/maps/google-maps/google-maps.html',
          controller: 'GmapPageCtrl',
          title: 'Google Maps',
          sidebarMeta: {
            order: 0,
          },
        })
        .state('maps.leaflet', {
          url: '/leaflet',
          templateUrl: 'app/pages/maps/leaflet/leaflet.html',
          controller: 'LeafletPageCtrl',
          title: 'Leaflet Maps',
          sidebarMeta: {
            order: 100,
          },
        })
        .state('maps.bubble', {
          url: '/bubble',
          templateUrl: 'app/pages/maps/map-bubbles/map-bubbles.html',
          controller: 'MapBubblePageCtrl',
          title: 'Bubble Maps',
          sidebarMeta: {
            order: 200,
          },
        })
        .state('maps.line', {
          url: '/line',
          templateUrl: 'app/pages/maps/map-lines/map-lines.html',
          controller: 'MapLinesPageCtrl',
          title: 'Line Maps',
          sidebarMeta: {
            order: 300,
          },
        });
  }

})();

(function () {
    'use strict';
    angular.module('Merchant.pages.myOutlet', [])
        .config(routeConfig);
    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('myOutlet', {
                url: '/myOutlet',
                templateUrl: 'app/pages/myOutlet/myOutlet.html',
                abstract: true,
                controller: 'MyOutletPageCtrl',
                controllerAs: '$ctrl',
                title: 'ENQUIRIES',
                sidebarMeta: {
                    icon: 'Menusupport.png',
                    order: 100,
                },
            })
            // .state('myOutlet.addOutlet', {
            //     url: '/addOutlet',
            //     templateUrl: 'app/pages/myOutlet/addOutlet/addOutlet.html',
            //     abstract: true,
            //     controller: 'AddOutletPageCtrl',
            //     controllerAs: '$ctrl',
            //     title: 'ENQUIRIES',
            
            // })
            .state('myOutlet.details', {
                url: '/details',
                templateUrl: 'app/pages/myOutlet/details/details.html',
              
                controller: 'DetailsPageCtrl',
                controllerAs: '$ctrl',
                title: 'DETAILS',
                sidebarMeta: {
                    icon: 'Menumyoutlet.png',
                    order: 2,  
                },
                data: {
                    activeTab: 0
                }
            })
            //     .state('myOutlet.prices', {
            //         url: '/prices',
            //         templateUrl: 'app/pages/myOutlet/prices/prices.html',
                   
            //         controller: 'PricesPageCtrl',
            //         title: 'PRICES',
            //         sidebarMeta: {
            //             icon: 'Menumyoutlet.png',
            //             order: 5,
            //         },
            //     })
            //     .state('myOutlet.rewards', {
            //         url: '/rewards',
            //     templateUrl: 'app/pages/myOutlet/rewards/rewards.html',
               
            //     controller: 'RewardsPageCtrl',
            //     title: 'REWARDS',
            //     sidebarMeta: {
            //         icon: 'Menumyoutlet.png',
            //         order: 400,
            //     },
            // })
            // .state('myOutlet.typeandfeatures', {
            //     url: '/typeandfeatures',
            //     templateUrl: 'app/pages/myOutlet/typeandfeatures/typeandfeatures.html',
               
            //     controller: 'TypeandfeaturesPageCtrl',
            //     title: 'TYPES FEATURES',
            //     sidebarMeta: {
            //         icon: 'Menumyoutlet.png',
            //         order: 3,
            //     },
            // })
            // .state('myOutlet.validationpin', {
            //     url: '/validationPin',
            //     templateUrl: 'app/pages/myOutlet/validationPin/validationPin.html',
              
            //     controller: 'ValidationPinsPageCtrl',
            //     title: 'VALIDATION PIN',
            //     sidebarMeta: {
            //         icon: 'Menumyoutlet.png',
            //         order: 6,
            //     },
            // })
            // .state('myOutlet.openingtime', {
            //     url: '/openingtime',
            //     templateUrl: 'app/pages/myOutlet/openingtime/openingtime.html',
     
            //     controller: 'OpeningTimePageCtrl',
            //     title: 'OPENING TIME',
            //     sidebarMeta: {
            //         icon: 'Menumyoutlet.png',
            //         order: 4,
            //     },
            // });



    }
})();
(function() {
    'use strict';

    angular.module('Merchant.pages.offermanagement', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('offermanagement', {
                url: '/offermanagement',
                templateUrl: 'app/pages/offermanagement/offermanagement.html',
                // abstract: true,
                controller: 'offermanagementPageCtrl',
                title: 'OFFERS MANAGEMENT',
                sidebarMeta: {
                    icon: 'offer_management.png',
                    order: 500,
                },
            });
    }
})();
(function() {
    'use strict';

    angular.module('Merchant.pages.payment', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('payment', {
                url: '/payment',
                templateUrl: 'app/pages/payment/payment.html',
                // abstract: true,
                controller: 'paymentPageCtrl',
                title: 'PAYMENTS',
                sidebarMeta: {
                    icon: 'Menunotification.png',
                    order: 600,
                },
            });
    }
})();
(function() {
    'use strict';

    angular.module('Merchant.pages.pinperformance', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('pinperformance', {
                url: '/pinperformance',
                templateUrl: 'app/pages/pin-performance/pin-performance.html',
                // abstract: true,
                controller: 'PinPerformancePageCtrl',
                title: 'PINPERFORMANCE',
                sidebarMeta: {
                    icon: 'Menupinperformance.png',
                    order: 800,
                },
            });
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.profile', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('profile', {
          url: '/profile',
          title: 'Profile',
          templateUrl: 'app/pages/profile/profile.html',
          controller: 'ProfilePageCtrl',
        });
  }

})();

(function() {
    'use strict';

    angular.module('Merchant.pages.report', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('report', {
                url: '/report',
                templateUrl: 'app/pages/report/report.html',
                abstract: true,
                controller: 'ReportPageCtrl',
                controllerAs: '$ctrl',
                title: 'REPORTS',
                sidebarMeta: {
                    icon: 'Menureports.png',
                    order: 700,
                },
            })
            .state('report.performance', {
                url: '/performance',
                templateUrl: 'app/pages/report/performance-overview/performance-overview.html',
                // abstract: true,
                title: 'PERFORMANCE OVERVIEW',
                controller: 'PerformanceOverviewPageCtrl',
                controllerAs: '$ctrl',
                sidebarMeta: {
                    order: 1,
                },
                data: {
                    activeTab: 1
                }
            })
            .state('report.referral', {
                url: '/referral',
                templateUrl: 'app/pages/report/referrals-activities/referrals-activities.html',
                // abstract: true,
                title: 'REFERRAL ACTIVITIES',
                controller: 'ReferralsActivitiesPageCtrl',
                controllerAs: '$ctrl',
                sidebarMeta: {
                    order: 2,
                },
                data: {
                    activeTab: 0
                }
            })
            .state('report.creditsreport', {
                url: '/creditsreport',
                templateUrl: 'app/pages/report/credits-report/credits-report.html',
                // abstract: true,
                title: 'CREDITS REPORTS',
                controller: 'CreditsReportsPageCtrl',
                controllerAs: '$ctrl',
                sidebarMeta: {
                    order: 3,
                },
                data: {
                    activeTab: 0
                }
            })
            .state('report.visitorsreport', {
                url: '/visitorsreport',
                templateUrl: 'app/pages/report/visitors-report/visitors-report.html',
                // abstract: true,
                title: 'VISITORS REPORTS',
                controller: 'VisitorsReportPageCtrl',
                controllerAs: '$ctrl',
                sidebarMeta: {
                    order: 4,
                },
                data: {
                    activeTab: 0
                }
            })
        
    }
})();
(function() {
    'use strict';

    angular.module('Merchant.pages.reservation', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('reservation', {
                url: '/reservation',
                templateUrl: 'app/pages/reservation/reservation.html',
                controller: 'ReservationPageCtrl',
                title: 'MANAGE RESERVATIONS',
                sidebarMeta: {
                    icon: 'manage_reservations.png',
                    order: 1000,
                },
                data: {
                    activeTab: 0
                }
            })
            // .state('reservation.overview', {
            //     url: '/overview',
            //     templateUrl: 'app/pages/reservation/overview/overview.html',
            //     title: 'OVERVIEW',
            //     controller: 'OverviewPageCtrl',
            //     sidebarMeta: {
            //         order: 1,
            //     },
            //     data: {
            //         activeTab: 0
            //     }
                
            // })
   }
})();
(function() {
    'use strict';

    angular.module('Merchant.pages.review', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('review', {
                url: '/review',
                templateUrl: 'app/pages/review/review.html',
                // abstract: true,
                controller: 'ReviewPageCtrl',
                title: 'REVIEW',
                sidebarMeta: {
                    icon: 'Menureview.png',
                    order: 900,
                },
            });
    }
})();
(function() {
    'use strict';

    angular.module('Merchant.pages.support', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('support', {
                url: '/support',
                templateUrl: 'app/pages/support/support.html',
                // abstract: true,
                controller: 'SupportPageCtrl',
                title: 'SUPPORT',
                sidebarMeta: {
                    icon: 'Menusupport.png',
                    order: 1100,
                },
            });
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('tables', {
          url: '/tables',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          controller: 'TablesPageCtrl',
          title: 'Tables',
          // sidebarMeta: {
          //   icon: 'ion-grid',
          //   order: 1000,
          // },
        }).state('tables.basic', {
          url: '/basic',
          templateUrl: 'app/pages/tables/basic/tables.html',
          title: 'Basic Tables',
          sidebarMeta: {
            order: 0,
          },
        }).state('tables.smart', {
          url: '/smart',
          templateUrl: 'app/pages/tables/smart/tables.html',
          title: 'Smart Tables',
          sidebarMeta: {
            order: 100,
          },
        });
    $urlRouterProvider.when('/tables','/tables/basic');
  }

})();

/**
 * @author k.danovsky
 * created on 12.01.2016
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui', [
    'Merchant.pages.ui.typography',
    'Merchant.pages.ui.buttons',
    'Merchant.pages.ui.icons',
    'Merchant.pages.ui.modals',
    'Merchant.pages.ui.grid',
    'Merchant.pages.ui.alerts',
    'Merchant.pages.ui.progressBars',
    'Merchant.pages.ui.notifications',
    'Merchant.pages.ui.tabs',
    'Merchant.pages.ui.slider',
    'Merchant.pages.ui.panels',
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui', {
          url: '/ui',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'UI Features',
          // sidebarMeta: {
          //   icon: 'ion-android-laptop',
          //   order: 1000,
          // },
        });
  }

})();

(function() {
    'use strict';

    angular.module('Merchant.pages.vendorcontract', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('vendorcontract', {
                url: '/vendorcontract',
                templateUrl: 'app/pages/vendorcontract/vendorcontract.html',
                // abstract: true,
                controller: 'vendorPageCtrl',
                title: 'VENDOR CONTRACTS',
                sidebarMeta: {
                    icon: 'vendor_contracts.png',
                    order: 400,
                },
            });
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('Merchant.theme.inputs', []);

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
    'use strict';

    angular.module('Merchant.pages.charts.chartJs', [])
        .config(routeConfig).config(chartJsConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('charts.chartJs', {
                url: '/chartJs',
                templateUrl: 'app/pages/charts/chartJs/chartJs.html',
                title: 'Chart.js',
                sidebarMeta: {
                    order: 200
                }
            });
    }

    function chartJsConfig(ChartJsProvider, baConfigProvider) {
        var layoutColors = baConfigProvider.colors;
        // Configure all charts
        ChartJsProvider.setOptions({
            chartColors: [
                layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight],
            responsive: true,
            maintainAspectRatio: false,
            animation: {
                duration: 2500
            },
            scale: {
                gridLines: {
                    color: layoutColors.border
                },
                scaleLabel: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    fontColor: layoutColors.defaultText,
                    showLabelBackdrop: false
                }
            }
        });
        // Configure all line charts
        ChartJsProvider.setOptions('Line', {
            datasetFill: false
        });
        // Configure all radar charts
        ChartJsProvider.setOptions('radar', {
            scale: {
                pointLabels: {
                    fontColor: layoutColors.defaultText
                },
                ticks: {
                    maxTicksLimit: 5,
                    display: false
                }
            }
        });
        // Configure all bar charts
        ChartJsProvider.setOptions('bar', {
            tooltips: {
                enabled: false
            }
        });
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.charts.amCharts', [])
      .config(routeConfig).config(amChartConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.amCharts', {
          url: '/amCharts',
          templateUrl: 'app/pages/charts/amCharts/charts.html',
          title: 'amCharts',
          sidebarMeta: {
            order: 0,
          },
        });
  }

  function amChartConfig(baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    AmCharts.themes.blur = {

      themeName: "blur",

      AmChart: {
        color: layoutColors.defaultText,
        backgroundColor: "#FFFFFF"
      },

      AmCoordinateChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmStockChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmSlicedChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark],
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3
      },

      AmRectangularChart: {
        zoomOutButtonColor: '#FFFFFF',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens.png"
      },

      AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF"
      },

      ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
      },

      ChartCursor: {
        cursorColor: layoutColors.primary,
        color: "#FFFFFF",
        cursorAlpha: 0.5
      },

      AmLegend: {
        color: "#FFFFFF"
      },

      AmGraph: {
        lineAlpha: 0.9
      },
      GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
      },

      GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#FFFFFF',
        axisAlpha: 1,
        bandAlpha: 0.8
      },

      TrendLine: {
        lineColor: layoutColors.danger,
        lineAlpha: 0.8
      },

      // ammap
      AreasSettings: {
        alpha: 0.8,
        color: layoutColors.info,
        colorSolid: layoutColors.primaryDark,
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#FFFFFF",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: layoutColors.primary,
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
      },

      LinesSettings: {
        color: "#FFFFFF",
        alpha: 0.8
      },

      ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: layoutColors.primaryDark
      },

      ZoomControl: {
        buttonFillAlpha: 0.8,
        buttonIconColor: layoutColors.defaultText,
        buttonRollOverColor: layoutColors.danger,
        buttonFillColor: layoutColors.primaryDark,
        buttonBorderColor: layoutColors.primaryDark,
        buttonBorderAlpha: 0,
        buttonCornerRadius: 0,
        gridColor: "#FFFFFF",
        gridBackgroundColor: "#FFFFFF",
        buttonIconAlpha: 0.6,
        gridAlpha: 0.6,
        buttonSize: 20
      },

      SmallMap: {
        mapColor: "#000000",
        rectangleColor: layoutColors.danger,
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
      },

      // the defaults below are set using CSS syntax, you can use any existing css property
      // if you don't use Stock chart, you can delete lines below
      PeriodSelector: {
        color: "#FFFFFF"
      },

      PeriodButton: {
        color: "#FFFFFF",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
      },

      PeriodButtonSelected: {
        color: "#FFFFFF",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
      },

      PeriodInputField: {
        color: "#FFFFFF",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      },

      DataSetSelector: {
        color: "#FFFFFF",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
      },

      DataSetCompareList: {
        color: "#FFFFFF",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
      },

      DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      }

    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/17/15
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.charts.chartist', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.chartist', {
          url: '/chartist',
          templateUrl: 'app/pages/charts/chartist/chartist.html',
          title: 'Chartist',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();

/**
 * @author a.demeshko
 * created on 12/18/15
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.charts.morris', [])
    .config(routeConfig).config(function(baConfigProvider){
      var layoutColors = baConfigProvider.colors;
      Morris.Donut.prototype.defaults.backgroundColor = 'transparent';
      Morris.Donut.prototype.defaults.labelColor = layoutColors.defaultText;
      Morris.Grid.prototype.gridDefaults.gridLineColor = layoutColors.borderDark;
      Morris.Grid.prototype.gridDefaults.gridTextColor = layoutColors.defaultText;
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.morris', {
          url: '/morris',
          templateUrl: 'app/pages/charts/morris/morris.html',
          title: 'Morris',
          sidebarMeta: {
            order: 300,
          }
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.components.mail', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider,$urlRouterProvider) {
    $stateProvider
        .state('components.mail', {
          url: '/mail',
          abstract: true,
          templateUrl: 'app/pages/components/mail/mail.html',
          controller: "MailTabCtrl",
          controllerAs: "tabCtrl",
          title: 'Mail',
          sidebarMeta: {
            order: 0,
          },
        }).state('components.mail.label', {
          url: '/:label',
          templateUrl: 'app/pages/components/mail/list/mailList.html',
          title: 'Mail',
          controller: "MailListCtrl",
          controllerAs: "listCtrl"
        }).state('components.mail.detail', {
          url: '/:label/:id',
          templateUrl: 'app/pages/components/mail/detail/mailDetail.html',
          title: 'Mail',
          controller: "MailDetailCtrl",
          controllerAs: "detailCtrl"
        });
    $urlRouterProvider.when('/components/mail','/components/mail/inbox');
  }

})();

/**
 * @author a.demeshko
 * created on 1/12/16
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.components.timeline', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('components.timeline', {
        url: '/timeline',
        templateUrl: 'app/pages/components/timeline/timeline.html',
          title: 'Timeline',
          sidebarMeta: {
            icon: 'ion-ios-pulse',
            order: 100,
          },
      });
  }
})();

/**
 * @author a.demeshko
 * created on 12.21.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.components.tree', [])
    .config(routeConfig)
    .config(function(){
      $.jstree.defaults.core.themes.url = true;
      $.jstree.defaults.core.themes.dir = "assets/img/theme/vendor/jstree/dist/themes";
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('components.tree', {
          url: '/tree',
          templateUrl: 'app/pages/components/tree/tree.html',
          title: 'Tree View',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();


/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui.alerts', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.alerts', {
          url: '/alerts',
          templateUrl: 'app/pages/ui/alerts/alerts.html',
          title: 'Alerts',
          sidebarMeta: {
            order: 500,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui.buttons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.buttons', {
          url: '/buttons',
          templateUrl: 'app/pages/ui/buttons/buttons.html',
          controller: 'ButtonPageCtrl',
          title: 'Buttons',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui.grid', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.grid', {
          url: '/grid',
          templateUrl: 'app/pages/ui/grid/grid.html',
          title: 'Grid',
          sidebarMeta: {
            order: 400,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui.icons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.icons', {
          url: '/icons',
          templateUrl: 'app/pages/ui/icons/icons.html',
          controller: 'IconsPageCtrl',
          title: 'Icons',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui.modals', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.modals', {
          url: '/modals',
          templateUrl: 'app/pages/ui/modals/modals.html',
          controller: 'ModalsPageCtrl',
          title: 'Modals',
          sidebarMeta: {
            order: 300,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui.notifications', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.notifications', {
          url: '/notifications',
          templateUrl: 'app/pages/ui/notifications/notifications.html',
          controller: 'NotificationsPageCtrl',
          title: 'Notifications',
          sidebarMeta: {
            order: 700,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui.panels', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.panels', {
          url: '/panels',
          templateUrl: 'app/pages/ui/panels/panels.html',
          controller: 'NotificationsPageCtrl',
          title: 'Panels',
          sidebarMeta: {
            order: 1100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui.progressBars', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.progressBars', {
          url: '/progressBars',
          templateUrl: 'app/pages/ui/progressBars/progressBars.html',
          title: 'Progress Bars',
          sidebarMeta: {
            order: 600,
          },
        });
  }

})();

/**
 * @author a.demeshko
 * created on 12/22/15
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui.slider', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.slider', {
          url: '/slider',
          templateUrl: 'app/pages/ui/slider/slider.html',
          title: 'Sliders',
          sidebarMeta: {
            order: 1000,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 21.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui.tabs', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.tabs', {
          url: '/tabs',
          templateUrl: 'app/pages/ui/tabs/tabs.html',
          title: 'Tabs & Accordions',
          sidebarMeta: {
            order: 800,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui.typography', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.typography', {
          url: '/typography',
          templateUrl: 'app/pages/ui/typography/typography.html',
          title: 'Typography',
          sidebarMeta: {
            order: 0,
          },
        });
  }

})();

'use strict';

angular.module('Merchant', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'toastr',
  'smart-table',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',

  'Merchant.theme',
  'Merchant.pages'
]);

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('Merchant.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, $httpProvider, colorHelper, $provide) {
    
    // $httpProvider.interceptors.push('rest.interceptor');
    $httpProvider.interceptors.push('auth.interceptor');
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('Merchant.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('Merchant.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, $state, $http, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    
    var token = localStorage.getItem("token");
    if(token != null){  
      $http.defaults.headers.common['Authorization'] = token;
    }else{
      // alert('please Login')
      // window.location.href = '/login'; 
    }
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];
    
    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $rootScope.$on('event:auth:invalid:token', function () {
      alert('redirec')
      // window.location.href = AdminPortalUrl + 'login'; 
    });
   
    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();

/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('Merchant.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
    angular.module('Merchant.pages.customersection')
        .controller('customersectionPageCtrl', customersectionPageCtrl);
    /** @ngInject */
    function customersectionPageCtrl($scope, $filter, editableOptions, editableThemes, $uibModal) {
        // function datepickerpopupCtrl($scope) {

            $scope.outletFilterLists = [{
                name: "Outlet1",
                value: "Outlet1"
              },
              {
                name: "Outlet2",
                value: "Outlet2"
              },
              {
                name: "Outlet3",
                value: "Outlet3"
              }
              ];   

            $scope.sortBy = [{
                name: "NAME",
                value: "NAME"
              },
              {
                name: "AMOUNT",
                value: "AMOUNT"
              },
              {
                name: "STATUS",
                value: "STATUS"
              }
              ];
       
    
            $scope.country = [{
                name: "usa",
                value: "usa"
              },
              {
                name: "Uk",
                value: "Uk"
              },
              {
                name: "India",
                value: "India"
              }
              ];
    
              $scope.plan = [{
                name: "plan1",
                value: "plan1"
              },
              {
                name: "plan2",
                value: "plan2"
              },
              {
                name: "plan3",
                value: "plan3"
              }
              ];

        $scope.genderLists = ["Male", "Female"];
        $scope.datepicker1 = {};
        $scope.datepicker1.open = open;
        $scope.datepicker1.opened = false;
        $scope.datepicker1.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.datepicker1.format = $scope.datepicker1.formats[2];
        $scope.datepicker1.options = {
            showWeeks: false
        };

        function open() {
            $scope.datepicker1.opened = true;
        }
        $scope.datepicker2 = {};
        $scope.datepicker2.open = open;
        $scope.datepicker2.opened = false;
        $scope.datepicker2.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.datepicker2.format = $scope.datepicker2.formats[2];
        $scope.datepicker2.options = {
            showWeeks: false
        };

        $scope.returnCustColors = ["#636BE4", "#FF6557"];
        $scope.returnCustLabels = ["70% are new to your business.", "40% are curent customers"];
        $scope.returnCustData = [70, 40];

        $scope.returnCust1Colors = ["#636BE4", "#FF6557"];
        $scope.returnCust1Labels = ["70% are new to your business.", "40% are curent customers"];
        $scope.returnCust1Data = [70, 40];

        // $scope.revenueLabels = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
        //  $scope.revenueDatas = [ [0, 1, 2, 3, 4, 5] ]; 
        //  $scope.revenueLineColors = [{ 
        //      backgroundColor: 'transparent', 
        //      borderColor: '#FAA370', 
        //      pointBorderColor: '#C44483', 
        //      pointBackgroundColor: '#ffffff', 
        //      pointHoverBackgroundColor: '#ffffff', 
        //      pointHoverBorderColor: '#FAA370',
        //      borderWidth: 3 
        //     }]; 
            $scope.linechartopt = {
                elements: {
                    line: {
                        tension: 0
                    }
                },
                scales: {
                    xAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'REFERRALS',
                            fontSize: 20,
                            fontColor: '#586777'
                        }
                    }],
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'DATE',
                            fontSize: 20,
                            fontColor: '#586777'
                        }
                    }]
                }
            };

            
        $scope.lineLabels = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
        $scope.lineDatas = [
            [0, 22, 24, 20, 23, 25, 22, 24, 20, 23],
            [0, 35, 37, 32, 38, 40, 35, 37, 32, 38]
        ];

        $scope.lineColors = [{
            borderColor: '#5783f1',
            pointBorderColor: '#46c4ff',
            pointBackgroundColor: '#fff',
            backgroundColor: 'transparent',
            pointHoverBackgroundColor: '#60CEDF',
            pointHoverBorderColor: '#60CEDF'
        }, {
            borderColor: '#f6a129',
            pointBorderColor: '#f95c16',
            pointBackgroundColor: '#fff',
            backgroundColor: 'transparent',
            pointHoverBackgroundColor: '#EB5E89',
            pointHoverBorderColor: '#EB5E89'
        }];

        $scope.lineOptions = {
            elements: { line: { tension: 0, fill: false } },
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        suggestedMin: 0
                    }
                }]
            }
        };

        $scope.revenueOptions = { elements: { line: { tension: 0 } } };

        $scope.open = function(page, size) {
            $uibModal.open({
                animation: true,
                templateUrl: page,
                size: size,
                resolve: {
                    items: function() {
                        return $scope.items;
                    }
                }
            });
        };

        function open() {
            $scope.datepicker2.opened = true;
        }
        // $scope.open = open;
        // $scope.opened = false;
        // $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        // $scope.format = $scope.formats[0];
        // $scope.options = {
        //   showWeeks: false
        // };

        // function open() {
        //   if (!$scope.opened)
        //     $scope.opened = true;
        //   else
        //     $scope.opened = false;
        // }
        // }
        $scope.sortTransactionItems = [{
                label: 'Option 1',
                value: 1
            },
            {
                label: 'Option 2',
                value: 2
            },
            {
                label: 'Option 3',
                value: 3
            },
            {
                label: 'Option 4',
                value: 4
            },
        ];
        $scope.outletItems = [{
                label: 'Option 1',
                value: 1
            },
            {
                label: 'Option 2',
                value: 2
            },
            {
                label: 'Option 3',
                value: 3
            },
            {
                label: 'Option 4',
                value: 4
            },
        ];

        $scope.smartTablePageSize = 10;

        $scope.smartTableData = [{
                id: 1,
                brand: 'Mark',
                offer_name: 'Otto',
                offer_time: '@mdo',
                expected_sale: 'mdo@gmail.com',
                amount: '28',
                no_sold: '123',
                comp_add: 'B.21-jtl Bulding-21 st Abu Dhabi',
                nation: 'UAE/UK'
            },
            {
                id: 2,
                brand: 'Jacob',
                offer_name: 'Thornton',
                offer_time: '@fat',
                expected_sale: 'fat@yandex.ru',
                amount: '45',
                no_sold: '111',
                comp_add: 'B.21-jtl Bulding-21 st Abu Dhabi',
                nation: 'UAE/UK'
            },
            {
                id: 3,
                brand: 'Larry',
                offer_name: 'Bird',
                offer_time: '@twitter',
                expected_sale: 'twitter@outlook.com',
                amount: '18',
                no_sold: '111',
                comp_add: 'B.21-jtl Bulding-21 st Abu Dhabi',
                nation: 'UAE/UK'
            },
            {
                id: 4,
                brand: 'John',
                offer_name: 'Snow',
                offer_time: '@snow',
                expected_sale: 'snow@gmail.com',
                amount: '20',
                no_sold: '111',
                comp_add: 'B.21-jtl Bulding-21 st Abu Dhabi',
                nation: 'UAE/UK'
            },
            {
                id: 5,
                brand: 'Jack',
                offer_name: 'Sparrow',
                offer_time: '@jack',
                expected_sale: 'jack@yandex.ru',
                amount: '30',
                no_sold: '111',
                comp_add: 'B.21-jtl Bulding-21 st Abu Dhabi',
                nation: 'UAE/UK'
            },
            {
                id: 6,
                brand: 'Ann',
                offer_name: 'Smith',
                offer_time: '@ann',
                expected_sale: 'ann@gmail.com',
                amount: '21',
                no_sold: '111',
                comp_add: 'B.21-jtl Bulding-21 st Abu Dhabi',
                nation: 'UAE/UK'
            },
            {
                id: 7,
                brand: 'Barbara',
                offer_name: 'Black',
                offer_time: '@barbara',
                expected_sale: 'barbara@yandex.ru',
                amount: '43',
                no_sold: '111',
                comp_add: 'B.21-jtl Bulding-21 st Abu Dhabi',
                nation: 'UAE/UK'
            },
            {
                id: 8,
                brand: 'Sevan',
                offer_name: 'Bagrat',
                offer_time: '@sevan',
                expected_sale: 'sevan@outlook.com',
                amount: '13',
                no_sold: '111'
            },
            {
                id: 9,
                brand: 'Ruben',
                offer_name: 'Vardan',
                offer_time: '@ruben',
                expected_sale: 'ruben@gmail.com',
                amount: '22',
                no_sold: '111'

            },
            {
                id: 10,
                brand: 'Karen',
                offer_name: 'Sevan',
                offer_time: '@karen',
                expected_sale: 'karen@yandex.ru',
                amount: '33',
                no_sold: '111'
            },
            {
                id: 11,
                brand: 'Mark',
                offer_name: 'Otto',
                offer_time: '@mark',
                expected_sale: 'mark@gmail.com',
                amount: '38',
                no_sold: '111'
            },
            {
                id: 12,
                brand: 'Jacob',
                offer_name: 'Thornton',
                offer_time: '@jacob',
                expected_sale: 'jacob@yandex.ru',
                amount: '48',
                no_sold: '111'
            },
            {
                id: 13,
                brand: 'Haik',
                offer_name: 'Hakob',
                offer_time: '@haik',
                expected_sale: 'haik@outlook.com',
                amount: '48',
                no_sold: '111'
            },
            {
                id: 14,
                brand: 'Garegin',
                offer_name: 'Jirair',
                offer_time: '@garegin',
                expected_sale: 'garegin@gmail.com',
                amount: '40',
                no_sold: '111'
            },
            {
                id: 15,
                brand: 'Krikor',
                offer_name: 'Bedros',
                offer_time: '@krikor',
                expected_sale: 'krikor@yandex.ru',
                amount: '32'
            },
            {
                "id": 16,
                "brand": "Francisca",
                "offer_name": "Brady",
                "offer_time": "@Gibson",
                "expected_sale": "franciscagibson@comtours.com",
                "amount": 11
            },
            {
                "id": 17,
                "brand": "Tillman",
                "offer_name": "Figueroa",
                "offer_time": "@Snow",
                "expected_sale": "tillmansnow@comtours.com",
                "amount": 34
            },
            {
                "id": 18,
                "brand": "Jimenez",
                "offer_name": "Morris",
                "offer_time": "@Bryant",
                "expected_sale": "jimenezbryant@comtours.com",
                "amount": 45
            },
            {
                "id": 19,
                "brand": "Sandoval",
                "offer_name": "Jacobson",
                "offer_time": "@Mcbride",
                "expected_sale": "sandovalmcbride@comtours.com",
                "amount": 32
            },
            {
                "id": 20,
                "brand": "Griffin",
                "offer_name": "Torres",
                "offer_time": "@Charles",
                "expected_sale": "griffincharles@comtours.com",
                "amount": 19
            },
            {
                "id": 21,
                "brand": "Cora",
                "offer_name": "Parker",
                "offer_time": "@Caldwell",
                "expected_sale": "coracaldwell@comtours.com",
                "amount": 27
            },
            {
                "id": 22,
                "brand": "Cindy",
                "offer_name": "Bond",
                "offer_time": "@Velez",
                "expected_sale": "cindyvelez@comtours.com",
                "amount": 24
            },
            {
                "id": 23,
                "brand": "Frieda",
                "offer_name": "Tyson",
                "offer_time": "@Craig",
                "expected_sale": "friedacraig@comtours.com",
                "amount": 45
            },
            {
                "id": 24,
                "brand": "Cote",
                "offer_name": "Holcomb",
                "offer_time": "@Rowe",
                "expected_sale": "coterowe@comtours.com",
                "amount": 20
            },
            {
                "id": 25,
                "brand": "Trujillo",
                "offer_name": "Mejia",
                "offer_time": "@Valenzuela",
                "expected_sale": "trujillovalenzuela@comtours.com",
                "amount": 16
            },
            {
                "id": 26,
                "brand": "Pruitt",
                "offer_name": "Shepard",
                "offer_time": "@Sloan",
                "expected_sale": "pruittsloan@comtours.com",
                "amount": 44
            },
            {
                "id": 27,
                "brand": "Sutton",
                "offer_name": "Ortega",
                "offer_time": "@Black",
                "expected_sale": "suttonblack@comtours.com",
                "amount": 42
            },
            {
                "id": 28,
                "brand": "Marion",
                "offer_name": "Heath",
                "offer_time": "@Espinoza",
                "expected_sale": "marionespinoza@comtours.com",
                "amount": 47
            },
            {
                "id": 29,
                "brand": "Newman",
                "offer_name": "Hicks",
                "offer_time": "@Keith",
                "expected_sale": "newmankeith@comtours.com",
                "amount": 15
            },
            {
                "id": 30,
                "brand": "Boyle",
                "offer_name": "Larson",
                "offer_time": "@Summers",
                "expected_sale": "boylesummers@comtours.com",
                "amount": 32
            },
            {
                "id": 31,
                "brand": "Haynes",
                "offer_name": "Vinson",
                "offer_time": "@Mckenzie",
                "expected_sale": "haynesmckenzie@comtours.com",
                "amount": 15
            },
            {
                "id": 32,
                "brand": "Miller",
                "offer_name": "Acosta",
                "offer_time": "@Young",
                "expected_sale": "milleryoung@comtours.com",
                "amount": 55
            },
            {
                "id": 33,
                "brand": "Johnston",
                "offer_name": "Brown",
                "offer_time": "@Knight",
                "expected_sale": "johnstonknight@comtours.com",
                "amount": 29
            },
            {
                "id": 34,
                "brand": "Lena",
                "offer_name": "Pitts",
                "offer_time": "@Forbes",
                "expected_sale": "lenaforbes@comtours.com",
                "amount": 25
            },
            {
                "id": 35,
                "brand": "Terrie",
                "offer_name": "Kennedy",
                "offer_time": "@Branch",
                "expected_sale": "terriebranch@comtours.com",
                "amount": 37
            },
            {
                "id": 36,
                "brand": "Louise",
                "offer_name": "Aguirre",
                "offer_time": "@Kirby",
                "expected_sale": "louisekirby@comtours.com",
                "amount": 44
            },
            {
                "id": 37,
                "brand": "David",
                "offer_name": "Patton",
                "offer_time": "@Sanders",
                "expected_sale": "davidsanders@comtours.com",
                "amount": 26
            },
            {
                "id": 38,
                "brand": "Holden",
                "offer_name": "Barlow",
                "offer_time": "@Mckinney",
                "expected_sale": "holdenmckinney@comtours.com",
                "amount": 11
            },
            {
                "id": 39,
                "brand": "Baker",
                "offer_name": "Rivera",
                "offer_time": "@Montoya",
                "expected_sale": "bakermontoya@comtours.com",
                "amount": 47
            },
            {
                "id": 40,
                "brand": "Belinda",
                "offer_name": "Lloyd",
                "offer_time": "@Calderon",
                "expected_sale": "belindacalderon@comtours.com",
                "amount": 21
            },
            {
                "id": 41,
                "brand": "Pearson",
                "offer_name": "Patrick",
                "offer_time": "@Clements",
                "expected_sale": "pearsonclements@comtours.com",
                "amount": 42
            },
            {
                "id": 42,
                "brand": "Alyce",
                "offer_name": "Mckee",
                "offer_time": "@Daugherty",
                "expected_sale": "alycedaugherty@comtours.com",
                "amount": 55
            },
            {
                "id": 43,
                "brand": "Valencia",
                "offer_name": "Spence",
                "offer_time": "@Olsen",
                "expected_sale": "valenciaolsen@comtours.com",
                "amount": 20
            },
            {
                "id": 44,
                "brand": "Leach",
                "offer_name": "Holcomb",
                "offer_time": "@Humphrey",
                "expected_sale": "leachhumphrey@comtours.com",
                "amount": 28
            },
            {
                "id": 45,
                "brand": "Moss",
                "offer_name": "Baxter",
                "offer_time": "@Fitzpatrick",
                "expected_sale": "mossfitzpatrick@comtours.com",
                "amount": 51
            },
            {
                "id": 46,
                "brand": "Jeanne",
                "offer_name": "Cooke",
                "offer_time": "@Ward",
                "expected_sale": "jeanneward@comtours.com",
                "amount": 59
            },
            {
                "id": 47,
                "brand": "Wilma",
                "offer_name": "Briggs",
                "offer_time": "@Kidd",
                "expected_sale": "wilmakidd@comtours.com",
                "amount": 53
            },
            {
                "id": 48,
                "brand": "Beatrice",
                "offer_name": "Perry",
                "offer_time": "@Gilbert",
                "expected_sale": "beatricegilbert@comtours.com",
                "amount": 39
            },
            {
                "id": 49,
                "brand": "Whitaker",
                "offer_name": "Hyde",
                "offer_time": "@Mcdonald",
                "expected_sale": "whitakermcdonald@comtours.com",
                "amount": 35
            },
            {
                "id": 50,
                "brand": "Rebekah",
                "offer_name": "Duran",
                "offer_time": "@Gross",
                "expected_sale": "rebekahgross@comtours.com",
                "amount": 40
            },
            {
                "id": 51,
                "brand": "Earline",
                "offer_name": "Mayer",
                "offer_time": "@Woodward",
                "expected_sale": "earlinewoodward@comtours.com",
                "amount": 52
            },
            {
                "id": 52,
                "brand": "Moran",
                "offer_name": "Baxter",
                "offer_time": "@Johns",
                "expected_sale": "moranjohns@comtours.com",
                "amount": 20
            },
            {
                "id": 53,
                "brand": "Nanette",
                "offer_name": "Hubbard",
                "offer_time": "@Cooke",
                "expected_sale": "nanettecooke@comtours.com",
                "amount": 55
            },
            {
                "id": 54,
                "brand": "Dalton",
                "offer_name": "Walker",
                "offer_time": "@Hendricks",
                "expected_sale": "daltonhendricks@comtours.com",
                "amount": 25
            },
            {
                "id": 55,
                "brand": "Bennett",
                "offer_name": "Blake",
                "offer_time": "@Pena",
                "expected_sale": "bennettpena@comtours.com",
                "amount": 13
            },
            {
                "id": 56,
                "brand": "Kellie",
                "offer_name": "Horton",
                "offer_time": "@Weiss",
                "expected_sale": "kellieweiss@comtours.com",
                "amount": 48
            },
            {
                "id": 57,
                "brand": "Hobbs",
                "offer_name": "Talley",
                "offer_time": "@Sanford",
                "expected_sale": "hobbssanford@comtours.com",
                "amount": 28
            },
            {
                "id": 58,
                "brand": "Mcguire",
                "offer_name": "Donaldson",
                "offer_time": "@Roman",
                "expected_sale": "mcguireroman@comtours.com",
                "amount": 38
            },
            {
                "id": 59,
                "brand": "Rodriquez",
                "offer_name": "Saunders",
                "offer_time": "@Harper",
                "expected_sale": "rodriquezharper@comtours.com",
                "amount": 20
            },
            {
                "id": 60,
                "brand": "Lou",
                "offer_name": "Conner",
                "offer_time": "@Sanchez",
                "expected_sale": "lousanchez@comtours.com",
                "amount": 16
            }
        ];

        $scope.editableTableData = $scope.smartTableData.slice(0, 36);

        $scope.peopleTableData = [{
                id: 1,
                brand: 'Mark',
                offer_name: 'Otto',
                offer_time: '@mdo',
                expected_sale: 'mdo@gmail.com',
                age: '28',
                status: 'info'
            },
            {
                id: 2,
                brand: 'Jacob',
                offer_name: 'Thornton',
                offer_time: '@fat',
                expected_sale: 'fat@yandex.ru',
                age: '45',
                status: 'primary'
            },
            {
                id: 3,
                brand: 'Larry',
                offer_name: 'Bird',
                offer_time: '@twitter',
                expected_sale: 'twitter@outlook.com',
                age: '18',
                status: 'success'
            },
            {
                id: 4,
                brand: 'John',
                offer_name: 'Snow',
                offer_time: '@snow',
                expected_sale: 'snow@gmail.com',
                age: '20',
                status: 'danger'
            },
            {
                id: 5,
                brand: 'Jack',
                offer_name: 'Sparrow',
                offer_time: '@jack',
                expected_sale: 'jack@yandex.ru',
                age: '30',
                status: 'warning'
            }
        ];

        $scope.metricsTableData = [{
                image: 'app/browsers/chrome.svg',
                browser: 'Google Chrome',
                visits: '10,392',
                isVisitsUp: true,
                purchases: '4,214',
                isPurchasesUp: true,
                percent: '45%',
                isPercentUp: true
            },
            {
                image: 'app/browsers/firefox.svg',
                browser: 'Mozilla Firefox',
                visits: '7,873',
                isVisitsUp: true,
                purchases: '3,031',
                isPurchasesUp: false,
                percent: '28%',
                isPercentUp: true
            },
            {
                image: 'app/browsers/ie.svg',
                browser: 'Internet Explorer',
                visits: '5,890',
                isVisitsUp: false,
                purchases: '2,102',
                isPurchasesUp: false,
                percent: '17%',
                isPercentUp: false
            },
            {
                image: 'app/browsers/safari.svg',
                browser: 'Safari',
                visits: '4,001',
                isVisitsUp: false,
                purchases: '1,001',
                isPurchasesUp: false,
                percent: '14%',
                isPercentUp: true
            },
            {
                image: 'app/browsers/opera.svg',
                browser: 'Opera',
                visits: '1,833',
                isVisitsUp: true,
                purchases: '83',
                isPurchasesUp: true,
                percent: '5%',
                isPercentUp: false
            }
        ];

        $scope.users = [{
                "id": 1,
                "name": "Esther Vang",
                "status": 4,
                "group": 3
            },
            {
                "id": 2,
                "name": "Leah Freeman",
                "status": 3,
                "group": 1
            },
            {
                "id": 3,
                "name": "Mathews Simpson",
                "status": 3,
                "group": 2
            },
            {
                "id": 4,
                "name": "Buckley Hopkins",
                "group": 4
            },
            {
                "id": 5,
                "name": "Buckley Schwartz",
                "status": 1,
                "group": 1
            },
            {
                "id": 6,
                "name": "Mathews Hopkins",
                "status": 4,
                "group": 2
            },
            {
                "id": 7,
                "name": "Leah Vang",
                "status": 4,
                "group": 1
            },
            {
                "id": 8,
                "name": "Vang Schwartz",
                "status": 4,
                "group": 2
            },
            {
                "id": 9,
                "name": "Hopkin Esther",
                "status": 1,
                "group": 2
            },
            {
                "id": 10,
                "name": "Mathews Schwartz",
                "status": 1,
                "group": 3
            }
        ];

        $scope.statuses = [{
                value: 1,
                text: 'Good'
            },
            {
                value: 2,
                text: 'Awesome'
            },
            {
                value: 3,
                text: 'Excellent'
            },
        ];

        $scope.groups = [{
                id: 1,
                text: 'user'
            },
            {
                id: 2,
                text: 'customer'
            },
            {
                id: 3,
                text: 'vip'
            },
            {
                id: 4,
                text: 'admin'
            }
        ];

        $scope.showGroup = function(user) {
            if (user.group && $scope.groups.length) {
                var selected = $filter('filter')($scope.groups, {
                    id: user.group
                });
                return selected.length ? selected[0].text : 'Not set';
            } else return 'Not set'
        };

        $scope.showStatus = function(user) {
            var selected = [];
            if (user.status) {
                selected = $filter('filter')($scope.statuses, {
                    value: user.status
                });
            }
            return selected.length ? selected[0].text : 'Not set';
        };
        $scope.removeUser = function(index) {
            $scope.users.splice(index, 1);
        };
        $scope.addUser = function() {
            $scope.inserted = {
                id: $scope.users.length + 1,
                name: '',
                status: null,
                group: null
            };
            $scope.users.push($scope.inserted);
        };
        editableOptions.theme = 'bs3';
        editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Merchant.pages.dashboard')
        .controller('DashboardvuPageCtrl', DashboardvuPageCtrl);

    /** @ngInject */
    function DashboardvuPageCtrl($scope, $timeout, baConfig) {

        function initialize() {
            var mapCanvas = document.getElementById('google-maps');
            var mapOptions = {
                center: new google.maps.LatLng(44.5403, -78.5463),
                zoom: 8,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            var map = new google.maps.Map(mapCanvas, mapOptions);
        }

        $timeout(function() {
            initialize();
        }, 100);

        // var layoutColors = baConfig.colors;
        $scope.genderColors = ["#F42169", "#93DCFC"];
        $scope.genderLabels = ["Male", "Female"];
        $scope.genderdata = [45, 55];
        $scope.genderoptions = {
            elements: {
                arc: {
                    borderWidth: 0
                }
            },
            legend: {
                display: false,
                position: 'right',
            }
        };

        $scope.playstoreColors = ["#636BE4", "#FF6557"];
        $scope.playstoreLabels = ["70% are new to your business.", "40% are curent customers"];
        $scope.playstoreData = [70, 40];

        $scope.appstoreColors = ["#636BE4", "#FF6557"];
        $scope.appstoreLabels = ["70% are new to your business.", "40% are curent customers"];
        $scope.appstoreData = [70, 40];

        $scope.playstore1Colors = ["#636BE4", "#FF6557"];
        $scope.playstore1Labels = ["70% are new to your business.", "40% are curent customers"];
        $scope.playstore1Data = [70, 40];

        $scope.appstore1Colors = ["#636BE4", "#FF6557"];
        $scope.appstore1Labels = ["70% are new to your business.", "40% are curent customers"];
        $scope.appstore1Data = [70, 40];

        $scope.multiColors = ["#00C9B1", "#636BE4", "#FFB83E" ,"#FF7269"];
        $scope.multiLabels = ["Android Customers", "IOS Customers", "Marketing Customers", "Merchants"];
        $scope.multiData = [20, 60, 4, 16];
        $scope.multioptions = {
            elements: {
                arc: {
                    borderWidth: 0
                }
            },
            legend: {
                display: true,
                position: 'right',
            }
        };


        $scope.outletFilter;
        $scope.isFilterLabel = false;
        $scope.outletFilterLists = [{
                name: "Outlet1",
                value: "Outlet1"
            },
            {
                name: "Outlet2",
                value: "Outlet2"
            },
            {
                name: "Outlet3",
                value: "Outlet3"
            }
        ];
        $scope.genderLists = ["All", "Registration", "Reward", "Account", "Payment", "Order", "Term", "Place"]

        // $scope.labels = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24"];
        // $scope.data = ["100", "200", "300", "450", "500", "633", "733", "508", "339", "770", "181", "120", "813", "1014", "1015", "316", "917", "518", "419", "220", "21", "122", "723", "424"];


        // $scope.labels2 = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
        // $scope.data2 = ["100", "200", "300", "450", "500", "633", "733", "850", "900", "1010"];


        $scope.horzData = ["7", "13", "17", "26", "37"];
        $scope.horzLabels = ["UAE National", "Others", "Western", "Asian", "Arab"];
        $scope.horzBarColors = [{
            backgroundColor: "#C7CAC7",
            pointBackgroundColor: "#C7CAC7",
            pointHoverBackgroundColor: "#C7CAC7",
            borderColor: "#C7CAC7",
            pointBorderColor: '#fff',
            pointHoverBorderColor: "#C7CAC7"
        }];

        $scope.vertData = ["10", "35", "15", "7"];
        $scope.vertLabels = ["Under 26", "26-35", "36-45", "51+"];

        // vertical bar chart
        $scope.vertBarColors = [{
            fillColor: "rgba(151,187,205,0.5)",
            strokeColor: "rgba(151,187,205,0.8)",
            highlightFill: "rgba(151,187,205,0.75)",
            highlightStroke: "rgba(151,187,205,1)"
        }];




        $scope.visitorWeekLabels = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
        $scope.visitorWeekDatas = [
            [10, 30, 15, 25, 40, 40, 60]
        ];
        $scope.visitorLineColors = [{
            backgroundColor: 'transparent',
            borderColor: '#5E74CE',
            pointBorderColor: '#5E74CE',
            pointBackgroundColor: '#ffffff',
            pointHoverBackgroundColor: '#5E74CE',
            pointHoverBorderColor: '#5E74CE',
            borderWidth: 3,
            pointBorderWidth: 10,
            pointBorderColor: "#07CBFB"
        }];
        $scope.visitorOptions = {
            elements: {
                line: {
                    tension: 0
                }
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'NUMBER OF OUTLETS',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'TIME',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }]
            }
        };

        $scope.revenueWeekLabels = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
        $scope.revenueWeekDatas = [
            [10, 30, 15, 25, 40, 40, 60]
        ];
        $scope.revenueLineColors = [{
            backgroundColor: 'transparent',
            borderColor: '#9CE0BA',
            pointBorderColor: '#9CE0BA',
            pointBackgroundColor: '#ffffff',
            pointHoverBackgroundColor: '#9CE0BA',
            pointHoverBorderColor: '#9CE0BA',
            borderWidth: 3,
            pointBorderWidth: 10,
            pointBorderColor: "#0FE7C1"
        }];
        $scope.revenueOptions = {
            elements: {
                line: {
                    tension: 0
                }
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'NUMBER OF REQUESTS',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'TIME',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }]
            }
        };


        $scope.appLabels = ["500", "1000", "1500", "2000", "2500", "3000", "3500", "4000", "4500", "5000"];
        $scope.appDatas = [
            [10, 30, 15, 25, 40, 40, 60]
        ];
        $scope.appColors = [{
            backgroundColor: 'transparent',
            borderColor: '#F1A164',
            pointBorderColor: '#EE4E97',
            pointBackgroundColor: '#ffffff',
            pointHoverBackgroundColor: '#EE4E97',
            pointHoverBorderColor: '#EE4E97',
            borderWidth: 3,
            pointBorderWidth: 10,
            pointBorderColor: "#EE4E97"
        }];
        $scope.appOptions = {
            elements: {
                line: {
                    tension: 0
                }
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'DOWNLOADS',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'TIME',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }]
            }
        };

        $scope.app1Labels = ["500", "1000", "1500", "2000", "2500", "3000", "3500", "4000", "4500", "5000"];
        $scope.app1Datas = [
            [10, 30, 15, 25, 40, 40, 60]
        ];
        $scope.app1Colors = [{
            backgroundColor: 'transparent',
            borderColor: '#EE4E97',
            pointBorderColor: '#F1A164',
            pointBackgroundColor: '#ffffff',
            pointHoverBackgroundColor: '#F1A164',
            pointHoverBorderColor: '#F1A164',
            borderWidth: 3,
            pointBorderWidth: 10,
            pointBorderColor: "#F1A164"
        }];
        $scope.app1Options = {
            elements: {
                line: {
                    tension: 0
                }
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'INSTALLATIONS',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'TIME',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }]
            }
        };




        $scope.custDemoLabels = ["13-23", "23-33", "33-43", "43-53", "53-63", "63-73"];
        $scope.custDemoDatas = [
            [450, 750, 1000, 1200, 1750, 2000, 2300]
        ];
        $scope.custDemoLineColors = [{
            borderColor: '#E18263',
            pointBorderColor: '#E18263',
            pointBackgroundColor: '#ffffff',
            pointHoverBackgroundColor: '#E18263',
            pointHoverBorderColor: '#E18263'
        }];


        $scope.revenueDemoLabels = ["13-23", "23-33", "33-43", "43-53", "53-63", "63-73"];
        $scope.revenueDemoDatas = [
            [450, 750, 1000, 1200, 1750, 2000, 2300]
        ];
        $scope.revenueDemoLineColors = [{
            borderColor: '#C68DCE',
            pointBorderColor: '#C68DCE',
            pointBackgroundColor: '#ffffff',
            pointHoverBackgroundColor: '#C68DCE',
            pointHoverBorderColor: '#C68DCE'
        }];


        $scope.lineLabels = ["Under 26", "26-35", "36-45", "51+"];
        $scope.lineDatas = [
            [25, 22, 24, 20, 23],
            [40, 35, 37, 32, 38]
        ];

        $scope.lineColors = [{
            borderColor: '#60CEDF',
            pointBorderColor: '#60CEDF',
            pointBackgroundColor: '#60CEDF',
            pointHoverBackgroundColor: '#60CEDF',
            pointHoverBorderColor: '#60CEDF'
        }, {
            borderColor: '#EB5E89',
            pointBorderColor: '#EB5E89',
            pointBackgroundColor: '#EB5E89',
            pointHoverBackgroundColor: '#EB5E89',
            pointHoverBorderColor: '#EB5E89'
        }];

        $scope.lineOptions = {
            elements: { line: { tension: 0, fill: false } },
            scales: {
                yAxes: [{
                    ticks: {
                        beginAtZero: true,
                        suggestedMin: 0
                    }
                }]
            }
        };

        

        $scope.smartTableData = [{
                id: 1,
                nationality: 'Australia',
                head: '121',
                revenue: '3433',
                per: '24323',
                offers: '23243238',
                Rewards: '3434',
                Unredeemed: '76756',
                Made: '354,34',
                Active: '3437,7',
                Expired: '23433,565'
            },
            {
                id: 2,
                nationality: 'Brazil',
                head: '121',
                revenue: '3433',
                per: '24323',
                offers: '23243238',
                Rewards: '3434',
                Unredeemed: '76756',
                Made: '354,34',
                Active: '3437,7',
                Expired: '23433,565'
            },
            {
                id: 3,
                nationality: 'Canada',
                head: '121',
                revenue: '3433',
                per: '24323',
                offers: '23243238',
                Rewards: '3434',
                Unredeemed: '76756',
                Made: '354,34',
                Active: '3437,7',
                Expired: '23433,565'
            }
        ];
    }

    


})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Merchant.pages.globalsetting')
        .controller('globalsettingPageCtrl', globalsettingPageCtrl);

    /** @ngInject */
    function globalsettingPageCtrl($scope, baConfig, $uibModal) {
        $scope.open = function(page, size) { $uibModal.open({ animation: true, templateUrl: page, size: size, resolve: { items: function() { return $scope.items; } } }); };
        $scope.outletFilter;
        $scope.isFilterLabel = false;
        $scope.sortBy = [{
            name: "NAME",
            value: "NAME"
          },
          {
            name: "AMOUNT",
            value: "AMOUNT"
          },
          {
            name: "STATUS",
            value: "STATUS"
          }
          ];
       
    }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';
  
    angular.module('Merchant.theme.components')
        .directive('backTop', backTop);
  
    /** @ngInject */
    function backTop() {
      return {
        restrict: 'E',
        templateUrl: 'app/theme/components/backTop/backTop.html',
        controller: function () {
          $('#backTop').backTop({
            'position': 200,
            'speed': 100
          });
        }
      };
    }
  
  })();
  

(function () {
    'use strict';

    angular.module('Merchant.pages.mangevendor')
        .controller('mangevendorCtrl', mangevendorCtrl);

    /** @ngInject */
    function mangevendorCtrl($state, $uibModal, $scope, baProgressModal) {
        $state.go('mangevendor.outlet');
        $(document).on('click','.selectpin',function(){
        
          $('#manage-vendor').hide();
          $('#pin-management').show();
        });
        $(document).on('click','.closePin',function(){
        
          $('#manage-vendor').show();
          $('#pin-management').hide();
        });
                
        $scope.open = function (page, size) {
            $uibModal.open({
              animation: true,
              templateUrl: page,
              size: size,
              resolve: {
                items: function () {
                  return $scope.items;
                }
              }
            });
          };
        $scope.openProgressDialog = baProgressModal.open;
        
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';
  angular.module('Merchant.pages.myOutlet')
    .controller('MyOutletPageCtrl', MyOutletPageCtrl);
  /** @ngInject */
  function MyOutletPageCtrl($state) {
    $state.go('myOutlet.details')
    console.log("test add");
  }
  // function datepickerpopupCtrl($scope) {

  // }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Merchant.pages.offermanagement')
        .controller('offermanagementPageCtrl', offermanagementPageCtrl);

    /** @ngInject */
    function offermanagementPageCtrl($scope, baConfig, $uibModal, taOptions) {
        $scope.open = function(page, size) { $uibModal.open({ animation: true, templateUrl: page, size: size, resolve: { items: function() { return $scope.items; } } }); };
        $scope.orightml = '';
		$scope.htmlcontent = $scope.orightml;
		$scope.disabled = false;
         $scope.outletFilter;
         taOptions.toolbar = [
            ['bold','ul', 'ol'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
            ['insertLink']
        ];
     
         $scope.isFilterLabel = false;
        $scope.sortBy = [{
            name: "NAME",
            value: "NAME"
          },
          {
            name: "AMOUNT",
            value: "AMOUNT"
          },
          {
            name: "STATUS",
            value: "STATUS"
          }
          ];
       
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Merchant.pages.payment')
        .controller('paymentPageCtrl', paymentPageCtrl);

    /** @ngInject */
    function paymentPageCtrl($scope, baConfig, $uibModal) {
        $scope.open = function(page, size) { $uibModal.open({ animation: true, templateUrl: page, size: size, resolve: { items: function() { return $scope.items; } } }); };
        $scope.outletFilter;
        $scope.isFilterLabel = false;
        
        $scope.sortBy = [{
            name: "NAME",
            value: "NAME"
          },
          {
            name: "AMOUNT",
            value: "AMOUNT"
          },
          {
            name: "STATUS",
            value: "STATUS"
          }
          ];

       
    }
 
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Merchant.pages.pinperformance')
        .controller('PinPerformancePageCtrl', PinPerformancePageCtrl);

    /** @ngInject */
    function PinPerformancePageCtrl($scope, $timeout, baConfig) {

        $scope.outletFilterLists = [{
            name: "Outlet1",
            value: "Outlet1"
          },
          {
            name: "Outlet2",
            value: "Outlet2"
          },
          {
            name: "Outlet3",
            value: "Outlet3"
          }
          ];

        $scope.openFrom = openFrom;
        $scope.openedFrom = false;
        $scope.openTo = openTo;
        $scope.openedTo = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function openFrom() {
            $scope.openedFrom = true;
        }

        function openTo() {
            $scope.openedTo = true;
        }

    }

})();
/**
 * @author a.demeshko
 * created on 21.01.2016
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.profile')
    .controller('ProfileModalCtrl', ProfileModalCtrl);

  /** @ngInject */
  function ProfileModalCtrl($scope, $uibModalInstance) {
    $scope.link = '';
    $scope.ok = function () {
      $uibModalInstance.close($scope.link);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.profile')
    .controller('ProfilePageCtrl', ProfilePageCtrl);

  /** @ngInject */
  function ProfilePageCtrl($scope, fileReader, $filter, $uibModal) {
    $scope.picture = $filter('profilePicture')('Nasta');

    $scope.removePicture = function () {
      $scope.picture = $filter('appImage')('theme/no-photo.png');
      $scope.noPicture = true;
    };

    $scope.uploadPicture = function () {
      var fileInput = document.getElementById('uploadFile');
      fileInput.click();

    };

    $scope.socialProfiles = [
      {
        name: 'Facebook',
        href: 'https://www.facebook.com/akveo/',
        icon: 'socicon-facebook'
      },
      {
        name: 'Twitter',
        href: 'https://twitter.com/akveo_inc',
        icon: 'socicon-twitter'
      },
      {
        name: 'Google',
        icon: 'socicon-google'
      },
      {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/akveo',
        icon: 'socicon-linkedin'
      },
      {
        name: 'GitHub',
        href: 'https://github.com/akveo',
        icon: 'socicon-github'
      },
      {
        name: 'StackOverflow',
        icon: 'socicon-stackoverflow'
      },
      {
        name: 'Dribbble',
        icon: 'socicon-dribble'
      },
      {
        name: 'Behance',
        icon: 'socicon-behace'
      }
    ];

    $scope.unconnect = function (item) {
      item.href = undefined;
    };

    $scope.showModal = function (item) {
      $uibModal.open({
        animation: false,
        controller: 'ProfileModalCtrl',
        templateUrl: 'app/pages/profile/profileModal.html'
      }).result.then(function (link) {
          item.href = link;
        });
    };

    $scope.getFile = function () {
      fileReader.readAsDataUrl($scope.file, $scope)
          .then(function (result) {
            $scope.picture = result;
          });
    };

    $scope.switches = [true, true, false, true, true, false];
  }

})();

(function() {
    'use strict';

    angular.module('Merchant.pages.report')
        .controller('ReportPageCtrl', ReportPageCtrl);

    /** @ngInject */
    function ReportPageCtrl($state, $scope, $window, baConfig) {
        $state.go('report.performance')


       

       
    }
})();

(function () {
  'use strict';

  angular.module('Merchant.pages.reservation')
    .controller('ReservationPageCtrl', ReservationPageCtrl);

  /** @ngInject */
  function ReservationPageCtrl($scope, $timeout, baConfig) {
    // $state.go('reservation.overview')
    // $scope.simpleLineOptions = {
    //     color: baConfig.colors.defaultText,
    //     fullWidth: true,
    //     height: "500px",
    //     chartPadding: {
    //       right: 40
    //     }
    //   };

    //   $scope.simpleLineData = {

    //     labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    //     series: [
    //       [10, 20, 12, 40, 50, 70, 60]
    //     ]
    //   };


    //   $timeout(function(){
    //     new Chartist.Line('#line-chart', $scope.simpleLineData, $scope.simpleLineOptions);

    //   });
    $scope.registerLabels = ["500", "1000", "1500", "2000", "2500", "3000", "3500", "4000", "4500", "5000"];
    $scope.registerDatas = [
      [10, 30, 15, 25, 40, 40, 60]
    ];
    $scope.registerLineColors = [{
      backgroundColor: 'transparent',
      borderColor: '#3aa992',
      pointBorderColor: '#58b7a3',
      pointBackgroundColor: '#ffffff',
      pointHoverBackgroundColor: '#ffffff',
      pointHoverBorderColor: '#FAA370',
      height: "500px",
      borderWidth: 3,
      pointBorderWidth: 10,
      pointBorderColor: "#3aa992"
      
    }];

    $scope.registerOptions = {
   
      elements:
        {
          line:
            {
              tension: 0
            }
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: 'RESERVATIONS',
              fontSize: 22,
              fontColor: '#586777'

              
            }
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: 'DATE',
              fontSize: 22,
              fontColor: '#586777'

              

            }
          }]
        }
    };
  }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Merchant.pages.review')
        .controller('ReviewPageCtrl', ReviewPageCtrl);

    /** @ngInject */
    function ReviewPageCtrl($scope, $timeout, baConfig, $uibModal) {
        $scope.open = function(page, size) {
             $uibModal.open({ 
                 animation: true, 
                 templateUrl: page,
                  size: size,
                   resolve: { 
                 items: function() {
                      return $scope.items;
                     } 
                    } 
                });
             };
        $scope.sortBy = [{
            name: "NAME",
            value: "NAME"
          },
          {
            name: "AMOUNT",
            value: "AMOUNT"
          },
          {
            name: "STATUS",
            value: "STATUS"
          }
          ];

        $scope.openFrom = openFrom;
        $scope.openedFrom = false;
        $scope.openTo = openTo;
        $scope.openedTo = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function openFrom() {
            $scope.openedFrom = true;
        }

        function openTo() {
            $scope.openedTo = true;
        }

        $scope.open1 = open1;
        $scope.opened1 = false;
        $scope.open2 = open2;
        $scope.opened2 = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open1() {
            $scope.opened1 = true;
        }

        function open2() {
            $scope.opened2 = true;
        }


        var layoutColors = baConfig.colors;
        $scope.labels1 = ["Service", "Cleaning", "Value", "Facility"];
        $scope.data1 = [20, 40, 5, 35];
        $scope.options1 = {
            elements: {
                arc: {
                    borderWidth: 0
                }
            },
            legend: {
                display: true,
                position: 'right',
                labels1: {
                    fontColor: layoutColors.defaultText
                }
            }
        };
        $scope.labels = ["Service", "Cleaning", "Value", "Facility"];
        $scope.type = 'StackedBar';
        $scope.series = ['20', '40', '200', '280'];
        $scope.options = {
            scales: {
                xAxes: [{
                    stacked: true,
                }],
                yAxes: [{
                    stacked: true
                }]
            }
        };

        $scope.data = [
            [65, 20, 10, 5],
            [35, 43, 21, 11],
            [55, 21, 52, 79],
            [65, 71, 30, 55]

        ];
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Merchant.pages.support')
        .controller('SupportPageCtrl', SupportPageCtrl);

    /** @ngInject */
    function SupportPageCtrl($scope) {
        $scope.outletFilter;
        $scope.isFilterLabel = false;
        $scope.outletFilterLists = [{
                name: "Outlet1",
                value: "Outlet1"
            },
            {
                name: "Outlet2",
                value: "Outlet2"
            },
            {
                name: "Outlet3",
                value: "Outlet3"
            }
        ];
        $scope.genderLists = ["All", "Registration", "Reward", "Account", "Payment", "Order", "Term", "Place"]
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.tables')
      .controller('TablesPageCtrl', TablesPageCtrl);

  /** @ngInject */
  function TablesPageCtrl($scope, $filter, editableOptions, editableThemes) {

    $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('Merchant.pages.vendorcontract')
        .controller('vendorPageCtrl', vendorPageCtrl);

    /** @ngInject */
    function vendorPageCtrl($scope, baConfig) {
        // $scope.openTo = openTo;
        // $scope.openedTo = false;
        // $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        // $scope.format = $scope.formats[0];
        // $scope.options = {
        //     showWeeks: false
        // };

     

        // function openTo() {
        //     $scope.openedTo = true;
        // }
        // $scope.outletFilter;
        // $scope.isFilterLabel = false;
        // $scope.sortBy = [{
        //     name: "NAME",
        //     value: "NAME"
        //   },
        //   {
        //     name: "AMOUNT",
        //     value: "AMOUNT"
        //   },
        //   {
        //     name: "STATUS",
        //     value: "STATUS"
        //   }
        //   ];

       
    }

})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();

/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();

/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('Merchant.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('Merchant.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();

(function () {
  'use strict';

  angular.module('Merchant.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();

(function () {
  'use strict';

  angular.module('Merchant.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();

/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();

/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('Merchant.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();

/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();

/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.charts.chartJs')
    .controller('chartJs1DCtrl', chartJs1DCtrl);

  /** @ngInject */
  function chartJs1DCtrl($scope, baConfig) {
    var layoutColors = baConfig.colors;

    $scope.labels =["Sleeping", "Designing", "Coding", "Cycling"];
    $scope.data = [20, 40, 5, 35];
    $scope.options = {
      elements: {
        arc: {
          borderWidth: 0
        }
      },
      legend: {
        display: true,
        position: 'bottom',
        labels: {
          fontColor: layoutColors.defaultText
        }
      }
    };

    $scope.changeData = function () {
      $scope.data = shuffle($scope.data);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.charts.chartJs')
    .controller('chartJs2DCtrl', chartJs2DCtrl);

  /** @ngInject */
  function chartJs2DCtrl($scope) {
    $scope.labels =["May", "Jun", "Jul", "Aug", "Sep"];
    $scope.data = [
      [65, 59, 90, 81, 56],
      [28, 48, 40, 19, 88]
    ];
    $scope.series = ['Product A', 'Product B'];


    $scope.changeData = function () {
      $scope.data[0] = shuffle($scope.data[0]);
      $scope.data[1] = shuffle($scope.data[1]);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.charts.chartJs')
    .controller('chartJsWaveCtrl', chartJsWaveCtrl);

  /** @ngInject */
  function chartJsWaveCtrl($scope, $interval, stopableInterval) {
    $scope.labels =["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    $scope.data = [1, 9, 3, 4, 5, 6, 7, 8, 2].map(function(e){
      return Math.sin(e) * 25 +25;
    });

    stopableInterval.start($interval, function(){
      var tempArray = [];
      var lastElement = $scope.data[$scope.data.length-1];
      for(var i = $scope.data.length-1; i > 0; i--){
       tempArray[i] = $scope.data[i-1];
      }
      tempArray[0] = lastElement;
      $scope.data = tempArray;
    }, 400)
  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.charts.chartist')
    .controller('chartistCtrl', chartistCtrl);

  /** @ngInject */
  function chartistCtrl($scope, $timeout, baConfig) {

    $scope.simpleLineOptions = {
      color: baConfig.colors.defaultText,
      fullWidth: true,
      height: "300px",
      chartPadding: {
        right: 40
      }
    };

    $scope.simpleLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      series: [
        [20, 20, 12, 45, 50],
        [10, 45, 30, 14, 12],
        [34, 12, 12, 40, 50],
        [10, 43, 25, 22, 16],
        [3, 6, 30, 33, 43]
      ]
    };

    $scope.areaLineData = {
      labels: [1, 2, 3, 4, 5, 6, 7, 8],
      series: [
        [5, 9, 7, 8, 5, 3, 5, 4]
      ]
    };

    $scope.areaLineOptions = {
      fullWidth: true,
      height: "300px",
      low: 0,
      showArea: true
    };

    $scope.biLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      series: [
        [1, 2, 3, 1, -2, 0, 1],
        [-2, -1, -2, -1, -2.5, -1, -2],
        [0, 0, 0, 1, 2, 2.5, 2],
        [2.5, 2, 1, 0.5, 1, 0.5, -1]
      ]
    };

    $scope.biLineOptions = {
      height: "300px",
      high: 3,
      low: -3,
      showArea: true,
      showLine: false,
      showPoint: false,
      fullWidth: true,
      axisX: {
        showGrid: false
      }
    };

    $scope.simpleBarData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      series: [
        [15, 24, 43, 27, 5, 10, 23, 44, 68, 50, 26, 8],
        [13, 22, 49, 22, 4, 6, 24, 46, 57, 48, 22, 4]
      ]
    };

    $scope.simpleBarOptions = {
      fullWidth: true,
      height: "300px"
    };

    $scope.multiBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [5, 4, 3, 7],
        [3, 2, 9, 5],
        [1, 5, 8, 4],
        [2, 3, 4, 6],
        [4, 1, 2, 1]
      ]
    };

    $scope.multiBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value.split(/\s+/).map(function (word) {
            return word[0];
          }).join('');
        }
      },
      axisY: {
        offset: 20
      }
    };

    $scope.multiBarResponsive = [
      ['screen and (min-width: 400px)', {
        reverseData: true,
        horizontalBars: true,
        axisX: {
          labelInterpolationFnc: Chartist.noop
        },
        axisY: {
          offset: 60
        }
      }],
      ['screen and (min-width: 700px)', {
        stackBars: false,
        reverseData: false,
        horizontalBars: false,
        seriesBarDistance: 15
      }]
    ];

    $scope.stackedBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [800000, 1200000, 1400000, 1300000],
        [200000, 400000, 500000, 300000],
        [100000, 200000, 400000, 600000]
      ]
    };

    $scope.stackedBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisY: {
        labelInterpolationFnc: function (value) {
          return (value / 1000) + 'k';
        }
      }
    };

    $scope.simplePieData = {
      series: [5, 3, 4]
    };

    $scope.simplePieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelInterpolationFnc: function (value) {
        return Math.round(value / 12 * 100) + '%';
      }
    };

    $scope.labelsPieData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.labelsPieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.simpleDonutData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.simpleDonutOptions = {
      fullWidth: true,
      donut: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.donutResponsive = getResponsive(5, 40);

    $scope.pieResponsive = getResponsive(20, 80);

    function getResponsive(padding, offset){
      return [
        ['screen and (min-width: 1550px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 1200px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 600px)', {
          chartPadding: 0,
          labelOffset: 0,
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }]
      ];
    }

    $timeout(function(){
      new Chartist.Line('#line-chart', $scope.simpleLineData, $scope.simpleLineOptions);
      new Chartist.Line('#area-chart', $scope.areaLineData, $scope.areaLineOptions);
      new Chartist.Line('#bi-chart', $scope.biLineData, $scope.biLineOptions);

      new Chartist.Bar('#simple-bar', $scope.simpleBarData, $scope.simpleBarOptions);
      new Chartist.Bar('#multi-bar', $scope.multiBarData, $scope.multiBarOptions, $scope.multiBarResponsive);
      new Chartist.Bar('#stacked-bar', $scope.stackedBarData, $scope.stackedBarOptions);

      new Chartist.Pie('#simple-pie', $scope.simplePieData, $scope.simplePieOptions, $scope.pieResponsive);
      new Chartist.Pie('#label-pie', $scope.labelsPieData, $scope.labelsPieOptions);
      new Chartist.Pie('#donut', $scope.simpleDonutData, $scope.simpleDonutOptions, $scope.donutResponsive);
    });
  }
})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.charts.morris')
    .controller('morrisCtrl', morrisCtrl);

  /** @ngInject */
  function morrisCtrl($scope, $window, baConfig) {
    var layoutColors = baConfig.colors;
    $scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];
    $scope.lineData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.areaData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.barData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.donutData = [
      {label: "Download Sales", value: 12},
      {label: "In-Store Sales", value: 30},
      {label: "Mail-Order Sales", value: 20}
    ];

    angular.element($window).bind('resize', function () {
      //$window.Morris.Grid.prototype.redraw();
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.components.mail')
      .controller('MailTabCtrl', MailTabCtrl);

  /** @ngInject */
  function MailTabCtrl(composeModal, mailMessages) {

    var vm = this;
    vm.navigationCollapsed = true;
    vm.showCompose = function(subject, to , text){
      composeModal.open({
        subject : subject,
        to: to,
        text: text
      })
    };

    vm.tabs = mailMessages.getTabs();
  }

})();

/**
 * @author a.demeshko
 * created on 12/29/15
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.components.mail')
    .service('mailMessages', mailMessages);

  /** @ngInject */
  function mailMessages($sce) {
    var messages = [
      {
        "id": "4563faass",
        "name": "Nasta Linnie",
        "subject": "Great text",
        "date": "2015-08-28T07:57:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Check out this cool text.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "attachment": "poem.txt",
        "position": "Great Employee",
        "tag": "friend",
        "labels": ['inbox']
      },
      {
        "id": "4563fdfvd",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-11-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ex mauris, ultrices vel lectus quis, scelerisque hendrerit ipsum. Suspendisse ullamcorper turpis neque, eget dapibus magna placerat ac. Suspendisse rhoncus ligula ac mi tempus varius ut sed lacus. Sed et commodo nulla, et placerat leo. Nam rhoncus vulputate sem non pharetra. Praesent fringilla massa in laoreet convallis. Aliquam lobortis dui a congue facilisis. Aenean dapibus semper semper. Quisque aliquam, nibh dapibus interdum condimentum, ex velit tempor tortor, at vestibulum magna leo quis leo. Morbi pulvinar varius erat ac rutrum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; In hac habitasse platea dictumst.</p>" +
          "<br><p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "4563zxcss",
        "name": "Nasta Linnie",
        "subject": "Lores ipsum",
        "date": "2015-10-19T03:30:45",
        "important": false,
        "body": $sce.trustAsHtml("<p>Hey Nasta, </p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>"),
        "pic": "img/Nasta.png",
        "email": "petraramsey@mail.com",
        "position": "Great Employee",
        "tag": "work",
        "labels": ['sent', 'important']
      },
      {
        "id": "8955sddf",
        "name": "Nick Cat",
        "subject": "New Design",
        "date": "2015-05-05T12:59:45",
        "body": $sce.trustAsHtml("<p>Hey John, Consectetur adipiscing elit</p><br>" +
          "<p>Cras rhoncus quam ipsum, vel dignissim nisl egestas sed. Aliquam erat volutpat. Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "attachment": "design.psd",
        "tag": "work",
        "labels": ['inbox']
      },
      {
        "id": "8955sdfcc",
        "name": "Nick Cat",
        "subject": "Gift card",
        "date": "2015-07-18T10:19:01",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Consectetur adipiscing elit, Lorem ipsum dolor sit amet</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "study",
        "labels": ['inbox']
      },
      {
        "id": "8955asewf",
        "name": "Nick Cat",
        "subject": "Some news",
        "date": "2015-09-23T03:04:10",
        "body": $sce.trustAsHtml("<p>Hey John, </p><br><p>Integer eu nisl elit. Donec malesuada diam vitae tellus luctus tincidunt. Donec tempus blandit neque, rutrum egestas ipsum sagittis tempor. Curabitur volutpat ligula enim, nec vehicula purus molestie at. Sed a facilisis enim, nec molestie magna. Donec in augue non est viverra dapibus vel tempus risus. Nam porttitor purus sit amet hendrerit ullamcorper. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.</p>"),
        "pic": "img/Nick.png",
        "email": "barlowshort@mail.com",
        "position": "Graphical designer",
        "tag": "work",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334uudsa",
        "name": "Kostya Danovsky",
        "subject": "Street Art",
        "date": "2015-11-22T10:05:09",
        "body": $sce.trustAsHtml("<p>Hey John, </p><p>Aliquam eu facilisis eros, quis varius est.</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Lorem ipsum dolor sit amet! Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed." +
          "Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "attachment": "file.doc",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334aefvv",
        "name": "Kostya Danovsky",
        "subject": "New product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<p>Aliquam eu facilisis eros, quis varius est. Nullam imperdiet justo a ipsum laoreet euismod.</p>" +
          "<br><p>Nulla facilisi. Nulla congue, arcu eget blandit lacinia, leo ante ullamcorper lectus, vel pulvinar justo ipsum vitae justo." +
          "Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "family",
        "labels": ['inbox', 'important']
      },
      {
        "id": "2334cvdss",
        "name": "Kostya Danovsky",
        "subject": "Old product",
        "date": "2015-06-22T06:26:10",
        "body": $sce.trustAsHtml("<p>Hello John, </p>" +
          "<p>Consectetur adipiscing elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>" +
          "<br>"+
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Kostya.png",
        "email": "schwart@mail.com",
        "position": "Technical Chef",
        "tag": "study",
        "labels": ['trash']
      },
      {
        "id": "8223xzxfn",
        "name": "Andrey Hrabouski",
        "subject": "Skype moji",
        "date": "2015-07-16T06:47:53",
        "body": $sce.trustAsHtml("<p>Hello John, </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Lorem ipsum dolor I find moji in skype sit amet!.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['trash']
      },
      {
        "id": "8223sdffn",
        "name": "Andrey Hrabouski",
        "subject": "My App",
        "date": "2015-06-20T07:05:02",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Consectetur My Falasson App elit. Aliquam sodales sem in nibh pellentesque, ac dignissim mi dapibus.</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": 'family',
        "labels": ['spam']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "Cool",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Aliquam sodales sem in nibh pellentesque</p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['draft']
      },
      {
        "id": "8223xsdaa",
        "name": "Andrey Hrabouski",
        "subject": "Car rent",
        "date": "2015-02-25T10:58:58",
        "body": $sce.trustAsHtml("<p>Hey Andrey. </p>" +
          "<p>Cras tincidunt fermentum lectus, quis scelerisque lorem volutpat sed. Sed quis orci sed nisl sagittis viverra id at mauris. Nam venenatis mi nibh. Sed fringilla mattis vehic</p>"),
        "pic": "img/Andrey.png",
        "email": "lakeishaphillips@mail.com",
        "position": "Mobile Developer",
        "tag": "family",
        "labels": ['draft']
      },
      {
        "id": "9391xdsff",
        "name": "Vlad Lugovsky",
        "subject": "What next",
        "date": "2015-03-31T11:52:58",
        "body": $sce.trustAsHtml("<p>Hey Vlad. </p><p>Lorem ipsum dolor sit amet!</p>" +
          "<p>Esse esse labore tempor ullamco ullamco. Id veniam laborum c.</p>"),
        "pic": "img/Vlad.png",
        "email": "carlsongoodman@mail.com",
        "position": "Fullstack man",
        "tag": "study",
        "labels": ['sent']
      }
    ].sort(function (a, b) {
        if (a.date > b.date) return 1;
        if (a.date < b.date) return -1;
      }).reverse();
    var tabs = [{
      label: 'inbox',
      name: 'Inbox',
      newMails: 7
    }, {
      label: 'sent',
      name: 'Sent Mail'
    }, {
      label: 'important',
      name: 'Important'
    }, {
      label: 'draft',
      name: 'Draft',
      newMails: 2
    }, {
      label: 'spam',
      name: 'Spam'
    }, {
      label: 'trash',
      name: 'Trash'
    }];

    return{
      getTabs : function(){
        return tabs
      },
      getMessagesByLabel : function(label){
        return messages.filter(function(m){
          return m.labels.indexOf(label) != -1;
        });
      },
      getMessageById : function(id){
        return messages.filter(function(m){
          return m.id == id;
        })[0];
      }
    }

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.components.timeline')
      .controller('TimelineCtrl', TimelineCtrl);

  /** @ngInject */
  function TimelineCtrl() {
    var timelineBlocks = $('.cd-timeline-block'),
        offset = 0.8;

    //hide timeline blocks which are outside the viewport
    hideBlocks(timelineBlocks, offset);

    //on scolling, show/animate timeline blocks when enter the viewport
    $(window).on('scroll', function () {
      if (!window.requestAnimationFrame) {
        setTimeout(function () {
          showBlocks(timelineBlocks, offset);
        }, 100);
      } else {
        window.requestAnimationFrame(function () {
          showBlocks(timelineBlocks, offset);
        });
      }
    });

    function hideBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top > $(window).scrollTop() + $(window).height() * offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
      });
    }

    function showBlocks(blocks, offset) {
      blocks.each(function () {
        ( $(this).offset().top <= $(window).scrollTop() + $(window).height() * offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
      });
    }
  }
})();

/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.components.tree')
    .controller('treeCtrl', treeCtrl);

  /** @ngInject */
  function treeCtrl($scope, $timeout) {

    $scope.ignoreChanges = false;
    var newId = 0;
    $scope.ignoreChanges = false;
    $scope.newNode = {};

    $scope.basicConfig = {
      core: {
        multiple: false,
        check_callback: true,
        worker: true
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      'plugins': ['types'],
      'version': 1
    };

    $scope.dragConfig = {
      'core': {
        'check_callback': true,
        'themes': {
          'responsive': false
        }
      },
      'types': {
        'folder': {
          'icon': 'ion-ios-folder'
        },
        'default': {
          'icon': 'ion-document-text'
        }
      },
      "plugins": ["dnd", 'types']
    };

    $scope.addNewNode = function () {
      $scope.ignoreChanges = true;
      var selected = this.basicTree.jstree(true).get_selected()[0];
      if (selected)
        $scope.treeData.push({
          id: (newId++).toString(),
          parent: selected,
          text: "New node " + newId,
          state: {opened: true}
        });
      $scope.basicConfig.version++;
    };


    $scope.refresh = function () {
      $scope.ignoreChanges = true;
      newId = 0;
      $scope.treeData = getDefaultData();
      $scope.basicConfig.version++;
    };

    $scope.expand = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = true;
      });
      $scope.basicConfig.version++;
    };

    $scope.collapse = function () {
      $scope.ignoreChanges = true;
      $scope.treeData.forEach(function (n) {
        n.state.opened = false;
      });
      $scope.basicConfig.version++;
    };

    $scope.readyCB = function() {
      $timeout(function() {
        $scope.ignoreChanges = false;
      });
    };


    $scope.applyModelChanges = function() {
      return !$scope.ignoreChanges;
    };

    $scope.treeData = getDefaultData();
    $scope.dragData = [
      {
        "id": "nd1",
        "parent": "#",
        "type": "folder",
        "text": "Node 1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd2",
        "parent": "#",
        "type": "folder",
        "text": "Node 2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd3",
        "parent": "#",
        "type": "folder",
        "text": "Node 3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd4",
        "parent": "#",
        "type": "folder",
        "text": "Node 4",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd5",
        "parent": "nd1",
        "text": "Node 1.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd6",
        "parent": "nd1",
        "text": "Node 1.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd7",
        "parent": "nd1",
        "text": "Node 1.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd8",
        "parent": "nd2",
        "text": "Node 2.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd9",
        "parent": "nd2",
        "text": "Node 2.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd10",
        "parent": "nd2",
        "text": "Node 2.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd11",
        "parent": "nd3",
        "text": "Node 3.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd12",
        "parent": "nd3",
        "text": "Node 3.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd13",
        "parent": "nd3",
        "text": "Node 3.3",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd14",
        "parent": "nd4",
        "text": "Node 4.1",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd15",
        "parent": "nd4",
        "text": "Node 4.2",
        "state": {
          "opened": true
        }
      },
      {
        "id": "nd16",
        "parent": "nd4",
        "text": "Node 4.3",
        "state": {
          "opened": true
        }
      }
    ];

    function getDefaultData() {
      return [
        {
          "id": "n1",
          "parent": "#",
          "type": "folder",
          "text": "Node 1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n2",
          "parent": "#",
          "type": "folder",
          "text": "Node 2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n3",
          "parent": "#",
          "type": "folder",
          "text": "Node 3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n5",
          "parent": "n1",
          "text": "Node 1.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n6",
          "parent": "n1",
          "text": "Node 1.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n7",
          "parent": "n1",
          "text": "Node 1.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n8",
          "parent": "n1",
          "text": "Node 1.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n9",
          "parent": "n2",
          "text": "Node 2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n10",
          "parent": "n2",
          "text": "Node 2.2 (Custom icon)",
          "icon": "ion-help-buoy",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n12",
          "parent": "n3",
          "text": "Node 3.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n13",
          "parent": "n3",
          "type": "folder",
          "text": "Node 3.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n14",
          "parent": "n13",
          "text": "Node 3.2.1",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n15",
          "parent": "n13",
          "text": "Node 3.2.2",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n16",
          "parent": "n3",
          "text": "Node 3.3",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n17",
          "parent": "n3",
          "text": "Node 3.4",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n18",
          "parent": "n3",
          "text": "Node 3.5",
          "state": {
            "opened": true
          }
        },
        {
          "id": "n19",
          "parent": "n3",
          "text": "Node 3.6",
          "state": {
            "opened": true
          }
        }
      ]
    }


  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .controller('BlurFeedCtrl', BlurFeedCtrl);

  /** @ngInject */
  function BlurFeedCtrl($scope) {
    $scope.feed = [
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Guys, check this out: \nA police officer found a perfect hiding place for watching for speeding motorists. One day, the officer was amazed when everyone was under the speed limit, so he investigated and found the problem. A 10 years old boy was standing on the side of the road with a huge hand painted sign which said "Radar Trap Ahead." A little more investigative work led the officer to the boy\'s accomplice: another boy about 100 yards beyond the radar trap with a sign reading "TIPS" and a bucket at his feet full of change.',
        time: 'Today 11:55 pm',
        ago: '25 minutes ago',
        expanded: false,
      }, {
        type: 'video-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Added new video',
        text: '"Vader and Me"',
        preview: 'app/feed/vader-and-me-preview.png',
        link: 'https://www.youtube.com/watch?v=IfcpzBbbamk',
        time: 'Today 9:30 pm',
        ago: '3 hrs ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Added new image',
        text: '"My little kitten"',
        preview: 'app/feed/my-little-kitten.png',
        link: 'http://api.ning.com/files/DtcI2O2Ry7A7VhVxeiWfGU9WkHcMy4WSTWZ79oxJq*h0iXvVGndfD7CIYy-Ax-UAFCBCdqXI4GCBw3FOLKTTjQc*2cmpdOXJ/1082127884.jpeg',
        time: 'Today 2:20 pm',
        ago: '10 hrs ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'Haha lol',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'geo-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted location',
        text: '"New York, USA"',
        preview: 'app/feed/new-york-location.png',
        link: 'https://www.google.by/maps/place/New+York,+NY,+USA/@40.7201111,-73.9893872,14z',
        time: '11.11.2015',
        ago: '2 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Vlad',
        surname: 'Lugovsky',
        header: 'Posted new message',
        text: "First snake: I hope I'm not poisonous. Second snake: Why? First snake: Because I bit my lip!",
        time: '12.11.2015',
        ago: '3 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Andrey',
        surname: 'Hrabouski',
        header: 'Posted new message',
        text: 'How do you smuggle an elephant across the border? Put a slice of bread on each side, and call him "lunch".',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Nasta',
        surname: 'Linnie',
        header: 'Posted new message',
        text: 'When your hammer is C++, everything begins to look like a thumb.',
        time: '14.11.2015',
        ago: '5 days ago',
        expanded: false,
      }, {
        type: 'text-message',
        author: 'Alexander',
        surname: 'Demeshko',
        header: 'Posted new message',
        text: '“I mean, they say you die twice. One time when you stop breathing and a second time, a bit later on, when somebody says your name for the last time." ©',
        time: '15.11.2015',
        ago: '6 days ago',
        expanded: false,
      }, {
        type: 'image-message',
        author: 'Nick',
        surname: 'Cat',
        header: 'Posted photo',
        text: '"Protein Heroes"',
        preview: 'app/feed/genom.png',
        link: 'https://dribbble.com/shots/2504810-Protein-Heroes',
        time: '16.11.2015',
        ago: '7 days ago',
        expanded: false,
      },
      {
        type: 'text-message',
        author: 'Kostya',
        surname: 'Danovsky',
        header: 'Posted new message',
        text: 'Why did the CoffeeScript developer keep getting lost? Because he couldn\'t find his source without a map',
        time: '18.11.2015',
        ago: '9 days ago',
        expanded: false,
      }
    ];

    $scope.expandMessage = function(message){
      message.expanded = !message.expanded;
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .directive('blurFeed', blurFeed);

  /** @ngInject */
  function blurFeed() {
    return {
      restrict: 'E',
      controller: 'BlurFeedCtrl',
      templateUrl: 'app/pages/dashboard/blurFeed/blurFeed.html'
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .service('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {

  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    var dashboardColors = baConfig.colors.dashboard;
    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      defaultDate: '2016-03-08',
      selectable: true,
      selectHelper: true,
      select: function (start, end) {
        var title = prompt('Event Title:');
        var eventData;
        if (title) {
          eventData = {
            title: title,
            start: start,
            end: end
          };
          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
        }
        $element.fullCalendar('unselect');
      },
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      events: [
        {
          title: 'All Day Event',
          start: '2016-03-01',
          color: dashboardColors.silverTree
        },
        {
          title: 'Long Event',
          start: '2016-03-07',
          end: '2016-03-10',
          color: dashboardColors.blueStone
        },
        {
          title: 'Dinner',
          start: '2016-03-14T20:00:00',
          color: dashboardColors.surfieGreen
        },
        {
          title: 'Birthday Party',
          start: '2016-04-01T07:00:00',
          color: dashboardColors.gossipDark
        }
      ]
    });
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/pages/dashboard/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'MM YYYY',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'MM YYYY',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var map = AmCharts.makeChart('amChartMap', {
      type: 'map',
      theme: 'blur',
      zoomControl: { zoomControlEnabled: false, panControlEnabled: false },

      dataProvider: {
        map: 'worldLow',
        zoomLevel: 3.5,
        zoomLongitude: 10,
        zoomLatitude: 52,
        areas: [
          { title: 'Austria', id: 'AT', color: layoutColors.primary, customData: '1 244', groupId: '1'},
          { title: 'Ireland', id: 'IE', color: layoutColors.primary, customData: '1 342', groupId: '1'},
          { title: 'Denmark', id: 'DK', color: layoutColors.primary, customData: '1 973', groupId: '1'},
          { title: 'Finland', id: 'FI', color: layoutColors.primary, customData: '1 573', groupId: '1'},
          { title: 'Sweden', id: 'SE', color: layoutColors.primary, customData: '1 084', groupId: '1'},
          { title: 'Great Britain', id: 'GB', color: layoutColors.primary, customData: '1 452', groupId: '1'},
          { title: 'Italy', id: 'IT', color: layoutColors.primary, customData: '1 321', groupId: '1'},
          { title: 'France', id: 'FR', color: layoutColors.primary, customData: '1 112', groupId: '1'},
          { title: 'Spain', id: 'ES', color: layoutColors.primary, customData: '1 865', groupId: '1'},
          { title: 'Greece', id: 'GR', color: layoutColors.primary, customData: '1 453', groupId: '1'},
          { title: 'Germany', id: 'DE', color: layoutColors.primary, customData: '1 957', groupId: '1'},
          { title: 'Belgium', id: 'BE', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Luxembourg', id: 'LU', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Netherlands', id: 'NL', color: layoutColors.primary, customData: '1 213', groupId: '1'},
          { title: 'Portugal', id: 'PT', color: layoutColors.primary, customData: '1 291', groupId: '1'},
          { title: 'Lithuania', id: 'LT', color: layoutColors.successLight, customData: '567', groupId: '2'},
          { title: 'Latvia', id: 'LV', color: layoutColors.successLight, customData: '589', groupId: '2'},
          { title: 'Czech Republic ', id: 'CZ', color: layoutColors.successLight, customData: '785', groupId: '2'},
          { title: 'Slovakia', id: 'SK', color: layoutColors.successLight, customData: '965', groupId: '2'},
          { title: 'Estonia', id: 'EE', color: layoutColors.successLight, customData: '685', groupId: '2'},
          { title: 'Hungary', id: 'HU', color: layoutColors.successLight, customData: '854', groupId: '2'},
          { title: 'Cyprus', id: 'CY', color: layoutColors.successLight, customData: '754', groupId: '2'},
          { title: 'Malta', id: 'MT', color: layoutColors.successLight, customData: '867', groupId: '2'},
          { title: 'Poland', id: 'PL', color: layoutColors.successLight, customData: '759', groupId: '2'},
          { title: 'Romania', id: 'RO', color: layoutColors.success, customData: '302', groupId: '3'},
          { title: 'Bulgaria', id: 'BG', color: layoutColors.success, customData: '102', groupId: '3'},
          { title: 'Slovenia', id: 'SI', color: layoutColors.danger, customData: '23', groupId: '4'},
          { title: 'Croatia', id: 'HR', color: layoutColors.danger, customData: '96', groupId: '4'}
        ]
      },

      areasSettings: {
        rollOverOutlineColor: layoutColors.border,
        rollOverColor: layoutColors.primaryDark,
        alpha: 0.8,
        unlistedAreasAlpha: 0.2,
        unlistedAreasColor: layoutColors.defaultText,
        balloonText: '[[title]]: [[customData]] users'
      },


      legend: {
        width: '100%',
        marginRight: 27,
        marginLeft: 27,
        equalWidths: false,
        backgroundAlpha: 0.3,
        backgroundColor: layoutColors.border,
        borderColor: layoutColors.border,
        borderAlpha: 1,
        top: 362,
        left: 0,
        horizontalGap: 10,
        data: [
          {
            title: 'over 1 000 users',
            color: layoutColors.primary
          },
          {
            title: '500 - 1 000 users',
            color: layoutColors.successLight
          },
          {
            title: '100 - 500 users',
            color: layoutColors.success
          },
          {
            title: '0 - 100 users',
            color: layoutColors.danger
          }
        ]
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/dashboard/dashboardMap/dashboardMap.html'
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

  /** @ngInject */
  function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.charts = [{
      color: pieColor,
      description: 'New Visits',
      stats: '57,820',
      icon: 'person',
    }, {
      color: pieColor,
      description: 'Purchases',
      stats: '$ 89,745',
      icon: 'money',
    }, {
      color: pieColor,
      description: 'Active Users',
      stats: '178,391',
      icon: 'face',
    }, {
      color: pieColor,
      description: 'Returned',
      stats: '32,592',
      icon: 'refresh',
    }
    ];

    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }

    function loadPieCharts() {
      $('.chart').each(function () {
        var chart = $(this);
        chart.easyPieChart({
          easing: 'easeOutBounce',
          onStep: function (from, to, percent) {
            $(this.el).find('.percent').text(Math.round(percent));
          },
          barColor: chart.attr('rel'),
          trackColor: 'rgba(0,0,0,0)',
          size: 84,
          scaleLength: 0,
          animation: 2000,
          lineWidth: 9,
          lineCap: 'round',
        });
      });

      $('.refresh-data').on('click', function () {
        updatePieCharts();
      });
    }

    function updatePieCharts() {
      $('.pie-charts .chart').each(function(index, chart) {
        $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
      });
    }

    $timeout(function () {
      loadPieCharts();
      updatePieCharts();
    }, 1000);
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/dashboard/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/pages/dashboard/dashboardTodo/dashboardTodo.html'
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .directive('popularApp', popularApp);

  /** @ngInject */
  function popularApp() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/dashboard/popularApp/popularApp.html'
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

      $scope.transparent = baConfig.theme.blur;
      var dashboardColors = baConfig.colors.dashboard;
      $scope.doughnutData = {
          labels: [
              'Other',
              'Search engines',
              'Referral Traffic',
              'Direct Traffic',
              'Ad Campaigns'
          ],
          datasets: [
              {
                  data: [2000, 1500, 1000, 1200, 400],
                  backgroundColor: [
                      dashboardColors.white,
                      dashboardColors.blueStone,
                      dashboardColors.surfieGreen,
                      dashboardColors.silverTree,
                      dashboardColors.gossip

                  ],
                  hoverBackgroundColor: [
                      colorHelper.shade(dashboardColors.white, 15),
                      colorHelper.shade(dashboardColors.blueStone, 15),
                      colorHelper.shade(dashboardColors.surfieGreen, 15),
                      colorHelper.shade(dashboardColors.silverTree, 15),
                      colorHelper.shade(dashboardColors.gossip, 15)
                  ],
                  percentage: [87, 22, 70, 38, 17]
              }]
      };

      var ctx = document.getElementById('chart-area').getContext('2d');
      window.myDoughnut = new Chart(ctx, {
          type: 'doughnut',
          data: $scope.doughnutData,
          options: {
              cutoutPercentage: 64,
              responsive: true,
              elements: {
                  arc: {
                      borderWidth: 0
                  }
              }
          }
      });
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/dashboard/trafficChart/trafficChart.html'
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.dashboard')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/dashboard/weather/weather.html'
    };
  }
})();

(function () {
  'use strict';

  angular.module('Merchant.pages.form')
      .controller('WizardCtrl', WizardCtrl);

  /** @ngInject */
  function WizardCtrl($scope) {
   var vm = this;

    vm.personalInfo = {};
    vm.productInfo = {};
    vm.shipment = {};

    vm.arePersonalInfoPasswordsEqual = function () {
      return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
    };
  }

})();


/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
    angular.module('Merchant.pages.mangevendor')
        .controller('messagePageCtrl', messagePageCtrl);
    /** @ngInject */
    function messagePageCtrl($state) {
        $state.go('mangevendor.details')
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
    angular.module('Merchant.pages.mangevendor')
        .controller('outletPageCtrl', outletPageCtrl);
    /** @ngInject */
    function outletPageCtrl($state, $scope) {
        $state.go('mangevendor.outlet');
        $scope.sortBy = [{
            name: "NAME",
            value: "NAME"
          },
          {
            name: "AMOUNT",
            value: "AMOUNT"
          },
          {
            name: "STATUS",
            value: "STATUS"
          }
          ];
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
    angular.module('Merchant.pages.mangevendor')
        .controller('vendordetailsPageCtrl', vendordetailsPageCtrl);
    /** @ngInject */
    function vendordetailsPageCtrl($state,  $scope) {
        $scope.sortBy = [{
            name: "NAME",
            value: "NAME"
          },
          {
            name: "AMOUNT",
            value: "AMOUNT"
          },
          {
            name: "STATUS",
            value: "STATUS"
          }
          ];
        // $state.go('mangevendor.vendordetails')
    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.maps')
      .controller('GmapPageCtrl', GmapPageCtrl);

  /** @ngInject */
  function GmapPageCtrl($timeout) {
    function initialize() {
      var mapCanvas = document.getElementById('google-maps');
      var mapOptions = {
        center: new google.maps.LatLng(44.5403, -78.5463),
        zoom: 8,
        mapTypeId: google.maps.MapTypeId.ROADMAP
      };
      var map = new google.maps.Map(mapCanvas, mapOptions);
    }

    $timeout(function(){
      initialize();
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.maps')
      .controller('LeafletPageCtrl', LeafletPageCtrl);

  /** @ngInject */
  function LeafletPageCtrl($timeout) {
    function initialize() {
      L.Icon.Default.imagePath = 'assets/img/theme/vendor/leaflet/dist/images';
      var map = L.map(document.getElementById('leaflet-map')).setView([51.505, -0.09], 13);
      L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
      }).addTo(map);

      L.marker([51.5, -0.09]).addTo(map)
          .bindPopup('A pretty CSS3 popup.<br> Easily customizable.')
          .openPopup();
    }

    $timeout(function(){
      initialize();
    }, 100);

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.maps')
      .controller('MapBubblePageCtrl', MapBubblePageCtrl);

  /** @ngInject */
  function MapBubblePageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    var latlong = {};
    latlong['AD'] = {'latitude': 42.5, 'longitude': 1.5};
    latlong['AE'] = {'latitude': 24, 'longitude': 54};
    latlong['AF'] = {'latitude': 33, 'longitude': 65};
    latlong['AG'] = {'latitude': 17.05, 'longitude': -61.8};
    latlong['AI'] = {'latitude': 18.25, 'longitude': -63.1667};
    latlong['AL'] = {'latitude': 41, 'longitude': 20};
    latlong['AM'] = {'latitude': 40, 'longitude': 45};
    latlong['AN'] = {'latitude': 12.25, 'longitude': -68.75};
    latlong['AO'] = {'latitude': -12.5, 'longitude': 18.5};
    latlong['AP'] = {'latitude': 35, 'longitude': 105};
    latlong['AQ'] = {'latitude': -90, 'longitude': 0};
    latlong['AR'] = {'latitude': -34, 'longitude': -64};
    latlong['AS'] = {'latitude': -14.3333, 'longitude': -170};
    latlong['AT'] = {'latitude': 47.3333, 'longitude': 13.3333};
    latlong['AU'] = {'latitude': -27, 'longitude': 133};
    latlong['AW'] = {'latitude': 12.5, 'longitude': -69.9667};
    latlong['AZ'] = {'latitude': 40.5, 'longitude': 47.5};
    latlong['BA'] = {'latitude': 44, 'longitude': 18};
    latlong['BB'] = {'latitude': 13.1667, 'longitude': -59.5333};
    latlong['BD'] = {'latitude': 24, 'longitude': 90};
    latlong['BE'] = {'latitude': 50.8333, 'longitude': 4};
    latlong['BF'] = {'latitude': 13, 'longitude': -2};
    latlong['BG'] = {'latitude': 43, 'longitude': 25};
    latlong['BH'] = {'latitude': 26, 'longitude': 50.55};
    latlong['BI'] = {'latitude': -3.5, 'longitude': 30};
    latlong['BJ'] = {'latitude': 9.5, 'longitude': 2.25};
    latlong['BM'] = {'latitude': 32.3333, 'longitude': -64.75};
    latlong['BN'] = {'latitude': 4.5, 'longitude': 114.6667};
    latlong['BO'] = {'latitude': -17, 'longitude': -65};
    latlong['BR'] = {'latitude': -10, 'longitude': -55};
    latlong['BS'] = {'latitude': 24.25, 'longitude': -76};
    latlong['BT'] = {'latitude': 27.5, 'longitude': 90.5};
    latlong['BV'] = {'latitude': -54.4333, 'longitude': 3.4};
    latlong['BW'] = {'latitude': -22, 'longitude': 24};
    latlong['BY'] = {'latitude': 53, 'longitude': 28};
    latlong['BZ'] = {'latitude': 17.25, 'longitude': -88.75};
    latlong['CA'] = {'latitude': 54, 'longitude': -100};
    latlong['CC'] = {'latitude': -12.5, 'longitude': 96.8333};
    latlong['CD'] = {'latitude': 0, 'longitude': 25};
    latlong['CF'] = {'latitude': 7, 'longitude': 21};
    latlong['CG'] = {'latitude': -1, 'longitude': 15};
    latlong['CH'] = {'latitude': 47, 'longitude': 8};
    latlong['CI'] = {'latitude': 8, 'longitude': -5};
    latlong['CK'] = {'latitude': -21.2333, 'longitude': -159.7667};
    latlong['CL'] = {'latitude': -30, 'longitude': -71};
    latlong['CM'] = {'latitude': 6, 'longitude': 12};
    latlong['CN'] = {'latitude': 35, 'longitude': 105};
    latlong['CO'] = {'latitude': 4, 'longitude': -72};
    latlong['CR'] = {'latitude': 10, 'longitude': -84};
    latlong['CU'] = {'latitude': 21.5, 'longitude': -80};
    latlong['CV'] = {'latitude': 16, 'longitude': -24};
    latlong['CX'] = {'latitude': -10.5, 'longitude': 105.6667};
    latlong['CY'] = {'latitude': 35, 'longitude': 33};
    latlong['CZ'] = {'latitude': 49.75, 'longitude': 15.5};
    latlong['DE'] = {'latitude': 51, 'longitude': 9};
    latlong['DJ'] = {'latitude': 11.5, 'longitude': 43};
    latlong['DK'] = {'latitude': 56, 'longitude': 10};
    latlong['DM'] = {'latitude': 15.4167, 'longitude': -61.3333};
    latlong['DO'] = {'latitude': 19, 'longitude': -70.6667};
    latlong['DZ'] = {'latitude': 28, 'longitude': 3};
    latlong['EC'] = {'latitude': -2, 'longitude': -77.5};
    latlong['EE'] = {'latitude': 59, 'longitude': 26};
    latlong['EG'] = {'latitude': 27, 'longitude': 30};
    latlong['EH'] = {'latitude': 24.5, 'longitude': -13};
    latlong['ER'] = {'latitude': 15, 'longitude': 39};
    latlong['ES'] = {'latitude': 40, 'longitude': -4};
    latlong['ET'] = {'latitude': 8, 'longitude': 38};
    latlong['EU'] = {'latitude': 47, 'longitude': 8};
    latlong['FI'] = {'latitude': 62, 'longitude': 26};
    latlong['FJ'] = {'latitude': -18, 'longitude': 175};
    latlong['FK'] = {'latitude': -51.75, 'longitude': -59};
    latlong['FM'] = {'latitude': 6.9167, 'longitude': 158.25};
    latlong['FO'] = {'latitude': 62, 'longitude': -7};
    latlong['FR'] = {'latitude': 46, 'longitude': 2};
    latlong['GA'] = {'latitude': -1, 'longitude': 11.75};
    latlong['GB'] = {'latitude': 54, 'longitude': -2};
    latlong['GD'] = {'latitude': 12.1167, 'longitude': -61.6667};
    latlong['GE'] = {'latitude': 42, 'longitude': 43.5};
    latlong['GF'] = {'latitude': 4, 'longitude': -53};
    latlong['GH'] = {'latitude': 8, 'longitude': -2};
    latlong['GI'] = {'latitude': 36.1833, 'longitude': -5.3667};
    latlong['GL'] = {'latitude': 72, 'longitude': -40};
    latlong['GM'] = {'latitude': 13.4667, 'longitude': -16.5667};
    latlong['GN'] = {'latitude': 11, 'longitude': -10};
    latlong['GP'] = {'latitude': 16.25, 'longitude': -61.5833};
    latlong['GQ'] = {'latitude': 2, 'longitude': 10};
    latlong['GR'] = {'latitude': 39, 'longitude': 22};
    latlong['GS'] = {'latitude': -54.5, 'longitude': -37};
    latlong['GT'] = {'latitude': 15.5, 'longitude': -90.25};
    latlong['GU'] = {'latitude': 13.4667, 'longitude': 144.7833};
    latlong['GW'] = {'latitude': 12, 'longitude': -15};
    latlong['GY'] = {'latitude': 5, 'longitude': -59};
    latlong['HK'] = {'latitude': 22.25, 'longitude': 114.1667};
    latlong['HM'] = {'latitude': -53.1, 'longitude': 72.5167};
    latlong['HN'] = {'latitude': 15, 'longitude': -86.5};
    latlong['HR'] = {'latitude': 45.1667, 'longitude': 15.5};
    latlong['HT'] = {'latitude': 19, 'longitude': -72.4167};
    latlong['HU'] = {'latitude': 47, 'longitude': 20};
    latlong['ID'] = {'latitude': -5, 'longitude': 120};
    latlong['IE'] = {'latitude': 53, 'longitude': -8};
    latlong['IL'] = {'latitude': 31.5, 'longitude': 34.75};
    latlong['IN'] = {'latitude': 20, 'longitude': 77};
    latlong['IO'] = {'latitude': -6, 'longitude': 71.5};
    latlong['IQ'] = {'latitude': 33, 'longitude': 44};
    latlong['IR'] = {'latitude': 32, 'longitude': 53};
    latlong['IS'] = {'latitude': 65, 'longitude': -18};
    latlong['IT'] = {'latitude': 42.8333, 'longitude': 12.8333};
    latlong['JM'] = {'latitude': 18.25, 'longitude': -77.5};
    latlong['JO'] = {'latitude': 31, 'longitude': 36};
    latlong['JP'] = {'latitude': 36, 'longitude': 138};
    latlong['KE'] = {'latitude': 1, 'longitude': 38};
    latlong['KG'] = {'latitude': 41, 'longitude': 75};
    latlong['KH'] = {'latitude': 13, 'longitude': 105};
    latlong['KI'] = {'latitude': 1.4167, 'longitude': 173};
    latlong['KM'] = {'latitude': -12.1667, 'longitude': 44.25};
    latlong['KN'] = {'latitude': 17.3333, 'longitude': -62.75};
    latlong['KP'] = {'latitude': 40, 'longitude': 127};
    latlong['KR'] = {'latitude': 37, 'longitude': 127.5};
    latlong['KW'] = {'latitude': 29.3375, 'longitude': 47.6581};
    latlong['KY'] = {'latitude': 19.5, 'longitude': -80.5};
    latlong['KZ'] = {'latitude': 48, 'longitude': 68};
    latlong['LA'] = {'latitude': 18, 'longitude': 105};
    latlong['LB'] = {'latitude': 33.8333, 'longitude': 35.8333};
    latlong['LC'] = {'latitude': 13.8833, 'longitude': -61.1333};
    latlong['LI'] = {'latitude': 47.1667, 'longitude': 9.5333};
    latlong['LK'] = {'latitude': 7, 'longitude': 81};
    latlong['LR'] = {'latitude': 6.5, 'longitude': -9.5};
    latlong['LS'] = {'latitude': -29.5, 'longitude': 28.5};
    latlong['LT'] = {'latitude': 55, 'longitude': 24};
    latlong['LU'] = {'latitude': 49.75, 'longitude': 6};
    latlong['LV'] = {'latitude': 57, 'longitude': 25};
    latlong['LY'] = {'latitude': 25, 'longitude': 17};
    latlong['MA'] = {'latitude': 32, 'longitude': -5};
    latlong['MC'] = {'latitude': 43.7333, 'longitude': 7.4};
    latlong['MD'] = {'latitude': 47, 'longitude': 29};
    latlong['ME'] = {'latitude': 42.5, 'longitude': 19.4};
    latlong['MG'] = {'latitude': -20, 'longitude': 47};
    latlong['MH'] = {'latitude': 9, 'longitude': 168};
    latlong['MK'] = {'latitude': 41.8333, 'longitude': 22};
    latlong['ML'] = {'latitude': 17, 'longitude': -4};
    latlong['MM'] = {'latitude': 22, 'longitude': 98};
    latlong['MN'] = {'latitude': 46, 'longitude': 105};
    latlong['MO'] = {'latitude': 22.1667, 'longitude': 113.55};
    latlong['MP'] = {'latitude': 15.2, 'longitude': 145.75};
    latlong['MQ'] = {'latitude': 14.6667, 'longitude': -61};
    latlong['MR'] = {'latitude': 20, 'longitude': -12};
    latlong['MS'] = {'latitude': 16.75, 'longitude': -62.2};
    latlong['MT'] = {'latitude': 35.8333, 'longitude': 14.5833};
    latlong['MU'] = {'latitude': -20.2833, 'longitude': 57.55};
    latlong['MV'] = {'latitude': 3.25, 'longitude': 73};
    latlong['MW'] = {'latitude': -13.5, 'longitude': 34};
    latlong['MX'] = {'latitude': 23, 'longitude': -102};
    latlong['MY'] = {'latitude': 2.5, 'longitude': 112.5};
    latlong['MZ'] = {'latitude': -18.25, 'longitude': 35};
    latlong['NA'] = {'latitude': -22, 'longitude': 17};
    latlong['NC'] = {'latitude': -21.5, 'longitude': 165.5};
    latlong['NE'] = {'latitude': 16, 'longitude': 8};
    latlong['NF'] = {'latitude': -29.0333, 'longitude': 167.95};
    latlong['NG'] = {'latitude': 10, 'longitude': 8};
    latlong['NI'] = {'latitude': 13, 'longitude': -85};
    latlong['NL'] = {'latitude': 52.5, 'longitude': 5.75};
    latlong['NO'] = {'latitude': 62, 'longitude': 10};
    latlong['NP'] = {'latitude': 28, 'longitude': 84};
    latlong['NR'] = {'latitude': -0.5333, 'longitude': 166.9167};
    latlong['NU'] = {'latitude': -19.0333, 'longitude': -169.8667};
    latlong['NZ'] = {'latitude': -41, 'longitude': 174};
    latlong['OM'] = {'latitude': 21, 'longitude': 57};
    latlong['PA'] = {'latitude': 9, 'longitude': -80};
    latlong['PE'] = {'latitude': -10, 'longitude': -76};
    latlong['PF'] = {'latitude': -15, 'longitude': -140};
    latlong['PG'] = {'latitude': -6, 'longitude': 147};
    latlong['PH'] = {'latitude': 13, 'longitude': 122};
    latlong['PK'] = {'latitude': 30, 'longitude': 70};
    latlong['PL'] = {'latitude': 52, 'longitude': 20};
    latlong['PM'] = {'latitude': 46.8333, 'longitude': -56.3333};
    latlong['PR'] = {'latitude': 18.25, 'longitude': -66.5};
    latlong['PS'] = {'latitude': 32, 'longitude': 35.25};
    latlong['PT'] = {'latitude': 39.5, 'longitude': -8};
    latlong['PW'] = {'latitude': 7.5, 'longitude': 134.5};
    latlong['PY'] = {'latitude': -23, 'longitude': -58};
    latlong['QA'] = {'latitude': 25.5, 'longitude': 51.25};
    latlong['RE'] = {'latitude': -21.1, 'longitude': 55.6};
    latlong['RO'] = {'latitude': 46, 'longitude': 25};
    latlong['RS'] = {'latitude': 44, 'longitude': 21};
    latlong['RU'] = {'latitude': 60, 'longitude': 100};
    latlong['RW'] = {'latitude': -2, 'longitude': 30};
    latlong['SA'] = {'latitude': 25, 'longitude': 45};
    latlong['SB'] = {'latitude': -8, 'longitude': 159};
    latlong['SC'] = {'latitude': -4.5833, 'longitude': 55.6667};
    latlong['SD'] = {'latitude': 15, 'longitude': 30};
    latlong['SE'] = {'latitude': 62, 'longitude': 15};
    latlong['SG'] = {'latitude': 1.3667, 'longitude': 103.8};
    latlong['SH'] = {'latitude': -15.9333, 'longitude': -5.7};
    latlong['SI'] = {'latitude': 46, 'longitude': 15};
    latlong['SJ'] = {'latitude': 78, 'longitude': 20};
    latlong['SK'] = {'latitude': 48.6667, 'longitude': 19.5};
    latlong['SL'] = {'latitude': 8.5, 'longitude': -11.5};
    latlong['SM'] = {'latitude': 43.7667, 'longitude': 12.4167};
    latlong['SN'] = {'latitude': 14, 'longitude': -14};
    latlong['SO'] = {'latitude': 10, 'longitude': 49};
    latlong['SR'] = {'latitude': 4, 'longitude': -56};
    latlong['ST'] = {'latitude': 1, 'longitude': 7};
    latlong['SV'] = {'latitude': 13.8333, 'longitude': -88.9167};
    latlong['SY'] = {'latitude': 35, 'longitude': 38};
    latlong['SZ'] = {'latitude': -26.5, 'longitude': 31.5};
    latlong['TC'] = {'latitude': 21.75, 'longitude': -71.5833};
    latlong['TD'] = {'latitude': 15, 'longitude': 19};
    latlong['TF'] = {'latitude': -43, 'longitude': 67};
    latlong['TG'] = {'latitude': 8, 'longitude': 1.1667};
    latlong['TH'] = {'latitude': 15, 'longitude': 100};
    latlong['TJ'] = {'latitude': 39, 'longitude': 71};
    latlong['TK'] = {'latitude': -9, 'longitude': -172};
    latlong['TM'] = {'latitude': 40, 'longitude': 60};
    latlong['TN'] = {'latitude': 34, 'longitude': 9};
    latlong['TO'] = {'latitude': -20, 'longitude': -175};
    latlong['TR'] = {'latitude': 39, 'longitude': 35};
    latlong['TT'] = {'latitude': 11, 'longitude': -61};
    latlong['TV'] = {'latitude': -8, 'longitude': 178};
    latlong['TW'] = {'latitude': 23.5, 'longitude': 121};
    latlong['TZ'] = {'latitude': -6, 'longitude': 35};
    latlong['UA'] = {'latitude': 49, 'longitude': 32};
    latlong['UG'] = {'latitude': 1, 'longitude': 32};
    latlong['UM'] = {'latitude': 19.2833, 'longitude': 166.6};
    latlong['US'] = {'latitude': 38, 'longitude': -97};
    latlong['UY'] = {'latitude': -33, 'longitude': -56};
    latlong['UZ'] = {'latitude': 41, 'longitude': 64};
    latlong['VA'] = {'latitude': 41.9, 'longitude': 12.45};
    latlong['VC'] = {'latitude': 13.25, 'longitude': -61.2};
    latlong['VE'] = {'latitude': 8, 'longitude': -66};
    latlong['VG'] = {'latitude': 18.5, 'longitude': -64.5};
    latlong['VI'] = {'latitude': 18.3333, 'longitude': -64.8333};
    latlong['VN'] = {'latitude': 16, 'longitude': 106};
    latlong['VU'] = {'latitude': -16, 'longitude': 167};
    latlong['WF'] = {'latitude': -13.3, 'longitude': -176.2};
    latlong['WS'] = {'latitude': -13.5833, 'longitude': -172.3333};
    latlong['YE'] = {'latitude': 15, 'longitude': 48};
    latlong['YT'] = {'latitude': -12.8333, 'longitude': 45.1667};
    latlong['ZA'] = {'latitude': -29, 'longitude': 24};
    latlong['ZM'] = {'latitude': -15, 'longitude': 30};
    latlong['ZW'] = {'latitude': -20, 'longitude': 30};

    var mapData = [
      {'code': 'AF', 'name': 'Afghanistan', 'value': 32358260, 'color': layoutColors.primaryDark},
      {'code': 'AL', 'name': 'Albania', 'value': 3215988, 'color': layoutColors.warning},
      {'code': 'DZ', 'name': 'Algeria', 'value': 35980193, 'color': layoutColors.danger},
      {'code': 'AO', 'name': 'Angola', 'value': 19618432, 'color': layoutColors.danger},
      {'code': 'AR', 'name': 'Argentina', 'value': 40764561, 'color': layoutColors.success},
      {'code': 'AM', 'name': 'Armenia', 'value': 3100236, 'color': layoutColors.warning},
      {'code': 'AU', 'name': 'Australia', 'value': 22605732, 'color': layoutColors.warningDark},
      {'code': 'AT', 'name': 'Austria', 'value': 8413429, 'color': layoutColors.warning},
      {'code': 'AZ', 'name': 'Azerbaijan', 'value': 9306023, 'color': layoutColors.warning},
      {'code': 'BH', 'name': 'Bahrain', 'value': 1323535, 'color': layoutColors.primaryDark},
      {'code': 'BD', 'name': 'Bangladesh', 'value': 150493658, 'color': layoutColors.primaryDark},
      {'code': 'BY', 'name': 'Belarus', 'value': 9559441, 'color': layoutColors.warning},
      {'code': 'BE', 'name': 'Belgium', 'value': 10754056, 'color': layoutColors.warning},
      {'code': 'BJ', 'name': 'Benin', 'value': 9099922, 'color': layoutColors.danger},
      {'code': 'BT', 'name': 'Bhutan', 'value': 738267, 'color': layoutColors.primaryDark},
      {'code': 'BO', 'name': 'Bolivia', 'value': 10088108, 'color': layoutColors.success},
      {'code': 'BA', 'name': 'Bosnia and Herzegovina', 'value': 3752228, 'color': layoutColors.warning},
      {'code': 'BW', 'name': 'Botswana', 'value': 2030738, 'color': layoutColors.danger},
      {'code': 'BR', 'name': 'Brazil', 'value': 196655014, 'color': layoutColors.success},
      {'code': 'BN', 'name': 'Brunei', 'value': 405938, 'color': layoutColors.primaryDark},
      {'code': 'BG', 'name': 'Bulgaria', 'value': 7446135, 'color': layoutColors.warning},
      {'code': 'BF', 'name': 'Burkina Faso', 'value': 16967845, 'color': layoutColors.danger},
      {'code': 'BI', 'name': 'Burundi', 'value': 8575172, 'color': layoutColors.danger},
      {'code': 'KH', 'name': 'Cambodia', 'value': 14305183, 'color': layoutColors.primaryDark},
      {'code': 'CM', 'name': 'Cameroon', 'value': 20030362, 'color': layoutColors.danger},
      {'code': 'CA', 'name': 'Canada', 'value': 34349561, 'color': layoutColors.primary},
      {'code': 'CV', 'name': 'Cape Verde', 'value': 500585, 'color': layoutColors.danger},
      {'code': 'CF', 'name': 'Central African Rep.', 'value': 4486837, 'color': layoutColors.danger},
      {'code': 'TD', 'name': 'Chad', 'value': 11525496, 'color': layoutColors.danger},
      {'code': 'CL', 'name': 'Chile', 'value': 17269525, 'color': layoutColors.success},
      {'code': 'CN', 'name': 'China', 'value': 1347565324, 'color': layoutColors.primaryDark},
      {'code': 'CO', 'name': 'Colombia', 'value': 46927125, 'color': layoutColors.success},
      {'code': 'KM', 'name': 'Comoros', 'value': 753943, 'color': layoutColors.danger},
      {'code': 'CD', 'name': 'Congo, Dem. Rep.', 'value': 67757577, 'color': layoutColors.danger},
      {'code': 'CG', 'name': 'Congo, Rep.', 'value': 4139748, 'color': layoutColors.danger},
      {'code': 'CR', 'name': 'Costa Rica', 'value': 4726575, 'color': layoutColors.primary},
      {'code': 'CI', 'name': 'Cote d\'Ivoire', 'value': 20152894, 'color': layoutColors.danger},
      {'code': 'HR', 'name': 'Croatia', 'value': 4395560, 'color': layoutColors.warning},
      {'code': 'CU', 'name': 'Cuba', 'value': 11253665, 'color': layoutColors.primary},
      {'code': 'CY', 'name': 'Cyprus', 'value': 1116564, 'color': layoutColors.warning},
      {'code': 'CZ', 'name': 'Czech Rep.', 'value': 10534293, 'color': layoutColors.warning},
      {'code': 'DK', 'name': 'Denmark', 'value': 5572594, 'color': layoutColors.warning},
      {'code': 'DJ', 'name': 'Djibouti', 'value': 905564, 'color': layoutColors.danger},
      {'code': 'DO', 'name': 'Dominican Rep.', 'value': 10056181, 'color': layoutColors.primary},
      {'code': 'EC', 'name': 'Ecuador', 'value': 14666055, 'color': layoutColors.success},
      {'code': 'EG', 'name': 'Egypt', 'value': 82536770, 'color': layoutColors.danger},
      {'code': 'SV', 'name': 'El Salvador', 'value': 6227491, 'color': layoutColors.primary},
      {'code': 'GQ', 'name': 'Equatorial Guinea', 'value': 720213, 'color': layoutColors.danger},
      {'code': 'ER', 'name': 'Eritrea', 'value': 5415280, 'color': layoutColors.danger},
      {'code': 'EE', 'name': 'Estonia', 'value': 1340537, 'color': layoutColors.warning},
      {'code': 'ET', 'name': 'Ethiopia', 'value': 84734262, 'color': layoutColors.danger},
      {'code': 'FJ', 'name': 'Fiji', 'value': 868406, 'color': layoutColors.warningDark},
      {'code': 'FI', 'name': 'Finland', 'value': 5384770, 'color': layoutColors.warning},
      {'code': 'FR', 'name': 'France', 'value': 63125894, 'color': layoutColors.warning},
      {'code': 'GA', 'name': 'Gabon', 'value': 1534262, 'color': layoutColors.danger},
      {'code': 'GM', 'name': 'Gambia', 'value': 1776103, 'color': layoutColors.danger},
      {'code': 'GE', 'name': 'Georgia', 'value': 4329026, 'color': layoutColors.warning},
      {'code': 'DE', 'name': 'Germany', 'value': 82162512, 'color': layoutColors.warning},
      {'code': 'GH', 'name': 'Ghana', 'value': 24965816, 'color': layoutColors.danger},
      {'code': 'GR', 'name': 'Greece', 'value': 11390031, 'color': layoutColors.warning},
      {'code': 'GT', 'name': 'Guatemala', 'value': 14757316, 'color': layoutColors.primary},
      {'code': 'GN', 'name': 'Guinea', 'value': 10221808, 'color': layoutColors.danger},
      {'code': 'GW', 'name': 'Guinea-Bissau', 'value': 1547061, 'color': layoutColors.danger},
      {'code': 'GY', 'name': 'Guyana', 'value': 756040, 'color': layoutColors.success},
      {'code': 'HT', 'name': 'Haiti', 'value': 10123787, 'color': layoutColors.primary},
      {'code': 'HN', 'name': 'Honduras', 'value': 7754687, 'color': layoutColors.primary},
      {'code': 'HK', 'name': 'Hong Kong, China', 'value': 7122187, 'color': layoutColors.primaryDark},
      {'code': 'HU', 'name': 'Hungary', 'value': 9966116, 'color': layoutColors.warning},
      {'code': 'IS', 'name': 'Iceland', 'value': 324366, 'color': layoutColors.warning},
      {'code': 'IN', 'name': 'India', 'value': 1241491960, 'color': layoutColors.primaryDark},
      {'code': 'ID', 'name': 'Indonesia', 'value': 242325638, 'color': layoutColors.primaryDark},
      {'code': 'IR', 'name': 'Iran', 'value': 74798599, 'color': layoutColors.primaryDark},
      {'code': 'IQ', 'name': 'Iraq', 'value': 32664942, 'color': layoutColors.primaryDark},
      {'code': 'IE', 'name': 'Ireland', 'value': 4525802, 'color': layoutColors.warning},
      {'code': 'IL', 'name': 'Israel', 'value': 7562194, 'color': layoutColors.primaryDark},
      {'code': 'IT', 'name': 'Italy', 'value': 60788694, 'color': layoutColors.warning},
      {'code': 'JM', 'name': 'Jamaica', 'value': 2751273, 'color': layoutColors.primary},
      {'code': 'JP', 'name': 'Japan', 'value': 126497241, 'color': layoutColors.primaryDark},
      {'code': 'JO', 'name': 'Jordan', 'value': 6330169, 'color': layoutColors.primaryDark},
      {'code': 'KZ', 'name': 'Kazakhstan', 'value': 16206750, 'color': layoutColors.primaryDark},
      {'code': 'KE', 'name': 'Kenya', 'value': 41609728, 'color': layoutColors.danger},
      {'code': 'KP', 'name': 'Korea, Dem. Rep.', 'value': 24451285, 'color': layoutColors.primaryDark},
      {'code': 'KR', 'name': 'Korea, Rep.', 'value': 48391343, 'color': layoutColors.primaryDark},
      {'code': 'KW', 'name': 'Kuwait', 'value': 2818042, 'color': layoutColors.primaryDark},
      {'code': 'KG', 'name': 'Kyrgyzstan', 'value': 5392580, 'color': layoutColors.primaryDark},
      {'code': 'LA', 'name': 'Laos', 'value': 6288037, 'color': layoutColors.primaryDark},
      {'code': 'LV', 'name': 'Latvia', 'value': 2243142, 'color': layoutColors.warning},
      {'code': 'LB', 'name': 'Lebanon', 'value': 4259405, 'color': layoutColors.primaryDark},
      {'code': 'LS', 'name': 'Lesotho', 'value': 2193843, 'color': layoutColors.danger},
      {'code': 'LR', 'name': 'Liberia', 'value': 4128572, 'color': layoutColors.danger},
      {'code': 'LY', 'name': 'Libya', 'value': 6422772, 'color': layoutColors.danger},
      {'code': 'LT', 'name': 'Lithuania', 'value': 3307481, 'color': layoutColors.warning},
      {'code': 'LU', 'name': 'Luxembourg', 'value': 515941, 'color': layoutColors.warning},
      {'code': 'MK', 'name': 'Macedonia, FYR', 'value': 2063893, 'color': layoutColors.warning},
      {'code': 'MG', 'name': 'Madagascar', 'value': 21315135, 'color': layoutColors.danger},
      {'code': 'MW', 'name': 'Malawi', 'value': 15380888, 'color': layoutColors.danger},
      {'code': 'MY', 'name': 'Malaysia', 'value': 28859154, 'color': layoutColors.primaryDark},
      {'code': 'ML', 'name': 'Mali', 'value': 15839538, 'color': layoutColors.danger},
      {'code': 'MR', 'name': 'Mauritania', 'value': 3541540, 'color': layoutColors.danger},
      {'code': 'MU', 'name': 'Mauritius', 'value': 1306593, 'color': layoutColors.danger},
      {'code': 'MX', 'name': 'Mexico', 'value': 114793341, 'color': layoutColors.primary},
      {'code': 'MD', 'name': 'Moldova', 'value': 3544864, 'color': layoutColors.warning},
      {'code': 'MN', 'name': 'Mongolia', 'value': 2800114, 'color': layoutColors.primaryDark},
      {'code': 'ME', 'name': 'Montenegro', 'value': 632261, 'color': layoutColors.warning},
      {'code': 'MA', 'name': 'Morocco', 'value': 32272974, 'color': layoutColors.danger},
      {'code': 'MZ', 'name': 'Mozambique', 'value': 23929708, 'color': layoutColors.danger},
      {'code': 'MM', 'name': 'Myanmar', 'value': 48336763, 'color': layoutColors.primaryDark},
      {'code': 'NA', 'name': 'Namibia', 'value': 2324004, 'color': layoutColors.danger},
      {'code': 'NP', 'name': 'Nepal', 'value': 30485798, 'color': layoutColors.primaryDark},
      {'code': 'NL', 'name': 'Netherlands', 'value': 16664746, 'color': layoutColors.warning},
      {'code': 'NZ', 'name': 'New Zealand', 'value': 4414509, 'color': layoutColors.warningDark},
      {'code': 'NI', 'name': 'Nicaragua', 'value': 5869859, 'color': layoutColors.primary},
      {'code': 'NE', 'name': 'Niger', 'value': 16068994, 'color': layoutColors.danger},
      {'code': 'NG', 'name': 'Nigeria', 'value': 162470737, 'color': layoutColors.danger},
      {'code': 'NO', 'name': 'Norway', 'value': 4924848, 'color': layoutColors.warning},
      {'code': 'OM', 'name': 'Oman', 'value': 2846145, 'color': layoutColors.primaryDark},
      {'code': 'PK', 'name': 'Pakistan', 'value': 176745364, 'color': layoutColors.primaryDark},
      {'code': 'PA', 'name': 'Panama', 'value': 3571185, 'color': layoutColors.primary},
      {'code': 'PG', 'name': 'Papua New Guinea', 'value': 7013829, 'color': layoutColors.warningDark},
      {'code': 'PY', 'name': 'Paraguay', 'value': 6568290, 'color': layoutColors.success},
      {'code': 'PE', 'name': 'Peru', 'value': 29399817, 'color': layoutColors.success},
      {'code': 'PH', 'name': 'Philippines', 'value': 94852030, 'color': layoutColors.primaryDark},
      {'code': 'PL', 'name': 'Poland', 'value': 38298949, 'color': layoutColors.warning},
      {'code': 'PT', 'name': 'Portugal', 'value': 10689663, 'color': layoutColors.warning},
      {'code': 'PR', 'name': 'Puerto Rico', 'value': 3745526, 'color': layoutColors.primary},
      {'code': 'QA', 'name': 'Qatar', 'value': 1870041, 'color': layoutColors.primaryDark},
      {'code': 'RO', 'name': 'Romania', 'value': 21436495, 'color': layoutColors.warning},
      {'code': 'RU', 'name': 'Russia', 'value': 142835555, 'color': layoutColors.warning},
      {'code': 'RW', 'name': 'Rwanda', 'value': 10942950, 'color': layoutColors.danger},
      {'code': 'SA', 'name': 'Saudi Arabia', 'value': 28082541, 'color': layoutColors.primaryDark},
      {'code': 'SN', 'name': 'Senegal', 'value': 12767556, 'color': layoutColors.danger},
      {'code': 'RS', 'name': 'Serbia', 'value': 9853969, 'color': layoutColors.warning},
      {'code': 'SL', 'name': 'Sierra Leone', 'value': 5997486, 'color': layoutColors.danger},
      {'code': 'SG', 'name': 'Singapore', 'value': 5187933, 'color': layoutColors.primaryDark},
      {'code': 'SK', 'name': 'Slovak Republic', 'value': 5471502, 'color': layoutColors.warning},
      {'code': 'SI', 'name': 'Slovenia', 'value': 2035012, 'color': layoutColors.warning},
      {'code': 'SB', 'name': 'Solomon Islands', 'value': 552267, 'color': layoutColors.warningDark},
      {'code': 'SO', 'name': 'Somalia', 'value': 9556873, 'color': layoutColors.danger},
      {'code': 'ZA', 'name': 'South Africa', 'value': 50459978, 'color': layoutColors.danger},
      {'code': 'ES', 'name': 'Spain', 'value': 46454895, 'color': layoutColors.warning},
      {'code': 'LK', 'name': 'Sri Lanka', 'value': 21045394, 'color': layoutColors.primaryDark},
      {'code': 'SD', 'name': 'Sudan', 'value': 34735288, 'color': layoutColors.danger},
      {'code': 'SR', 'name': 'Suriname', 'value': 529419, 'color': layoutColors.success},
      {'code': 'SZ', 'name': 'Swaziland', 'value': 1203330, 'color': layoutColors.danger},
      {'code': 'SE', 'name': 'Sweden', 'value': 9440747, 'color': layoutColors.warning},
      {'code': 'CH', 'name': 'Switzerland', 'value': 7701690, 'color': layoutColors.warning},
      {'code': 'SY', 'name': 'Syria', 'value': 20766037, 'color': layoutColors.primaryDark},
      {'code': 'TW', 'name': 'Taiwan', 'value': 23072000, 'color': layoutColors.primaryDark},
      {'code': 'TJ', 'name': 'Tajikistan', 'value': 6976958, 'color': layoutColors.primaryDark},
      {'code': 'TZ', 'name': 'Tanzania', 'value': 46218486, 'color': layoutColors.danger},
      {'code': 'TH', 'name': 'Thailand', 'value': 69518555, 'color': layoutColors.primaryDark},
      {'code': 'TG', 'name': 'Togo', 'value': 6154813, 'color': layoutColors.danger},
      {'code': 'TT', 'name': 'Trinidad and Tobago', 'value': 1346350, 'color': layoutColors.primary},
      {'code': 'TN', 'name': 'Tunisia', 'value': 10594057, 'color': layoutColors.danger},
      {'code': 'TR', 'name': 'Turkey', 'value': 73639596, 'color': layoutColors.warning},
      {'code': 'TM', 'name': 'Turkmenistan', 'value': 5105301, 'color': layoutColors.primaryDark},
      {'code': 'UG', 'name': 'Uganda', 'value': 34509205, 'color': layoutColors.danger},
      {'code': 'UA', 'name': 'Ukraine', 'value': 45190180, 'color': layoutColors.warning},
      {'code': 'AE', 'name': 'United Arab Emirates', 'value': 7890924, 'color': layoutColors.primaryDark},
      {'code': 'GB', 'name': 'United Kingdom', 'value': 62417431, 'color': layoutColors.warning},
      {'code': 'US', 'name': 'United States', 'value': 313085380, 'color': layoutColors.primary},
      {'code': 'UY', 'name': 'Uruguay', 'value': 3380008, 'color': layoutColors.success},
      {'code': 'UZ', 'name': 'Uzbekistan', 'value': 27760267, 'color': layoutColors.primaryDark},
      {'code': 'VE', 'name': 'Venezuela', 'value': 29436891, 'color': layoutColors.success},
      {'code': 'PS', 'name': 'West Bank and Gaza', 'value': 4152369, 'color': layoutColors.primaryDark},
      {'code': 'VN', 'name': 'Vietnam', 'value': 88791996, 'color': layoutColors.primaryDark},
      {'code': 'YE', 'name': 'Yemen, Rep.', 'value': 24799880, 'color': layoutColors.primaryDark},
      {'code': 'ZM', 'name': 'Zambia', 'value': 13474959, 'color': layoutColors.danger},
      {'code': 'ZW', 'name': 'Zimbabwe', 'value': 12754378, 'color': layoutColors.danger}
    ];

    var map;
    var minBulletSize = 3;
    var maxBulletSize = 70;
    var min = Infinity;
    var max = -Infinity;

    // get min and max values
    for (var i = 0; i < mapData.length; i++) {
      var value = mapData[i].value;
      if (value < min) {
        min = value;
      }
      if (value > max) {
        max = value;
      }
    }

    // build map
    AmCharts.theme = AmCharts.themes.blur;
    map = new AmCharts.AmMap();

    map.addTitle('Population of the World in 2011', 14);
    map.addTitle('source: Gapminder', 11);
    map.areasSettings = {
      unlistedAreasColor: '#000000',
      unlistedAreasAlpha: 0.1
    };
    map.imagesSettings.balloonText = '<span style="font-size:14px;"><b>[[title]]</b>: [[value]]</span>';
    map.pathToImages = layoutPaths.images.amMap;

    var dataProvider = {
      mapVar: AmCharts.maps.worldLow,
      images: []
    };

    // it's better to use circle square to show difference between values, not a radius
    var maxSquare = maxBulletSize * maxBulletSize * 2 * Math.PI;
    var minSquare = minBulletSize * minBulletSize * 2 * Math.PI;

    // create circle for each country
    for (var i = 0; i < mapData.length; i++) {
      var dataItem = mapData[i];
      var value = dataItem.value;
      // calculate size of a bubble
      var square = (value - min) / (max - min) * (maxSquare - minSquare) + minSquare;
      if (square < minSquare) {
        square = minSquare;
      }
      var size = Math.sqrt(square / (Math.PI * 2));
      var id = dataItem.code;

      dataProvider.images.push({
        type: 'circle',
        width: size,
        height: size,
        color: dataItem.color,
        longitude: latlong[id].longitude,
        latitude: latlong[id].latitude,
        title: dataItem.name,
        value: value
      });
    }

    map.dataProvider = dataProvider;
    map.export = {
      enabled: true
    };

    $timeout(function() {
      map.write('map-bubbles');
    }, 100);
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.maps')
      .controller('MapLinesPageCtrl', MapLinesPageCtrl);

  /** @ngInject */
  function MapLinesPageCtrl(baConfig, $timeout, layoutPaths) {
    var layoutColors = baConfig.colors;
    // svg path for target icon
    var targetSVG = 'M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z';
// svg path for plane icon
    var planeSVG = 'M19.671,8.11l-2.777,2.777l-3.837-0.861c0.362-0.505,0.916-1.683,0.464-2.135c-0.518-0.517-1.979,0.278-2.305,0.604l-0.913,0.913L7.614,8.804l-2.021,2.021l2.232,1.061l-0.082,0.082l1.701,1.701l0.688-0.687l3.164,1.504L9.571,18.21H6.413l-1.137,1.138l3.6,0.948l1.83,1.83l0.947,3.598l1.137-1.137V21.43l3.725-3.725l1.504,3.164l-0.687,0.687l1.702,1.701l0.081-0.081l1.062,2.231l2.02-2.02l-0.604-2.689l0.912-0.912c0.326-0.326,1.121-1.789,0.604-2.306c-0.452-0.452-1.63,0.101-2.135,0.464l-0.861-3.838l2.777-2.777c0.947-0.947,3.599-4.862,2.62-5.839C24.533,4.512,20.618,7.163,19.671,8.11z';
    $timeout(function() {
      var map = AmCharts.makeChart( 'map-lines', {
        type: 'map',
        theme: 'blur',
        dataProvider: {
          map: 'worldLow',
          linkToObject: 'london',
          images: [ {
            id: 'london',
            svgPath: targetSVG,
            title: 'London',
            latitude: 51.5002,
            longitude: -0.1262,
            scale: 1.5,
            zoomLevel: 2.74,
            zoomLongitude: -20.1341,
            zoomLatitude: 49.1712,

            lines: [ {
              latitudes: [ 51.5002, 50.4422 ],
              longitudes: [ -0.1262, 30.5367 ]
            }, {
              latitudes: [ 51.5002, 46.9480 ],
              longitudes: [ -0.1262, 7.4481 ]
            }, {
              latitudes: [ 51.5002, 59.3328 ],
              longitudes: [ -0.1262, 18.0645 ]
            }, {
              latitudes: [ 51.5002, 40.4167 ],
              longitudes: [ -0.1262, -3.7033 ]
            }, {
              latitudes: [ 51.5002, 46.0514 ],
              longitudes: [ -0.1262, 14.5060 ]
            }, {
              latitudes: [ 51.5002, 48.2116 ],
              longitudes: [ -0.1262, 17.1547 ]
            }, {
              latitudes: [ 51.5002, 44.8048 ],
              longitudes: [ -0.1262, 20.4781 ]
            }, {
              latitudes: [ 51.5002, 55.7558 ],
              longitudes: [ -0.1262, 37.6176 ]
            }, {
              latitudes: [ 51.5002, 38.7072 ],
              longitudes: [ -0.1262, -9.1355 ]
            }, {
              latitudes: [ 51.5002, 54.6896 ],
              longitudes: [ -0.1262, 25.2799 ]
            }, {
              latitudes: [ 51.5002, 64.1353 ],
              longitudes: [ -0.1262, -21.8952 ]
            }, {
              latitudes: [ 51.5002, 40.4300 ],
              longitudes: [ -0.1262, -74.0000 ]
            } ],

            images: [ {
              label: 'Flights from London',
              svgPath: planeSVG,
              left: 100,
              top: 45,
              labelShiftY: 5,
              labelShiftX: 5,
              color: layoutColors.defaultText,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 20
            }, {
              label: 'show flights from Vilnius',
              left: 106,
              top: 70,
              labelColor: layoutColors.defaultText,
              labelRollOverColor: layoutColors.defaultText,
              labelFontSize: 11,
              linkToObject: 'vilnius'
            } ]
          },

            {
              id: 'vilnius',
              svgPath: targetSVG,
              title: 'Vilnius',
              latitude: 54.6896,
              longitude: 25.2799,
              scale: 1.5,
              zoomLevel: 4.92,
              zoomLongitude: 15.4492,
              zoomLatitude: 50.2631,

              lines: [ {
                latitudes: [ 54.6896, 50.8371 ],
                longitudes: [ 25.2799, 4.3676 ]
              }, {
                latitudes: [ 54.6896, 59.9138 ],
                longitudes: [ 25.2799, 10.7387 ]
              }, {
                latitudes: [ 54.6896, 40.4167 ],
                longitudes: [ 25.2799, -3.7033 ]
              }, {
                latitudes: [ 54.6896, 50.0878 ],
                longitudes: [ 25.2799, 14.4205 ]
              }, {
                latitudes: [ 54.6896, 48.2116 ],
                longitudes: [ 25.2799, 17.1547 ]
              }, {
                latitudes: [ 54.6896, 44.8048 ],
                longitudes: [ 25.2799, 20.4781 ]
              }, {
                latitudes: [ 54.6896, 55.7558 ],
                longitudes: [ 25.2799, 37.6176 ]
              }, {
                latitudes: [ 54.6896, 37.9792 ],
                longitudes: [ 25.2799, 23.7166 ]
              }, {
                latitudes: [ 54.6896, 54.6896 ],
                longitudes: [ 25.2799, 25.2799 ]
              }, {
                latitudes: [ 54.6896, 51.5002 ],
                longitudes: [ 25.2799, -0.1262 ]
              }, {
                latitudes: [ 54.6896, 53.3441 ],
                longitudes: [ 25.2799, -6.2675 ]
              } ],

              images: [ {
                label: 'Flights from Vilnius',
                svgPath: planeSVG,
                left: 100,
                top: 45,
                labelShiftY: 5,
                labelShiftX: 5,
                color: layoutColors.defaultText,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 20
              }, {
                label: 'show flights from London',
                left: 106,
                top: 70,
                labelColor: layoutColors.defaultText,
                labelRollOverColor: layoutColors.defaultText,
                labelFontSize: 11,
                linkToObject: 'london'
              } ]
            }, {
              svgPath: targetSVG,
              title: 'Brussels',
              latitude: 50.8371,
              longitude: 4.3676
            }, {
              svgPath: targetSVG,
              title: 'Prague',
              latitude: 50.0878,
              longitude: 14.4205
            }, {
              svgPath: targetSVG,
              title: 'Athens',
              latitude: 37.9792,
              longitude: 23.7166
            }, {
              svgPath: targetSVG,
              title: 'Reykjavik',
              latitude: 64.1353,
              longitude: -21.8952
            }, {
              svgPath: targetSVG,
              title: 'Dublin',
              latitude: 53.3441,
              longitude: -6.2675
            }, {
              svgPath: targetSVG,
              title: 'Oslo',
              latitude: 59.9138,
              longitude: 10.7387
            }, {
              svgPath: targetSVG,
              title: 'Lisbon',
              latitude: 38.7072,
              longitude: -9.1355
            }, {
              svgPath: targetSVG,
              title: 'Moscow',
              latitude: 55.7558,
              longitude: 37.6176
            }, {
              svgPath: targetSVG,
              title: 'Belgrade',
              latitude: 44.8048,
              longitude: 20.4781
            }, {
              svgPath: targetSVG,
              title: 'Bratislava',
              latitude: 48.2116,
              longitude: 17.1547
            }, {
              svgPath: targetSVG,
              title: 'Ljubljana',
              latitude: 46.0514,
              longitude: 14.5060
            }, {
              svgPath: targetSVG,
              title: 'Madrid',
              latitude: 40.4167,
              longitude: -3.7033
            }, {
              svgPath: targetSVG,
              title: 'Stockholm',
              latitude: 59.3328,
              longitude: 18.0645
            }, {
              svgPath: targetSVG,
              title: 'Bern',
              latitude: 46.9480,
              longitude: 7.4481
            }, {
              svgPath: targetSVG,
              title: 'Kiev',
              latitude: 50.4422,
              longitude: 30.5367
            }, {
              svgPath: targetSVG,
              title: 'Paris',
              latitude: 48.8567,
              longitude: 2.3510
            }, {
              svgPath: targetSVG,
              title: 'New York',
              latitude: 40.43,
              longitude: -74
            }
          ]
        },

        areasSettings: {
          unlistedAreasColor: layoutColors.info
        },

        imagesSettings: {
          color: layoutColors.warningLight,
          selectedColor: layoutColors.warning
        },

        linesSettings: {
          color: layoutColors.warningLight,
          alpha: 0.8
        },


        backgroundZoomsToTop: true,
        linesAboveImages: true,

        export: {
          'enabled': true
        },
        pathToImages: layoutPaths.images.amMap
      } );
    }, 100);

  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
    angular.module('Merchant.pages.myOutlet')
        .controller('AddOutletPageCtrl', AddOutletPageCtrl);
    /** @ngInject */
    function AddOutletPageCtrl($state) {
        // $state.go('myOutlet.addOutlet')
    }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';
  
    angular.module('Merchant.pages.myOutlet')
        .controller('DetailsPageCtrl', DetailsPageCtrl);
  
    /** @ngInject */
    // function DetailsPageCtrl($scope, $uibModal, baProgressModal) {
    
    // }
    function DetailsPageCtrl($scope, $filter, editableOptions, editableThemes, $uibModal, baProgressModal, toastrConfig ) {
      // define list of items
$scope.carColors = ["New","Inprogress","Enquire Review","Contract Sign Off"];

// initialize filter object
$scope.filter = {};


// reset the filter
$scope.resetFilter = function() {
  // set filter object as blank
  $scope.filter = {}; 
  

}
      var defaultConfig = angular.copy(toastrConfig);
      $scope.types = ['success', 'error'];

      $scope.open = function (page, size) {
        $uibModal.open({
          animation: true,
          templateUrl: page,
          size: size,
          resolve: {
            items: function () {
              return $scope.items;
            }
          }
        });
      };
      $scope.clearLastToast = function () {
        var toast = openedToasts.pop();
        toastr.clear(toast);
      };
  
      $scope.clearToasts = function () {
        toastr.clear();
      };
      $scope.openProgressDialog = baProgressModal.open;
        $scope.smartTablePageSize = 5;

        $scope.smartTableData = [
          
          {
            id: 1,
            name: 'Mark',
            position: 'Otto',
            organization: '@mdo',
            location: 'Dubhai',
            mobile: '9985787',
            email: 'mdo@gmail.com',
            enqdate: '10/11/12',
            status: 'New',
            details: 'View details'
          },
          {
            id: 2,
  
            name: 'dev',
            position: 'sss',
            organization: '@mdo',
            location: 'Dubhai',
            mobile: '99999',
            email: 'mdo@gmail.com',
            enqdate: '10/11/12',
            status: 'Inprogress',
            details: 'View details'
          },
          {
            id: 3,
            name: 'sin',
            position: 'rrrr',
            organization: '@mdo',
            location: 'Dubhais',
            mobile: '7345435435',
            email: 'mdo@gmail.com',
            enqdate: '10/11/12',
            status: 'Enquire Review',
            details: 'View details'
          },
          {
            id: 4,
            name: 'Mark',
            position: 'Otto',
            organization: '@mdo',
            location: 'Dubhai',
            mobile: '9985787',
            email: 'mdo@gmail.com',
            enqdate: '10/11/12',
            status: 'Contract Sign Off',
            details: 'View details'
          },
          {
            id: 5,
            name: 'Mark',
            position: 'Otto',
            organization: '@mdo',
            location: 'Dubhai',
            mobile: '9985787',
            email: 'mdo@gmail.com',
            enqdate: '10/11/12',
            status: 'Contract Sign Off',
            details: 'View details'
          },
          {
            id: 6,
            name: 'Mark',
            position: 'Otto',
            organization: '@mdo',
            location: 'Dubhai',
            mobile: '9985787',
            email: 'mdo@gmail.com',
            enqdate: '10/11/12',
            status: 'Not Published',
            details: 'View details'
          },
          {
            id: 7,
            name: 'Mark',
            position: 'Otto',
            organization: '@mdo',
            location: 'Dubhai',
            mobile: 'Ne9985787w',
            email: 'mdo@gmail.com',
            enqdate: '10/11/12',
            status: 'Inprogress',
            details: 'View details'
          },
          {
            id: 8,
            name: 'Mark',
            position: 'Otto',
            organization: '@mdo',
            location: 'Dubhai',
            mobile: '9985787',
            email: 'mdo@gmail.com',
            enqdate: '10/11/12',
            status: 'Inprogress',
            details: 'View details'
          },
          {
            id: 9,
            name: 'Mark',
            position: 'Otto',
            organization: '@mdo',
            location: 'Dubhai',
            mobile: '9985787',
            email: 'mdo@gmail.com',
            enqdate: '10/11/12',
            status: 'Inprogress',
            details: 'View details'
          },
          {
            id: 10,
            name: 'Mark',
            position: 'Otto',
            organization: '@mdo',
            location: 'Dubhai',
            mobile: 'New',
            email: 'mdo@gmail.com',
            enqdate: '10/11/12',
            status: 'Inprogress',
            details: 'View details'
          },
          {
            id: 11,
            name: 'Mark',
            position: 'Otto',
            organization: '@mdo',
            location: 'Dubhai',
            mobile: '9985787',
            email: 'mdo@gmail.com',
            enqdate: '10/11/12',
            status: 'Inprogress',
            details: 'View details'
          },
          {
            id: 12,
            name: 'Mark',
            position: 'Otto',
            organization: '@mdo',
            location: 'Dubhai',
            mobile: '9985787',
            email: 'mdo@gmail.com',
            enqdate: 'New',
            status: 'Inprogress',
            details: 'View details'
          },
          {
            id: 13,
            name: 'Mark',
            position: 'Otto',
            organization: '@mdo',
            location: 'Dubhai',
            mobile: '9985787',
            email: 'mdo@gmail.com',
            enqdate: 'New',
            status: 'Inprogress',
            details: 'View details'
          },
          {
            id: 14,
            name: 'Mark',
            position: 'Otto',
            organization: '@mdo',
            location: 'Dubhai',
            mobile: '9985787',
            email: 'mdo@gmail.com',
            enqdate: 'New',
            status: 'Inprogress',
            details: 'View details'
          },
          {
            id: 15,
            name: 'Mark',
            position: 'Otto',
            organization: '@mdo',
            location: 'Dubhai',
            mobile: '9985787',
            email: 'mdo@gmail.com',
            enqdate: 'New',
            status: 'Inprogress',
            details: 'View details'
          },
          {
            "id": 16,
            "firstName": "Francisca",
            "lastName": "Brady",
            "username": "@Gibson",
            "email": "franciscagibson@comtours.com",
            "status": "active",
            "age": 11
          },
          {
            "id": 17,
            "firstName": "Tillman",
            "lastName": "Figueroa",
            "username": "@Snow",
            "email": "tillmansnow@comtours.com",
            "status": "active",
            "age": 34
          },
          {
            "id": 18,
            "firstName": "Jimenez",
            "lastName": "Morris",
            "username": "@Bryant",
            "email": "jimenezbryant@comtours.com",
            "status": "active",
            "age": 45
          },
          {
            "id": 19,
            "firstName": "Sandoval",
            "lastName": "Jacobson",
            "username": "@Mcbride",
            "email": "sandovalmcbride@comtours.com",
            "status": "active",
            "age": 32
          },
          {
            "id": 20,
            "firstName": "Griffin",
            "lastName": "Torres",
            "username": "@Charles",
            "email": "griffincharles@comtours.com",
            "status": "active",
            "age": 19
          },
          {
            "id": 21,
            "firstName": "Cora",
            "lastName": "Parker",
            "username": "@Caldwell",
            "email": "coracaldwell@comtours.com",
            "status": "active",
            "age": 27
          },
          {
            "id": 22,
            "firstName": "Cindy",
            "lastName": "Bond",
            "username": "@Velez",
            "email": "cindyvelez@comtours.com",
            "status": "active",
            "age": 24
          },
          {
            "id": 23,
            "firstName": "Frieda",
            "lastName": "Tyson",
            "username": "@Craig",
            "email": "friedacraig@comtours.com",
            "status": "active",
            "age": 45
          },
          {
            "id": 24,
            "firstName": "Cote",
            "lastName": "Holcomb",
            "username": "@Rowe",
            "email": "coterowe@comtours.com",
            "status": "active",
            "age": 20
          },
          {
            "id": 25,
            "firstName": "Trujillo",
            "lastName": "Mejia",
            "username": "@Valenzuela",
            "email": "trujillovalenzuela@comtours.com",
            "status": "active",
            "age": 16
          },
          {
            "id": 26,
            "firstName": "Pruitt",
            "lastName": "Shepard",
            "username": "@Sloan",
            "email": "pruittsloan@comtours.com",
            "status": "active",
            "age": 44
          },
          {
            "id": 27,
            "firstName": "Sutton",
            "lastName": "Ortega",
            "username": "@Black",
            "email": "suttonblack@comtours.com",
            "status": "active",
            "age": 42
          },
          {
            "id": 28,
            "firstName": "Marion",
            "lastName": "Heath",
            "username": "@Espinoza",
            "email": "marionespinoza@comtours.com",
            "status": "active",
            "age": 47
          },
          {
            "id": 29,
            "firstName": "Newman",
            "lastName": "Hicks",
            "username": "@Keith",
            "email": "newmankeith@comtours.com",
            "status": "active",
            "age": 15
          },
          {
            "id": 30,
            "firstName": "Boyle",
            "lastName": "Larson",
            "username": "@Summers",
            "email": "boylesummers@comtours.com",
            "status": "active",
            "age": 32
          },
          {
            "id": 31,
            "firstName": "Haynes",
            "lastName": "Vinson",
            "username": "@Mckenzie",
            "email": "haynesmckenzie@comtours.com",
            "status": "active",
            "age": 15
          },
          {
            "id": 32,
            "firstName": "Miller",
            "lastName": "Acosta",
            "username": "@Young",
            "email": "milleryoung@comtours.com",
            "status": "active",
            "age": 55
          },
          {
            "id": 33,
            "firstName": "Johnston",
            "lastName": "Brown",
            "username": "@Knight",
            "email": "johnstonknight@comtours.com",
            "status": "active",
            "age": 29
          },
          {
            "id": 34,
            "firstName": "Lena",
            "lastName": "Pitts",
            "username": "@Forbes",
            "email": "lenaforbes@comtours.com",
            "status": "active",
            "age": 25
          },
          {
            "id": 35,
            "firstName": "Terrie",
            "lastName": "Kennedy",
            "username": "@Branch",
            "email": "terriebranch@comtours.com",
            "status": "active",
            "age": 37
          },
          {
            "id": 36,
            "firstName": "Louise",
            "lastName": "Aguirre",
            "username": "@Kirby",
            "email": "louisekirby@comtours.com",
            "status": "active",
            "age": 44
          },
          {
            "id": 37,
            "firstName": "David",
            "lastName": "Patton",
            "username": "@Sanders",
            "email": "davidsanders@comtours.com",
            "status": "active",
            "age": 26
          },
          {
            "id": 38,
            "firstName": "Holden",
            "lastName": "Barlow",
            "username": "@Mckinney",
            "email": "holdenmckinney@comtours.com",
            "status": "active",
            "age": 11
          },
          {
            "id": 39,
            "firstName": "Baker",
            "lastName": "Rivera",
            "username": "@Montoya",
            "email": "bakermontoya@comtours.com",
            "status": "active",
            "age": 47
          },
          {
            "id": 40,
            "firstName": "Belinda",
            "lastName": "Lloyd",
            "username": "@Calderon",
            "email": "belindacalderon@comtours.com",
            "status": "active",
            "age": 21
          },
          {
            "id": 41,
            "firstName": "Pearson",
            "lastName": "Patrick",
            "username": "@Clements",
            "email": "pearsonclements@comtours.com",
            "status": "active",
            "age": 42
          },
          {
            "id": 42,
            "firstName": "Alyce",
            "lastName": "Mckee",
            "username": "@Daugherty",
            "email": "alycedaugherty@comtours.com",
            "status": "active",
            "age": 55
          },
          {
            "id": 43,
            "firstName": "Valencia",
            "lastName": "Spence",
            "username": "@Olsen",
            "email": "valenciaolsen@comtours.com",
            "status": "active",
            "age": 20
          },
          {
            "id": 44,
            "firstName": "Leach",
            "lastName": "Holcomb",
            "username": "@Humphrey",
            "email": "leachhumphrey@comtours.com",
            "status": "active",
            "age": 28
          },
          {
            "id": 45,
            "firstName": "Moss",
            "lastName": "Baxter",
            "username": "@Fitzpatrick",
            "email": "mossfitzpatrick@comtours.com",
            "status": "active",
            "age": 51
          },
          {
            "id": 46,
            "firstName": "Jeanne",
            "lastName": "Cooke",
            "username": "@Ward",
            "email": "jeanneward@comtours.com",
            "age": 59
          },
          {
            "id": 47,
            "firstName": "Wilma",
            "lastName": "Briggs",
            "username": "@Kidd",
            "email": "wilmakidd@comtours.com",
            "status": "active",
            "age": 53
          },
          {
            "id": 48,
            "firstName": "Beatrice",
            "lastName": "Perry",
            "username": "@Gilbert",
            "email": "beatricegilbert@comtours.com",
            "status": "active",
            "age": 39
          },
          {
            "id": 49,
            "firstName": "Whitaker",
            "lastName": "Hyde",
            "username": "@Mcdonald",
            "email": "whitakermcdonald@comtours.com",
            "status": "active",
            "age": 35
          },
          {
            "id": 50,
            "firstName": "Rebekah",
            "lastName": "Duran",
            "username": "@Gross",
            "email": "rebekahgross@comtours.com",
            "status": "active",
            "age": 40
          },
          {
            "id": 51,
            "firstName": "Earline",
            "lastName": "Mayer",
            "username": "@Woodward",
            "email": "earlinewoodward@comtours.com",
            "status": "active",
            "age": 52
          },
          {
            "id": 52,
            "firstName": "Moran",
            "lastName": "Baxter",
            "username": "@Johns",
            "email": "moranjohns@comtours.com",
            "status": "active",
            "age": 20
          },
          {
            "id": 53,
            "firstName": "Nanette",
            "lastName": "Hubbard",
            "username": "@Cooke",
            "email": "nanettecooke@comtours.com",
            "status": "active",
            "age": 55
          },
          {
            "id": 54,
            "firstName": "Dalton",
            "lastName": "Walker",
            "username": "@Hendricks",
            "email": "daltonhendricks@comtours.com",
            "status": "active",
            "age": 25
          },
          {
            "id": 55,
            "firstName": "Bennett",
            "lastName": "Blake",
            "username": "@Pena",
            "email": "bennettpena@comtours.com",
            "status": "active",
            "age": 13
          },
          {
            "id": 56,
            "firstName": "Kellie",
            "lastName": "Horton",
            "username": "@Weiss",
            "email": "kellieweiss@comtours.com",
            "status": "active",
            "age": 48
          },
          {
            "id": 57,
            "firstName": "Hobbs",
            "lastName": "Talley",
            "username": "@Sanford",
            "email": "hobbssanford@comtours.com",
            "status": "active",
            "age": 28
          },
          {
            "id": 58,
            "firstName": "Mcguire",
            "lastName": "Donaldson",
            "username": "@Roman",
            "email": "mcguireroman@comtours.com",
            "status": "active",
            "age": 38
          },
          {
            "id": 59,
            "firstName": "Rodriquez",
            "lastName": "Saunders",
            "username": "@Harper",
            "email": "rodriquezharper@comtours.com",
            "status": "active",
            "age": 20
          },
          {
            "id": 60,
            "firstName": "Lou",
            "lastName": "Conner",
            "username": "@Sanchez",
            "email": "lousanchez@comtours.com",
            "status": "active",
            "age": 16
          }
        ];
  
      $scope.editableTableData = $scope.smartTableData.slice(0, 36);
  
      $scope.peopleTableData = [
        {
          id: 1,
          firstName: 'Mark',
          lastName: 'Otto',
          username: '@mdo',
          email: 'mdo@gmail.com',
          age: '28',
          status: 'info'
        },
        {
          id: 2,
          firstName: 'Jacob',
          lastName: 'Thornton',
          username: '@fat',
          email: 'fat@yandex.ru',
          age: '45',
          status: 'primary'
        },
        {
          id: 3,
          firstName: 'Larry',
          lastName: 'Bird',
          username: '@twitter',
          email: 'twitter@outlook.com',
          age: '18',
          status: 'success'
        },
        {
          id: 4,
          firstName: 'John',
          lastName: 'Snow',
          username: '@snow',
          email: 'snow@gmail.com',
          age: '20',
          status: 'danger'
        },
        {
          id: 5,
          firstName: 'Jack',
          lastName: 'Sparrow',
          username: '@jack',
          email: 'jack@yandex.ru',
          age: '30',
          status: 'warning'
        }
      ];
  
      $scope.metricsTableData = [
        {
          image: 'app/browsers/chrome.svg',
          browser: 'Google Chrome',
          visits: '10,392',
          isVisitsUp: true,
          purchases: '4,214',
          isPurchasesUp: true,
          percent: '45%',
          isPercentUp: true
        },
        {
          image: 'app/browsers/firefox.svg',
          browser: 'Mozilla Firefox',
          visits: '7,873',
          isVisitsUp: true,
          purchases: '3,031',
          isPurchasesUp: false,
          percent: '28%',
          isPercentUp: true
        },
        {
          image: 'app/browsers/ie.svg',
          browser: 'Internet Explorer',
          visits: '5,890',
          isVisitsUp: false,
          purchases: '2,102',
          isPurchasesUp: false,
          percent: '17%',
          isPercentUp: false
        },
        {
          image: 'app/browsers/safari.svg',
          browser: 'Safari',
          visits: '4,001',
          isVisitsUp: false,
          purchases: '1,001',
          isPurchasesUp: false,
          percent: '14%',
          isPercentUp: true
        },
        {
          image: 'app/browsers/opera.svg',
          browser: 'Opera',
          visits: '1,833',
          isVisitsUp: true,
          purchases: '83',
          isPurchasesUp: true,
          percent: '5%',
          isPercentUp: false
        }
      ];
  
      $scope.users = [
        {
          "id": 1,
          "name": "Esther Vang",
          "status": 4,
          "group": 3
        },
        {
          "id": 2,
          "name": "Leah Freeman",
          "status": 3,
          "group": 1
        },
        {
          "id": 3,
          "name": "Mathews Simpson",
          "status": 3,
          "group": 2
        },
        {
          "id": 4,
          "name": "Buckley Hopkins",
          "group": 4
        },
        {
          "id": 5,
          "name": "Buckley Schwartz",
          "status": 1,
          "group": 1
        },
        {
          "id": 6,
          "name": "Mathews Hopkins",
          "status": 4,
          "group": 2
        },
        {
          "id": 7,
          "name": "Leah Vang",
          "status": 4,
          "group": 1
        },
        {
          "id": 8,
          "name": "Vang Schwartz",
          "status": 4,
          "group": 2
        },
        {
          "id": 9,
          "name": "Hopkin Esther",
          "status": 1,
          "group": 2
        },
        {
          "id": 10,
          "name": "Mathews Schwartz",
          "status": 1,
          "group": 3
        }
      ];
  
      $scope.statuses = [
        {value: 1, text: 'Good'},
        {value: 2, text: 'Awesome'},
        {value: 3, text: 'Excellent'},
      ];
  
      $scope.groups = [
        {id: 1, text: 'user'},
        {id: 2, text: 'customer'},
        {id: 3, text: 'vip'},
        {id: 4, text: 'admin'}
      ];
  
      $scope.showGroup = function(user) {
        if(user.group && $scope.groups.length) {
          var selected = $filter('filter')($scope.groups, {id: user.group});
          return selected.length ? selected[0].text : 'Not set';
        } else return 'Not set'
      };
  
      $scope.showStatus = function(user) {
        var selected = [];
        if(user.status) {
          selected = $filter('filter')($scope.statuses, {value: user.status});
        }
        return selected.length ? selected[0].text : 'Not set';
      };
  
  
      $scope.removeUser = function(index) {
        $scope.users.splice(index, 1);
      };
  
      $scope.addUser = function() {
        $scope.inserted = {
          id: $scope.users.length+1,
          name: '',
          status: null,
          group: null
        };
        $scope.users.push($scope.inserted);
      };
  
      editableOptions.theme = 'bs3';
      editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
      editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';
  
  
    }
  
  })();
  
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
    angular.module('Merchant.pages.myOutlet')
        .controller('OpeningTimePageCtrl', OpeningTimePageCtrl);
    /** @ngInject */
    function OpeningTimePageCtrl($state,$rootScope) {
        $rootScope.activeTab =3;
        // $state.go('myOutlet.details')
    }
    // function datepickerpopupCtrl($scope) {
    // }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
    angular.module('Merchant.pages.myOutlet')
        .controller('PricesPageCtrl', PricesPageCtrl);
    /** @ngInject */
    function PricesPageCtrl($scope, $filter, editableOptions, editableThemes, $timeout,$rootScope) {
        $rootScope.activeTab =4;
       
        // $(function() {

        //     // We can attach the `fileselect` event to all file inputs on the page
        //     $(document).on('change', ':file', function() {
        //         var input = $(this),
        //             numFiles = input.get(0).files ? input.get(0).files.length : 1,
        //             label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
        //         input.trigger('fileselect', [numFiles, label]);
        //     });

        //     // We can watch for our custom `fileselect` event like this
        //     $(document).ready(function() {
        //         $(':file').on('fileselect', function(event, numFiles, label) {

        //             var input = $(this).parents('.input-group').find(':text'),
        //                 log = numFiles > 1 ? numFiles + ' files selected' : label;

        //             if (input.length) {
        //                 input.val(log);
        //             } else {
        //                 if (log) alert(log);
        //             }

        //         });
        //     });

        // });

    }
    // function datepickerpopupCtrl($scope) {

    // }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';
    angular.module('Merchant.pages.myOutlet')
        .controller('RewardsPageCtrl', RewardsPageCtrl);
    /** @ngInject */
    function RewardsPageCtrl($scope, $filter, editableOptions, editableThemes, $timeout,$rootScope) {
        $rootScope.activeTab =6;
        $scope.genderLists = ["All Time", "From"];
        $scope.from = ["From"];
        $scope.alltime = 'ALL Time';
        // $scope.value = "R"
        // dropdown
        $scope.outletFilter;
        $scope.isFilterLabel = false;
        $scope.outletFilterLists = [{
                name: "Outlet1",
                value: "Outlet1"
            },
            {
                name: "Outlet2",
                value: "Outlet2"
            },
            {
                name: "Outlet3",
                value: "Outlet3"
            }
        ];

        $scope.FloorList = [{
                name: "1",
                value: "1"
            },
            {
                name: "2",
                value: "2"
            },
            {
                name: "3",
                value: "3"
            }
        ];

        $scope.cityList = [{
                name: "City1",
                value: "City1"
            },
            {
                name: "City2",
                value: "City2"
            },
            {
                name: "City3",
                value: "City3"
            }
        ];
        $scope.locationList = [{
                name: "usa",
                value: "usa"
            },
            {
                name: "Uk",
                value: "Uk"
            },
            {
                name: "India",
                value: "India"
            }
        ];

        $scope.durationList = [{
                name: "Month",
                value: "Month"
            },
            {
                name: "Year",
                value: "Year"
            },
            {
                name: "Week",
                value: "Week"
            }
        ];


        function initialize() {
            var mapCanvas = document.getElementById('google-maps');
            var mapOptions = {
                center: new google.maps.LatLng(44.5403, -78.5463),
                zoom: 8,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            var map = new google.maps.Map(mapCanvas, mapOptions);
        }

        $timeout(function() {
            initialize();
        }, 100);

        $scope.openFrom = openFrom;
        $scope.openedFrom = false;
        $scope.openTo = openTo;
        $scope.openedTo = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[2];
        $scope.options = {
            showWeeks: false
        };

        function openFrom() {
            $scope.openedFrom = true;
        }

        function openTo() {
            $scope.openedTo = true;
        }

        $scope.open1 = open1;
        $scope.opened1 = false;
        $scope.open2 = open2;
        $scope.opened2 = false;
        $scope.options = {
            showWeeks: false
        };

        function open1() {
            $scope.opened1 = true;
        }

        function open2() {
            $scope.opened2 = true;
        }


        $scope.open3 = open3;
        $scope.opened3 = false;
        $scope.open4 = open4;
        $scope.opened4 = false;
        $scope.options = {
            showWeeks: false
        };

        function open3() {
            $scope.opened3 = true;
        }

        function open4() {
            $scope.opened4 = true;
        }

        $scope.open6 = open6;
        $scope.opened6 = false;
        $scope.open5 = open5;
        $scope.opened5 = false;
        $scope.options = {
            showWeeks: false
        };

        function open6() {
            $scope.opened6 = true;
        }

        function open5() {
            $scope.opened5 = true;
        }


        $scope.open7 = open7;
        $scope.opened7 = false;
        $scope.open8 = open8;
        $scope.opened8 = false;
        $scope.options = {
            showWeeks: false
        };

        function open7() {
            $scope.opened7 = true;
        }

        function open8() {
            $scope.opened8 = true;
        }

        $scope.open9 = open9;
        $scope.opened9 = false;
        $scope.open10 = open10;
        $scope.opened10 = false;
        $scope.options = {
            showWeeks: false
        };

        function open9() {
            $scope.opened9 = true;
        }

        function open10() {
            $scope.opened10 = true;
        }

        $scope.open11 = open11;
        $scope.opened11 = false;
        $scope.open12 = open12;
        $scope.opened12 = false;
        $scope.options = {
            showWeeks: false
        };

        function open11() {
            $scope.opened11 = true;
        }

        function open12() {
            $scope.opened12 = true;
        }

        $scope.open13 = open13;
        $scope.opened13 = false;
        $scope.open14 = open14;
        $scope.opened14 = false;
        $scope.options = {
            showWeeks: false
        };

        function open13() {
            $scope.opened13 = true;
        }

        function open14() {
            $scope.opened14 = true;
        }

        $scope.open15 = open15;
        $scope.opened15 = false;
        $scope.open16 = open16;
        $scope.opened16 = false;
        $scope.options = {
            showWeeks: false
        };

        function open15() {
            $scope.opened15 = true;
        }

        function open16() {
            $scope.opened16 = true;
        }

        $scope.open17 = open17;
        $scope.opened17 = false;
        $scope.open18 = open18;
        $scope.opened18 = false;
        $scope.options = {
            showWeeks: false
        };

        function open17() {
            $scope.opened17 = true;
        }

        function open18() {
            $scope.opened18 = true;
        }

        $scope.open19 = open19;
        $scope.opened19 = false;
        $scope.open20 = open20;
        $scope.opened20 = false;
        $scope.options = {
            showWeeks: false
        };

        function open19() {
            $scope.opened19 = true;
        }

        function open20() {
            $scope.opened20 = true;
        }

        $scope.open21 = open21;
        $scope.opened21 = false;
        $scope.open22 = open22;
        $scope.opened22 = false;
        $scope.options = {
            showWeeks: false
        };

        function open21() {
            $scope.opened21 = true;
        }

        function open22() {
            $scope.opened22 = true;
        }

        $scope.open23 = open23;
        $scope.opened23 = false;
        $scope.open24 = open24;
        $scope.opened24 = false;
        $scope.options = {
            showWeeks: false
        };

        function open23() {
            $scope.opened23 = true;
        }

        function open24() {
            $scope.opened24 = true;
        }

        // $scope.open24= open24;
        // $scope.opened24 = false;
        $scope.open25 = open25;
        $scope.opened25 = false;
        $scope.options = {
            showWeeks: false
        };

        // function open24() {
        //     $scope.opened24 = true;
        // }

        function open25() {
            $scope.opened25 = true;
        }

        $scope.open26 = open26;
        $scope.opened26 = false;
        $scope.open27 = open27;
        $scope.opened27 = false;
        $scope.options = {
            showWeeks: false
        };

        function open26() {
            $scope.opened26 = true;
        }

        function open27() {
            $scope.opened27 = true;
        }

        $scope.open28 = open28;
        $scope.opened28 = false;
        $scope.open29 = open29;
        $scope.opened29 = false;
        $scope.options = {
            showWeeks: false
        };

        function open28() {
            $scope.opened28 = true;
        }

        function open29() {
            $scope.opened29 = true;
        }
    }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';
  angular.module('Merchant.pages.myOutlet')
    .controller('TypeandfeaturesPageCtrl', TypeandfeaturesPageCtrl);
  /** @ngInject */
  function TypeandfeaturesPageCtrl($scope, $filter, editableOptions, editableThemes, $timeout,$rootScope) {
    $rootScope.activeTab =2;
   
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Alcohol Served',
          img: 'liveentertainment.png'
        },
        {
          name: 'Brunch',
          img: 'brunch.png'
        },
        {
          name: 'Buffet',
          img: 'buffet.png'
        },
        {
          name: 'Credit Card',
          img: 'creditcards.png'
        },
        {
          name: 'Cuisine',
          img: 'cuisine.png'
        },
        {
          name: 'Dress Code',
          img: 'dresscode.png'
        },
        {
          name: 'Fine /Luxury Dining',
          img: 'fineluxury.png'
        },
        {
          name: 'Friday Brunch',
          img: 'fridaybrunch.png'
        },
        {
          name: 'Group Welcome',
          img: 'groupwelcome.png'
        },
        {
          name: 'Halal',
          img: 'halai.png'
        },
        {
          name: 'Kids welcome',
          img: 'Kidwelcome.png'
        },
        {
          name: 'Live Entertainment',
          img: 'liveentertainment.png'
        },
        {
          name: 'Happy Hours',
          img: 'hapyhours.png' 
        },
        {
          name: 'Outdoor Cooling ',
          img: 'outdoorcooling.png'
        },
        {
         name: 'Kids Supervised play Area',
         img: 'kidsupervised.png'
        },
        {
        name: 'Outdoor Seating',
         img: 'outdorseating.png'
        },
        {
          name: 'Parking',
          img: 'parking.png'
        },
        {
          name: 'Pets Permitted',
          img: 'petpermitted.png'
        },
        {
          name: 'Pork Products Available',
          img: 'porkproduct.png'
        },
        {
          name: 'Pure Vegetarian',
          img: 'Pure Vegitarian.png'
        },
        {
          name: 'Smoking indoor',
          img: 'smokingindoor.png'
        },
        {
          name: 'Smoking Outdoor',
          img: 'smokingoutdoor.png'
        },
        {
          name: 'Smoking Shisha',
          img: 'Smoking Shisha.png'
        },
      ]
    }
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';
  angular.module('Merchant.pages.myOutlet')
    .controller('ValidationPinsPageCtrl', ValidationPinsPageCtrl);
  /** @ngInject */
  function ValidationPinsPageCtrl($scope, $filter, editableOptions, editableThemes, $timeout,$rootScope) {
    $rootScope.activeTab =5;
    $scope.outletFilter;
    $scope.isFilterLabel = false;
    $scope.outletFilterLists = [{
      name: "Outlet1",
      value: "Outlet1"
    },
    {
      name: "Outlet2",
      value: "Outlet2"
    },
    {
      name: "Outlet3",
      value: "Outlet3"
    }
    ];   

    $(function () {
      // We can attach the `fileselect` event to all file inputs on the page
      $(document).on('change', ':file', function () {
        var input = $(this),
          numFiles = input.get(0).files ? input.get(0).files.length : 1,
          label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
        input.trigger('fileselect', [numFiles, label]);
      });

      // We can watch for our custom `fileselect` event like this
      $(document).ready(function () {
        $(':file').on('fileselect', function (event, numFiles, label) {

          var input = $(this).parents('.input-group').find(':text'),
            log = numFiles > 1 ? numFiles + ' files selected' : label;

          if (input.length) {
            input.val(log);
          } else {
            if (log) alert(log);
          }

        });
      });

    });

  }
  // function datepickerpopupCtrl($scope) {

  // }
})();
(function () {
    'use strict';

    angular.module('Merchant.pages.report')
        .controller('CreditsReportsPageCtrl', CreditsReportsPageCtrl);

    /** @ngInject */
    function CreditsReportsPageCtrl($scope, $timeout, baConfig) {


        $scope.creditsLabels = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
        $scope.creditsDatas = [
            [10, 30, 15, 25, 40, 40, 60]
        ];
        $scope.creditsLineColors = [{
            backgroundColor: 'transparent',
            borderColor: '#4F7DC6',
            pointBorderColor: '#50B8D9',
            pointBackgroundColor: '#ffffff',
            pointHoverBackgroundColor: '#5E74CE',
            pointHoverBorderColor: '#5E74CE',
            borderWidth: 3,
            pointBorderWidth: 10,
            pointBorderColor: "#50B8D9"
        }];

        $scope.creditsOptions = {
            elements: {
             
                line: {
                    tension: 0
                }
              
            },
            
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'CREDITS',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'TIME UNIT',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }]
            }

        };


        $scope.credits1Labels = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
        $scope.credits1Datas = [
            [10, 30, 15, 25, 40, 40, 60]
        ];
        $scope.credits1LineColors = [{
            backgroundColor: 'transparent',
            borderColor: '#BFF19A',
            pointBorderColor: '#54D8C0',
            pointBackgroundColor: '#ffffff',
            pointHoverBackgroundColor: '#ffffff',
            pointHoverBorderColor: '#BFF19A',
            borderWidth: 3,
            pointBorderWidth: 10,
            pointBorderColor: "#54D8C0"
        }];
        
        
        $scope.credits1Options = {
            elements: {
                line: {
                    tension: 0
                },
                center: {
                    text: 'Desktop',
                    color: '#36A2EB', //Default black
                    fontStyle: 'Helvetica', //Default Arial
                    sidePadding: 15 //Default 20 (as a percentage)
                  }
            },
            
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'CREDITS',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'TIME UNIT',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }]
            }
        };



        $scope.returnCustColors = ["#636BE4", "#FF6557"];
        $scope.returnCustLabels = ["70% are new to your business.", "40% are curent customers"];
        $scope.returnCustData = [70, 40];

        $scope.returnCust1Colors = ["#636BE4", "#FF6557"];
        $scope.returnCust1Labels = ["70% are new to your business.", "40% are curent customers"];
        $scope.returnCust1Data = [70, 40];


    }
})();
(function() {
    'use strict';

    angular.module('Merchant.pages.report')
        .controller('PerformanceOverviewPageCtrl', PerformanceOverviewPageCtrl);

    /** @ngInject */
    function PerformanceOverviewPageCtrl($scope,  $timeout, baConfig) {


      


        $scope.openFrom = openFrom;
        $scope.openedFrom = false;
        $scope.openTo = openTo;
        $scope.openedTo = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function openFrom() {
            $scope.openedFrom = true;
        }

        function openTo() {
            $scope.openedTo = true;
        }



        $scope.overviewLabels = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
        $scope.overviewDatas = [
            [10, 30, 15, 25, 40, 40, 60]
        ];
        $scope.overviewLineColors = [{
            backgroundColor: 'transparent',
            borderColor: '#4F7DC6',
            pointBorderColor: '#50B8D9',
            pointBackgroundColor: '#ffffff',
            pointHoverBackgroundColor: '#66B3CC',
            pointHoverBorderColor: '#5E74CE',
            borderWidth: 3,
            pointBorderWidth: 10,
            pointBorderColor: "#66B3CC"
        }];

        $scope.overviewOptions = {           
            elements: {
                line: {
                    tension: 0
                }
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'OUTLETS ADDED',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'TIME',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }]
            }
        };

        $scope.revenueLabels = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
        $scope.revenueDatas = [
            [10, 30, 15, 25, 40, 40, 60]
        ];
        $scope.revenueLineColors = [{
            backgroundColor: 'transparent',
            borderColor: '#BFF19A',
            pointBorderColor: '#54D8C0',
            pointBackgroundColor: '#ffffff',
            pointHoverBackgroundColor: '#ffffff',
            pointHoverBorderColor: '#BFF19A',
            borderWidth: 3,
            pointBorderWidth: 10,
            pointBorderColor: "#54D8C0"
        }];

        $scope.revenueOptions = {           
            elements: {
                line: {
                    tension: 0
                }
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'REVENUE',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'TIME',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }]
            }
        };


        $scope.custsLabels = ["500", "1000", "1500", "2000", "2500", "3000", "3500", "4000", "4500", "5000"];
        $scope.custsDatas = [
            [10, 30, 15, 25, 40, 40, 60]
        ];
        $scope.custsLineColors = [{
            backgroundColor: 'transparent',
            borderColor: '#FAA370',
            pointBorderColor: '#C44483',
            pointBackgroundColor: '#ffffff',
            pointHoverBackgroundColor: '#ffffff',
            pointHoverBorderColor: '#FAA370',
            borderWidth: 3,
            pointBorderWidth: 10,
            pointBorderColor: "#C44483"
        }];

        $scope.custsOptions = {           
            elements: {
                line: {
                    tension: 0
                }
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'CUSTOMERS',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'TIME',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }]
            }
        };



        


       



    }
})();
(function() {
    'use strict';

    angular.module('Merchant.pages.report')
        .controller('ReferralsActivitiesPageCtrl', ReferralsActivitiesPageCtrl);

    /** @ngInject */
    function ReferralsActivitiesPageCtrl($scope,  $timeout, baConfig) {       


        $scope.referralLabels = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
        $scope.referralDatas = [
            [10, 30, 15, 25, 40, 40, 60]
        ];
        $scope.referralLineColors = [{
            backgroundColor: 'transparent',
            borderColor: '#4F7DC6',
            pointBorderColor: '#50B8D9',
            pointBackgroundColor: '#ffffff',
            pointHoverBackgroundColor: '#5E74CE',
            pointHoverBorderColor: '#5E74CE',
            borderWidth: 3,
            pointBorderWidth: 10,
            pointBorderColor: "#50B8D9"
        }];

        $scope.referralOptions = {           
            elements: {
                line: {
                    tension: 0
                }
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'REFERRALS',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'TIME UNIT',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }]
            }
        };


        $scope.revenueLabels = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
        $scope.revenueDatas = [
            [10, 30, 15, 25, 40, 40, 60]
        ];
        $scope.revenueLineColors = [{
            backgroundColor: 'transparent',
            borderColor: '#BFF19A',
            pointBorderColor: '#54D8C0',
            pointBackgroundColor: '#ffffff',
            pointHoverBackgroundColor: '#ffffff',
            pointHoverBorderColor: '#BFF19A',
            borderWidth: 3,
            pointBorderWidth: 10,
            pointBorderColor: "#54D8C0"
        }];

        $scope.revenueOptions = {           
            elements: {
                line: {
                    tension: 0
                }
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'REVENUE',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'TIME UNIT',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }]
            }
        };



        $scope.returnCustColors = ["#636BE4", "#FF6557"];
        $scope.returnCustLabels = ["70% are new to your business.", "40% are curent customers"];
        $scope.returnCustData = [70, 40];

        $scope.returnCust1Colors = ["#636BE4", "#FF6557"];
        $scope.returnCust1Labels = ["70% are new to your business.", "40% are curent customers"];
        $scope.returnCust1Data = [70, 40];



        $scope.horzData = ["37", "26", "17", "12", "8"];
        $scope.horzLabels = ["Visitors1", "Visitors2", "Visitors3", "Visitors4", "Visitors5"];
        $scope.horzBarColors = ['#A1D8E3', '#A1D8E3', '#A1D8E3', '#A1D8E3', '#A1D8E3']
        // $scope.horzBarColors = [{
        //     backgroundColor: '#b3e7fb',
        //     borderColor: '#b3e7fb',
        //     hoverBackgroundColor: '#b3e7fb',
        //     hoverBorderColor: '#b3e7fb'       
        // }];

        $scope.options2 = {           
            scales: {
                xAxes: [{
                  display: false
                }],
                yAxes: [{
                  display: false
                }],
                
              },
              backgroundColor: '#b3e7fb'
        };
        


    }
})();
(function() {
    'use strict';

    angular.module('Merchant.pages.report')
        .controller('VisitorsReportPageCtrl', VisitorsReportPageCtrl);

    /** @ngInject */
    function VisitorsReportPageCtrl($scope,  $timeout, baConfig) {


       
        $scope.visitorsLabels = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
        $scope.visitorsDatas = [
            [10, 30, 15, 25, 40, 40, 60]
        ];
        $scope.visitorsLineColors = [{
            backgroundColor: 'transparent',
            borderColor: '#BFF19A',
            // pointBorderColor: '#54D8C0',
            pointBackgroundColor: '#ffffff',
            pointHoverBackgroundColor: '#ffffff',
            pointHoverBorderColor: '#BFF19A',
            borderWidth: 3,
            pointBorderWidth: 10,
            pointBorderColor: "#54D8C0"
        }];

        $scope.visitorsOptions = {           
            elements: {
                line: {
                    tension: 0
                }
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'VISITORS',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'TIME UNIT',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }]
            }
        };


        $scope.revenueLabels = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
        $scope.revenueDatas = [
            [10, 30, 15, 25, 40, 40, 60]
        ];
        $scope.revenueLineColors = [{
            backgroundColor: 'transparent',
            borderColor: '#FAA370',
            pointBorderColor: '#C44483',
            pointBackgroundColor: '#ffffff',
            pointHoverBackgroundColor: '#ffffff',
            pointHoverBorderColor: '#FAA370',
            borderWidth: 3,
            pointBorderWidth: 10,
            pointBorderColor: "#C44483"
        }];

        $scope.revenueOptions = {           
            elements: {
                line: {
                    tension: 0
                }
            },
            scales: {
                xAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'REVENUE',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }],
                yAxes: [{
                    display: true,
                    scaleLabel: {
                        display: true,
                        labelString: 'TIME UNIT',
                        fontSize: 22,
                        fontColor: '#586777'
                    }
                }]
            }
        };
     
        $scope.returnCustColors = ["#636BE4", "#FF6557"];
        $scope.returnCustLabels = ["70% are new to your business.", "40% are curent customers"];
        $scope.returnCustData = [70, 40];


        $scope.horzData = ["37", "26", "17", "12", "8"];
        $scope.horzLabels = ["Visitors1", "Visitors2", "Visitors3", "Visitors4", "Visitors5"];
        $scope.horzBarColors = ['#A1D8E3', '#A1D8E3', '#A1D8E3', '#A1D8E3', '#A1D8E3']
       
        // $scope.horzBarColors = [{
        //     backgroundColor: '#b3e7fb',
        //     borderColor: '#b3e7fb',
        //     hoverBackgroundColor: '#b3e7fb',
        //     hoverBorderColor: '#b3e7fb'       
        // }];

        $scope.options2 = {           
            scales: {
                xAxes: [{
                  display: false
                }],
                yAxes: [{
                  display: false
                }],
                
              }             
        };

    }
})();
(function() {
    'use strict';

    angular.module('Merchant.pages.reservation')
        .controller('OverviewPageCtrl', OverviewPageCtrl);

    /** @ngInject */
    function OverviewPageCtrl($scope, baConfig,$rootScope) {
        $rootScope.activeTab = 0;
        $scope.outletFilter;
        $scope.isFilterLabel = false;
        $scope.outletFilterLists = [{
          name: "Outlet1",
          value: "Outlet1"
        },
        {
          name: "Outlet2",
          value: "Outlet2"
        },
        {
          name: "Outlet3",
          value: "Outlet3"
        }
        ];
        
        $scope.days = [{
            name: "LAST 7 days",
            value: "LAST 7 days"
          },
          {
            name: "Last 1 WEEK",
            value: "Last 1 WEEK"
          },
          {
            name: "LAST 1 MONTH",
            value: "LAST 1 MONTH"
          }
          ];

        $scope.openFrom = openFrom;
        $scope.openedFrom = false;
        $scope.openTo = openTo;
        $scope.openedTo = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[2];
        $scope.options = {
            showWeeks: false
        };

        function openFrom() {
            $scope.openedFrom = true;
        }

        function openTo() {
            $scope.openedTo = true;
        }

        $scope.open1 = open1;
        $scope.opened1 = false;
        $scope.open2 = open2;
        $scope.opened2 = false;
        $scope.options = {
            showWeeks: false
        };

        function open1() {
            $scope.opened1 = true;
        }

        function open2() {
            $scope.opened2 = true;
        }


        $scope.open3 = open3;
        $scope.opened3 = false;
        $scope.open4 = open4;
        $scope.opened4 = false;
        $scope.options = {
            showWeeks: false
        };

        function open3() {
            $scope.opened3 = true;
        }

        function open4() {
            $scope.opened4 = true;
        }

        $scope.open6 = open6;
        $scope.opened6 = false;
        $scope.open5 = open5;
        $scope.opened5 = false;
        $scope.options = {
            showWeeks: false
        };

        function open6() {
            $scope.opened6 = true;
        }

        function open5() {
            $scope.opened5 = true;
        }




        $scope.labels = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24"];
        $scope.data = ["100", "200", "300", "450", "500", "633", "733", "508", "339", "770", "181", "120", "813", "1014", "1015", "316", "917", "518", "419", "220", "21", "122", "723", "424"];

        var layoutColors = baConfig.colors;
        $scope.labels1 = ["Service", "Cleaning", "Value", "Facility"];
        $scope.data1 = [20, 40, 5, 35];
        $scope.options1 = {
            elements: {
                arc: {
                    borderWidth: 0
                }
            },
            legend: {
                display: true,
                position: 'right',
                labels1: {
                    fontColor: layoutColors.defaultText
                }
            }
        };
        $scope.labels3 = ["May", "Jun", "Jul", "Aug", "Sep"];
        $scope.data3 = [
            [65, 59, 90, 81, 56],
            [28, 48, 40, 19, 88]
        ];

    }
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui.buttons')
      .controller('ButtonPageCtrl', ButtonPageCtrl);

  /** @ngInject */
  function ButtonPageCtrl($scope, $timeout) {
    $scope.progressFunction = function() {
      return $timeout(function() {}, 3000);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui.icons')
      .controller('IconsPageCtrl', IconsPageCtrl);

  /** @ngInject */
  function IconsPageCtrl($scope) {
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Beach',
          img: 'Beach'
        },
        {
          name: 'Bus',
          img: 'Bus'
        },
        {
          name: 'Cheese',
          img: 'Cheese'
        },
        {
          name: 'Desert',
          img: 'Desert'
        },
        {
          name: 'Images',
          img: 'Images'
        },
        {
          name: 'Magician',
          img: 'Magician'
        },
        {
          name: 'Makeup',
          img: 'Makeup'
        },
        {
          name: 'Programming',
          img: 'Programming'
        },
        {
          name: 'Shop',
          img: 'Shop'
        },
        {
          name: 'Surfer',
          img: 'Surfer'
        },
        {
          name: 'Phone Booth',
          img: 'Phone-Booth'
        },
        {
          name: 'Ninja',
          img: 'Ninja'
        },
        {
          name: 'Apartment',
          img: 'Apartment'
        },
        {
          name: 'Batman',
          img: 'Batman'
        },
        {
          name: 'Medal',
          img: 'Medal-2'
        },
        {
          name: 'Money',
          img: 'Money-Increase'
        },
        {
          name: 'Street View',
          img: 'Street-View'
        },
        {
          name: 'Student',
          img: 'Student-3'
        },
        {
          name: 'Bell',
          img: 'Bell'
        },
        {
          name: 'Woman',
          img: 'Boss-5'
        },
        {
          name: 'Euro',
          img: 'Euro-Coin'
        },
        {
          name: 'Chessboard',
          img: 'Chessboard'
        },
        {
          name: 'Burglar',
          img: 'Burglar'
        },
        {
          name: 'Dna',
          img: 'Dna'
        },
        {
          name: 'Clipboard Plan',
          img: 'Clipboard-Plan'
        },
        {
          name: 'Boss',
          img: 'Boss-3'
        },
        {
          name: 'Key',
          img: 'Key'
        },
        {
          name: 'Surgeon',
          img: 'Surgeon'
        },
        {
          name: 'Hacker',
          img: 'Hacker'
        },
        {
          name: 'Santa',
          img: 'Santa'
        }
      ],
      kameleonRoundedIcons: [
        {
          color: 'success',
          img: 'Apartment',
          name: 'Apartment'
        },
        {
          color: 'warning',
          img: 'Bus',
          name: 'Bus'
        },
        {
          color: 'primary',
          img: 'Checklist',
          name: 'Checklist'
        },
        {
          color: 'warning',
          img: 'Desert',
          name: 'Desert'
        },
        {
          color: 'danger',
          img: 'Laptop-Signal',
          name: 'Laptop Signal'
        },
        {
          color: 'info',
          img: 'Love-Letter',
          name: 'Love Letter'
        },
        {
          color: 'success',
          img: 'Makeup',
          name: 'Makeup'
        },
        {
          color: 'primary',
          img: 'Santa',
          name: 'Santa'
        },
        {
          color: 'success',
          img: 'Surfer',
          name: 'Surfer'
        },
        {
          color: 'info',
          img: 'Vector',
          name: 'Vector'
        },
        {
          color: 'warning',
          img: 'Money-Increase',
          name: 'Money Increase'
        },
        {
          color: 'info',
          img: 'Alien',
          name: 'Alien'
        },
        {
          color: 'danger',
          img: 'Online-Shopping',
          name: 'Online Shopping'
        },
        {
          color: 'warning',
          img: 'Euro-Coin',
          name: 'Euro'
        },
        {
          color: 'info',
          img: 'Boss-3',
          name: 'Boss'
        }
      ],
      ionicons: ['ion-ionic', 'ion-arrow-right-b', 'ion-arrow-down-b', 'ion-arrow-left-b', 'ion-arrow-up-c', 'ion-arrow-right-c', 'ion-arrow-down-c', 'ion-arrow-left-c', 'ion-arrow-return-right', 'ion-arrow-return-left', 'ion-arrow-swap', 'ion-arrow-shrink', 'ion-arrow-expand', 'ion-arrow-move', 'ion-arrow-resize', 'ion-chevron-up', 'ion-chevron-right', 'ion-chevron-down', 'ion-chevron-left', 'ion-navicon-round', 'ion-navicon', 'ion-drag', 'ion-log-in', 'ion-log-out', 'ion-checkmark-round', 'ion-checkmark', 'ion-checkmark-circled', 'ion-close-round', 'ion-plus-round', 'ion-minus-round', 'ion-information', 'ion-help', 'ion-backspace-outline', 'ion-help-buoy', 'ion-asterisk', 'ion-alert', 'ion-alert-circled', 'ion-refresh', 'ion-loop', 'ion-shuffle', 'ion-home', 'ion-search', 'ion-flag', 'ion-star', 'ion-heart', 'ion-heart-broken', 'ion-gear-a', 'ion-gear-b', 'ion-toggle-filled', 'ion-toggle', 'ion-settings', 'ion-wrench', 'ion-hammer', 'ion-edit', 'ion-trash-a', 'ion-trash-b', 'ion-document', 'ion-document-text', 'ion-clipboard', 'ion-scissors', 'ion-funnel', 'ion-bookmark', 'ion-email', 'ion-email-unread', 'ion-folder', 'ion-filing', 'ion-archive', 'ion-reply', 'ion-reply-all', 'ion-forward'],
      fontAwesomeIcons: ['fa fa-adjust', 'fa fa-anchor', 'fa fa-archive', 'fa fa-area-chart', 'fa fa-arrows', 'fa fa-arrows-h', 'fa fa-arrows-v', 'fa fa-asterisk', 'fa fa-at', 'fa fa-automobile', 'fa fa-ban', 'fa fa-bank', 'fa fa-bar-chart', 'fa fa-bar-chart-o', 'fa fa-barcode', 'fa fa-bars', 'fa fa-bed', 'fa fa-beer', 'fa fa-bell', 'fa fa-bell-o', 'fa fa-bell-slash', 'fa fa-bell-slash-o', 'fa fa-bicycle', 'fa fa-binoculars', 'fa fa-birthday-cake', 'fa fa-bolt', 'fa fa-bomb', 'fa fa-book', 'fa fa-bookmark', 'fa fa-bookmark-o', 'fa fa-briefcase', 'fa fa-bug', 'fa fa-building', 'fa fa-building-o', 'fa fa-bullhorn'],
      socicon: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ',', ';', ':', '+', '@', '=', '-', '^', '?', '$', '*', '&', '(', '#', '.', '_', ']', ')', '\'', '"', '}', '{']
    }
  }

})();

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal, baProgressModal, toastr) {
    

    $scope.showSuccessMsg = function() {
      toastr.success('Thanking for submitting this form!');
    };
    // $scope.showErrorMsg = function() {
    //   toastr.error("This form has been cancelled by User", 'Error');
    // };
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
    
    $scope.openProgressDialog = baProgressModal.open;
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, toastr, toastrConfig) {
    var defaultConfig = angular.copy(toastrConfig);
    $scope.types = ['success', 'error', 'info', 'warning'];

    $scope.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Looking for bootstrap?',
        message: 'Try ui-bootstrap out!'
      },
      {
        title: 'Wants a better router?',
        message: 'We have you covered with ui-router'
      },
      {
        title: 'Angular 2',
        message: 'Is gonna rock the world'
      },
      {
        title: null,
        message: 'Titles are not always needed'
      },
      {
        title: null,
        message: 'Toastr rock!'
      },
      {
        title: 'What about nice html?',
        message: '<strong>Sure you <em>can!</em></strong>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Ionic is <em>cool</em>',
        message: 'Best mobile framework ever',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    $scope.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      type: 'info',
      timeOut: '5000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: false,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      title: "Some title here",
      msg: "Type your message here"
    };


    $scope.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    $scope.clearToasts = function () {
      toastr.clear();
    };

    $scope.openRandomToast = function () {
      var type = Math.floor(Math.random() * $scope.types.length);
      var quote = Math.floor(Math.random() * $scope.quotes.length);
      var toastType = $scope.types[type];
      var toastQuote = $scope.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      $scope.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    $scope.openToast = function () {
      angular.extend(toastrConfig, $scope.options);
      openedToasts.push(toastr[$scope.options.type]($scope.options.msg, $scope.options.title));
      var strOptions = {};
      for (var o in  $scope.options) if (o != 'msg' && o != 'title')strOptions[o] = $scope.options[o];
      $scope.optionsStr = "toastr." + $scope.options.type + "(\'" + $scope.options.msg + "\', \'" + $scope.options.title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
      angular.extend(toastrConfig, defaultConfig);
    })
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('Merchant.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('Merchant.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('Merchant.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('Merchant.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

(function() {
  'use strict';

  angular.module('Merchant.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('Merchant.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('Merchant.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();

(function () {
'use strict';

angular.module('Merchant')

.factory('auth.interceptor', function($q, $rootScope) {
    console.log('auth')
    
    var interceptor = {
        response: function (response)  
        {  
            
            if (response.status == 200 ){
                $rootScope.$emit('event:auth:valide:token',response);
              }
              
            return response;  
        }, 
        responseError: function(response) {
            // Session has expired
            
            if (response.status == 401 || response.status == 403){
              $rootScope.$emit('event:auth:invalid:token',response);
            }

            return $q.reject(response);
        }
    };
    return interceptor;
});
})();
(function () {
    'use strict';

    angular
        .module('Merchant')
        .factory('rest.interceptor', function () {
            // console.log('asdsad')
            return {
                request: function (config) {
                    console.log('request started...'); 
                   
                    return config;
                }
            };
        }).run(function($http) {
            var token = localStorage.getItem("token")
            // console.log('sam');    
            if(token != null){
                // alert('front')
            // $http.defaults.headers.common['Auth-Token'] = token;
            }else{
                // alert('admin')
                // window.location.href = AdminPortalUrl + 'login';
            }
          
          });
        
        ;


} ());




/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme.components')
      .directive('pageTop', pageTop);

  /** @ngInject */
  function pageTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('Merchant.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('Merchant.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
    'use strict';

    angular.module('Merchant.theme.inputs')
        .component('googleMaps', {
            bindings: {
                label: "@",
                textValue: "=",
                isDisable: "<",
                radioList: "<",
                isHorizontalForm: "<",
                xs: "<",
                lg: "<",
                isLabel: "<"
            },
            templateUrl: "app/theme/inputs/maps/maps.html",
            controller: function () {
                var vm = this;
                var mapCanvas = document.getElementById('googleMaps');
                var mapOptions = {
                    center: new google.maps.LatLng(44.5403, -78.5463),
                    zoom: 8,
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                };
                var map = new google.maps.Map(mapCanvas, mapOptions);

            }
        });

    /** @ngInject */

})();
/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function() {
    'use strict';

    angular.module('Merchant.theme.inputs')
        .component('vouchedRadioButton', {
            bindings: {
                label: "@",
                textValue: "=",
                isDisable: "<",
                radioList: "<",
                isHorizontalForm: "<",
                xs: "<",
                lg: "<",
                isLabel: "<"
            },
            templateUrl: "app/theme/inputs/radioButton/radioButton.html",
            controller: function() {
                var vm = this;
                vm.$onInit = function() {
                    vm.isDisable = vm.isDisable || false;
                    vm.isLabel = vm.isLabel == false ? vm.isLabel : true;
                    vm.isHorizontalForm = vm.isHorizontalForm || false;
                    vm.xs = vm.xs || 3;
                    vm.lg = vm.lg || 3
                }

            }
        });

    /** @ngInject */

})();
/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
    'use strict';

    angular.module('Merchant.theme.inputs')
        .component('vouchedSelect', {
            bindings: {
                label: "@",
                selectedValue: "=",
                isSearchable: "<",
                displayField: "@",
                selectLists: "<",
                isDisable: "<",
                isMultiple: "<",
                isLabel: "<"
            },
            templateUrl: "app/theme/inputs/select/select.html",
            controller: function () {
                var vm = this;
                vm.$onInit = function () {
                    vm.isSearchable = vm.isSearchable || false;
                    vm.isDisable = vm.isDisable || false
                    vm.isMultiple = vm.isMultiple || false;
                    vm.isLabel = vm.isLabel == false ? vm.isLabel : true;
                }

                console.log("lists", vm.selectLists)

            }
        });

    /** @ngInject */

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
    'use strict';

    angular.module('Merchant.theme.inputs')
        .component('vouchedTextArea', {
            bindings: {
                label: "@",
                textValue: "=",
                rows: "@"
            },
            templateUrl: "app/theme/inputs/textArea/textArea.html",
            controller: function () {
                var vm = this;
                vm.$onInit = function () {
                    vm.rows = vm.rows || 4;
                }
            }
        });

    /** @ngInject */

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
    'use strict';

    angular.module('Merchant.theme.inputs')
        .component('vouchedTextBox', {
            bindings: {
                label: "@",
                textValue: "=",
                isLabel: "<",
                isHorizontalForm: "<"
            },
            templateUrl: "app/theme/inputs/textBox/textBox.html",
            controller: function () {
                var vm = this;
                vm.isLabel = vm.isLabel == false ? vm.isLabel : true;
                vm.isHorizontalForm = vm.isHorizontalForm || false;
            }
        });

    /** @ngInject */

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.charts.amCharts')
      .controller('AreaChartCtrl', AreaChartCtrl);

  /** @ngInject */
  function AreaChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var areaChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          lineColor: layoutColors.info,
          date: '2012-01-01',
          duration: 408
        },
        {
          date: '2012-01-02',
          duration: 482
        },
        {
          date: '2012-01-03',
          duration: 562
        },
        {
          date: '2012-01-04',
          duration: 379
        },
        {
          lineColor: layoutColors.warning,
          date: '2012-01-05',
          duration: 501
        },
        {
          date: '2012-01-06',
          duration: 443
        },
        {
          date: '2012-01-07',
          duration: 405
        },
        {
          date: '2012-01-08',
          duration: 309,
          lineColor: layoutColors.danger
        },
        {
          date: '2012-01-09',
          duration: 287
        },
        {
          date: '2012-01-10',
          duration: 485
        },
        {
          date: '2012-01-11',
          duration: 890
        },
        {
          date: '2012-01-12',
          duration: 810
        }
      ],
      balloon: {
        cornerRadius: 6,
        horizontalPadding: 15,
        verticalPadding: 10
      },
      valueAxes: [
        {
          duration: 'mm',
          durationUnits: {
            hh: 'h ',
            mm: 'min'
          },
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          bullet: 'square',
          bulletBorderAlpha: 1,
          bulletBorderThickness: 1,
          fillAlphas: 0.5,
          fillColorsField: 'lineColor',
          legendValueText: '[[value]]',
          lineColorField: 'lineColor',
          title: 'duration',
          valueField: 'duration'
        }
      ],

      chartCursor: {
        categoryBalloonDateFormat: 'YYYY MMM DD',
        cursorAlpha: 0,
        fullWidth: true
      },
      dataDateFormat: 'YYYY-MM-DD',
      categoryField: 'date',
      categoryAxis: {
        dateFormats: [
          {
            period: 'DD',
            format: 'DD'
          },
          {
            period: 'WW',
            format: 'MMM DD'
          },
          {
            period: 'MM',
            format: 'MMM'
          },
          {
            period: 'YYYY',
            format: 'YYYY'
          }
        ],
        parseDates: true,
        autoGridCount: false,
        gridCount: 50,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      pathToImages: layoutPaths.images.amChart
    });

    areaChart.addListener('dataUpdated', zoomAreaChart);

    function zoomAreaChart() {
      areaChart.zoomToDates(new Date(2012, 0, 3), new Date(2012, 0, 11));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.charts.amCharts')
      .controller('BarChartCtrl', BarChartCtrl);

  /** @ngInject */
  function BarChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var barChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          country: 'USA',
          visits: 3025,
          color: layoutColors.primary
        },
        {
          country: 'China',
          visits: 1882,
          color: layoutColors.danger

        },
        {
          country: 'Japan',
          visits: 1809,
          color: layoutColors.info
        },
        {
          country: 'Germany',
          visits: 1322,
          color: layoutColors.success
        },
        {
          country: 'UK',
          visits: 1122,
          color: layoutColors.warning
        },
        {
          country: 'France',
          visits: 1114,
          color: layoutColors.primaryLight
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          title: 'Visitors from country',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      startDuration: 1,
      graphs: [
        {
          balloonText: '<b>[[category]]: [[value]]</b>',
          fillColorsField: 'color',
          fillAlphas: 0.7,
          lineAlpha: 0.2,
          type: 'column',
          valueField: 'visits'
        }
      ],
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        zoomable: false
      },
      categoryField: 'country',
      categoryAxis: {
        gridPosition: 'start',
        labelRotation: 45,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'top-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.charts.amCharts')
    .controller('combinedChartCtrl', combinedChartCtrl);

  /** @ngInject */
  function combinedChartCtrl($element, baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart(id, {
      "type": "serial",
      "theme": "none",
      "color": layoutColors.defaultText,
      "dataDateFormat": "YYYY-MM-DD",
      "precision": 2,
      "valueAxes": [{
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v1",
        "title": "Sales",
        "position": "left",
        "autoGridCount": false,
        "labelFunction": function(value) {
          return "$" + Math.round(value) + "M";
        }
      }, {
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v2",
        "title": "Market Days",
        "gridAlpha": 0,
        "position": "right",
        "autoGridCount": false
      }],
      "graphs": [{
        "id": "g3",
        color: layoutColors.defaultText,
        "valueAxis": "v1",
        "lineColor": layoutColors.primaryLight,
        "fillColors": layoutColors.primaryLight,
        "fillAlphas": 0.8,
        "lineAlpha": 0.8,
        "type": "column",
        "title": "Actual Sales",
        "valueField": "sales2",
        "clustered": false,
        "columnWidth": 0.5,
        "lineColorField" : layoutColors.defaultText,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g4",
        "valueAxis": "v1",
        color: layoutColors.defaultText,
        "lineColor": layoutColors.primary,
        "fillColors": layoutColors.primary,
        "fillAlphas": 0.9,
        "lineAlpha": 0.9,
        "type": "column",
        "title": "Target Sales",
        "valueField": "sales1",
        "clustered": false,
        "columnWidth": 0.3,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g1",
        "valueAxis": "v2",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        color: layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.danger,
        "type": "smoothedLine",
        "title": "Market Days",
        "useLineColorForBulletBorder": true,
        "valueField": "market1",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }, {
        "id": "g2",
        "valueAxis": "v2",
        color: layoutColors.defaultText,
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.warning,
        "type": "smoothedLine",
        "dashLength": 5,
        "title": "Market Days ALL",
        "useLineColorForBulletBorder": true,
        "valueField": "market2",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }],
      "chartScrollbar": {
        "graph": "g1",
        "oppositeAxis": false,
        "offset": 30,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 50,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      "chartCursor": {
        "pan": true,
        "cursorColor" : layoutColors.danger,
        "valueLineEnabled": true,
        "valueLineBalloonEnabled": true,
        "cursorAlpha": 0,
        "valueLineAlpha": 0.2
      },
      "categoryField": "date",
      "categoryAxis": {
        "axisColor": layoutColors.defaultText,
        "color": layoutColors.defaultText,
        "gridColor": layoutColors.defaultText,
        "parseDates": true,
        "dashLength": 1,
        "minorGridEnabled": true
      },
      "legend": {
        "useGraphSettings": true,
        "position": "top",
        "color": layoutColors.defaultText
      },
      "balloon": {
        "borderThickness": 1,
        "shadowAlpha": 0
      },
      "export": {
        "enabled": true
      },
      "dataProvider": [{
        "date": "2013-01-16",
        "market1": 71,
        "market2": 75,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-17",
        "market1": 74,
        "market2": 78,
        "sales1": 4,
        "sales2": 6
      }, {
        "date": "2013-01-18",
        "market1": 78,
        "market2": 88,
        "sales1": 5,
        "sales2": 2
      }, {
        "date": "2013-01-19",
        "market1": 85,
        "market2": 89,
        "sales1": 8,
        "sales2": 9
      }, {
        "date": "2013-01-20",
        "market1": 82,
        "market2": 89,
        "sales1": 9,
        "sales2": 6
      }, {
        "date": "2013-01-21",
        "market1": 83,
        "market2": 85,
        "sales1": 3,
        "sales2": 5
      }, {
        "date": "2013-01-22",
        "market1": 88,
        "market2": 92,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-23",
        "market1": 85,
        "market2": 90,
        "sales1": 7,
        "sales2": 6
      }, {
        "date": "2013-01-24",
        "market1": 85,
        "market2": 91,
        "sales1": 9,
        "sales2": 5
      }, {
        "date": "2013-01-25",
        "market1": 80,
        "market2": 84,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-26",
        "market1": 87,
        "market2": 92,
        "sales1": 4,
        "sales2": 8
      }, {
        "date": "2013-01-27",
        "market1": 84,
        "market2": 87,
        "sales1": 3,
        "sales2": 4
      }, {
        "date": "2013-01-28",
        "market1": 83,
        "market2": 88,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-29",
        "market1": 84,
        "market2": 87,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-30",
        "market1": 81,
        "market2": 85,
        "sales1": 4,
        "sales2": 7
      }],
      pathToImages: layoutPaths.images.amChart
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.charts.amCharts')
      .controller('FunnelChartCtrl', FunnelChartCtrl);

  /** @ngInject */
  function FunnelChartCtrl($scope, $element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var funnelChart = AmCharts.makeChart(id, {
      type: 'funnel',
      theme: 'blur',
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      dataProvider: [
        {
          title: 'Website visits',
          value: 300
        },
        {
          title: 'Downloads',
          value: 123
        },
        {
          title: 'Requested prices',
          value: 98
        },
        {
          title: 'Contaced',
          value: 72
        },
        {
          title: 'Purchased',
          value: 35
        },
        {
          title: 'Asked for support',
          value: 25
        },
        {
          title: 'Purchased more',
          value: 18
        }
      ],
      titleField: 'title',
      marginRight: 160,
      marginLeft: 15,
      labelPosition: 'right',
      funnelAlpha: 0.9,
      valueField: 'value',
      startX: 0,
      alpha: 0.8,
      neckWidth: '0%',
      startAlpha: 0,
      outlineThickness: 1,
      neckHeight: '0%',
      balloonText: '[[title]]:<b>[[value]]</b>',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',
      pathToImages: layoutPaths
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.charts.amCharts')
    .controller('ganttChartCtrl', ganttChartCtrl);

  /** @ngInject */
  function ganttChartCtrl($element) {
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart( id, {
      "type": "gantt",
      "theme": "light",
      "marginRight": 70,
      "period": "hh",
      "dataDateFormat":"YYYY-MM-DD",
      "balloonDateFormat": "JJ:NN",
      "columnWidth": 0.5,
      "valueAxis": {
        "type": "date",
        "minimum": 7,
        "maximum": 31
      },
      "brightnessStep": 10,
      "graph": {
        "fillAlphas": 1,
        "balloonText": "<b>[[task]]</b>: [[open]] [[value]]"
      },
      "rotate": true,
      "categoryField": "category",
      "segmentsField": "segments",
      "colorField": "color",
      "startDate": "2015-01-01",
      "startField": "start",
      "endField": "end",
      "durationField": "duration",
      "dataProvider": [
        {
        "category": "John",
        "segments": [ {
          "start": 7,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Smith",
        "segments": [ {
          "start": 10,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Ben",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Mike",
        "segments": [ {
          "start": 9,
          "duration": 6,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 4,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Lenny",
        "segments": [ {
          "start": 8,
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Scott",
        "segments": [ {
          "start": 15,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Julia",
        "segments": [ {
          "start": 9,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 1,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 8,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Bob",
        "segments": [ {
          "start": 9,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 7,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kendra",
        "segments": [ {
          "start": 11,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Tom",
        "segments": [ {
          "start": 9,
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 5,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kyle",
        "segments": [ {
          "start": 6,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Anita",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Jack",
        "segments": [ {
          "start": 8,
          "duration": 10,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Kim",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 3,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Aaron",
        "segments": [ {
          "start": 18,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Alan",
        "segments": [ {
          "start": 17,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Ruth",
        "segments": [ {
          "start": 13,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Simon",
        "segments": [ {
          "start": 10,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 17,
          "duration": 4,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      } ],
      "valueScrollbar": {
        "autoGridCount":true
      },
      "chartCursor": {
        "cursorColor":"#55bb76",
        "valueBalloonsEnabled": false,
        "cursorAlpha": 0,
        "valueLineAlpha":0.5,
        "valueLineBalloonEnabled": true,
        "valueLineEnabled": true,
        "zoomable":false,
        "valueZoomable":true
      },
      "export": {
        "enabled": true
      }
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.charts.amCharts')
      .controller('LineChartCtrl', LineChartCtrl);

  /** @ngInject */
  function LineChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var lineChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      marginTop: 0,
      marginRight: 15,
      dataProvider: [
        {
          year: '1990',
          value: -0.17
        },
        {
          year: '1991',
          value: -0.254
        },
        {
          year: '1992',
          value: 0.019
        },
        {
          year: '1993',
          value: -0.063
        },
        {
          year: '1994',
          value: 0.005
        },
        {
          year: '1995',
          value: 0.077
        },
        {
          year: '1996',
          value: 0.12
        },
        {
          year: '1997',
          value: 0.011
        },
        {
          year: '1998',
          value: 0.177
        },
        {
          year: '1999',
          value: -0.021
        },
        {
          year: '2000',
          value: -0.037
        },
        {
          year: '2001',
          value: 0.03
        },
        {
          year: '2002',
          value: 0.179
        },
        {
          year: '2003',
          value: 0.2
        },
        {
          year: '2004',
          value: 0.180
        },
        {
          year: '2005',
          value: 0.21
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          id: 'g1',
          balloonText: '[[value]]',
          bullet: 'round',
          bulletSize: 8,
          lineColor: layoutColors.danger,
          lineThickness: 1,
          negativeLineColor: layoutColors.warning,
          type: 'smoothedLine',
          valueField: 'value'
        }
      ],
      chartScrollbar: {
        graph: 'g1',
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 55,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      chartCursor: {
        categoryBalloonDateFormat: 'YYYY',
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5,
        fullWidth: true
      },
      dataDateFormat: 'YYYY',
      categoryField: 'year',
      categoryAxis: {
        minPeriod: 'YYYY',
        parseDates: true,
        minorGridAlpha: 0.1,
        minorGridEnabled: true,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });

    lineChart.addListener('rendered', zoomChart);
    if (lineChart.zoomChart) {
      lineChart.zoomChart();
    }

    function zoomChart() {
      lineChart.zoomToIndexes(Math.round(lineChart.dataProvider.length * 0.4), Math.round(lineChart.dataProvider.length * 0.55));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.charts.amCharts')
      .controller('PieChartCtrl', PieChartCtrl);

  /** @ngInject */
  function PieChartCtrl($element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var pieChart = AmCharts.makeChart(id, {
      type: 'pie',
      startDuration: 0,
      theme: 'blur',
      addClassNames: true,
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      legend: {
        position: 'right',
        marginRight: 100,
        autoMargins: false,
      },
      innerRadius: '40%',
      defs: {
        filter: [
          {
            id: 'shadow',
            width: '200%',
            height: '200%',
            feOffset: {
              result: 'offOut',
              in: 'SourceAlpha',
              dx: 0,
              dy: 0
            },
            feGaussianBlur: {
              result: 'blurOut',
              in: 'offOut',
              stdDeviation: 5
            },
            feBlend: {
              in: 'SourceGraphic',
              in2: 'blurOut',
              mode: 'normal'
            }
          }
        ]
      },
      dataProvider: [
        {
          country: 'Lithuania',
          litres: 501.9
        },
        {
          country: 'Czech Republic',
          litres: 301.9
        },
        {
          country: 'Ireland',
          litres: 201.1
        },
        {
          country: 'Germany',
          litres: 165.8
        },
        {
          country: 'Australia',
          litres: 139.9
        },
        {
          country: 'Austria',
          litres: 128.3
        },
        {
          country: 'UK',
          litres: 99
        },
        {
          country: 'Belgium',
          litres: 60
        }
      ],
      valueField: 'litres',
      titleField: 'country',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',

      autoMargins: false,
      marginTop: 10,
      alpha: 0.8,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      pullOutRadius: 0,
      pathToImages: layoutPaths.images.amChart,
      responsive: {
        enabled: true,
        rules: [
          // at 900px wide, we hide legend
          {
            maxWidth: 900,
            overrides: {
              legend: {
                enabled: false
              }
            }
          },

          // at 200 px we hide value axis labels altogether
          {
            maxWidth: 200,
            overrides: {
              valueAxes: {
                labelsEnabled: false
              },
              marginTop: 30,
              marginBottom: 30,
              marginLeft: 30,
              marginRight: 30
            }
          }
        ]
      }
    });

    pieChart.addListener('init', handleInit);

    pieChart.addListener('rollOverSlice', function (e) {
      handleRollOver(e);
    });

    function handleInit() {
      pieChart.legend.addListener('rollOverItem', handleRollOver);
    }

    function handleRollOver(e) {
      var wedge = e.dataItem.wedge.node;
      wedge.parentNode.appendChild(wedge);
    }
  }

})();

/**
 * @author a.demeshko
 * created on 24/12/15
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.components.mail')
    .controller('composeBoxCtrl', composeBoxCtrl);

  /** @ngInject */
  function composeBoxCtrl(subject, to, text) {
    var vm = this;
    vm.subject = subject;
    vm.to = to;
    vm.text = text;
  }
})();

/**
 * @author a.demeshko
 * created on 12/24/15
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.components.mail')
    .service('composeModal', composeModal);

  /** @ngInject */
  function composeModal($uibModal) {
      this.open = function(options){
        return $uibModal.open({
          animation: false,
          templateUrl: 'app/pages/components/mail/composeBox/compose.html',
          controller: 'composeBoxCtrl',
          controllerAs: 'boxCtrl',
          size: 'compose',
          resolve: {
            subject: function () {
              return options.subject;
            },
            to: function () {
              return options.to;
            },
            text: function () {
              return options.text;
            }
          }
        });
      }

  }

})();

/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.components.mail')
    .controller('MailDetailCtrl', MailDetailCtrl);

  /** @ngInject */
  function MailDetailCtrl($stateParams, mailMessages) {
    var vm = this;
    vm.mail = mailMessages.getMessageById($stateParams.id);
    vm.label = $stateParams.label;
  }

})();

/**
 * @author a.demeshko
 * created on 28.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.components.mail')
    .controller('MailListCtrl', MailListCtrl);

  /** @ngInject */
  function MailListCtrl($stateParams,  mailMessages) {
    var vm = this;
    vm.messages = mailMessages.getMessagesByLabel($stateParams.label);
    vm.label = $stateParams.label;
  }

})();





/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 24.06.2016.
 */
(function () {
    'use strict';

    angular.module('Merchant.pages.ui.modals')
        .controller('ProgressModalCtrl', ProgressModalCtrl);

    function ProgressModalCtrl($timeout, baProgressModal) {

        baProgressModal.setProgress(0);

        (function changeValue() {
            if (baProgressModal.getProgress() >= 100) {
                baProgressModal.close();
            } else {
                baProgressModal.setProgress(baProgressModal.getProgress() + 10);
                $timeout(changeValue, 300);
            }
        })();
    }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);

/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('Merchant.pages.form')
        .controller('datepickerCtrl', datepickerCtrl);

    /** @ngInject */
    function datepickerCtrl($scope) {

        $scope.dt = new Date();
        $scope.options = {
            showWeeks: false
        };

    }
})();

/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('Merchant.pages.form')
        .controller('datepickerpopupCtrl', datepickerpopupCtrl);

    /** @ngInject */
    function datepickerpopupCtrl($scope) {

        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
})();

/**
 * @author v.lugovsky
 * created on 22.04.2016
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.form')
      .controller('OldSelectpickerPanelCtrl', OldSelectpickerPanelCtrl);

  /** @ngInject */
  function OldSelectpickerPanelCtrl() {
    var vm = this;

    vm.standardSelectItems = [
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
      { label: 'Option 4', value: 4 },
    ];

    vm.selectWithSearchItems = [
      { label: 'Hot Dog, Fries and a Soda', value: 1 },
      { label: 'Burger, Shake and a Smile', value: 2 },
      { label: 'Sugar, Spice and all things nice', value: 3 },
      { label: 'Baby Back Ribs', value: 4 },
    ];

    vm.groupedSelectItems = [
      { label: 'Group 1 - Option 1', value: 1, group: 'Group 1' },
      { label: 'Group 2 - Option 2', value: 2, group: 'Group 2' },
      { label: 'Group 1 - Option 3', value: 3, group: 'Group 1' },
      { label: 'Group 2 - Option 4', value: 4, group: 'Group 2' },
    ];

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.form')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();

/**
 * @author v.lugovsky
 * created on 07.06.2016
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.form')
      .controller('OldSwitchPanelCtrl', OldSwitchPanelCtrl);

  /** @ngInject */
  function OldSwitchPanelCtrl() {
    var vm = this;

    vm.switcherValues = {
      primary: true,
      warning: true,
      danger: true,
      info: true,
      success: true
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 *
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.form')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        var input = $(elem).find('input');
        input.bootstrapSwitch({
          size: 'small',
          onColor: attr.color
        });
        input.on('switchChange.bootstrapSwitch', function(event, state) {
          scope.ngModel = state;
          scope.$apply();
        });

      }
    };
  }
})();

/**
 * @author p.maslava
 * created on 28.11.2016
 */

(function() {
  'use strict';

  angular.module('Merchant.pages.form')
    .filter('groupSelectpickerOptions', GroupSelectpickerOptions);

  /** @ngInject */
  function GroupSelectpickerOptions() {
    return function (items, props) {
      var out = [];

      if (angular.isArray(items)) {
        var keys = Object.keys(props);

        items.forEach(function (item) {
          var itemMatches = false;

          for (var i = 0; i < keys.length; i++) {
            var prop = keys[i];
            var text = props[prop].toLowerCase();
            if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
              itemMatches = true;
              break;
            }
          }

          if (itemMatches) {
            out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

      return out;
    };
  }
})();

/**
 * @author p.maslava
 * created on 28.11.2016
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.form')
    .controller('SelectpickerPanelCtrl', SelectpickerPanelCtrl);

  /** @ngInject */
  function SelectpickerPanelCtrl() {

    var vm = this;
    vm.disabled = undefined;


    vm.standardItem = {};
    vm.standardSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4}
    ];

    vm.withSearchItem = {};

    vm.selectWithSearchItems = [
      {label: 'Hot Dog, Fries and a Soda', value: 1},
      {label: 'Burger, Shake and a Smile', value: 2},
      {label: 'Sugar, Spice and all things nice', value: 3},
      {label: 'Baby Back Ribs', value: 4}
    ];
    vm.groupedItem = {};
    vm.groupedSelectItems = [
      {label: 'Group 1 - Option 1', value: 1, group: 'Group 1'},
      {label: 'Group 2 - Option 2', value: 2, group: 'Group 2'},
      {label: 'Group 1 - Option 3', value: 3, group: 'Group 1'},
      {label: 'Group 2 - Option 4', value: 4, group: 'Group 2'}
    ];

    vm.groupedByItem = {};
    vm.groupedBySelectItems = [
      {name: 'Adam', country: 'United States'},
      {name: 'Amalie', country: 'Argentina'},
      {name: 'Estefanía', country: 'Argentina'},
      {name: 'Adrian', country: 'Ecuador'},
      {name: 'Wladimir', country: 'Ecuador'},
      {name: 'Samantha', country: 'United States'},
      {name: 'Nicole', country: 'Colombia'},
      {name: 'Natasha', country: 'Ecuador'},
      {name: 'Michael', country: 'Colombia'},
      {name: 'Nicolás', country: 'Colombia'}
    ];
    vm.someGroupFn = function (item) {

      if (item.name[0] >= 'A' && item.name[0] <= 'M')
        return 'From A - M';
      if (item.name[0] >= 'N' && item.name[0] <= 'Z')
        return 'From N - Z';
    };

    vm.disableItem = {};
    vm.disableItems = [];

    vm.multipleItem = {};
    vm.multipleSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];
    vm.withDeleteItem = {};
    vm.withDeleteSelectItems = [
      {label: 'Option 1', value: 1},
      {label: 'Option 2', value: 2},
      {label: 'Option 3', value: 3},
      {label: 'Option 4', value: 4},
      {label: 'Option 5', value: 5},
      {label: 'Option 6', value: 6},
      {label: 'Option 7', value: 7},
      {label: 'Option 8', value: 8}
    ];

  }
})();



/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.form')
      .controller('SwitchDemoPanelCtrl', SwitchDemoPanelCtrl);

  /** @ngInject */
  function SwitchDemoPanelCtrl() {
    var vm = this;
    vm.switches = {
      s1: true,
      s2: false,
      s3: true,
      s4: true,
      s5: false
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Merchant.pages.form')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      link: function( $scope, elem, attr) {
        $(elem).tagsinput({
          tagClass:  'label label-' + attr.tagInput
        });
      }
    };
  }
})();

angular.module('Merchant').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/customersection/customersection.html','<uib-tabset active="$tabSetStatus.activeTab" class="account-tab"><uib-tab heading="CUSTOMERS"><div class="container-fluid new-bran1"><div class="row"><div class="col-xs-2 opp-con">ALL CUSTOMERS</div><div class="col-xs-8"></div><div class="col-xs-2"><button type="button" class="btn btn-info new-bran" style="font-family:bebas;">+ &nbsp; ADD NEW CATEGORY</button></div></div><div class="row"><table class="table new-bran1 tab-pad"><thead class="thead-bg"><tr><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="text-center tab-headpad p-l-0" colspan="2">REFERREE</th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th></tr><tr><th>CUSTOMER<br>NAME</th><th>EMAIL</th><th>LOCATION</th><th>MOBILE</th><th>REFERRED</th><th class="text-center">NAME</th><th class="text-center">MOBILE</th><th>DATE</th><th>STATUS</th><th>REFERRALS<br>SENT</th><th>REFERRALS<br>AVAILED</th><th>CREDITS</th><th>UPDATE</th></tr></thead><tbody><tr><td>Jerry</td><td>jerry@test.com</td><td>Najda</td><td>742-1235-4578</td><td>No</td><td>--</td><td>--</td><td>14-03-2017</td><td class="active_sel">Active</td><td>10</td><td>2</td><td>10</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon" ng-click="open(\'app/pages/ui/modals/modalTemplates/customersectionmodal.html\', \'newmodal\')"></td></tr><tr><td>Marry</td><td>marry@test.com</td><td>Najda</td><td>562-1235-4578</td><td>Yes</td><td>--</td><td>--</td><td>15-03-2017</td><td class="active_sel">Active</td><td>--</td><td>--</td><td>--</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon" ng-click="open(\'app/pages/ui/modals/modalTemplates/customersectionmodal.html\', \'newmodal\')"></td></tr><tr><td>John</td><td>john@test.com</td><td>Najda</td><td>122-1235-4578</td><td>No</td><td>Deamond</td><td>342-1225-4008</td><td>16-03-2017</td><td class="pending-sel">Validation Pending</td><td>--</td><td>--</td><td>--</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon" ng-click="open(\'app/pages/ui/modals/modalTemplates/customersectionmodal.html\', \'newmodal\')"></td></tr><tr><td>Richard</td><td>richard@test.com</td><td>Najda</td><td>742-1235-4578</td><td>Yes</td><td>--</td><td>--</td><td>17-03-2017</td><td class="active_sel">Active</td><td>--</td><td>--</td><td>--</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon" ng-click="open(\'app/pages/ui/modals/modalTemplates/customersectionmodal.html\', \'newmodal\')"></td></tr><tr><td>Steve</td><td>steve@test.com</td><td>Najda</td><td>562-1235-4578</td><td>No</td><td>--</td><td>--</td><td>18-03-2017</td><td class="active_sel">Active</td><td>--</td><td>--</td><td>--</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>Smith</td><td>smith@test.com</td><td>Najda</td><td>122-1235-4578</td><td>Yes</td><td>Deamond</td><td>342-1225-4008</td><td>19-03-2017</td><td class="inactive_sel">Inactive</td><td>--</td><td>--</td><td>--</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr></tbody></table><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></uib-tab><uib-tab heading="CUSTOMERS &nbsp; ENGAGEMENTS"><div class="container-fluid"><div class="row"><div class="dash-bg m-t-2 panel-warning change-bg m-b-5"><div class="panel-heading p-t-b-10 clearfix"><div class="row"><div class="col-md-7"><h3 class="panel-title f-18px p-t-10">CUSTOMERS ANALYTICS</h3></div><div class="col-md-3 pull-right tran-select"><div class="form-group font-montser"><div class="selectCust selectoutlets m-0 new height-var"><select id="" class="form-control border-sel" name="business"><option value="First Choice">7th Mar 2017 - 17th Apr 2017</option><option value="Second Choice">7th May 2017 - 17th June 2017</option><option value="Third Choice">7th June 2017 - 17th July 2017</option></select></div></div></div></div></div></div></div><div class="row"><div class="panel-body top-box-bg1 min-hg"><div class="row p-l-r-15"><div class="col-xs-6 b-r-1 b-b-1 pad60-0"><h3 class="text-center"><span class="orange-text f25">14</span></h3><h5 class="text-center dark-text">TOTAL REGISTERED<br>CUSTOMERS</h5></div><div class="col-xs-6 b-b-1 pad60-0"><h3 class="text-center"><span class="orange-text f25">25</span></h3><h5 class="text-center rating-line dark-text">ACTIVE<br>CUSTOMERS</h5></div><div class="col-xs-4 b-r-1 pad60-0"><h3 class="text-center"><span class="orange-text f25">2.5%</span></h3><h5 class="text-center rating-line dark-text">PERCENTAGE OF CUSTOMERS<br>WHO HAVE NOT REFERRED<br>ANY ONCE</h5></div><div class="col-xs-4 b-r-1 pad60-0"><h3 class="text-center"><span class="orange-text f25">2%</span></h3><h5 class="text-center rating-line dark-text">PERCENTAGE OF CUSTOMERS<br>WHO HAVE NOT VISITED ANY<br>OUTLER ONCE</h5></div><div class="col-xs-4 pad60-0"><h3 class="text-center"><span class="orange-text f25">1.5%</span></h3><h5 class="text-center dark-text">PERCENTAGE OF CUSTOMERS WHO<br>HAVE NOT REDEEMED REFERRAL<br>ONCE EVEN AFTER VISIT</h5></div></div></div></div><div class="row"><div class="panel-body top-box-bg2 m-b-5 m-t-5"><div class="row"><div class="col-md-6"><div class="panel-body"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" class="chart chart-doughnut" chart-options="genderoptions" chart-data="returnCustData" chart-colors="returnCustColors" chart-labels="returnCustLabels" chart-click="changeData"></canvas><div class="text-Cen">100%</div></div><div class="text-center chart-bot-title1"><p>Locationwise - Distribution<br>of Credits Earned</p></div></div></div><div class="col-md-6"><div class="panel-body"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" class="chart chart-doughnut" chart-options="genderoptions" chart-data="returnCustData" chart-colors="returnCustColors" chart-labels="returnCustLabels" chart-click="changeData"></canvas><div class="text-Cen">100%</div></div><div class="text-center chart-bot-title1"><p>Locationwise - Distribution<br>of Credits Availed</p></div></div></div></div></div></div><div class="row"><div class="panel-body top-box-bg2 m-b-5 m-t-5"><div class="row"><div class="col-lg-2"></div><div class="col-lg-8"><p class="org-text-ref">Referrals vs Redemptions</p><div class="chartjs-canvas-holder-first-row"><canvas id="line" class="chart chart-line" chart-data="lineDatas" chart-colors="lineColors" chart-labels="lineLabels" chart-options="linechartopt" chart-series="series" chart-click="changeData"></canvas></div></div><div class="col-lg-2"></div></div></div></div></div></uib-tab><uib-tab heading="REPORTED &nbsp; ISSUES"><div class="container-fluid new-bran1"><div class="row"><div class="col-xs-8 opp-con">ISSUES REPORTED</div><div class="col-xs-4 p-t-15"><div class="form-group pull-right searchVend m-0 font-montser"><input type="text" class="form-control" id="input01s" placeholder="Search"> <i class="fa fa-search" aria-hidden="true"></i></div></div></div><div class="row"><table class="table new-bran1 tab-pad"><thead class="brand-bgcol"><tr><th>DATE</th><th>REPORTED BY</th><th>EMAIL</th><th>PHONE</th><th>DETAILS</th><th>STATUS</th><th>COMMENTS</th><th>UPDATE</th></tr></thead><tbody><tr><td>01/04/2017</td><td>Hary</td><td>hary@test.com</td><td>8451629874</td><td>Mobile app is crashing on sending referrals</td><td class="active_sel">Open</td><td></td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>01/04/2017</td><td>Mary</td><td>mary@test.com</td><td>7451629874</td><td>Can\'t see credit in my accounts</td><td class="inactive_sel">Closed</td><td>All transactions mode by the referrals was checked and as there we no referrals mode by him yet redeemed. No credits there</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>27/03/2017</td><td>Tomy</td><td>tomy@test.com</td><td>4781526398</td><td>Vendor refused to deduct my credits</td><td class="inactive_sel">Closed</td><td>Case referred to Sales team and customer was granted 30 bonus credits</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr></tbody></table><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></uib-tab><uib-tab heading="CUSTOMER &nbsp; REQUEST"><div class="container-fluid new-bran1"><div class="row"><div class="col-xs-8 opp-con">ISSUES REPORTED</div><div class="col-xs-4 p-t-15"><div class="form-group searchVend m-0 pull-right font-montser"><input type="text" class="form-control" id="input01s" placeholder="Search"> <i class="fa fa-search" aria-hidden="true"></i></div></div></div><div class="row"><table class="table new-bran1 tab-pad"><thead class="brand-bgcol"><tr><th>DATE</th><th>CUSTOMER</th><th>EMAIL</th><th>PHONE</th><th>REQUEST DETAILS</th><th>STATUS</th><th>UPDATE</th></tr></thead><tbody><tr><td>01/04/2017</td><td>Hary</td><td>hary@test.com</td><td>8451629874</td><td>Mobile app is crashing on sending referrals</td><td class="active_sel">Open</td><td><a href="" ng-click="open(\'app/pages/ui/modals/modalTemplates/record.html\', \'md\')"><img src="assets/images/view_icon.png" class="editTab" alt="edit_icon"></a></td></tr><tr><td>01/04/2017</td><td>Mary</td><td>mary@test.com</td><td>7451629874</td><td>Can\'t see credit in my accounts</td><td class="inactive_sel">Closed</td><td><a href="" ng-click="open(\'app/pages/ui/modals/modalTemplates/record.html\', \'md\')"><img src="assets/images/view_icon.png" class="editTab" alt="edit_icon"></a></td></tr><tr><td>27/03/2017</td><td>Tomy</td><td>tomy@test.com</td><td>4781526398</td><td>Vendor refused to deduct my credits</td><td class="inactive_sel">Closed</td><td><a href="" ng-click="open(\'app/pages/ui/modals/modalTemplates/record.html\', \'md\')"><img src="assets/images/view_icon.png" class="editTab" alt="edit_icon"></a></td></tr></tbody></table><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/dash-board/dashboardvu.html','<div class="panel panel-default bootstrap-panel dash-bg m-b-5"><div class="panel-body top-box-bg p-10 pb-0"><div class="row"><div class="col-md-12"><div class="panel-body p-b-0"><p class="color-theme bebas m-0 title-bor f-18px">MY DASHBOARD</p></div></div></div><div class="row pt15 p-rl-10"><div class="col-xs-4 b-r-1 b-b-1 pad60-0"><h3 class="text-center"><span class="orange-text f25">14</span></h3><h5 class="text-center dark-text">NEW ENQUIREIS</h5></div><div class="col-xs-4 b-r-1 b-b-1 pad60-0"><h3 class="text-center"><span class="orange-text f25">25</span></h3><h5 class="text-center rating-line dark-text">PENDING ENQUIREIS</h5></div><div class="col-xs-4 b-b-1 pad60-0"><h3 class="text-center"><span class="orange-text f25">25</span></h3><h5 class="text-center rating-line dark-text">ENQUIREIS IN PROCESS</h5></div><div class="col-xs-4 b-r-1 pad60-0"><h3 class="text-center"><span class="orange-text f25">25</span></h3><h5 class="text-center rating-line dark-text">TOTAL VENDORS</h5></div><div class="col-xs-4 b-r-1 pad60-0"><h3 class="text-center"><span class="orange-text f25">22</span> <span class="pull-right"></span></h3><h5 class="text-center dark-text">TOTAL OUTLETS</h5></div><div class="col-xs-4 pad60-0"><h3 class="text-center"><span class="orange-text f25">25</span></h3><h5 class="text-center dark-text">REGISTERED CUSTOMERS</h5></div></div></div></div><div class="panel panel-default bootstrap-panel dash-bg m-b-5"><div class="panel-body p-10 top-box-bg"><div class="row"><div class="col-md-6"><div class="panel-heading panel-form border-none"><div class="row"><div class="col-md-12 text-left p-t-10"><p class="color-theme bebas title-bor f-18px">OUTLETS ADDED</p></div></div></div><div class="panel-body"><div class="chartjs-canvas-holder-third-row chart-height1"><canvas id="line" class="chart chart-line" chart-colors="visitorLineColors" chart-data="visitorWeekDatas" chart-labels="visitorWeekLabels" chart-series="series" chart-click="changeData" chart-options="visitorOptions"></canvas></div></div></div><div class="col-md-6"><div class="panel-heading panel-form border-none"><div class="row"><div class="col-md-12 text-left p-t-10"><p class="color-theme bebas title-bor f-18px">OUTLET REGISTRATION REQUESTS</p></div></div></div><div class="panel-body"><div class="chartjs-canvas-holder-third-row chart-height1"><canvas id="line" class="chart chart-line" chart-colors="revenueLineColors" chart-data="revenueWeekDatas" chart-labels="revenueWeekLabels" chart-series="series" chart-click="changeData" chart-options="revenueOptions"></canvas></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel dash-bg m-b-5"><div class="panel-body p-10 top-box-bg"><div class="row"><div class="col-md-12"><div class="panel-body p-b-0"><p class="color-theme bebas m-0 title-bor f-18px">MOBILE APP USAGE</p></div></div></div><div class="row"><div class="col-md-4"><div class="panel-body app-top-title font-mont"><div class="row"><div class="col-md-6"><div class="success-title"><span class="rounded-btn"></span>SUCCESS</div></div><div class="col-md-6"><div class="failure-title"><span class="rounded-btn"></span>FAILURE</div></div></div></div><div class="panel-body font-mont p-t-1"><div class="row"><div class="col-md-12"><h3 class="text-center"><span class="orange-text f45">150</span></h3><h6 class="text-center font-montser dark-text f25">TOTAL DOWNLOADS</h6></div></div></div><div class="panel-body font-mont p-t-2"><div class="row"><div class="col-md-12"><h3 class="text-center"><span class="orange-text f45">150</span></h3><h6 class="text-center font-montser dark-text f25">SUCCESSFULL REGISTRATIONS</h6></div></div></div><div class="panel-body font-mont p-t-3"><div class="row"><div class="col-md-12"><h3 class="text-center"><span class="orange-text f45">4,500</span></h3><h6 class="text-center font-montser dark-text f25">ACTIVE USERS</h6></div></div></div></div><div class="col-md-8 bor-left"><div class="row"><div class="col-md-6"><div class="panel-body"><div class="text-center chart-bot-title1"><p>PLAY STORE</p></div><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" class="chart chart-doughnut" chart-options="genderoptions" chart-data="playstoreData" chart-colors="playstoreColors" chart-labels="playstoreLabels" chart-click="changeData"></canvas><div class="center-percentage">100%</div></div></div></div><div class="col-md-6"><div class="panel-body"><div class="text-center chart-bot-title1"><p>APP STORE(IOS)</p></div><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" class="chart chart-doughnut" chart-options="genderoptions" chart-data="appstoreData" chart-colors="appstoreColors" chart-labels="appstoreLabels" chart-click="changeData"></canvas><div class="center-percentage">100%</div></div></div></div></div><div class="row"><div class="col-md-6"><div class="panel-body"><div class="text-center chart-bot-title1"><p>PLAY STORE</p></div><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" class="chart chart-doughnut" chart-options="genderoptions" chart-data="playstore1Data" chart-colors="playstore1Colors" chart-labels="playstore1Labels" chart-click="changeData"></canvas><div class="center-percentage">100%</div></div></div></div><div class="col-md-6"><div class="panel-body"><div class="text-center chart-bot-title1"><p>APP STORE(IOS)</p></div><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" class="chart chart-doughnut" chart-options="genderoptions" chart-data="appstore1Data" chart-colors="appstore1Colors" chart-labels="appstore1Labels" chart-click="changeData"></canvas><div class="center-percentage">100%</div></div></div></div></div><div class="row"><div class="col-md-8"><div class="panel-body"><div class="text-center chart-bot-title1"><p></p></div><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" class="chart chart-doughnut" chart-options="multioptions" chart-data="multiData" chart-colors="multiColors" chart-labels="multiLabels" chart-click="changeData"></canvas><div class="center-percentage l-32per">100%</div></div></div></div></div></div></div></div></div><div class="panel panel-default bootstrap-panel dash-bg m-b-5"><div class="panel-body p-10 top-box-bg"><div class="row"><div class="col-md-6"><div class="panel-heading panel-form border-none"><div class="row"><div class="col-md-12 text-left p-t-10"><p class="color-theme bebas title-bor f-18px">APP DOWNLOADS</p></div></div></div><div class="panel-body"><div class="chartjs-canvas-holder-third-row chart-height1"><canvas id="line" class="chart chart-line" chart-colors="appColors" chart-data="appDatas" chart-labels="appLabels" chart-series="series" chart-click="changeData" chart-options="appOptions"></canvas></div></div></div><div class="col-md-6"><div class="panel-heading panel-form border-none"><div class="row"><div class="col-md-12 text-left p-t-10"><p class="color-theme bebas title-bor f-18px">APP INSTALLATIONS</p></div></div></div><div class="panel-body"><div class="chartjs-canvas-holder-third-row chart-height1"><canvas id="line" class="chart chart-line" chart-colors="app1Colors" chart-data="app1Datas" chart-labels="app1Labels" chart-series="series" chart-click="changeData" chart-options="app1Options"></canvas></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboard.html','<dashboard-pie-chart></dashboard-pie-chart><div class="row"><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Acquisition Channels" ba-panel-class="medium-panel traffic-panel"><traffic-chart></traffic-chart></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Users by Country" ba-panel-class="medium-panel"><dashboard-map></dashboard-map></div></div><div class="row"><div class="col-xlg-9 col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="row"><div class="col-xlg-8 col-lg-12 col-md-12 col-sm-7 col-xs-12" ba-panel="" ba-panel-title="Revenue" ba-panel-class="medium-panel"><dashboard-line-chart></dashboard-line-chart></div><div class="col-xlg-4 col-lg-12 col-md-12 col-sm-5 col-xs-12" ba-panel="" ba-panel-class="popular-app medium-panel"><popular-app></popular-app></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-12 col-xs-12" ba-panel="" ba-panel-title="Feed" ba-panel-class="large-panel with-scroll feed-panel"><blur-feed></blur-feed></div></div><div class="row shift-up"><div class="col-xlg-3 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="To Do List" ba-panel-class="xmedium-panel feed-comply-panel with-scroll todo-panel"><dashboard-todo></dashboard-todo></div><div class="col-xlg-6 col-lg-6 col-md-6 col-xs-12" ba-panel="" ba-panel-title="Calendar" ba-panel-class="xmedium-panel feed-comply-panel with-scroll calendar-panel"><dashboard-calendar></dashboard-calendar></div></div>');
$templateCache.put('app/pages/globalsetting/globalsetting.html','<div class="color-theme bebas f-20px reviewTtles px-15">GLOBAL SETTINGS</div><uib-tabset active="$tabSetStatus.activeTab" class="account-tab"><uib-tab heading="MANAGE &nbsp; VOUCHED4U &nbsp; CATEGORIES"><div class="container-fluid new-bran1"><div class="row"><div class="col-xs-12"><button type="button" class="btn btn-info new-bran bebas">+ &nbsp; ADD NEW CATEGORY</button></div><div class="allVistrs"><table class="table new-bran1 table-striped-blue tab-pad"><thead class="brand-bgcol"><tr><th>CATEGORY NAME</th><th>STATE</th><th>UPDATE</th></tr></thead><tbody><tr><td>Food & Beverages</td><td class="active_sel">Active</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/reviewpopup.html\',\'border-wid\')"></td></tr><tr><td>Health & Beauty</td><td class="active_sel">Active</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>Hotel & Travel</td><td class="active_sel">Active</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>Entertainment & Leisure Attractions</td><td class="active_sel">Active</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>Retail & Other Services</td><td class="active_sel">Active</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>Education & Tutoring</td><td class="inactive_sel">Inactive</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr></tbody></table></div><div class="col-md-6 font-montser"><div class="color-black pb-20 p-t-10 paginats"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></uib-tab><uib-tab heading="MANAGE &nbsp; BRANDS"><div class="container-fluid new-bran1"><div class="row"><div class="col-xs-12"><button type="button" class="btn btn-info new-bran bebas" ng-click="open(\'app/pages/ui/modals/modalTemplates/pin-modal.html\', \'cusomer-setings\')">+ &nbsp; ADD NEW BRAND</button></div><div class="allVistrs"><table class="table new-bran1 table-striped-blue tab-pad"><thead class="brand-bgcol"><tr><th>BRAND NAME</th><th>CATEGORY</th><th>UPDATE</th></tr></thead><tbody><tr><td>Tim Hortons</td><td>Food & Beverages</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>BU</td><td>Food & Beverages</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>Lee</td><td>Food & Beverages</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>Applebee\'s</td><td>Food & Beverages</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>Ibtisama</td><td>Health & Beauty</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>Magrabi</td><td>Retail & Other Services</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr></tbody></table></div><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="m-r-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></uib-tab><uib-tab heading="BANNERS & ADVERTISEMENTS"><div class="ng-scope"><div class="panel banner-bg panel-info bootstrap-panel m-b-10"><div class="panel-heading panel-form border-none m-0"><div class="row"><div class="col-xs-12"><div class="color-theme bebas f-20px reviewTtles px-15 ng-scope"><div>MOBILE APP HOME SCREEN BANNER</div></div></div><div class="col-xs-12 img-padin"><img src="assets/images/banner image.png" class="img-wid"> <button type="button" class="btn btn-info chang-btn change_btn">CHANGE</button></div></div></div></div><div class="panel banner-bg panel-info bootstrap-panel m-b-10"><div class="panel-heading panel-form border-none m-0"><div class="row"><div class="col-xs-6"><div class="color-theme bebas f-20px reviewTtles px-15 ng-scope">VENDOR WEBSITE -HOMESCREEN -PROMOTIONAL BRANDS</div></div><div class="col-xs-6"><p class="panel-heading mobile-app1"><u>VIEW & CHANGE DISPLAY ORDER</u></p></div></div><div class="row brand-marg"><div class="col-xs-12"><div class="panel-heading mobile-app2"><p class="brand-Titles">BRAND -1 <span class="underline">Tim Hortons</span></p></div></div><div class="col-xs-4"></div><div class="col-xs-4"><img src="assets/images/TimsHortons.png" class="promationBrand-img" alt="TimsHortons"> <button type="button" class="btn btn-info chang-btn1 change_btn">CHANGE</button></div><div class="col-xs-4"></div></div></div></div><div class="panel banner-bg panel-info bootstrap-panel m-b-10"><div class="panel-heading panel-form border-none m-0"><div class="row brand-marg"><div class="col-xs-12"><div class="panel-heading mobile-app4"><p class="brand-Titles">BRAND -2 <span class="underline">BU</span></p></div></div><div class="col-xs-4"></div><div class="col-xs-4"><img src="assets/images/bud.png" class="promationBrand-img" alt="bud"> <button type="button" class="btn btn-info chang-btn1 change_btn">CHANGE</button></div><div class="col-xs-4"></div></div></div></div><div class="panel banner-bg panel-info bootstrap-panel m-b-10"><div class="panel-heading panel-form border-none m-0"><div class="row brand-marg"><div class="col-xs-12"><div class="panel-heading mobile-app4"><p class="brand-Titles">BRAND -3 <span class="underline">Natural Grocers</span></p></div></div><div class="col-xs-4"></div><div class="col-xs-4"><img src="assets/images/NG_logo.png" class="promationBrand-img" alt="NG_logo.png"> <button type="button" class="btn btn-info chang-btn1 change_btn">CHANGE</button></div><div class="col-xs-4"></div></div></div></div><div class="panel banner-bg panel-info bootstrap-panel m-b-10"><div class="panel-heading panel-form border-none m-0"><div class="row brand-marg"><div class="col-xs-12"><div class="panel-heading mobile-app4"><p class="brand-Titles">BRAND -4 <span class="underline">Whole Food Market</span></p></div></div><div class="col-xs-4"></div><div class="col-xs-4"><img src="assets/images/whole_food.png" class="promationBrand-img" alt="whole_food"> <button type="button" class="btn btn-info chang-btn1 change_btn">CHANGE</button></div><div class="col-xs-4"></div></div></div></div></div></uib-tab><uib-tab heading="OPERATIONAL &nbsp; CITIES"><div class="container-fluid new-bran1"><div class="row new-bran2"><div class="col-xs-2 opp-con">OPERATIONAL COUNTRY</div><div class="col-xs-2 opp-con1">Select Country</div><div class="col-xs-3 opp-con1"><div class="form-group font-montser"><div class="selectCust selectoutlets new height-var"><select id="" class="form-control m-0 border-sel" name="business"><option value="First Choice">United Arab Emirate</option><option value="Second Choice">United Arab Emirate</option><option value="Third Choice">United Arab Emirate</option></select></div></div></div><div class="col-md-3"></div><div class="col-xs-2"><button type="button" class="btn btn-info new-bran3" style="font-family:bebas;">+ &nbsp; ADD NEW COUNTRY</button></div></div><div class="row"><div class="col-xs-2 opp-con">OPERATIONAL CITIES</div><div class="col-xs-8"></div><div class="col-xs-2"><button type="button" class="btn btn-info new-bran3" style="font-family:bebas;">+ &nbsp; ADD NEW CITY / EMIRATE</button></div></div><div class="row"><div class="allVistrs"><table class="table new-bran1 table-striped-blue tab-pad"><thead class="brand-bgcol"><tr><th>CITY / EMIRATE NAME</th><th>COUNTRY</th><th>STATE</th><th>UPDATE</th></tr></thead><tbody><tr><td>Abu dhabi</td><td>UAE</td><td class="active_sel">Active</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>Sharjah</td><td>UAE</td><td class="inactive_sel">Inactive</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>Fujairah</td><td>UAE</td><td class="inactive_sel">Inactive</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>Dubai</td><td>UAE</td><td class="inactive_sel">Inactive</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>Umm al-Quwain</td><td>UAE</td><td class="inactive_sel">Inactive</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr><tr><td>Ras al Khaimah</td><td>UAE</td><td class="inactive_sel">Inactive</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"></td></tr></tbody></table></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="m-r-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/login/login.html','');
$templateCache.put('app/pages/mangevendor/mangevendor.html','<div class="col-md-12 color-theme bebas f-20px reviewTtles px-15 ng-scope">VENDORS</div><div class="container-fluid"><div class="row px-40"><div class="col-md-3 text-center"><p class="vendorValue">25</p><p class="totalVend">TOTAL VEDNORS</p></div><div class="col-md-3 text-center"><p class="vendorValue">25</p><p class="totalVend">ACTIVE VEDNORS</p></div><div class="col-md-3 text-center"><p class="vendorValue">25</p><p class="totalVend">VEDNORS NOT APPROVED</p></div><div class="col-md-3 text-center"><p class="vendorValue">25</p><p class="totalVend">DEACTIVATED VEDNORS</p></div></div><div class="row"><div class="col-md-12 bg-white"><div class="row"><div class="col-md-8"><p class="visitAll color-theme">VENDORS</p></div><div class="col-md-4 mt-15"><div class="form-group searchVend font-montser m-0 p-r-15 pull-right"><input type="text" class="form-control" id="input01s" placeholder="Search vendor"> <i class="fa fa-search" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-md-12 px-0"><div class="reviewMode table-responsive"><table class="table bg-white font-montser table-striped-blue"><thead class="thead-bg"><tr><th>NAME</th><th>POSITION</th><th>ORGANIZATION<br>NAME</th><th>LOCATION</th><th>ORGANIZATION<br>MODE</th><th>MOBILE</th><th>EMAIL</th><th>NO. OF OUTLETS</th><th>CLICK FOR<br>MORE INFO</th><th>UPDATE<br>DATE</th><th>STATUS<div class="dropdown"><button class="show-all btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">All <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></th><th>CHANGE<br>STATUS</th><th class="text-center">ACTION</th></tr></thead><tbody><tr class="firstHightlight"><td>John Cena</td><td>Sales Head</td><td><a href="" class="text-underline">Tim Hirton</a></td><td>Najdo</td><td>Standalone</td><td>754-586-4565</td><td>test@yopmail.com</td><td>10</td><td><a href="" class="text-underline">Details</a></td><td>10/11/2017</td><td>Suspended</td><td><div class="dropdown statusChanges"><button class="btn btn-primary dropdown-toggle active-dropdown" type="button" data-toggle="dropdown">DE-ACTIVATE <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><i class="fa fa-comment-o comneticon" aria-hidden="true"></i> <i class="fa fa-envelope-o envole" aria-hidden="true"></i> <img src="assets/images/mangevendor-user.png" class="user-img" alt="mangevendor-user"> <a href="" class="text-underline" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/mangevendormodal.html\',\'manageVendor\')">Update</a></td></tr><tr class="firstHightlight"><td>John Cena</td><td>Sales Head</td><td><a href="" class="text-underline">Tim Hirton</a></td><td>Najdo</td><td>Standalone</td><td>754-586-4565</td><td>test@yopmail.com</td><td>10</td><td><a href="" class="text-underline">Details</a></td><td>10/11/2017</td><td>Active</td><td><div class="dropdown statusChanges"><button class="btn btn-primary dropdown-toggle active-dropdown" type="button" data-toggle="dropdown">DISAPPROVED <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><i class="fa fa-comment-o comneticon" aria-hidden="true"></i> <i class="fa fa-envelope-o envole" aria-hidden="true"></i> <img src="assets/images/mangevendor-user.png" class="user-img" alt="mangevendor-user"> <a href="" class="text-underline">Update</a></td></tr><tr class="firstHightlight"><td>John Cena</td><td>Sales Head</td><td><a href="" class="text-underline">Tim Hirton</a></td><td>Najdo</td><td>Standalone</td><td>754-586-4565</td><td>test@yopmail.com</td><td>10</td><td><a href="" class="text-underline">Details</a></td><td>10/11/2017</td><td>Inactive</td><td><div class="dropdown statusChanges"><button class="btn btn-primary dropdown-toggle active-dropdown" type="button" data-toggle="dropdown">ACTIVATE <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><i class="fa fa-comment-o comneticon" aria-hidden="true"></i> <i class="fa fa-envelope-o envole" aria-hidden="true"></i> <img src="assets/images/mangevendor-user.png" class="user-img" alt="mangevendor-user"> <a href="" class="text-underline">Update</a></td></tr><tr class="firstHightlight"><td>John Cena</td><td>Sales Head</td><td><a href="" class="text-underline">Tim Hirton</a></td><td>Najdo</td><td>Standalone</td><td>754-586-4565</td><td>test@yopmail.com</td><td>10</td><td><a href="" class="text-underline">Details</a></td><td>10/11/2017</td><td>Approved</td><td><div class="dropdown statusChanges"><button class="btn btn-primary dropdown-toggle active-dropdown" type="button" data-toggle="dropdown">SUSPEND <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><i class="fa fa-comment-o comneticon" aria-hidden="true"></i> <i class="fa fa-envelope-o envole" aria-hidden="true"></i> <img src="assets/images/mangevendor-user.png" class="user-img" alt="mangevendor-user"> <a href="" class="text-underline">Update</a></td></tr><tr class="firstHightlight"><td>John Cena</td><td>Sales Head</td><td><a href="" class="text-underline">Tim Hirton</a></td><td>Najdo</td><td>Standalone</td><td>754-586-4565</td><td>test@yopmail.com</td><td>10</td><td><a href="" class="text-underline">Details</a></td><td>10/11/2017</td><td>Approved</td><td><div class="dropdown statusChanges"><button class="btn btn-primary dropdown-toggle active-dropdown" type="button" data-toggle="dropdown">ACTIVATE <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><i class="fa fa-comment-o comneticon" aria-hidden="true"></i> <i class="fa fa-envelope-o envole" aria-hidden="true"></i> <img src="assets/images/mangevendor-user.png" class="user-img" alt="mangevendor-user"> <a href="" class="text-underline">Update</a></td></tr><tr class="firstHightlight"><td>John Cena</td><td>Sales Head</td><td><a href="" class="text-underline">Tim Hirton</a></td><td>Najdo</td><td>Standalone</td><td>754-586-4565</td><td>test@yopmail.com</td><td>10</td><td><a href="" class="text-underline">Details</a></td><td>10/11/2017</td><td>Approved</td><td><div class="dropdown statusChanges"><button class="btn btn-primary dropdown-toggle active-dropdown" type="button" data-toggle="dropdown">ACTIVATE <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><i class="fa fa-comment-o comneticon" aria-hidden="true"></i> <i class="fa fa-envelope-o envole" aria-hidden="true"></i> <img src="assets/images/mangevendor-user.png" class="user-img" alt="mangevendor-user"> <a href="" class="text-underline">Update</a></td></tr></tbody></table></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right"><span class="show-pag">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></div></div>');
$templateCache.put('app/pages/maps/maps.html','<div class="widgets"><div class="row"><div class="col-md-12" ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div>');
$templateCache.put('app/pages/myOutlet/myOutlet.html','<ui-view></ui-view>');
$templateCache.put('app/pages/offermanagement/offermanagement.html','<div class="color-theme bebas f-20px reviewTtles px-15 ng-scope">OFFERS MANAGEMENT</div><div class="container-fluid"><div class="row offer-mng"><div class="col-md-5"><input type="text" class="input-search form-control" id="input01" placeholder="Type your search here"></div><div class="col-md-2"><button type="button" class="btn-search h-45 btn btn-block btn-info bebas">SEARCH</button></div><div class="col-md-5 p-t-10"><div class="row"><div class="col-md-8 text-right"><p class="sortcard">SORT OFFERS BY</p></div><div class="col-md-4"><div class="form-group font-montser"><div class="selectCust selectoutlets m-0 new height-var"><select id="" class="form-control border-sel" name="business"><option value="First Choice">Outlet Name</option></select></div></div></div></div></div></div><div class="row bg-white"><div class="col-md-12 px-0"><div class="offer-Management table-responsive mt-0"><table class="table bg-white font-montser table-striped-blue"><thead class="thead-bg"><tr><th>OUTLET NAME</th><th>OUTLET LOCATION</th><th>OFFER NAME</th><th>CODE</th><th class="text-center">CATEGORY</th><th>PRICE</th><th>OFFER EXPIRY</th><th>STATUS</th><th>ACTION</th></tr></thead><tbody><tr><td>Time Hortons</td><td>Al Wahdahmall</td><td>Morning Appetite</td><td>TIM 120</td><td>Food Beverage</td><td>15 AED</td><td>4-12-2019</td><td class="active_sel">Approved</td><td class="text-center"><img src="assets/images/view-files.png" alt="view_icon" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/offer-modal.html\',\'newmodal\')"></td></tr><tr><td>Time Hortons</td><td>Al Wahdahmall</td><td>Morning Appetite</td><td>TIM 120</td><td>Food Beverage</td><td>15 AED</td><td>4-12-2019</td><td>Submited</td><td class="text-center"><img src="assets/images/view-files.png" alt="view_icon" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/offer-modal.html\',\'newmodal\')"></td></tr><tr><td>Time Hortons</td><td>Al Wahdahmall</td><td>Morning Appetite</td><td>TIM 120</td><td>Food Beverage</td><td>15 AED</td><td>4-12-2019</td><td>Declined</td><td class="text-center"><img src="assets/images/view-files.png" alt="view_icon"></td></tr><tr><td>Time Hortons</td><td>Al Wahdahmall</td><td>Morning Appetite</td><td>TIM 120</td><td>Food Beverage</td><td>15 AED</td><td>4-12-2019</td><td class="inactive_sel">Rejected</td><td class="text-center"><img src="assets/images/view-files.png" alt="view_icon"></td></tr><tr><td>Time Hortons</td><td>Al Wahdahmall</td><td>Morning Appetite</td><td>TIM 120</td><td>Food Beverage</td><td>15 AED</td><td>4-12-2019</td><td class="purple">Accepted</td><td class="text-center"><img src="assets/images/view-files.png" alt="view_icon"></td></tr></tbody></table></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div>');
$templateCache.put('app/pages/payment/payment.html','<uib-tabset active="$tabSetStatus.activeTab" class="one-tab reviewHide"><uib-tab heading="REVIEW"><div class="container-fluid"><div class="row"><div class="col-md-12"><div class="row vendor-payment bg-white"><div class="col-md-8"><div class="color-theme bebas f-20px reviewTtles">VENDOR PAYMENTS DUE</div></div><div class="col-md-4 text-right"><div class="form-group searchVend font-montser float-l"><input type="text" class="form-control" id="input01s" placeholder="Search vendor"> <i class="fa fa-search" aria-hidden="true"></i></div><vouched-select label="Filter By" selected-value="outletFilter" select-lists="sortBy" class="vendro-filter filterBys" display-field="value" is-label="false"></vouched-select></div></div><div class="row namedetais acc-infomations bg-white"><div class="col-md-3"><div class="form-group font-montser"><label for="inputLastName" class="respons-f color-black"><b>VENDOR NAME</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black respons-f"><b>ORANGIZATION MODEL</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black respons-f"><b>MOBILE</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>EMAIL</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser"><label for="inputLastName" class="respons-f color-black"><b>NO. OF OUTLETS</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>DATE - TIME</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>PROMO FEE</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>OFFER FEE</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser"><label for="inputLastName" class="respons-f color-black"><b>SUBSCRIPTION PAYMENT (A)</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>TOTAL CREDITS EARNED</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>FEES IN CREDITS REDEENED (B)</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>FIRST VISIT DISCOUNT</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser"><label for="inputLastName" class="respons-f color-black"><b>FEES ON DISCOUNT (PLAN %) (C)</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>TAX VAT (5%) (D)</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>PAYMENT PENDING (A)</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>TOTAL PAYMENT DUE (A+B+C+D)</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-12 text-right"><div class="inlineflex"><p class="text-center invoice-actions color-theme" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/invoice-payments-new.html\',\'border-wids\')"><img src="assets/images/edit_icon.png" alt="edit_icon"> <span class="invoice-blck">Review and<br>Update Payment</span></p><p class="text-center invoice-actions color-theme" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/invoice-payments.html\',\'border-wids\')"><img src="assets/images/generate_icon.png" alt="generate_icon"> <span class="invoice-blck">Invoice</span></p><p class="text-center invoice-actions color-theme" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/review-payments.html\',\'review-pay\')"><img src="assets/images/view_icon.png" alt="view_icon"> <span class="invoice-blck">Payment<br>Histroy</span></p></div></div></div><div class="row namedetais acc-infomations bg-white"><div class="col-md-3"><div class="form-group font-montser"><label for="inputLastName" class="respons-f color-black"><b>VENDOR NAME</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>ORANGIZATION MODEL</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>MOBILE</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>EMAIL</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser"><label for="inputLastName" class="respons-f color-black"><b>NO. OF OUTLETS</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>DATE - TIME</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>PROMO FEE</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>OFFER FEE</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser"><label for="inputLastName" class="respons-f color-black"><b>SUBSCRIPTION PAYMENT (A)</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>TOTAL CREDITS EARNED</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>FEES IN CREDITS REDEENED (B)</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>FIRST VISIT DISCOUNT</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser"><label for="inputLastName" class="respons-f color-black"><b>FEES ON DISCOUNT (PLAN %) (C)</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>TAX VAT (5%) (D)</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>PAYMENT PENDING (A)</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-3"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="respons-f color-black"><b>TOTAL PAYMENT DUE (A+B+C+D)</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-12 text-right"><div class="inlineflex"><p class="text-center invoice-actions color-theme" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/invoice-payments-new.html\',\'border-wids\')"><img src="assets/images/edit_icon.png" alt="edit_icon"> <span class="invoice-blck">Review and<br>Update Payment</span></p><p class="text-center invoice-actions color-theme" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/invoice-payments.html\',\'border-wids\')"><img src="assets/images/generate_icon.png" alt="generate_icon"> <span class="invoice-blck">Invoice</span></p><p class="text-center invoice-actions color-theme" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/review-payments.html\',\'review-pay\')"><img src="assets/images/view_icon.png" alt="view_icon"> <span class="invoice-blck">Payment<br>Histroy</span></p></div></div></div></div></div></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/pin-performance/pin-performance.html','<uib-tabset active="$tabSetStatus.activeTab" class="one-tab"><uib-tab heading="PIN &nbsp; PERFORMANCE"><div class="panel-success panel ng-scope"><div class="panel-heading panel-form"><div class="row"><div class="col-md-12"><form class="form-horizontal"><div class="form-group"><div class="col-md-8"><label class="col-md-1"><span class="white-text">FROM</span></label><div class="col-md-3"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt1" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openFrom()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><label class="col-md-1"><span class="white-text">TO</span></label><div class="col-md-3"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt2" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openTo()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-4"><label class="col-md-7 text-right"><span class="white-text">SORT PIN</span></label><div class="col-md-5"><p class="input-group"><vouched-select label="By Outlet" selected-value="outletFilter" select-lists="outletFilterLists" display-field="value" is-label="false"></vouched-select></p></div></div></div></form></div></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><h4>TIM HORTONS</h4></div><div class="panel-body"><div class="row mt5"><div class="col-md-6"><img class="pin_img" src="assets/images/pinper.png"></div><div class="col-md-6 pin_border"><button class="orange-text">PIN 21281233</button><p><label>Name :</label> JOHN DECLAND</p><p><label>Location :</label> Al Wahda Mall</p><p><label>Phone :</label> +00 123 2121 212</p><p><label>Email :</label> john@timhortons.com</p><p><label>Date Employed :</label> January 4th 2016</p><p><label>Workshift :</label> Monday to Saturday - 17:00 To 22:00 - Sunday Off</p></div></div><div class="row pt15"><div class="col-md-1"></div><div class="col-md-2 col-sm-4"><h3 class="text-center orange-text rating-value"><span>14</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon"></i></span></h3><h6 class="text-center dark-text rating-line">POSITIVE REVIEWS</h6><p class="text-center">+12% Since Last Week</p></div><div class="col-md-2 col-sm-4"><h3 class="text-center orange-text rating-value"><span>55514</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon"></i></span></h3><h6 class="text-center dark-text rating-line">TOTAL REVENUE</h6><p class="text-center">+12% Since Last Week</p></div><div class="col-md-2 col-sm-4"><h3 class="text-center orange-text rating-value"><span>1664</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon-green"></i></span></h3><h6 class="text-center dark-text rating-line">REVENUE PER WEEK</h6><p class="text-center">+12% Since Last Week</p></div><div class="col-md-2 col-sm-4"><h3 class="text-center orange-text rating-value"><span>18884</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon"></i></span></h3><h6 class="text-center dark-text rating-line">VISITOR THIS WEEK</h6><p class="text-center">+12% Since Last Week</p></div><div class="col-md-2 col-sm-4"><h3 class="text-center orange-text rating-value"><span>445314</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon-green"></i></span></h3><h6 class="text-center dark-text rating-line">NEGATIVE FEEDBACKS</h6><p class="text-center">+12% Since Last Week</p></div><div class="col-md-1"></div></div></div><div class="panel-body p-0"><div class="table-responsive"><table class="table"><thead class="thead-bg"><tr class="table-header"><th>BRAND</th><th>ACTIVITY</th><th>PIN<br>NUMBER</th><th>PIN<br>VALIDATION NAME</th><th>DATE</th><th>GROSS<br>SALE</th><th>DISCOUNT<br>VALUE</th><th>NET AMOUNT<br>PAID</th><th>CREDIT USED</th></tr></thead><tbody><tr><td class="dark-text">Tim Hortons</td><td>Offer puchase, time hortons Al Wadha</td><td>34544</td><td>Jack D</td><td>12/12/2017</td><td>15%</td><td>15%</td><td>122133</td><td>122133</td></tr><tr><td class="dark-text">Tim Hortons</td><td>Offer puchase, time hortons Al Wadha</td><td>34544</td><td>Jack D</td><td>12/12/2017</td><td>15%</td><td>15%</td><td>122133</td><td>122133</td></tr></tbody></table></div><div class="panel-footer"></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><h4>TIM HORTONS</h4></div><div class="panel-body"><div class="row mt5"><div class="col-md-6"><img class="pin_img" src="assets/images/pinper.png"></div><div class="col-md-6 pin_border"><button class="orange-text">PIN 21281233</button><p><label>Name :</label> JOHN DECLAND</p><p><label>Location :</label> Al Wahda Mall</p><p><label>Phone :</label> +00 123 2121 212</p><p><label>Email :</label> john@timhortons.com</p><p><label>Date Employed :</label> January 4th 2016</p><p><label>Workshift :</label> Monday to Saturday - 17:00 To 22:00 - Sunday Off</p></div></div><div class="row pt15"><div class="col-md-2 col-sm-4"><h3 class="text-center orange-text rating-value"><span>14</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon"></i></span></h3><h6 class="text-center dark-text rating-line">POSITIVE REVIEWS</h6><p class="text-center">+12% Since Last Week</p></div><div class="col-md-2 col-sm-4"><h3 class="text-center orange-text rating-value"><span>55514</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon"></i></span></h3><h6 class="text-center dark-text rating-line">TOTAL REVENUE</h6><p class="text-center">+12% Since Last Week</p></div><div class="col-md-2 col-sm-4"><h3 class="text-center orange-text rating-value"><span>1664</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon-green"></i></span></h3><h6 class="text-center dark-text rating-line">REVENUE PER WEEK</h6><p class="text-center">+12% Since Last Week</p></div><div class="col-md-2 col-sm-4"><h3 class="text-center orange-text rating-value"><span>18884</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon"></i></span></h3><h6 class="text-center dark-text rating-line">VISITOR THIS WEEK</h6><p class="text-center">+12% Since Last Week</p></div><div class="col-md-2 col-sm-4"><h3 class="text-center orange-text rating-value"><span>445314</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon-green"></i></span></h3><h6 class="text-center dark-text rating-line">NEGATIVE FEEDBACKS</h6><p class="text-center">+12% Since Last Week</p></div></div></div><div class="panel-body p-0"><div class="table-responsive"><table class="table"><thead class="thead-bg"><tr class="table-header"><th>BRAND</th><th>ACTIVITY</th><th>PIN<br>NUMBER</th><th>PIN<br>VALIDATION NAME</th><th>DATE</th><th>GROSS<br>SALE</th><th>DISCOUNT<br>VALUE</th><th>NET AMOUNT<br>PAID</th><th>CREDIT USED</th></tr></thead><tbody><tr><td class="dark-text">Tim Hortons</td><td>Offer puchase, time hortons Al Wadha</td><td>34544</td><td>Jack D</td><td>12/12/2017</td><td>15%</td><td>15%</td><td>122133</td><td>122133</td></tr><tr><td class="dark-text">Tim Hortons</td><td>Offer puchase, time hortons Al Wadha</td><td>34544</td><td>Jack D</td><td>12/12/2017</td><td>15%</td><td>15%</td><td>122133</td><td>122133</td></tr></tbody></table></div></div><div class="panel-footer"></div></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/profile/profile.html','<div ba-panel="" ba-panel-class="profile-page"><div class="panel-content"><div class="progress-info">Your profile is 70% Complete</div><div class="progress"><div class="progress-bar progress-bar-primary progress-bar-striped active" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100" style="width: 70%"></div></div><h3 class="with-line">General Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">Picture</label><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{ picture }}" ng-click="uploadPicture()"></div><i class="ion-ios-close-outline" ng-click="removePicture()" ng-if="!noPicture"></i> <a href="" class="change-userpic" ng-click="uploadPicture()">Change Profile Picture</a> <input type="file" ng-show="false" id="uploadFile" ng-file-select="onFileSelect($files)"></div></div></div></div><div class="col-md-6"></div></div><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputFirstName" class="col-sm-3 control-label">First Name</label><div class="col-sm-9"><input type="text" class="form-control" id="inputFirstName" placeholder="" value="Anastasiya"></div></div><div class="form-group row clearfix"><label for="inputLastName" class="col-sm-3 control-label">Last Name</label><div class="col-sm-9"><input type="text" class="form-control" id="inputLastName" placeholder="" value=""></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Department</label><div class="col-sm-9"><select class="form-control" selectpicker=""><option>Web Development</option><option>System Development</option><option>Sales</option><option>Human Resources</option></select></div></div><div class="form-group row clearfix"><label for="inputOccupation" class="col-sm-3 control-label">Occupation</label><div class="col-sm-9"><input type="text" class="form-control" id="inputOccupation" placeholder="" value="Front End Web Developer"></div></div></div></div><h3 class="with-line">Change Password</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputPassword" class="col-sm-3 control-label">Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputPassword" placeholder="" value="12345678"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label for="inputConfirmPassword" class="col-sm-3 control-label">Confirm Password</label><div class="col-sm-9"><input type="password" class="form-control" id="inputConfirmPassword" placeholder=""></div></div></div></div><h3 class="with-line">Contact Information</h3><div class="row"><div class="col-md-6"><div class="form-group row clearfix"><label for="inputEmail3" class="col-sm-3 control-label">Email</label><div class="col-sm-9"><input type="email" class="form-control" id="inputEmail3" placeholder="" value="contact@akveo.com"></div></div><div class="form-group row clearfix"><label for="inputPhone" class="col-sm-3 control-label">Phone</label><div class="col-sm-9"><input type="text" class="form-control" id="inputPhone" placeholder="" value="+1 (23) 456 7890"></div></div></div><div class="col-md-6"><div class="form-group row clearfix"><label class="col-sm-3 control-label">Office Location</label><div class="col-sm-9"><select class="form-control" title="Standard Select" selectpicker=""><option>San Francisco</option><option>London</option><option>Minsk</option><option>Tokio</option></select></div></div><div class="form-group row clearfix"><label for="inputRoom" class="col-sm-3 control-label">Room</label><div class="col-sm-9"><input type="text" class="form-control" id="inputRoom" placeholder="" value="303"></div></div></div></div><h3 class="with-line">Social Profiles</h3><div class="social-profiles row clearfix"><div class="col-md-3 col-sm-4" ng-repeat="item in socialProfiles"><a class="sn-link" href="" ng-click="showModal(item)" ng-if="!item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span></a> <a class="sn-link connected" href="{{ item.href }}" target="_blank" ng-if="item.href"><i class="socicon {{ item.icon }}"></i> <span>{{ item.name }}</span> <em class="ion-ios-close-empty sn-link-close" ng-mousedown="unconnect(item)"></em></a></div></div><h3 class="with-line">Send Email Notifications</h3><div class="notification row clearfix"><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When I receive a message</label><div class="col-xs-4"><switch color="primary" ng-model="switches[0]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When Someone sends me an invitation</label><div class="col-xs-4"><switch color="primary" ng-model="switches[1]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">When profile information changes</label><div class="col-xs-4"><switch color="primary" ng-model="switches[2]"></switch></div></div></div><div class="col-sm-6"><div class="form-group row clearfix"><label class="col-xs-8">When anyone logs into your account from a new device or browser</label><div class="col-xs-4"><switch color="primary" ng-model="switches[3]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Weekly Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[4]"></switch></div></div><div class="form-group row clearfix"><label class="col-xs-8">Daily Reports</label><div class="col-xs-4"><switch color="primary" ng-model="switches[5]"></switch></div></div></div></div><button type="button" class="btn btn-primary btn-with-icon save-profile"><i class="ion-android-checkmark-circle"></i>Update Profile</button></div></div>');
$templateCache.put('app/pages/profile/profileModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Account</h4></div><form name="linkForm"><div class="modal-body"><p>Paste a link to your profile into the box below</p><div class="form-group"><input type="text" class="form-control" placeholder="Link to Profile" ng-model="link"></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="ok(link)">Save changes</button></div></form></div>');
$templateCache.put('app/pages/report/report.html','<uib-tabset active="$root.activeTab"><uib-tab heading="PERFORMANCE - OVERVIEW" ui-sref="report.performance"><div class="col-md-12" ui-view="" autoscroll="true" autoscroll-body-top=""></div></uib-tab><uib-tab heading="REFERRAL ACTIVITIES" ui-sref="report.referral"><div class="col-md-12" ui-view="" autoscroll="true" autoscroll-body-top=""></div></uib-tab><uib-tab heading="CREDITS REPORTS" ui-sref="report.creditsreport"><div class="col-md-12" ui-view="" autoscroll="true" autoscroll-body-top=""></div></uib-tab><uib-tab heading="VISITORS REPORTS" ui-sref="report.visitorsreport"><div class="col-md-12" ui-view="" autoscroll="true" autoscroll-body-top=""></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/reservation/reservation.html','<div class="container-fluid"><div class="row"><div class="col-md-12"><div class="row"><div class="col-md-8"><div class="panel dash-bg panel-info bootstrap-panel"><div class="panel-heading panel-form border-none mt-20"><p class="reservationDates color-theme">Reservation vs Date</p><div class="chartjs-canvas-holder-third-row h-500 chart-height1"><canvas id="line" class="chart chart-line" chart-colors="registerLineColors" chart-data="registerDatas" chart-labels="registerLabels" chart-series="series" chart-click="changeData" chart-options="registerOptions"></canvas></div></div></div></div><div class="col-md-4"><div class="table-box-shadow"><div class="reservationsReq orange-text bor-l-r-radius">RESERVATION REQUESTS DAILY</div><div class="table-responsive mt-0 font-montser reservationData"><table class="table table-striped-blue"><thead class="thead-bg"><tr><th>DATE</th><th>OUTLET</th><th>RESERVATION</th></tr></thead><tbody><tr><td>17/16/2018</td><td>Ground floor</td><td>100</td></tr><tr><td>17/16/2018</td><td>Ground floor</td><td>100</td></tr><tr><td>17/16/2018</td><td>Ground floor</td><td>100</td></tr><tr><td>17/16/2018</td><td>Ground floor</td><td>100</td></tr><tr><td>17/16/2018</td><td>Ground floor</td><td>100</td></tr><tr><td>17/16/2018</td><td>Ground floor</td><td>100</td></tr></tbody><tfoot class="bg-white"><tr><td colspan="3" class="text-right"><p class="mb-0 cusors color-theme text-underline text-right">Check All</p></td></tr></tfoot></table></div></div></div></div><div class="row allVistors bg-white"><div class="col-md-6"><p class="visitAll color-theme">ALL VISITORS</p></div><div class="col-md-6"><div class="dropdown_custom font-montser float-r"><div class="dropdown filtrDowns"><a class="btn btn-secondary dropdownMenuLinks dropdown-toggle" href="" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Filter By</a><div class="dropdown-menu" aria-labelledby="dropdownMenuLink"><ul><li><a class="dropdown-item" href="">Outlet Name</a></li><li><a class="dropdown-item" href="">Location</a></li><li><a class="dropdown-item" href="">Status</a></li><li><a class="dropdown-item" href="">Date-Time</a></li></ul></div></div></div></div><div class="col-md-12"><div class="row"><div class="table-responsive allVistrs font-montser"><table class="table table-striped-blue"><thead class="thead-bg"><tr><th>REQUESTS</th><th>DATE-TIME</th><th>OUTLET</th><th>LOCATION</th><th>COUNTRY</th><th class="text-center">NO.OF GUESTS</th><th class="text-center">STATUS</th></tr></thead><tbody><tr><td class="differ-status">Reserve a table</td><td>19th March 2018. 7.00PM</td><td>Tim Hortons</td><td>Najda</td><td>Abu Dhabi</td><td class="text-center">3</td><td class="text-right"><span class="differ-status">Cancel</span> <span class="statu-tavble differ-status">Pending</span> <span><img src="assets/images/edit_icon.png" alt=""></span></td></tr><tr><td class="differ-status">Reserve a table</td><td>19th March 2018. 7.00PM</td><td>Tim Hortons</td><td>Najda</td><td>Abu Dhabi</td><td class="text-center">3</td><td class="text-right"><span class="differ-status">Cancel</span> <span class="statu-tavble differ-status">Pending</span> <span><img src="assets/images/edit_icon.png" alt=""></span></td></tr><tr><td class="differ-status">Reserve a table</td><td>19th March 2018. 7.00PM</td><td>Tim Hortons</td><td>Najda</td><td>Abu Dhabi</td><td class="text-center">3</td><td class="text-right"><span class="differ-status">Cancel</span> <span class="statu-tavble differ-status">Pending</span> <span><img src="assets/images/edit_icon.png" alt=""></span></td></tr><tr><td class="differ-status">Reserve a table</td><td>19th March 2018. 7.00PM</td><td>Tim Hortons</td><td>Najda</td><td>Abu Dhabi</td><td class="text-center">3</td><td class="text-right"><span class="differ-status">Cancel</span> <span class="statu-tavble differ-status">Pending</span> <span><img src="assets/images/edit_icon.png" alt=""></span></td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/review/review.html','<div class="container-fluid"><div class="row"><div class="col-md-12 bg-white p-t-b-10"><div class="row"><div class="col-md-7"><div class="color-theme bebas f-20px reviewTtles">REVIEW MODERATION</div></div><div class="col-md-5 text-right"><div class="form-group searchVend font-montser"><input type="text" class="form-control" id="input01s" placeholder="Search vendor"> <i class="fa fa-search" aria-hidden="true"></i></div><div class="dropdown_custom font-montser float-r"><div class="dropdown filtrDowns m-0"><a class="btn btn-secondary dropdownMenuLinks wid-bg dropdown-toggle" href="" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Filter By</a><div class="dropdown-menu wid-bg" aria-labelledby="dropdownMenuLink"><ul><li><a class="dropdown-item" href="">Outlet Name</a></li><li><a class="dropdown-item" href="">Location</a></li><li><a class="dropdown-item" href="">Status</a></li><li><a class="dropdown-item" href="">Date-Time</a></li></ul></div></div></div></div></div><div class="row"><div class="col-md-12 px-0"><div class="reviewMode table-responsive"><table class="table bg-white font-montser table-striped-blue"><thead class="thead-bg"><tr><th>OUTLET NAME</th><th>LOCATION</th><th>CUSTOMER</th><th>EMAIL</th><th class="text-center">COMMENT</th><th>DATE & TIME</th><th>RATING</th><th>STATUS</th><th>VIEW</th><th class="text-center">REPORT SPAM</th></tr></thead><tbody><tr><td>Time Hortons</td><td>Dubai</td><td>Tim</td><td>test@yopmail.com</td><td>The vendor has significant <a href="#">more</a></td><td>Feb 28 10:00AM</td><td>4.5</td><td><div class="dropdown"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Allow <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><img src="assets/images/view_icon.png" alt="view_icon" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/reviewModal.html\',\'border-wid\')"></td><td class="text-center"><i class="ban-icons fa fa-ban" aria-hidden="true"></i></td></tr><tr><td>Time Hortons</td><td>Dubai</td><td>Tim</td><td>test@yopmail.com</td><td>The vendor has significant <a href="#">more</a></td><td>Feb 28 10:00AM</td><td>4.5</td><td><div class="dropdown"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Allow <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><img src="assets/images/view_icon.png" alt="view_icon"></td><td class="text-center"><i class="ban-icons fa fa-ban" aria-hidden="true"></i></td></tr><tr><td>Time Hortons</td><td>Dubai</td><td>Tim</td><td>test@yopmail.com</td><td>The vendor has significant <a href="#">more</a></td><td>Feb 28 10:00AM</td><td>4.5</td><td><div class="dropdown"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Allow <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><img src="assets/images/view_icon.png" alt="view_icon"></td><td class="text-center"><i class="ban-icons fa fa-ban" aria-hidden="true"></i></td></tr><tr><td>Time Hortons</td><td>Dubai</td><td>Tim</td><td>test@yopmail.com</td><td>The vendor has significant <a href="#">more</a></td><td>Feb 28 10:00AM</td><td>4.5</td><td><div class="dropdown"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Allow <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><img src="assets/images/view_icon.png" alt="view_icon"></td><td class="text-center"><i class="ban-icons fa fa-ban" aria-hidden="true"></i></td></tr><tr><td>Time Hortons</td><td>Dubai</td><td>Tim</td><td>test@yopmail.com</td><td>The vendor has significant <a href="#">more</a></td><td>Feb 28 10:00AM</td><td>4.5</td><td><div class="dropdown"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Allow <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><img src="assets/images/view_icon.png" alt="view_icon"></td><td class="text-center"><i class="ban-icons fa fa-ban" aria-hidden="true"></i></td></tr><tr><td>Time Hortons</td><td>Dubai</td><td>Tim</td><td>test@yopmail.com</td><td>The vendor has significant <a href="#">more</a></td><td>Feb 28 10:00AM</td><td>4.5</td><td><div class="dropdown"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Allow <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><img src="assets/images/view_icon.png" alt="view_icon"></td><td class="text-center"><i class="ban-icons fa fa-ban" aria-hidden="true"></i></td></tr></tbody></table></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></div><div class="row mt-20"><div class="col-md-12 bg-white p-t-b-10"><div class="row"><div class="col-md-8"><div class="color-theme bebas f-20px reviewTtles">NEGATIVE FEEDBACK</div></div><div class="col-md-4 text-right"><div class="form-group searchVend font-montser"><input type="text" class="form-control" id="input01s" placeholder="Search vendor"> <i class="fa fa-search" aria-hidden="true"></i></div><div class="dropdown_custom font-montser float-r"><div class="dropdown filtrDowns m-0"><a class="btn btn-secondary dropdownMenuLinks wid-bg dropdown-toggle" href="" role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Filter By</a><div class="dropdown-menu wid-bg" aria-labelledby="dropdownMenuLink"><ul><li><a class="dropdown-item" href="">Outlet Name</a></li><li><a class="dropdown-item" href="">Location</a></li><li><a class="dropdown-item" href="">Status</a></li><li><a class="dropdown-item" href="">Date-Time</a></li></ul></div></div></div></div></div><div class="row"><div class="col-md-12 px-0"><div class="reviewMode table-responsive"><table class="table bg-white font-montser table-striped-blue"><thead class="thead-bg"><tr><th>OUTLET NAME</th><th>LOCATION</th><th>CUSTOMER</th><th>EMAIL</th><th class="text-center">COMMENT</th><th>DATE & TIME</th><th>STATUS</th><th>VIEW</th><th class="text-center">REPORT SPAM</th></tr></thead><tbody><tr><td>Time Hortons</td><td>Dubai</td><td>Tim</td><td>test@yopmail.com</td><td>The vendor has significant <a href="#">more</a></td><td>Feb 28 10:00AM</td><td><div class="dropdown"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Allow <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><img src="assets/images/view_icon.png" alt="view_icon"></td><td class="text-center"><i class="ban-icons fa fa-ban" aria-hidden="true"></i></td></tr><tr><td>Time Hortons</td><td>Dubai</td><td>Tim</td><td>test@yopmail.com</td><td>The vendor has significant <a href="#">more</a></td><td>Feb 28 10:00AM</td><td><div class="dropdown"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Allow <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><img src="assets/images/view_icon.png" alt="view_icon"></td><td class="text-center"><i class="ban-icons fa fa-ban" aria-hidden="true"></i></td></tr><tr><td>Time Hortons</td><td>Dubai</td><td>Tim</td><td>test@yopmail.com</td><td>The vendor has significant <a href="#">more</a></td><td>Feb 28 10:00AM</td><td><div class="dropdown"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Allow <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><img src="assets/images/view_icon.png" alt="view_icon"></td><td class="text-center"><i class="ban-icons fa fa-ban" aria-hidden="true"></i></td></tr><tr><td>Time Hortons</td><td>Dubai</td><td>Tim</td><td>test@yopmail.com</td><td>The vendor has significant <a href="#">more</a></td><td>Feb 28 10:00AM</td><td><div class="dropdown"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Allow <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><img src="assets/images/view_icon.png" alt="view_icon"></td><td class="text-center"><i class="ban-icons fa fa-ban" aria-hidden="true"></i></td></tr><tr><td>Time Hortons</td><td>Dubai</td><td>Tim</td><td>test@yopmail.com</td><td>The vendor has significant <a href="#">more</a></td><td>Feb 28 10:00AM</td><td><div class="dropdown"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Allow <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><img src="assets/images/view_icon.png" alt="view_icon"></td><td class="text-center"><i class="ban-icons fa fa-ban" aria-hidden="true"></i></td></tr><tr><td>Time Hortons</td><td>Dubai</td><td>Tim</td><td>test@yopmail.com</td><td>The vendor has significant <a href="#">more</a></td><td>Feb 28 10:00AM</td><td><div class="dropdown"><button class="btn btn-primary dropdown-toggle" type="button" data-toggle="dropdown">Allow <span class="caret"></span></button><ul class="dropdown-menu"><li><a href="#">HTML</a></li><li><a href="#">CSS</a></li><li><a href="#">JavaScript</a></li></ul></div></td><td><img src="assets/images/view_icon.png" alt="view_icon"></td><td class="text-center"><i class="ban-icons fa fa-ban" aria-hidden="true"></i></td></tr></tbody></table></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></div></div>');
$templateCache.put('app/pages/support/support.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="GUIDES"><img src="../../../assets/img/guides.png" class="" style="width:100%;"><br><div class="row m-t-20"><div class="col-lg-12"><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><h4>DASHBOARD GUIDES</h4></div><div class="panel-body p-l-0 p-r-0"><div class="table-responsive"><table class="table list-table"><tr class="b-b-1"><td style="width:10%; text-align:center;"><img class="img-circle m-l-20" src="assets/images/gl-img1.jpg" alt="..." height="50" width="50"><h6 class="orange-text p-t-10" style="clear:both;">1 Day ago</h6></td><td><h5 class="orange-text">How to Submit a Ticket</h5><p>Whatever you need, we\'re here to help! Simply follow the steps below to submit a ticket. A ticket is used to submit requests online to our customer service, please submit a ticket whenever you have a question regarding one of your orders.</p></td></tr><tr><td style="width:10%; text-align:center;" class="pt10"><img class="img-circle m-l-20" src="assets/images/gl-img2.jpg" alt="..." height="50" width="50"><h5 class="orange-text p-t-10" style="clear:both;">1 Day ago</h5></td><td><h5 class="orange-text">Paladins Bug Reporting Form</h5><p>Finding a top feed outside the sample degustations, chef\'s menus and pop-up dinners on offer in Brisbane has never been hard, but making a night of it on the cheap is now easier than ever.</p></td></tr></table></div></div><div class="panel-footer"></div></div></div></div></uib-tab><uib-tab heading="TICKETS"><div class="panel panel-success bootstrap-panel"><div class="panel-heading panel-form"><form class="form-horizontal"><div class="form-group"><div class="col-md-8"></div><label for="inputEmail3" class="col-md-2 control-label"><span class="white-text">SORT TICKETS BY</span></label><div class="col-md-2"><vouched-select class="tran-select" label="By Outlet" selected-value="outletFilter" select-lists="outletFilterLists" display-field="value" is-label="isFilterLabel"></vouched-select></div></div></form></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="row"><div class="col-md-4"><div><label for="">Name of Ticket<i class="fa fa-ticket p-l-10" aria-hidden="true" style="font-size: 20px;"></i></label><vouched-text-box label="Name of Ticket" text-value="value" is-label="false"></vouched-text-box></div><div><label for="inputEmail3" class="control-label">Choose Category</label><vouched-select class="tran-select" label="Ticket Category" selected-value="outletFilter" select-lists="outletFilterLists" display-field="value" is-label="isFilterLabel"></vouched-select></div></div><vouched-text-area class="col-md-8 ticket" label="" text-value="value" is-label="false"></vouched-text-area></div><div class="button-wrapper"><button type="button" class="btn btn-info" style="font-family:bebas;">SUBMIT NEW TICKET</button></div></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><h4>CURRENTLY OPEN TICKETS</h4></div><div class="panel-body b-b-d"><div class="row"><div class="col-md-2"></div><div class="col-md-8"><vouched-radio-button radio-list="genderLists" text-value="genderValue" is-horizontal-form="true"></vouched-radio-button></div><div class="col-md-2"></div></div></div><div class="panel-body p-0"><div class="table-responsive"><table class="table list-table"><tr class="b-b-d"><td style="text-align:center;" class=""><p>04/11/2017</p><p>13:04</p><h5 class="orange-text p-t-10">1 day ago</h5></td><td class=""><img class="img-circle" src="assets/images/gl-img1.jpg" alt="..." height="50" width="50"></td><td class=""><p>Ranjani Manivannan</p><p>ranjani@yopmail.com</p></td><td class=""><h5 class="orange-text">How do I update employee account?</h5><h5>20% are current customers who have visited your business within the last 6months.</h5></td><td class=""><img class="img-circle" src="assets/images/gl-img1.jpg" alt="..." height="40" width="40"></td><td class=""><i class="fa fa-check-circle rating-icon-green p-b-10" aria-hidden="true"><u class="p-l-5">Solved</u></i><br><i class="fa fa-times-circle rating-icon" aria-hidden="true">Drop</i></td></tr><tr class="b-b-d"><td style="text-align:center;"><p>04/11/2017</p><p>13:04</p><h5 class="orange-text p-t-10">1 day ago</h5></td><td><img class="img-circle" src="assets/images/gl-img1.jpg" alt="..." height="50" width="50"></td><td><p>Ranjani Manivannan</p><p>ranjani@yopmail.com</p></td><td><h5 class="orange-text">How do I update employee account?</h5><h5>20% are current customers who have visited your business within the last 6months.</h5></td><td><img class="img-circle" src="assets/images/gl-img1.jpg" alt="..." height="40" width="40"></td><td><i class="fa fa-check-circle rating-icon-green p-b-10" aria-hidden="true"><u class="p-l-5">Solved</u></i><br><i class="fa fa-times-circle rating-icon" aria-hidden="true">Drop</i></td></tr></table></div></div><div class="panel-footer b-t-none"></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><h4>PINNED OPEN TICKETS</h4></div><div class="panel-body p-0"><div class="table-responsive"><table class="table list-table"><tr class="b-b-d"><td style="text-align:center;"><p>04/11/2017</p><p>13:04</p><h5 class="orange-text p-t-10">1 day ago</h5></td><td><img class="img-circle" src="assets/images/gl-img1.jpg" alt="..." height="50" width="50"></td><td><p>Ranjani Manivannan</p><p>ranjani@yopmail.com</p></td><td><h5 class="orange-text">How do I update employee account?</h5><h5>20% are current customers who have visited your business within the last 6months.</h5></td><td><img class="img-circle" src="assets/images/gl-img1.jpg" alt="..." height="40" width="40"></td><td><i class="fa fa-check-circle rating-icon-green p-b-10" aria-hidden="true"><u class="p-l-5">Solved</u></i><br><i class="fa fa-times-circle rating-icon" aria-hidden="true">Drop</i></td></tr><tr class="b-b-d"><td style="text-align:center;"><p>04/11/2017</p><p>13:04</p><h5 class="orange-text p-t-10">1 day ago</h5></td><td><img class="img-circle" src="assets/images/gl-img1.jpg" alt="..." height="50" width="50"></td><td><p>Ranjani Manivannan</p><p>ranjani@yopmail.com</p></td><td><h5 class="orange-text">How do I update employee account?</h5><h5>20% are current customers who have visited your business within the last 6months.</h5></td><td><img class="img-circle" src="assets/images/gl-img1.jpg" alt="..." height="40" width="40"></td><td><i class="fa fa-check-circle rating-icon-green p-b-10" aria-hidden="true"><u class="p-l-5">Solved</u></i><br><i class="fa fa-times-circle rating-icon" aria-hidden="true">Drop</i></td></tr></table></div></div><div class="panel-footer b-t-none"></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading"><h4>SOLVED TICKETS</h4></div><div class="panel-body p-0"><div class="table-responsive"><table class="table list-table"><tr class="b-b-d"><td style="text-align:center;"><p>04/11/2017</p><p>13:04</p><h5 class="orange-text p-t-10">1 day ago</h5></td><td><img class="img-circle" src="assets/images/gl-img1.jpg" alt="..." height="50" width="50"></td><td><p>Ranjani Manivannan</p><p>ranjani@yopmail.com</p></td><td><h5 class="orange-text">How do I update employee account?</h5><h5>20% are current customers who have visited your business within the last 6months.</h5></td><td><img class="img-circle" src="assets/images/gl-img1.jpg" alt="..." height="40" width="40"></td><td><i class="fa fa-check-circle rating-icon-green p-b-10" aria-hidden="true"><u class="p-l-5">Solved</u></i><br><i class="fa fa-times-circle rating-icon" aria-hidden="true">Drop</i></td></tr><tr class="b-b-d"><td style="text-align:center;"><p>04/11/2017</p><p>13:04</p><h5 class="orange-text p-t-10">1 day ago</h5></td><td><img class="img-circle" src="assets/images/gl-img1.jpg" alt="..." height="50" width="50"></td><td><p>Ranjani Manivannan</p><p>ranjani@yopmail.com</p></td><td style="width:50%;"><h5 class="orange-text">How do I update employee account?</h5><h5>20% are current customers who have visited your business within the last 6months.</h5></td><td><img class="img-circle" src="assets/images/gl-img1.jpg" alt="..." height="40" width="40"></td><td><i class="fa fa-check-circle rating-icon-green p-b-10" aria-hidden="true"><u class="p-l-5">Solved</u></i><br><i class="fa fa-times-circle rating-icon" aria-hidden="true">Drop</i></td></tr></table></div></div><div class="panel-footer b-t-none"></div></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/vendorcontract/vendorcontract.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="VENDOR CONTRACTS"><div class="container-fluid"><div class="row"><div class="col-md-12 bg-white"><div class="row"><div class="col-md-8"><p class="visitAll color-theme">VENDOR CONTRACTS</p></div><div class="col-md-4 text-right mt-15"><div class="form-group searchVend font-montser float-l"><input type="text" class="form-control" id="input01s" placeholder="Search vendor"> <i class="fa fa-search" aria-hidden="true"></i></div><vouched-select label="Filter By" selected-value="outletFilter" select-lists="sortBy" class="vendro-filter filterBys" display-field="value" is-label="false"></vouched-select></div></div><div class="row"><div class="col-md-12 px-0"><div class="reviewMode table-responsive"><table class="table bg-white font-montser table-striped-blue"><thead class="thead-bg"><tr><th>VENDOR NAME</th><th>ORGANIZATION MODE</th><th>MOBILE</th><th>EMAIL</th><th class="text-center">NO.OFOUTLETS</th><th>DATE & TIME</th><th><p class="color-white">YEARLY SUBSCRIPTION</p><span>FEE[1000 AED PER YEAR]</span></th><th class="text-center">CONTRACT</th><th>UPDATE CONTRACT</th></tr></thead><tbody><tr><td>Time Hortons</td><td>Standlone</td><td>777697594587</td><td>Test@yopmail.com <span>more</span></td><td>10</td><td>Feb 28 10:00AM</td><td>1000AED</td><td><img src="assets/images/view_icon.png" class="viewImg" alt="view_icon"> <img src="assets/images/pdf.png" class="pdfImg" alt="view_icon"> <img src="assets/images/download-button.png" alt="view_icon"></td><td class="text-center"><img src="assets/images/edit_icon.png" alt="view_icon"></td></tr><tr><td>Time Hortons</td><td>Standlone</td><td>777697594587</td><td>Test@yopmail.com <span>more</span></td><td>10</td><td>Feb 28 10:00AM</td><td>1000AED</td><td><img src="assets/images/view_icon.png" class="viewImg" alt="view_icon"> <img src="assets/images/pdf.png" class="pdfImg" alt="view_icon"> <img src="assets/images/download-button.png" alt="view_icon"></td><td class="text-center"><img src="assets/images/edit_icon.png" alt="view_icon"></td></tr><tr><td>Time Hortons</td><td>Standlone</td><td>777697594587</td><td>Test@yopmail.com <span>more</span></td><td>10</td><td>Feb 28 10:00AM</td><td>1000AED</td><td><img src="assets/images/view_icon.png" class="viewImg" alt="view_icon"> <img src="assets/images/pdf.png" class="pdfImg" alt="view_icon"> <img src="assets/images/download-button.png" alt="view_icon"></td><td class="text-center"><img src="assets/images/edit_icon.png" alt="view_icon"></td></tr><tr><td>Time Hortons</td><td>Standlone</td><td>777697594587</td><td>Test@yopmail.com <span>more</span></td><td>10</td><td>Feb 28 10:00AM</td><td>1000AED</td><td><img src="assets/images/view_icon.png" class="viewImg" alt="view_icon"> <img src="assets/images/pdf.png" class="pdfImg" alt="view_icon"> <img src="assets/images/download-button.png" alt="view_icon"></td><td class="text-center"><img src="assets/images/edit_icon.png" alt="view_icon"></td></tr><tr><td>Time Hortons</td><td>Standlone</td><td>777697594587</td><td>Test@yopmail.com <span>more</span></td><td>10</td><td>Feb 28 10:00AM</td><td>1000AED</td><td><img src="assets/images/view_icon.png" class="viewImg" alt="view_icon"> <img src="assets/images/pdf.png" class="pdfImg" alt="view_icon"> <img src="assets/images/download-button.png" alt="view_icon"></td><td class="text-center"><img src="assets/images/edit_icon.png" alt="view_icon"></td></tr><tr><td>Time Hortons</td><td>Standlone</td><td>777697594587</td><td>Test@yopmail.com <span>more</span></td><td>10</td><td>Feb 28 10:00AM</td><td>1000AED</td><td><img src="assets/images/view_icon.png" class="viewImg" alt="view_icon"> <img src="assets/images/pdf.png" class="pdfImg" alt="view_icon"> <img src="assets/images/download-button.png" alt="view_icon"></td><td class="text-center"><img src="assets/images/edit_icon.png" alt="view_icon"></td></tr></tbody></table></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></div></div></uib-tab><uib-tab heading="BRIEF CONTRACT"><div class="container-fluid p-3"><div class="row"><div class="col-lg-12"><p class="visitAll color-theme">BRIEF CONTRACTS</p></div></div><div class="row namedetais brief-detials-infor bg-white m-10"><div class="col-md-12"><p class="orstand outsandart argee-text color-black pt-0">AN AGREEMENT BETWEEN VOUCHED4U AND TIM HORTONS</p></div></div><div class="row namedetais brief-detials-infor bg-white m-10"><div class="col-md-12"><p class="font-w color-black">ACCOUNT INFORMATION</p></div><div class="col-md-4"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>NAME</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder="Peter Sampras"></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>NUMBER OF OUTLETS</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder="10"></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>YOUR POSITION</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder="Owner"></div></div><div class="col-md-4"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>PHONE</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder="0175-253-1256-425"></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>EMAIL ID</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder="test@test.com"></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>OUTLET / BRAND / WEBSITE</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder="www.test.com"></div></div></div><div class="row namedetais brief-detials-infor bg-white m-10"><div class="col-md-12"><p class="font-w color-black">PAYMENT TERMS</p></div><div class="col-md-3"><div class="font-montser"><label for="inputLastName" class="color-black mt-15"><b>SELECT PAYMENT MODE</b></label></div></div><div class="col-md-3"><div class="form-group font-montser"><div class="selectCust selectoutlets h-48 height-var"><select id="" class="form-control mb-10 border-sel" name="business"><option value="First Choice">Yearly</option><option value="Second Choice">Monthly</option><option value="Third Choice">Weekly</option></select></div></div></div><div class="col-md-3"><div class="font-montser text-right"><label for="inputLastName" class="color-black mt-15"><b>CONTRACT TERM</b></label></div></div><div class="col-md-2"><div class="form-group font-montser"><div class="selectCust selectoutlets h-48 height-var"><select id="" class="form-control mb-10 border-sel" name="business"><option value="First Choice">1</option><option value="Second Choice">2</option><option value="Third Choice">3</option></select></div></div></div><div class="col-md-1"><div class="form-group font-montser"><p class="font-w mt-15 color-theme">years</p></div></div><div class="col-md-3"><div class="font-montser"><label for="inputLastName" class="color-black mt-15"><b>SELECT PAYMENT MODE</b></label></div></div><div class="col-md-3"><div class="form-group font-montser"><p class="col-md-3 input-group calendar-vendor"><input type="text" class="form-control w-100" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dtt" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openTo()"><img src="assets/images/calendar-icons.png" alt="calendar-icons"></button></span></p></div></div></div><div class="row namedetais brief-detials-infor bg-white m-10"><div class="col-md-12"><p class="font-w color-black">TERMS & CONDITIONS</p></div><div class="col-md-6"><p class="grer-color">1. The Terms & Conditions is valid for</p><p class="grer-color">2. All the terms are to be mutually ...</p></div></div><div class="row namedetais brief-detials-infor bg-white m-10 mb30"><div class="col-md-12"><p class="font-w color-black">ANY OTHER CONTRACT INFORMATION</p></div><div class="col-md-12"><p class="grer-color">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p class="color-black">Can even upload prepared the contract here.. <a href="#"><img src="assets/images/uploads.png" class="ml-15"></a></p></div></div><div class="row pull-right"><div class="col-lg-12 mt-20 mb30"><button type="button" class="b-rad-30 boder-radu btn vendor-btn btn-info btn-with-icon mr-20">PREVIEW</button> <button type="button" class="b-rad-30 boder-radu btn vendor-btn btn-info btn-with-icon mr-20">SAVE CONTRACT</button></div></div></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/charts/amCharts/charts.html','<div class="widgets"><div class="row"><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/barChart/barChart.html\'"></div></div><div class="col-lg-4 col-md-6" ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/areaChart/areaChart.html\'"></div></div><div class="col-lg-4 col-md-12" ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/lineChart/lineChart.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Pie Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/pieChart/pieChart.html\'"></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Funnel Chart" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/funnelChart/funnelChart.html\'"></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Combined bullet/column and line graphs with multiple value axes" ba-panel-class="with-scroll"><div ng-include="\'app/pages/charts/amCharts/combinedChart/combinedChart.html\'"></div></div></div></div>');
$templateCache.put('app/pages/charts/chartJs/chartJs.html','<div class="row"><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Pie" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="pie" class="chart chart-pie" chart-options="options" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Doughnut" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" chart-options="options" class="chart chart-doughnut" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-md-4" ng-controller="chartJs1DCtrl"><div ba-panel="" ba-panel-title="Polar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-first-row"><canvas id="polar-area" class="chart chart-polar-area" chart-data="data" chart-options="options" chart-labels="labels" chart-click="changeData"></canvas></div></div></div></div><div class="row"><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Radar" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveLine" class="chart chart-radar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div><div class="col-md-6" ng-controller="chartJsWaveCtrl"><div ba-panel="" ba-panel-title="Animated Bars" ba-panel-class="col-eq-height"><div class="chartjs-canvas-holder-second-row"><canvas id="waveBars" class="chart chart-bar" chart-data="[data]" chart-labels="labels"></canvas></div></div></div></div><div class="row"><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Radar" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="radar" class="chart chart-radar" chart-series="series" chart-data="data" chart-labels="labels" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-6" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Line" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="line" class="chart chart-line" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData"></canvas></div></div></div><div class="col-lg-4 col-md-12" ng-controller="chartJs2DCtrl"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><div class="chartjs-canvas-holder-third-row"><canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData" chart-update="updateC"></canvas></div></div></div></div>');
$templateCache.put('app/pages/charts/chartist/chartist.html','<section ng-controller="chartistCtrl" class="chartist"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Lines" ba-panel-class="with-scroll"><h5>Simple line chart</h5><div id="line-chart" class="ct-chart"></div><h5>Line chart with area</h5><div id="area-chart" class="ct-chart"></div><h5>Bi-polar line chart with area only</h5><div id="bi-chart" class="ct-chart"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Bars" ba-panel-class="with-scroll"><h5>Simple bar chart</h5><div id="simple-bar" class="ct-chart"></div><h5>Multi-line labels bar chart</h5><div id="multi-bar" class="ct-chart"></div><h5>Stacked bar chart</h5><div id="stacked-bar" class="ct-chart stacked-bar"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Pies & Donuts" ba-panel-class="with-scroll"><div class="row"><div class="col-md-12 col-lg-4"><h5>Simple Pie</h5><div id="simple-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Pie with labels</h5><div id="label-pie" class="ct-chart"></div></div><div class="col-md-12 col-lg-4"><h5>Donut</h5><div id="donut" class="ct-chart"></div></div></div></div></div></div></section>');
$templateCache.put('app/pages/charts/morris/morris.html','<section ng-controller="morrisCtrl"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Line Chart" ba-panel-class="with-scroll"><div line-chart="" line-data="lineData" line-xkey="y" line-ykeys=\'["a", "b"]\' line-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div><div class="row"><div class="col-md-4"><div ba-panel="" ba-panel-title="Donut" ba-panel-class="with-scroll"><div donut-chart="" donut-data="donutData" donut-colors="colors" donut-formatter=\'"currency"\'></div></div></div><div class="col-md-8"><div ba-panel="" ba-panel-title="Bar Chart" ba-panel-class="with-scroll"><div bar-chart="" bar-data="barData" bar-x="y" bar-y=\'["a", "b"]\' bar-labels=\'["Series A", "Series B"]\' bar-colors="colors"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Area Chart" ba-panel-class="with-scroll"><div area-chart="" area-data="areaData" area-xkey="y" area-ykeys=\'["a", "b"]\' %="" area-labels=\'["Serie A", "Serie B"]\' line-colors="colors"></div></div></div></div></section>');
$templateCache.put('app/pages/components/mail/mail.html','<div class="row mail-client-container transparent"><div class="col-md-12"><div ba-panel="" ba-panel-class="xmedium-panel mail-panel"><div class="letter-layout"><div class="mail-navigation-container" ng-class="{\'expanded\' : !tabCtrl.navigationCollapsed}"><div class="text-center"><button type="button" class="btn btn-default compose-button" ng-click="tabCtrl.showCompose(\'\',\'\',\'\')">Compose</button></div><div ng-repeat="t in tabCtrl.tabs" ui-sref-active="active" class="mail-navigation" ui-sref="components.mail.label({label: t.label})" ng-click="selectTab(t.label)">{{t.name}}<span class="new-mails" ng-show="t.newMails">{{t.newMails}}</span></div><div class="labels"><div class="labels-title"></div><div class="labels-container"><div class="label-item"><span class="tag label work">Work</span></div><div class="label-item"><span class="tag label family">Family</span></div><div class="label-item"><span class="tag label friend">Friend</span></div><div class="label-item"><span class="tag label study">Study</span></div></div></div><div class="add-label-container"><i class="ion-plus-round"></i><span class="label-input-stub">Add new label</span></div></div><ui-view></ui-view></div></div></div></div>');
$templateCache.put('app/pages/components/timeline/timeline.html','<div ba-panel=""><section id="cd-timeline" class="cd-container cssanimations" ng-controller="TimelineCtrl"><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Euro-Coin\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 1</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Iusto, optio, dolorum provident rerum aut hic quasi placeat iure tempora laudantium ipsa ad debitis unde? Iste voluptatibus minus veritatis qui ut.</p><span class="cd-date">Jan 14</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Laptop-Signal\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 2</h5><p>Donec dapibus at leo eget volutpat. Praesent dolor tellus, ultricies venenatis molestie eu, luctus eget nibh. Curabitur ullamcorper eleifend nisl.</p><span class="cd-date">Jan 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Checklist\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 3</h5><p>Phasellus auctor tellus eget lacinia condimentum. Cum sociis natoque penatibus et magnis dis parturient montes.</p><span class="cd-date">Feb 18</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Boss-3\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 4</h5><p>Morbi fringilla in massa ac posuere. Fusce non sagittis massa, id accumsan odio. Nullam eget tempor est. Etiam eu felis eu purus aliquam tristique id quis nisl. Nam eros nibh, consequat sed pulvinar eu, ultrices ornare ligula. Aenean interdum sed nunc sed hendrerit.</p><span class="cd-date">Feb 20</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Online-Shopping\' | kameleonImg )}}"></div></div><div class="cd-timeline-content danger"><h5>Title of section 5</h5><p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Curabitur eget mattis metus. Nullam egestas eros metus, quis fringilla urna accumsan sed. Aliquam ultrices at arcu vitae tincidunt.</p><span class="cd-date">Feb 21</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg primary"><img ng-src="{{::( \'Money-Increase\' | kameleonImg )}}"></div></div><div class="cd-timeline-content primary"><h5>Title of section 6</h5><p>Praesent bibendum ante mattis augue consectetur, ut commodo turpis consequat. Donec ligula eros, porta in iaculis vel, semper ac sem. Integer at mauris lorem.</p><span class="cd-date">Feb 23</span></div></div><div class="cd-timeline-block"><div class="cd-timeline-img"><div class="kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Vector\' | kameleonImg )}}"></div></div><div class="cd-timeline-content warning"><h5>Title of section 7</h5><p>Vivamus ut laoreet erat, vitae eleifend eros. Sed varius id tellus non lobortis. Sed dolor ante, cursus non scelerisque sed, euismod id eros.</p><span class="cd-date">Feb 24</span></div></div></section></div>');
$templateCache.put('app/pages/components/tree/tree.html','<div class="row" ng-controller="treeCtrl"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Action" ba-panel-class="with-scroll tree-panel"><div class="row"><div class="col-sm-4"><div class="control-side text-center"><div><button class="btn btn-primary" ng-click="addNewNode()">Add</button></div><div><button class="btn btn-primary" ng-click="collapse()">Collapse All</button></div><div><button class="btn btn-primary" ng-click="expand()">Expand All</button></div><div><button class="btn btn-primary" ng-click="refresh()">Refresh</button></div></div></div><div class="col-sm-8"><div js-tree="basicConfig" ng-model="treeData" should-apply="applyModelChanges()" tree="basicTree" tree-events="ready:readyCB"></div></div></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Drag & Drop" ba-panel-class="with-scroll tree-panel"><div js-tree="dragConfig" ng-model="dragData"></div></div></div></div>');
$templateCache.put('app/pages/dashboard/blurFeed/blurFeed.html','<div class="feed-messages-container" track-width="smallContainerWidth" min-width="360"><div class="feed-message" ng-repeat="message in feed" ng-click="expandMessage(message)"><div class="message-icon" ng-if="message.type == \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"></div><div class="message-icon" ng-if="message.type != \'text-message\'"><img class="photo-icon" ng-src="{{::( message.author | profilePicture )}}"> <span class="sub-photo-icon" ng-class="::message.type"></span></div><div class="text-block text-message"><div class="message-header"><span class="author">{{ ::message.author }} {{ ::message.surname}}</span></div><div class="message-content line-clamp" ng-class="{\'line-clamp-2\' : !message.expanded}"><span ng-if="message.preview">{{message.header}}</span>{{::message.text}}</div><div class="preview" ng-show="message.expanded" ng-if="message.preview"><a href="{{::message.link}}" target="_blank"><img ng-src="{{ ::( message.preview | appImage )}}"></a></div><div ng-show="message.expanded" class="message-time"><div class="post-time">{{::message.time}}</div><div class="ago-time">{{::message.ago}}</div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/dashboardCalendar/dashboardCalendar.html','<div id="calendar" class="blurCalendar"></div>');
$templateCache.put('app/pages/dashboard/dashboardLineChart/dashboardLineChart.html','<div id="amchart"></div>');
$templateCache.put('app/pages/dashboard/dashboardMap/dashboardMap.html','<div id="amChartMap"></div>');
$templateCache.put('app/pages/dashboard/dashboardTodo/dashboardTodo.html','<div class="task-todo-container" ng-class="{\'transparent\': transparent}"><input type="text" value="" class="form-control task-todo" placeholder="Task to do.." ng-keyup="addToDoItem($event)" ng-model="newTodoText"> <i ng-click="addToDoItem(\'\',true)" class="add-item-icon ion-plus-round"></i><div class="box-shadow-border"></div><ul class="todo-list" ui-sortable="" ng-model="todoList"><li ng-repeat="item in todoList" ng-if="!item.deleted" ng-init="activeItem=false" ng-class="{checked: isChecked, active: activeItem}" ng-mouseenter="activeItem=true" ng-mouseleave="activeItem=false"><div class="blur-container"><div class="blur-box"></div></div><i class="mark" style="background-color: {{::item.color}}"></i> <label class="todo-checkbox custom-checkbox custom-input-success"><input type="checkbox" ng-model="isChecked"> <span class="cut-with-dots">{{ item.text }}</span></label> <i class="remove-todo ion-ios-close-empty" ng-click="item.deleted = true"></i></li></ul></div>');
$templateCache.put('app/pages/dashboard/dashboardPieChart/dashboardPieChart.html','<div class="row pie-charts"><div class="pie-chart-item-container" ng-repeat="chart in charts"><div ba-panel=""><div class="pie-chart-item"><div class="chart" rel="{{ ::chart.color }}" data-percent="60"><span class="percent"></span></div><div class="description"><div>{{ ::chart.description }}</div><div class="description-stats">{{ ::chart.stats }}</div></div><i class="chart-icon i-{{ ::chart.icon }}"></i></div></div></div></div>');
$templateCache.put('app/pages/dashboard/popularApp/popularApp.html','<div class="popular-app-img-container"><div class="popular-app-img"><img ng-src="{{::( \'app/my-app-logo.png\' | appImage )}}"> <span class="logo-text">Super&nbspApp</span></div></div><div class="popular-app-cost row"><div class="col-xs-9">Most Popular App</div><div class="col-xs-3 text-right">175$</div></div><div class="popular-app-info row"><div class="col-xs-4 text-left"><div class="info-label">Total Visits</div><div>47,512</div></div><div class="col-xs-4 text-center"><div class="info-label">New Visits</div><div>9,217</div></div><div class="col-xs-4 text-right"><div class="info-label">Sales</div><div>2,928</div></div></div>');
$templateCache.put('app/pages/dashboard/trafficChart/trafficChart.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="traffic-text">1,900,128 <span>Views Total</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="label in doughnutData.labels" ng-init="i = $index; data = doughnutData.datasets[0]"><div class="legend-color" style="background-color: {{::data.backgroundColor[i]}}"></div><p>{{::label}}<span class="channel-number">+{{data.percentage[i]}}%</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{data.percentage[i]}}" aria-valuemin="0" aria-valuemax="100" style="width: {{item.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/weather/weather.html','<div class="weather-wrapper"><div class="weather-main-info"><h5 class="city-date font-x1dot5"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class="weather-description font-x1dot5"><i class="font-x3 {{weatherIcons[weather.days[weather.current].icon]}}"></i><div class="weather-info">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class="weather-temp font-x1dot5"><i class="font-x2 ion-thermometer"></i><div class="weather-info" ng-switch="" on="units"><span ng-switch-when="metric">{{weather.days[weather.current].temp}} \xB0C | <a ng-click="switchUnits(\'imperial\')" href="">\xB0F</a></span> <span ng-switch-when="imperial">{{weather.days[weather.current].temp}} \xB0F | <a ng-click="switchUnits(\'metric\')" href="">\xB0C</a></span></div></div></div><div id="tempChart" class="temp-by-time"></div><div class="select-day"><div class="day" ng-repeat="day in weather.days" ng-click="switchDay($index)"><div><span class="font-x1dot25">{{day.temp}}</span></div><div><i class="weatherIcon font-x2 {{weatherIcons[day.icon]}}"></i> <span class="select-day-info">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/inputs.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Standard Fields" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/standardFields.html\'"></div></div><div ba-panel="" ba-panel-title="Tags Input" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/tagsInput/tagsInput.html\'"></div></div><div ba-panel="" ba-panel-title="Input Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/inputGroups.html\'"></div></div><div ba-panel="" ba-panel-title="Checkboxes & Radios" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/checkboxesRadios.html\'"></div></div><div ba-panel="" ba-panel-title="On/Off Switches" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/switches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Old On/Off Switches (Deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSwitches/switch.html\'"></div></div><div ba-panel="" ba-panel-title="Datepicker" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/datePickers/datePickers.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Validation States" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/validationStates.html\'"></div></div><div ba-panel="" ba-panel-title="Selects" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/select/select.html\'"></div></div><div ba-panel="" ba-panel-title="Old selects(deprecated)" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/inputs/widgets/oldSelect/select.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/layouts/layouts.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/inlineForm.html\'"></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/basicForm.html\'"></div></div><div ba-panel="" ba-panel-title="Horizontal Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/horizontalForm.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Form Without Labels" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/formWithoutLabels.html\'"></div></div><div ba-panel="" ba-panel-title="Block Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/form/layouts/widgets/blockForm.html\'"></div></div></div></div></div>');
$templateCache.put('app/pages/form/wizard/wizard.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Form Wizard" ba-panel-class="with-scroll"><ba-wizard><ba-wizard-step title="Personal info" form="vm.personalInfoForm"><form name="vm.personalInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.personalInfoForm.username.$invalid && (vm.personalInfoForm.username.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleUsername1">Username</label> <input type="text" class="form-control" id="exampleUsername1" name="username" placeholder="Username" ng-model="vm.personalInfo.username" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.email.$invalid && (vm.personalInfoForm.email.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" name="email" placeholder="Email" ng-model="vm.personalInfo.email" required=""> <span class="help-block error-block basic-block">Proper email required</span></div></div><div class="col-md-6"><div class="form-group" ng-class="{\'has-error\': vm.personalInfoForm.password.$invalid && (vm.personalInfoForm.password.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" name="password" placeholder="Password" ng-model="vm.personalInfo.password" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm.confirmPassword.$dirty || vm.personalInfoForm.$submitted)}"><label for="exampleInputConfirmPassword1">Confirm Password</label> <input type="password" class="form-control" id="exampleInputConfirmPassword1" name="confirmPassword" placeholder="Confirm Password" ng-model="vm.personalInfo.confirmPassword" required=""> <span class="help-block error-block basic-block">Passwords should match</span></div></div></div></form></ba-wizard-step><ba-wizard-step title="Product Info" form="vm.productInfoForm"><form name="vm.productInfoForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.productInfoForm.productName.$invalid && (vm.productInfoForm.productName.$dirty || vm.productInfoForm.$submitted)}"><label for="productName">Product name</label> <input type="text" class="form-control" id="productName" name="productName" placeholder="Product name" ng-model="vm.productInfo.productName" required=""> <span class="help-block error-block basic-block">Required</span></div><div class="form-group" ng-class="{\'has-error\': vm.productInfoForm.productId.$invalid && (vm.productInfoForm.productId.$dirty || vm.productInfoForm.$submitted)}"><label for="productId">Product id</label> <input type="text" class="form-control" id="productId" name="productId" placeholder="productId" ng-model="vm.productInfo.productId" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Category</label><select class="form-control" title="Category" selectpicker=""><option selected="">Electronics</option><option>Toys</option><option>Accessories</option></select></div></div></div></form></ba-wizard-step><ba-wizard-step title="Shipment" form="vm.addressForm"><form name="vm.addressForm" novalidate=""><div class="row"><div class="col-md-6"><div class="form-group has-feedback" ng-class="{\'has-error\': vm.addressForm.address.$invalid && (vm.addressForm.address.$dirty || vm.addressForm.$submitted)}"><label for="productName">Shipment address</label> <input type="text" class="form-control" id="address" name="address" placeholder="Shipment address" ng-model="vm.shipment.address" required=""> <span class="help-block error-block basic-block">Required</span></div></div><div class="col-md-6"><div class="form-group"><label for="productName">Shipment method</label><select class="form-control" title="Category" selectpicker=""><option selected="">Fast & expensive</option><option>Cheap & free</option></select></div></div></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Save shipment info</span></label></div></form></ba-wizard-step><ba-wizard-step title="Finish"><form class="form-horizontal" name="vm.finishForm" novalidate="">Congratulations! You have successfully filled the form!</form></ba-wizard-step></ba-wizard></div></div></div></div>');
$templateCache.put('app/pages/mangevendor/message/message.html','<div class="container-fluid"><div class="row"><div class="col-xs-12"><div class="row bg-white"><div class="col-md-12"><p class="msg-details color-theme"><b>MESSAGE DETAILS</b></p></div><div class="col-md-6 messagevenedars"><p><b>NAME:</b> <span>Tom Hanks</span></p><p><b>POSITION:</b> <span>Sale Head</span></p><p><b>EMAIL:</b> <span>test@yopmail.com</span></p><p><b>PHONE:</b> <span>999-465-8757</span></p></div><div class="col-md-6 email-sents"><p><b>EMAIL SENT:</b> <span>5</span></p><p><b>EMAIL RECEIVED:</b> <span>12</span></p><p><b>SMS SENT:</b> <span>6</span></p></div></div><div class="row mt-10"><div class="col-md-12 bg-white"><div class="row"><div class="col-md-8"><p class="color-theme f-15 reviewTtles">MESSAGE HISTORY</p></div><div class="col-md-4 text-right"><div class="form-group searchVend font-montser"><input type="text" class="form-control" id="input01s" placeholder="Search vendor"> <i class="fa fa-search" aria-hidden="true"></i></div><button type="button" class="addnewMsg btn btn-info btn-with-icon"><i class="fa fa-plus" aria-hidden="true"></i> ADD NEW MESSAGE</button></div></div><div class="row"><div class="col-md-12 px-0"><div class="reviewMode vendorContd mb-20 table-responsive"><table class="table bg-white font-montser"><thead class="thead-bg"><tr><th>DATE</th><th>MESSAGE TYPE</th><th>SEND / RECEIVE</th><th>DETAILS</th><th>COMMENTS</th></tr></thead><tbody><tr><td>10/10/2017</td><td>Email</td><td>Sent</td><td>Admin sent the mail Sales Head of Time Horstons to send the required details for Outlet at Najda</td><td>Vendor was asked to review and change the details in contract</td></tr><tr><td>10/10/2017</td><td>Email</td><td>Sent</td><td>Admin sent the mail Sales Head of Time Horstons to send the required details for Outlet at Najda</td><td>Vendor was asked to review and change the details in contract</td></tr><tr><td>10/10/2017</td><td>Email</td><td>Sent</td><td>Admin sent the mail Sales Head of Time Horstons to send the required details for Outlet at Najda</td><td>Vendor was asked to review and change the details in contract</td></tr></tbody></table></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10">PREV <i class="fa fa-angle-double-right" aria-hidden="true"></i></span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right"><span>SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/mangevendor/outlet/outlet.html','<div class="container-fluid"><div class="row"><div class="col-md-12"><p>TOTAL OUTLET: 10</p></div><div class="col-md-3"><p class="p-10 color-theme"><b>SELECT OUTLET TO CHECK DETAILS</b></p></div><div class="col-md-3"><vouched-select label="Tim Hortons" selected-value="outletFilter" select-lists="sortBy" class="w-100" display-field="value" is-label="false"></vouched-select></div><div class="col-md-3"><div class="row"><div class="col-md-4"><label for="" class="p-10 color-theme">LOCATION</label></div><div class="col-md-8"><vouched-select label="Najda" selected-value="outletFilter" select-lists="sortBy" class="w-100" display-field="value" is-label="false"></vouched-select></div></div></div><div class="col-md-3"><button type="button" class="btn btn-info btn-with-icon"><i class="fa fa-plus" aria-hidden="true"></i> ADD NEW OUTLET</button></div></div><div class="row"><div class="col-md-12"></div></div></div>');
$templateCache.put('app/pages/mangevendor/vendordetails/vendordetails.html','<div class="container-fluid"><div class="row bg-white"><div class="col-md-12 text-right"><img src="assets/images/edit_icon.png" alt=""> <span class="edit_details font-mont"><a href="">EDIT / UPDATE DETAILS</a></span></div><div class="col-md-7"><p class="orstand outsandart">ORANGIZATION MODEL: STANDALONE OUTLET</p></div><div class="col-md-5 text-right"><p class="pr-80 f14 pt-20"><b>OUTLET CODE: <span class="vouchercode">V4UUAE0TM0001</span></b></p></div></div><div class="row namedetais acc-infomations bg-white"><div class="col-md-12"><p class="catorgriesDetails">ACCOUNT INFORMATION</p></div><div class="col-md-4"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>NAME</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>PASSWORD</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>POSITION</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>MODAL TYPE</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>EMIRATE / REGION</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>STREET ADDRESS</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>PHONE NUMBER</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>EMAIL</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>OUTLET / BRAND WEBSITE</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div></div><div class="row mt-1 bg-white background-underdetails font-montser"><div class="col-md-12"><p><b>CATEGORIES IN WHICH YOU DEAL IN:</b></p></div><div class="col-md-12"><div class="row mb-20"><div class="col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Food & Beverages</span></label></div><div class="col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Leisure & Attractions</span></label></div><div class="col-md-2"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Wellness & Beauty</span></label></div></div><div class="row pb-20"><div class="col-md-2"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Retail & Services</span></label></div></div></div></div><div class="row font-montser textbrands"><div class="col-md-6"><p class="color-white"><b>BRANDS</b></p></div><div class="col-md-6"><p class="color-white"><b>NUMBER OF OUTLETS</b></p></div></div><div class="row font-montser bg-white"><div class="col-md-12"><table class="table abuDhai vendrorTab"><thead><tr class=""><th></th><th>Abu Dhabi Emirates (incl Al-Din)</th><th>Sharjah</th><th>Dubai</th><th>Fujaria</th><th>Ras Al Khamia</th><th>Umm All Quwain</th><th>UAE Total</th></tr></thead><tbody><tr><td>Tim Hortons</td><td>10</td><td>6</td><td>4</td><td>1</td><td>4</td><td>5</td><td>30</td></tr><tr><td>Bu</td><td>10</td><td>6</td><td>4</td><td>1</td><td>4</td><td>5</td><td>30</td></tr></tbody></table></div></div><div class="row font-montser bg-white"><div class="col-md-12"><p class="pt-30"><b>MENU AND PRICES</b></p></div><div class="col-md-12 p-0"><table class="table ml-0 vendrorTab abuDhai"><thead class="headtable-bg"><tr class=""><th>ITEM</th><th>DETAILS</th><th>CUISINE</th><th>PRICE</th><th>MEAL TIME</th></tr></thead><tbody><tr><td><img src="assets/images/pp1.jpg" alt="chicken" class="itemImage"> <span>Fried chicken</span></td><td>Achoice of french fires or salad</td><td>AMERICA</td><td>10AED</td><td>Lunch</td></tr><tr><td><img src="assets/images/pp1.jpg" alt="chicken" class="itemImage"> <span>Fried chicken</span></td><td>Achoice of french fires or salad</td><td>AMERICA</td><td>10AED</td><td>Lunch</td></tr></tbody></table></div><div class="col-md-12"><p class="pt-30"><b>MENU IMAGES</b></p></div><div class="col-md-12 mb-20"><span><img src="assets/images/fileIcon.png" alt="images"> Menu_1.jpg</span></div><div class="col-md-12 mb-20"><span><img src="assets/images/fileIcon.png" alt="images"> Menu_2.jpg</span></div></div><div class="row font-montser bg-white"><div class="col-md-12"><p class="pt-30"><b>ADDITIONAL INFORMATION</b></p></div><div class="col-md-12 p-0"><table class="table ml-0 abuDhai firstBold"><thead class="headtable-bg"><tr class=""><th>TITLE</th><th>DETAILS</th><th>ATTACHEMEMT</th></tr></thead><tbody><tr><td>Achoice of french fires or salad</td><td>AMERICA</td><td><img src="assets/images/fileIcon.png" alt="fileIcon"></td></tr><tr><td>Achoice of french fires or salad</td><td>AMERICA</td><td><img src="assets/images/fileIcon.png" alt="fileIcon"></td></tr><tr><td>Achoice of french fires or salad</td><td>AMERICA</td><td><img src="assets/images/fileIcon.png" alt="fileIcon"></td></tr></tbody></table></div><div class="col-md-12 text-right"><img src="assets/images/edit_icon.png" alt=""> <span class="edit_details font-mont"><a href="">EDIT / UPDATE DETAILS</a></span></div></div></div>');
$templateCache.put('app/pages/maps/google-maps/google-maps.html','<div ba-panel="" ba-panel-title="Google Maps" class="viewport100"><div id="google-maps"></div></div>');
$templateCache.put('app/pages/maps/leaflet/leaflet.html','<div ba-panel="" ba-panel-title="Leaflet" class="viewport100"><div id="leaflet-map"></div></div>');
$templateCache.put('app/pages/maps/map-bubbles/map-bubbles.html','<div ba-panel="" ba-panel-title="Map with Bubbles" class="viewport100"><div id="map-bubbles"></div></div>');
$templateCache.put('app/pages/maps/map-lines/map-lines.html','<div ba-panel="" ba-panel-title="Line Map" class="viewport100"><div id="map-lines"></div></div>');
$templateCache.put('app/pages/myOutlet/addOutlet/addOutlet.html','<div class="col-xs-12"><div class="row"></div></div>');
$templateCache.put('app/pages/myOutlet/details/details.html','<div ba-panel="" ba-panel-title="Enquires - review" ba-panel-class="with-scroll"><div class="reviewFilters"><div class="selectCust"><select class="form-control" id="filter" name="filter" ng-model="filter"><option value="0" selected="selected">All</option><option>New</option><option>Inprogress</option><option>Enquire Review</option><option>Contract Sign Off</option><option value="">Suggested</option></select></div></div><button class="reviewBtns" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/review-enquire.html\', \'newmodal\')">Reviews</button><div class="horizontal-scroll sortableTables table-responsive"><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th st-sort="name">NAME <span class="sortableArrows"></span></th><th st-sort="position">POSITION <span class="sortableArrows"></span></th><th st-sort="organization">ORGANIZATION NAME <span class="sortableArrows"></span></th><th st-sort="location">LOCATION <span class="sortableArrows"></span></th><th st-sort="mobile">MOBILE <span class="sortableArrows"></span></th><th st-sort="email">EMAIL <span class="sortableArrows"></span></th><th st-sort="enqdate">ENQUIRY DATE <span class="sortableArrows"></span></th><th st-sort="status">STATUS <span class="sortableArrows"></span></th><th st-sort="details">DETAILS <span class="sortableArrows"></span></th></tr></thead><tbody><tr ng-repeat="item in smartTableData | filter: filter"><td>{{item.name}}</td><td>{{item.position}}</td><td>{{item.organization}}</td><td>{{item.location}}</td><td>{{item.mobile}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.enqdate}}</td><td ng-class="{ \'pink\': item.status === \'New\', \'firebrick\': item.status === \'Inprogress\', \'purple\': item.status === \'Enquire Review\', \'green\': item.status === \'Contract Sign Off\', \'red\': item.status === \'Not Published\'}" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/contractsignoff.html\', \'newmodal\')">{{item.status}}</td><td><p class="view-detals" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'newmodal\')">{{item.details}}</p></td></tr></tbody><tfoot class="bordernormal"><tr><td colspan="6" class="border-none text-left pagination-customize"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5" style="display:none"></div><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> First</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> Prev</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">Next <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>Last <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></td></tr></tfoot></table><div class="col-md-6 numberRowTable font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div>');
$templateCache.put('app/pages/myOutlet/openingtime/openingtime.html','<div class="row"><div class="col-xs-12"><div class="panel panel-danger bootstrap-panel"><div class="panel-heading">OPENING TIME</div><div class="panel-warning thead-bg col-xs-12 p-t-10 p-b-10"><div class="col-xs-6"><div class="col-xs-2">DAY</div><div class="col-xs-4">OPEN</div></div><div class="col-xs-6"><div class="col-xs-4"></div><div class="col-xs-2 pull-left">CLOSE</div><div class="col-xs-4 pull-leftt">HAPPY HOURS</div><div class="col-xs-2 pull-left">EDIT</div></div></div><div class="panel-body"><h3 class="text-center" style="margin-top:10px">Calender Component will be added here</h3></div></div></div></div>');
$templateCache.put('app/pages/myOutlet/prices/prices.html','<div class="row"><div class="col-xs-12"><div class="panel-danger bootstrap-panel"><div class="panel-heading">MENU AND PRICES</div><div class="panel-body"><div class="orange-text m-b-15">ADD MENU</div><div class="row"><div class="col-xs-4"><div class="btn-group"><div class="btn-group" style="border:1px solid #ccc;border-radius: 5px;"><a href="" class="btn btn-default p-t-15 p-b-15" style="border:0px">Upload main menu image</a> <label class="btn" style="font-size:33px;"><i class="ion-archive" style="color:#f9856f"><input type="file" style="display: none;"></i></label></div></div></div><div class="col-xs-8"><div class="form-group"><input type="text" tag-input="primary" value="page1,page2,page3" data-role="tagsinput" placeholder="Add Tag"></div></div></div><div class="row"><div class="table-responsive"><table class="table list-table table-striped"><thead class="thead-bg"><tr class="sortable"><th class="p-l-15" st-sort="brand">ITEM</th><th st-sort="offer_name">DETAILS</th><th st-sort="offer_time">CUISINE</th><th st-sort="expected_sale">PRICE | AED</th><th st-sort="amount">MEAL TIME</th><th st-sort="no_sold">EDIT</th></tr></thead><tbody><tr><td class="p-l-10" style="width:20%;"><div class="img_head"><img class="img-circle m-r-10" src="assets/images/gl-img1.jpg" alt="..." height="50" width="50"><h5>Italian Salad</h5></div></td><td style="width:30%;"><h5>A Choice Of French Fries Or Salad</h5></td><td><h5>America</h5></td><td><h5>325</h5></td><td><h5>Breakfast</h5></td><td><i class="fa fa-pencil-square-o fa-2x" aria-hidden="true"></i> <i class="fa fa-times-circle fa-2x rating-icon" aria-hidden="true"></i></td></tr><tr class="ver-line"><td class="p-l-10" style="width:20%;"><div class="img_head"><img class="img-circle m-r-10" src="assets/images/gl-img1.jpg" alt="..." height="50" width="50"><h5>Nutella Crep</h5></div></td><td style="width:30%;"><h5>Delicious Dessert</h5></td><td><h5>America</h5></td><td><h5>325</h5></td><td><h5>Lunch</h5></td><td><i class="fa fa-pencil-square-o fa-2x" aria-hidden="true"></i> <i class="fa fa-times-circle fa-2x rating-icon" aria-hidden="true"></i></td></tr></tbody></table></div></div></div></div></div></div><div class="bor-line"></div><div class="row"><div class="col-md-12"><div class="panel panel-danger bootstrap-panel"><div class="panel-heading">ADD NEW ITEM</div><div class="panel-body"><div class="row"><div class="col-xs-4"><div class="form-group"><label for="input04" class="dark-text">Name of Item</label> <input type="text" class="form-control" id="input04" placeholder="With help"></div></div><div class="col-xs-4"><div class="form-group"><label for="input04" class="dark-text">Cuisine</label> <input type="text" class="form-control" id="input04" placeholder="With help"></div></div><div class="col-xs-4"><div class="form-group"><label for="input04" class="dark-text">Price</label> <input type="text" class="form-control" id="input04" placeholder="With help"></div></div></div><div class="row"><div class="panel-body"><div class="form-group"><label for="input04" class="dark-text">Details</label> <input type="text" class="form-control" id="input04" placeholder="With help"></div></div></div><div class="row"><div class="col-xs-4 p-0"><div class="panel-body"><div class="form-group"><label for="input04" class="dark-text">Meantime</label> <input type="text" class="form-control" id="input04" placeholder="With help"></div></div></div><div class="col-xs-8 p-t-45"><div class="btn-group" style="border:1px solid #ccc;border-radius: 5px;"><a href="" class="btn btn-default p-t-15 p-b-15" style="border:0px">Upload main menu image</a> <label class="btn" style="font-size:33px;"><span class="lnda lnda1428"></span><input type="file" style="display: none;"></label></div></div></div><div class="col-xs-12"><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised" style="font-family:bebas;">ADD ITEM</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/myOutlet/rewards/rewards.html','<div class="panel-group"><div class="panel panel-danger bootstrap-panel"><div class="panel-heading">EMPLOYEE VALIDATION PINS</div><div class="panel-body p-0"><div class="table-responsive m-t-0"><table class="table list-table"><thead class="thead-bg"><tr class="sortable"><th class="p-l-20">CODE NAME</th><th>DISCOUNT<br>PERCENTAGE</th><th>STATUS</th><th>DURATION<br>APPLIED</th><th>LOCATION<br>APPLIED</th><th>EDIT</th></tr></thead><tbody><tr><td><div></div><h5 class="dark-text1 p-l-15">Code P15</h5></td><td><h5 class="dark-text1">15%</h5></td><td><h5 class="dark-text1">In Use</h5></td><td class="col-md-5"><div class="row"><div class="col-md-6"><div class="col-md-3 p-0"><label class="dark-text1">FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt1" is-open="opened1" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open1()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="col-md-3"><label class="dark-text1">TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt2" is-open="opened2" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><h5></h5></td><td><h5 class="dark-text1">Abu Dhabi</h5></td><td><i class="fa fa-pencil-square-o" aria-hidden="true"></i><i class="fa fa-times-circle rating-icon" aria-hidden="true"></i></td></tr><tr><td><div></div><h5 class="dark-text1 p-l-10">Code P15</h5></td><td><h5 class="dark-text1">15%</h5></td><td><h5 class="dark-text1">In Use</h5></td><td><div class="row"><div class="col-md-6"><div class="col-md-3 p-0"><label class="dark-text1">FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt3" is-open="opened3" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open3()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="col-md-3"><label class="dark-text1">TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt4" is-open="opened4" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open4()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><h5></h5></td><td><h5 class="dark-text1">Dubai</h5></td><td><i class="fa fa-pencil-square-o" aria-hidden="true"></i> <i class="fa fa-times-circle rating-icon" aria-hidden="true"></i></td></tr><tr class="border-bot-line"><td style="opacity: 0.3;"><div></div><h5 class="dark-text1 p-l-15">Code P15</h5></td><td style="opacity: 0.3;"><h5 class="dark-text1">15%</h5></td><td style="opacity: 0.3;"><h5 class="dark-text1">In Use</h5></td><td style="opacity: 0.3;"><div class="row"><div class="col-md-6"><div class="col-md-3 p-0"><label class="dark-text1">FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt5" is-open="opened5" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open5()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="col-md-3"><label class="dark-text1">TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt6" is-open="opened6" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open6()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><h5></h5></td><td style="opacity: 0.3;"><h5 class="dark-text1">Ajman</h5></td><td><i class="fa fa-pencil-square-o" aria-hidden="true"></i> <i class="fa fa-times-circle rating-icon" aria-hidden="true"></i></td></tr></tbody></table></div></div><div class="panel-heading head-bg-w">ADD NEW CODE BY AMOUNT</div><div class="panel-body"><div class="row"><div class="col-md-9"><div class="col-md-4"><vouched-text-box label="Code Name" text-value="codename" is-label="true"></vouched-text-box></div><div class="col-md-4"><vouched-text-box label="Discount Amount" text-value="value" is-label="true"></vouched-text-box></div><div class="col-md-4"><vouched-text-box label="Reward for Referrer" text-value="value" is-label="true"></vouched-text-box></div></div><div class="col-md-3"><vouched-select label="Select Location to Apply" selected-value="outletFilter" select-lists="outletFilterLists" display-field="value"></vouched-select></div></div><div class="row"><div class="col-md-12 p-t-20 p-0"><div class="col-md-5"><div class="col-md-5 dark-text p-t-10">Duration Applied</div><div class="col-md-7"><div class="col-md-12 p-0"><div class="col-md-6 p-l-0"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="All Time"> <span class="dark-text">All Time</span></label></div><div class="col-md-6 p-0"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="From"> <span class="dark-text">From</span></label></div></div></div></div><div class="col-md-7"><div class="row"><div class="col-md-4"><div class="col-md-3 p-0"><label class="dark-text">FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt7" is-open="opened7" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open7()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-4"><div class="col-md-3"><label class="dark-text">TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt8" is-open="opened8" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open8()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-4"><vouched-select label="Year" selected-value="outletFilter" select-lists="durationList" display-field="value" is-label="false"></vouched-select></div></div></div></div></div><div class="col-md-12 push-middle"><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised" style="font-family:bebas;">ADD CODE</button></div></div></div><div class="panel panel-danger bootstrap-panel"><div class="panel-heading">FIRST VISIT DISCOUNT-AMOUNT</div><div class="panel-body p-0"><div class="table-responsive"><table class="table list-table"><thead class="thead-bg"><tr class="sortable"><th class="p-l-20">CODE NAME</th><th>DISCOUNT<br>PERCENTAGE</th><th>STATUS</th><th>DURATION<br>APPLED</th><th>LOCATION<br>APPLIED</th><th>EDIT</th></tr></thead><tbody><tr><td><div></div><h5 class="">Code P15</h5></td><td><h5 class="">15%</h5></td><td><h5 class="">In Use</h5></td><td class="col-md-5"><div class="row"><div class="col-md-6"><div class="col-md-3 p-0"><label class="">FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt9" is-open="opened9" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open9()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="col-md-3"><label class="">TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt10" is-open="opened10" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open10()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><h5></h5></td><td><h5 class="">Abu Dhabi</h5></td><td><i class="fa fa-pencil-square-o" aria-hidden="true"></i> <i class="fa fa-times-circle rating-icon" aria-hidden="true"></i></td></tr><tr><td><div></div><h5 class="">Code P15</h5></td><td><h5 class="">15%</h5></td><td><h5 class="">In Use</h5></td><td><div class="row"><div class="col-md-6"><div class="col-md-3 p-0"><label class="">FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt11" is-open="opened11" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open11()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="col-md-3"><label class="">TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt12" is-open="opened12" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open12()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><h5></h5></td><td><h5 class="">Dubai</h5></td><td><i class="fa fa-pencil-square-o" aria-hidden="true"></i> <i class="fa fa-times-circle rating-icon" aria-hidden="true"></i></td></tr><tr><td style="opacity: 0.3;"><div></div><h5 class="">Code P15</h5></td><td style="opacity: 0.3;"><h5 class="">15%</h5></td><td style="opacity: 0.3;"><h5 class="">In Use</h5></td><td style="opacity: 0.3;"><div class="row"><div class="col-md-6"><div class="col-md-3 p-0"><label class="">FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt13" is-open="opened13" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open13()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="col-md-3"><label class="">TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt14" is-open="opened14" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open14()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><h5></h5></td><td style="opacity: 0.3;"><h5 class="">Ajman</h5></td><td><i class="fa fa-pencil-square-o" aria-hidden="true"></i> <i class="fa fa-times-circle rating-icon" aria-hidden="true"></i></td></tr></tbody></table></div></div><div class="panel-heading">ADD NEW CODE BY AMOUNT</div><div class="panel-body"><div class="row"><div class="col-md-9"><div class="col-md-4"><vouched-text-box label="Code Name" text-value="value" is-label="true"></vouched-text-box></div><div class="col-md-4"><vouched-text-box label="Discount Amount" text-value="value" is-label="true"></vouched-text-box></div><div class="col-md-4"><vouched-text-box label="Reward for Referrer" text-value="value" is-label="true"></vouched-text-box></div></div><div class="col-md-3"><vouched-select label="Select Location to Apply" selected-value="outletFilter" select-lists="outletFilterLists" display-field="value"></vouched-select></div></div><div class="row"><div class="col-md-12 p-t-20 p-0"><div class="col-md-5"><div class="col-md-5 dark-text p-t-10">Duration Applied</div><div class="col-md-7"><div class="col-md-12 p-0"><div class="col-md-6 p-l-0"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="All Time"> <span class="dark-text">All Time</span></label></div><div class="col-md-6 p-0"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="From"> <span class="dark-text">From</span></label></div></div></div></div><div class="col-md-7"><div class="col-md-12 p-0"><div class="col-md-4 p-0"><div class="col-md-3 p-0"><label class="">FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt15" is-open="opened15" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open15()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-4"><div class="col-md-3"><label class="">TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt16" is-open="opened16" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open16()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-4"><vouched-select label="Year" selected-value="outletFilter" select-lists="durationList" display-field="value" is-label="false"></vouched-select></div></div></div></div></div><div class="col-md-12 push-middle"><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised" style="font-family:bebas;">ADD CODE</button></div></div></div></div></div></div><div class=""><div class="panel panel-danger bootstrap-panel"><div class="panel-heading">REFERRER\'S REWARD FOR EACH SUCCESFUL REFERAL</div><div class="panel-body p-0"><div class="table-responsive m-t-0"><table class="table list-table"><thead class="thead-bg"><tr class="sortable"><th class="p-l-20">CODE NAME</th><th>DISCOUNT<br>PERCENTAGE</th><th>STATUS</th><th>DURATION<br>APPLED</th><th>LOCATION<br>APPLIED</th><th>EDIT</th></tr></thead><tbody><tr><td><div></div><h5 class="">Code P15</h5></td><td><h5 class="">15%</h5></td><td><h5 class="">In Use</h5></td><td class="col-md-5"><div class="row"><div class="col-md-6"><div class="col-md-3 p-0"><label>FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt17" is-open="opened17" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open17()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="col-md-3"><label>TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt18" is-open="opened18" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open18()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><h5></h5></td><td><h5 class="">Abu Dhabi</h5></td><td><i class="fa fa-pencil-square-o" aria-hidden="true"></i> <i class="fa fa-times-circle rating-icon" aria-hidden="true"></i></td></tr><tr><td><div></div><h5 class="">Code P15</h5></td><td><h5 class="">15%</h5></td><td><h5 class="">In Use</h5></td><td><div class="row"><div class="col-md-6"><div class="col-md-3 p-0"><label class="">FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt19" is-open="opened19" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open19()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="col-md-3"><label class="">TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt20" is-open="opened20" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open20()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><h5></h5></td><td><h5>Dubai</h5></td><td><i class="fa fa-pencil-square-o" aria-hidden="true"></i> <i class="fa fa-times-circle rating-icon" aria-hidden="true"></i></td></tr><tr class="border-bot-line"><td style="opacity: 0.3;"><div></div><h5 class="">Code P15</h5></td><td style="opacity: 0.3;"><h5 class="">15%</h5></td><td style="opacity: 0.3;"><h5 class="">In Use</h5></td><td style="opacity: 0.3;"><div class="row"><div class="col-md-6"><div class="col-md-3 p-0"><label class="">FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt21" is-open="opened21" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open21()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="col-md-3"><label class="">TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt22" is-open="opened22" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open22()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div><h5></h5></td><td style="opacity: 0.3;"><h5 class="">Dubai</h5></td><td><i class="fa fa-pencil-square-o" aria-hidden="true"></i> <i class="fa fa-times-circle rating-icon" aria-hidden="true"></i></td></tr></tbody></table></div></div><div class="row panel-body p-0"><div class="col-md-12 p-t-20"><div class="col-md-6"><div class="col-md-6 p-t-30"><label>Credit Per successful Referral</label></div><div class="col-md-6 p-t-25"><vouched-select label="" selected-value="outletFilter" select-lists="outletFilterLists" display-field="value"></vouched-select></div></div><div class="col-md-6"><div class="col-md-6"><vouched-text-box label="Customs Amount" text-value="value" is-label="true"></vouched-text-box></div><div class="col-md-5 p-t-20"><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised" style="font-family:bebas;">ADD REWARDS</button></div></div></div></div></div><div class="panel-heading head-bg-w">CREDIT/DISCOUNT EXPIRY DATE</div><div class="panel-body p-0"><div class="table-responsive m-t-0"><table class="table list-table"><thead class="thead-bg"><tr class="sortable"><th class="p-l-50">EARN PERIOD</th><th>EXPIRING DATE</th></tr></thead><tbody><tr><td><div class=""><div class="col-md-12"><div class="col-md-4"><div class="col-md-4"><label class="">FROM</label></div><div class="col-md-8"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt23" is-open="opened23" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open23()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-4"><div class="col-md-4"><label class="">TO</label></div><div class="col-md-8"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt24" is-open="opened24" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open24()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></div></td><td><div class="row"><div class="col-md-10"><div class="col-md-1 p-0"><label class="">On</label></div><div class="col-md-8"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt25" is-open="opened25" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open25()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></td></tr><tr class="border-bot-line"><td><div class=""><div class="col-md-12"><div class="col-md-4"><div class="col-md-4"><label class="">FROM</label></div><div class="col-md-8"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt26" is-open="opened26" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open26()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-4"><div class="col-md-4"><label class="">TO</label></div><div class="col-md-8"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt27" is-open="opened27" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open27()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></div></td><td><div class="row"><div class="col-md-10"><div class="col-md-1 p-0"><label class="">On</label></div><div class="col-md-8"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt28" is-open="opened28" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open28()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></td></tr></tbody></table></div><p class="p-l-25 p-t-30">* This section is for your information only VOUCHED4u authorized Admin can change these dates</p></div><div class="panel-heading head-bg-w">CONDITION OF USE</div><div class="panel-body dark-text"><ul><li>Minimum total spend of AED 30 by Referee</li><li>Referrer entitled to the credit when his/her referrer validates unexpired links</li><li>Those accompanying referee can be validated to referrer so long as on average all parties minimum spending of 30 AED</li><li>Earned credits can be used to purchase Offers provided the credit does not exceed 50% of the total offer value</li><li>Earned credits for use any day within the expiry date</li><li>Earned credits is on beverage in participating outlets</li><li>One credit one Dirham</li></ul></div></div><div class="panel panel-default bootstrap-panel"></div><div class="panel panel-default bootstrap-panel"></div></div>');
$templateCache.put('app/pages/myOutlet/typeandfeatures/typeandfeatures.html','<div class="row"><div class="col-xs-12"><div class="panel panel-danger bootstrap-panel"><div class="panel-body"><div class="col-xs-3 pt15 orange-text m-t-20 font-w" style="padding:0px;"><h3 style="padding:0px;font-size:16px;">OUTLET CATEGORIES</h3></div><div class="col-xs-8"><div class="col-xs-6"><div class="col-xs-4"><img class="img-responsive" src="assets/images/wellness_sel.png"></div><div class="col-xs-8 pt15 dark-text m-t-25">Wellness & Beauty</div></div></div><div class="col-xs-1 m-t-10"><div><img class="img-responsive" src="assets/images/select_icon.png"></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="panel panel-danger bootstrap-panel"><div class="panel-heading">SELECT TYPE OF OUTLET</div><div class="panel-body p-0"><div class="p-l-10 p-r-10"><div class="table-responsive"><table class="table list-table"><tr class=""><td class="col-xs-4"><div class="pull-left m-b-10 m-t-10"><label class="radio-inline custom-radio nowrap dark-text"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Bars</span></label></div></td><td class="col-xs-4"><div><label class="radio-inline custom-radio nowrap dark-text"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <span>Cafes</span></label></div></td><td class="col-xs-4"><div><label class="radio-inline custom-radio nowrap dark-text"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <span>Cafe And Night Spots</span></label></div></td></tr><tr><td class="col-xs-4"><div class="pull-left m-b-10 m-t-10"><label class="radio-inline custom-radio nowrap dark-text"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Discotheque/Nightclubs</span></label></div></td><td class="col-xs-4"><div><label class="radio-inline custom-radio nowrap dark-text"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <span>Family/Casual Drinking<br>Restaurant</span></label></div></td><td class="col-xs-4"><div><label class="radio-inline custom-radio nowrap dark-text"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <span>Fast Food Outlets</span></label></div></td></tr><tr><td class="col-xs-4"><div class="pull-left m-b-10 m-t-10"><label class="radio-inline custom-radio nowrap dark-text"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Fine Dining</span></label></div></td><td class="col-xs-4"><div><label class="radio-inline custom-radio nowrap dark-text"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <span>Grill Room Or<br>Rotisserie</span></label></div></td><td class="col-xs-4"><div><label class="radio-inline custom-radio nowrap dark-text"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <span class="">Pubs</span></label></div></td></tr><tr><td class="col-xs-4"><div class="pull-left m-b-10 m-t-10"><label class="radio-inline custom-radio nowrap dark-text"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Quick Service Restaurants</span></label></div></td><td class="col-xs-4"><div><label class="radio-inline custom-radio nowrap dark-text"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <span>Specialty/Ethnic<br>Restaurant</span></label></div></td><td class="col-xs-4"><div><label class="radio-inline custom-radio nowrap dark-text"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <span class="">Tale-Away Restaurant</span></label></div></td></tr><tr><td class="col-xs-4"><div class="pull-left m-b-10 m-t-10"><label class="radio-inline custom-radio nowrap dark-text"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Themed Restaurant</span></label></div></td><td class="col-xs-4"></td><td class="col-xs-4"></td></tr></table></div></div></div></div></div></div><div class="row"><div class="col-xs-12"><div class="panel panel-danger bootstrap-panel"><div class="panel-heading">SELECT FEATURES OF OUTLET</div><div class="panel-body"><div class="col-xs-12 clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonIcons"><div class="m-b-20"><div class="row"><div class="col-md-4"><img ng-src="assets/images/{{icon.img}}"></div><div class="col-md-8 p-t-15"><span class="dark_text1 p-l-10">{{icon.name}}</span></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/myOutlet/validationPin/validationPin.html','<div class="row"><div class="col-md-12"><div class="panel-danger bootstrap-panel"><div class="panel-heading">EMPLOYEE VALIDATION PINS</div><div class="panel-body p-0"></div><div class="panel-body p-0"><div class="table-responsive"><table class="table list-table table-responsive"><thead class="thead-bg font-mont"><tr class="sortable"><th class="p-l-20">NAME</th><th>PIN</th><th>DOB</th><th>NATIONALITY</th><th>POSITION</th><th>EMPLOYEE ID</th><th>MOBILE NO.</th><th>EMAIL</th><th>EDIT</th></tr></thead><tr><td class="dark-text p-l-20"><h5>Melissa Jacey</h5></td><td><h5>****</h5></td><td class="dark-text"><h5>03/22/1987</h5></td><td class="dark-text"><h5>German</h5></td><td class="dark-text"><h5>Manager</h5></td><td><h5>AP 948984</h5></td><td class="dark-text"><h5>AP 9023481</h5></td><td class="dark-text"><h5>jmelissa@thortans.com</h5></td><td><i class="fa fa-pencil-square-o" aria-hidden="true"></i> <i class="fa fa-times-circle rating-icon" aria-hidden="true"></i></td></tr><tr class="ver-line"><td class="dark-text p-l-20"><h5>Harry Powter</h5></td><td><h5>****</h5></td><td class="dark-text"><h5>03/22/1987</h5></td><td class="dark-text"><h5>English</h5></td><td class="dark-text"><h5>sale</h5></td><td><h5>AP 948984</h5></td><td class="dark-text"><h5>SE 9023481</h5></td><td class="dark-text"><h5>pharry@thortans.com</h5></td><td><i class="fa fa-pencil-square-o" aria-hidden="true"></i> <i class="fa fa-times-circle rating-icon" aria-hidden="true"></i></td></tr></table></div></div></div></div></div><div class="row panel-group"><div class="col-md-12"><div class="panel panel-danger bootstrap-panel"><div class="panel-heading">ADD NEW PIN</div><div class="panel-body"><div class="col-xs-12"><div class="col-xs-4"><div class="form-group"><label for="input04" class="dark-text">Employee Name</label> <input type="text" class="form-control" id="input04" placeholder="With help"></div></div><div class="col-xs-4"><label for="input04" class="dark-text">Nationality</label><vouched-select label="Select Country" selected-value="outletFilter" select-lists="outletFilterLists" display-field="value" is-label="false"></vouched-select></div><div class="col-xs-4"><div class="form-group"><label for="input04" class="dark-text">Date of Birth</label><vouched-select label="Select Date" selected-value="outletFilter" select-lists="outletFilterLists" display-field="value" is-label="false"></vouched-select></div></div></div><div class="col-xs-12"><div class="col-xs-4"><div class="form-group"><label for="input04" class="dark-text">Employee ID Number</label> <input type="text" class="form-control" id="input04" placeholder="With help"></div></div><div class="col-xs-4"><div class="form-group"><label for="input04" class="dark-text">Position</label> <input type="text" class="form-control" id="input04" placeholder="With help"></div></div><div class="col-xs-4"><div class="form-group"><label for="input04" class="dark-text">Mobile Number &amp; Email</label> <input type="text" class="form-control" id="input04" placeholder="With help"></div></div></div><div class="col-xs-12"><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised" style="font-family:bebas;">GENERATE PIN</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/report/credits-report/credits-report.html','<div class="panel-body panel m-b-5 top-box-bg"><div class="row max-wid"><div class="col-md-6"><h3 class="text-center orange-text"><span class="">500</span></h3><h6 class="text-center font-montser fontbold dark-text">CREDITS TRANSACTION DONE</h6></div><div class="col-md-6"><h3 class="text-center orange-text"><span class="">200</span> <span class="arr-pos"><i class="ion-arrow-up-c rating-icon-green"></i></span></h3><h6 class="text-center font-montser fontbold dark-text">VISITORS AVAILED CREDITS</h6></div></div></div><div class="dash-bg panel-warning change-bg m-b-5 m-t-5"><div class="panel-heading clearfix"><div class="row"><div class="col-md-7"><h3 class="panel-title p-t-10 f-18px">CREDITS REPORTS</h3></div><div class="col-md-3 pull-right tran-select"><div class="form-group font-montser"><div class="selectCust selectoutlets new height-var"><select id="" class="form-control border-sel" name="business"><option value="First Choice">7th Mar 2017 - 17th Apr 2017</option><option value="Second Choice">7th May 2017 - 17th June 2017</option><option value="Third Choice">7th June 2017 - 17th July 2017</option></select></div></div></div></div></div></div><div class="panel-body panel m-b-5 top-box-bg1"><div class="row"><div class="col-md-6"><div class="panel-heading panel-form border-none"><div class="row"><div class="col-md-12 text-center p-t-10"><h2 class="font-montser orange-text fontbold">Credits Given</h2></div></div></div><div class="panel-body"><div class="chartjs-canvas-holder-third-row chart-height1"><canvas id="line" class="chart chart-line" chart-colors="creditsLineColors" chart-data="creditsDatas" chart-labels="creditsLabels" chart-series="series" chart-click="changeData" chart-options="creditsOptions"></canvas></div></div></div><div class="col-md-6"><div class="panel-heading panel-form border-none"><div class="row"><div class="col-md-12 text-center p-t-10"><h2 class="font-montser orange-text fontbold">Credits Availed</h2></div></div></div><div class="panel-body"><div class="chartjs-canvas-holder-third-row chart-height1"><canvas id="line" class="chart chart-line" chart-colors="credits1LineColors" chart-data="credits1Datas" chart-labels="credits1Labels" chart-series="series" chart-click="changeData" chart-options="credits1Options"></canvas></div></div></div></div></div><div class="panel-body panel m-b-5 top-box-bg1"><div class="row"><div class="col-md-6"><div class="panel-body"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" class="chart chart-doughnut" chart-options="genderoptions" chart-data="returnCustData" chart-colors="returnCustColors" chart-labels="returnCustLabels" chart-click="changeData"></canvas><div class="text-Cen">100%</div></div><div class="text-center chart-bot-title1"><p>Locationwise - Distribution<br>of Credits Earned</p></div></div></div><div class="col-md-6"><div class="panel-body"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" class="chart chart-doughnut" chart-options="genderoptions" chart-data="returnCust1Data" chart-colors="returnCust1Colors" chart-labels="returnCust1Labels" chart-click="changeData"></canvas><div class="text-Cen">100%</div></div><div class="text-center chart-bot-title1"><p>Locationwise - Distribution<br>of Credits Availed</p></div></div></div></div></div><div class="panel-body m-tb-5 p-tb-5"><div class="row"><div class="col-md-12 bg-white"><div class="row"><div class="col-md-6"><p class="visitAll color-theme">CREDITS EARNED</p></div><div class="col-md-6 text-right"><p class="visitAll color-theme">*1CREDIT = 1AED</p></div></div><div class="row"><div class="col-md-12 px-0"><div class="reviewMode report-table table-responsive"><table class="table bg-white font-montser table-striped-blue"><thead class="thead-bg"><tr><th class="p-0" colspan="1"></th><th class="text-center p-0 pos-head" colspan="2">EARNED BY</th><th class="p-0" colspan="1"></th><th class="text-center p-0 pos-head" colspan="2">REFERRED TO</th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th></tr><tr><th>CREDITS</th><th class="text-center">NAME</th><th class="text-center">MOBILE</th><th>DATE</th><th class="text-center">NAME</th><th class="text-center">MOBILE</th><th>BILL AMOUNT</th><th>BILL NUMBER</th><th>REF NUMBER</th><th>OUTLET</th><th>LOCATION</th></tr></thead><tbody><tr><td>15</td><td class="text-center">Desmond</td><td class="text-center">742-12345-4000</td><td>14-03-2017</td><td class="text-center">Imran</td><td class="text-center">742-12345-4578</td><td>200AED</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>Tim Hortons</td><td>Nadja</td></tr><tr><td>25</td><td class="text-center">Desmond</td><td class="text-center">742-12345-4000</td><td>14-03-2017</td><td class="text-center">Sushil</td><td class="text-center">742-12345-4578</td><td>250AED</td><td>ST-345-768-T</td><td>REF-234495-TR</td><td>Tim Hortons</td><td>Nadja</td></tr><tr><td>35</td><td class="text-center">Desmond</td><td class="text-center">742-12345-4000</td><td>14-03-2017</td><td class="text-center">Jerry</td><td class="text-center">742-12345-4578</td><td>200AED</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>Tim Hortons</td><td>Nadja</td></tr><tr><td>40</td><td class="text-center">Desmond</td><td class="text-center">742-12345-4000</td><td>14-03-2017</td><td class="text-center">Jhon</td><td class="text-center">742-12345-4578</td><td>200AED</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>Tim Hortons</td><td>Nadja</td></tr><tr><td>15</td><td class="text-center">Desmond</td><td class="text-center">742-12345-4000</td><td>14-03-2017</td><td class="text-center">Lisa Ray</td><td class="text-center">742-12345-4578</td><td>200AED</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>Tim Hortons</td><td>Nadja</td></tr><tr><td>15</td><td class="text-center">Desmond</td><td class="text-center">742-12345-4000</td><td>14-03-2017</td><td class="text-center">Charles</td><td class="text-center">742-12345-4578</td><td>200AED</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>Tim Hortons</td><td>Nadja</td></tr></tbody></table></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></div></div><div class="panel-body m-tb-5 p-tb-5"><div class="row"><div class="col-md-12 bg-white"><div class="row"><div class="col-md-6"><p class="visitAll color-theme">CREDITS AVAILED</p></div><div class="col-md-6 text-right"><p class="visitAll color-theme">*1CREDIT = 1AED</p></div></div><div class="row"><div class="col-md-12 px-0"><div class="reviewMode report-table table-responsive"><table class="table bg-white font-montser table-striped-blue"><thead class="thead-bg"><tr><th class="p-0" colspan="1"></th><th class="text-center p-0 pos-head" colspan="2">AVAILED BY</th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th></tr><tr><th>CREDITS</th><th class="text-center">NAME</th><th class="text-center">MOBILE</th><th>DATE - TIME</th><th>BILL NUMBER</th><th>REF NUMBER</th><th>BILL AMOUNT</th><th>OUTLET</th><th>LOCATION</th></tr></thead><tbody><tr><td>15</td><td class="text-center">Desmond</td><td class="text-center">742-12345-4000</td><td>14-03-2017-7:17PM</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>200AED</td><td>Tim Hortons</td><td>Nadja</td></tr><tr><td>15</td><td class="text-center">Desmond</td><td class="text-center">742-12345-4000</td><td>14-03-2017-7:17PM</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>200AED</td><td>Tim Hortons</td><td>Nadja</td></tr><tr><td>15</td><td class="text-center">Desmond</td><td class="text-center">742-12345-4000</td><td>14-03-2017-7:17PM</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>200AED</td><td>Tim Hortons</td><td>Nadja</td></tr><tr><td>15</td><td class="text-center">Desmond</td><td class="text-center">742-12345-4000</td><td>14-03-2017-7:17PM</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>200AED</td><td>Tim Hortons</td><td>Nadja</td></tr><tr><td>15</td><td class="text-center">Desmond</td><td class="text-center">742-12345-4000</td><td>14-03-2017-7:17PM</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>200AED</td><td>Tim Hortons</td><td>Nadja</td></tr><tr><td>15</td><td class="text-center">Desmond</td><td class="text-center">742-12345-4000</td><td>14-03-2017-7:17PM</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>200AED</td><td>Tim Hortons</td><td>Nadja</td></tr></tbody></table></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></div></div>');
$templateCache.put('app/pages/report/performance-overview/performance-overview.html','<div class="dash-bg panel-warning change-bg m-t-2 m-b-5"><div class="panel-heading p-t-b-10 clearfix"><div class="row"><div class="col-md-7"><h3 class="panel-title f-18px p-t-10">SUMMARY</h3></div><div class="col-md-3 pull-right tran-select"><div class="form-group font-montser"><div class="selectCust selectoutlets m-0 new height-var"><select id="" class="form-control border-sel" name="business"><option value="First Choice">7th Mar 2017 - 17th Apr 2017</option><option value="Second Choice">7th May 2017 - 17th June 2017</option><option value="Third Choice">7th June 2017 - 17th July 2017</option></select></div></div></div></div></div><div class="panel-body panel dash-bg panel-info bootstrap-panel m-b-5 top-box-bg"><div class="row"><div class="col-md-3"><h3 class="text-center font-montser orange-text"><span class="bebas">5000 AED</span></h3><h6 class="text-center font-montser dark-text">TOTAL REVENUE</h6></div><div class="col-md-3"><h3 class="text-center font-montser orange-text"><span class="bebas">500</span> <span class="arr-pos"><i class="ion-arrow-up-c rating-icon-green"></i></span></h3><h6 class="text-center font-montser dark-text">TOTAL VENDORS</h6></div><div class="col-md-3"><h3 class="text-center orange-text"><span class="bebas">2000</span></h3><h6 class="text-center font-montser dark-text">TOTAL OUTLETS</h6></div><div class="col-md-3"><h3 class="text-center orange-text"><span class="bebas">20000</span> <span class="arr-pos"><i class="ion-arrow-up-c rating-icon-green"></i></span></h3><h6 class="text-center font-montser dark-text">TOTAL CUSTOMERS</h6></div></div></div></div><div class="panel-body panel dash-bg panel-info bootstrap-panel m-b-5 top-box-bg1 min-hg"><div class="row p-l-r-15"><div class="col-xs-3 b-r-1 b-b-1 pad60-0"><h3 class="text-center"><span class="orange-text f25">25</span></h3><h5 class="text-center dark-text">NEW REGISTEATION REQUESTS</h5></div><div class="col-xs-3 b-r-1 b-b-1 pad60-0"><h3 class="text-center"><span class="orange-text f25">500</span></h3><h5 class="text-center rating-line dark-text">TOTAL VENDORS</h5></div><div class="col-xs-3 b-r-1 b-b-1 pad60-0"><h3 class="text-center"><span class="orange-text f25">2000</span></h3><h5 class="text-center rating-line dark-text">ACTIVE VENDORS</h5></div><div class="col-xs-3 b-b-1 pad60-0"><h3 class="text-center"><span class="orange-text f25">20000</span></h3><h5 class="text-center rating-line dark-text">CONTRACT RECEIVED</h5></div><div class="col-xs-3 b-r-1 pad60-0"><h3 class="text-center"><span class="orange-text f25">25</span></h3><h5 class="text-center dark-text">PENDING REQUETS</h5></div><div class="col-xs-3 b-r-1 pad60-0"><h3 class="text-center"><span class="orange-text f25">1</span></h3><h5 class="text-center rating-line dark-text">VENDORS NOT APPROVED</h5></div><div class="col-xs-3 b-r-1 pad60-0"><h3 class="text-center"><span class="orange-text f25">25</span></h3><h5 class="text-center rating-line dark-text">DEACTIVATED VENDORS</h5></div><div class="col-xs-3 pad60-0"><h3 class="text-center"><span class="orange-text f25">25</span></h3><h5 class="text-center rating-line dark-text">CONTRACT SENT</h5></div></div></div><div class="panel-body panel dash-bg panel-info bootstrap-panel top-box-bg2"><div class="row max-wid"><div class="col-md-6"><h3 class="text-center orange-text"><span class="">2000</span></h3><h6 class="text-center font-montser dark-text">ALL REFERRALS</h6></div><div class="col-md-6"><h3 class="text-center orange-text"><span class="">2500</span></h3><h6 class="text-center font-montser dark-text">ALL OFFERS</h6></div></div></div><div class="dash-bg panel-warning change-bg m-b-5"><div class="panel-heading clearfix"><div class="row"><div class="col-md-7"><h3 class="panel-title f-18px">PERFORMANCE OVERVIEW</h3></div></div></div><div class="panel-body py-5"><div class="row"><div class="lt-side col-md-3"><div class="table-box-shadow"><div class="reservationsReq orange-text f-16px bor-l-r-radius">OUTLETS REQUESTS LOCATION WISE</div><div class="table-responsive mt-0 font-montser reservationData"><table class="table table-striped-blue"><thead class="thead-bg"><tr><th>LOCATION</th><th>REQUESTS</th></tr></thead><tbody><tr><td>Nadjo</td><td>100</td></tr><tr><td>Mall Road</td><td>97</td></tr><tr><td>Shajah</td><td>35</td></tr><tr><td>Al-din</td><td>6</td></tr></tbody><tfoot class="bg-white"><tr><td colspan="3" class=""><p class="mb-0 cusors text-right color-theme text-underline">Check All</p></td></tr></tfoot></table></div></div><div class="table-box-shadow"><div class="reservationsReq orange-text f-16px bor-l-r-radius">OUTLETS REQUESTS DATE WISE</div><div class="table-responsive mt-0 font-montser reservationData"><table class="table table-striped-blue"><thead class="thead-bg"><tr><th>DATE</th><th>REQUESTS</th></tr></thead><tbody><tr><td>27/03/2017</td><td>86</td></tr><tr><td>28/03/2017</td><td>95</td></tr><tr><td>29/03/2017</td><td>102</td></tr><tr><td>30/03/2017</td><td>85</td></tr></tbody><tfoot class="bg-white"><tr><td colspan="3" class=""><p class="mb-0 cusors text-right color-theme text-underline">Check All</p></td></tr></tfoot></table></div></div><div class="table-box-shadow"><div class="reservationsReq orange-text f-16px bor-l-r-radius">TOP REFERRALS</div><div class="table-responsive mt-0 font-montser reservationData"><table class="table table-striped-blue"><thead class="thead-bg"><tr><th>OFFER</th><th>OUTLETS</th><th>REFERRALS</th></tr></thead><tbody><tr><td>15% Intro</td><td>Tim Horton.Nodja</td><td>86</td></tr><tr><td>15% Intro</td><td>Tim Horton.Sharjah</td><td>95</td></tr><tr><td>15% Intro</td><td>Tim Horton.Mall Road</td><td>102</td></tr><tr><td>30/03/2017</td><td>Tim Horton.Al-din</td><td>85</td></tr></tbody><tfoot class="bg-white"><tr><td colspan="3" class=""><p class="mb-0 cusors text-right color-theme text-underline">Check All</p></td></tr></tfoot></table></div></div></div><div class="rt-side col-md-9"><div class="panel panel-body top-box-bg p-t-0 pb-20 dash-bg panel-info bootstrap-panel"><div class="panel-heading panel-form border-none"><div class="row"><div class="col-md-12 text-center p-t-10"><h2 class="font-montser fontbold">Outlets Added Vs Time</h2></div></div></div><div class="panel-body"><div class="chartjs-canvas-holder-third-row chart-height"><canvas id="line" class="chart chart-line" chart-colors="overviewLineColors" chart-data="overviewDatas" chart-labels="overviewLabels" chart-series="series" chart-click="changeData" chart-options="overviewOptions"></canvas></div></div></div><div class="panel panel-body top-box-bg p-t-0 pb-20 dash-bg panel-info bootstrap-panel"><div class="panel-heading panel-form border-none"><div class="row"><div class="col-md-12 text-center p-t-10"><h2 class="font-montser fontbold">Revenue Vs Time</h2></div></div></div><div class="panel-body"><div class="chartjs-canvas-holder-third-row chart-height"><canvas id="line" class="chart chart-line" chart-colors="revenueLineColors" chart-data="revenueDatas" chart-labels="revenueLabels" chart-series="series" chart-click="changeData" chart-options="revenueOptions"></canvas></div></div></div><div class="panel panel-body top-box-bg p-t-0 pb-20 dash-bg panel-info bootstrap-panel"><div class="panel-heading panel-form border-none"><div class="row"><div class="col-md-12 text-center p-t-10"><h2 class="font-montser fontbold">Customers Added Vs Time</h2></div></div></div><div class="panel-body"><div class="chartjs-canvas-holder-third-row chart-height"><canvas id="line" class="chart chart-line" chart-colors="custsLineColors" chart-data="custsDatas" chart-labels="custsLabels" chart-series="series" chart-click="changeData" chart-options="custsOptions"></canvas></div></div></div></div></div></div></div>');
$templateCache.put('app/pages/report/referrals-activities/referrals-activities.html','<div class="panel-body panel m-b-5 top-box-bg"><div class="row"><div class="col-md-4"><h3 class="text-center orange-text"><span class="">5</span></h3><h6 class="text-center font-montser dark-text">REFERRALS</h6></div><div class="col-md-4"><h3 class="text-center orange-text"><span class="">500 AED</span> <span class="arr-pos"><i class="ion-arrow-up-c rating-icon-green"></i></span></h3><h6 class="text-center font-montser dark-text">REVENUE BY REFERRALS</h6></div><div class="col-md-4"><h3 class="text-center orange-text"><span class="">200</span> <span class="arr-pos"><i class="ion-arrow-up-c rating-icon-green"></i></span></h3><h6 class="text-center font-montser dark-text">VISITORS VIA REFERRALS</h6></div></div></div><div class="dash-bg panel-warning change-bg m-b-5 m-t-5"><div class="panel-heading p-t-b-10 clearfix"><div class="row"><div class="col-md-7"><h3 class="panel-title p-t-10 f-18px">REFERRAL ACTIVITIES</h3></div><div class="col-md-3 pull-right tran-select"><div class="form-group font-montser"><div class="selectCust selectoutlets new height-var"><select id="" class="form-control border-sel" name="business"><option value="First Choice">7th Mar 2017 - 17th Apr 2017</option><option value="Second Choice">7th May 2017 - 17th June 2017</option><option value="Third Choice">7th June 2017 - 17th July 2017</option></select></div></div></div></div></div></div><div class="panel-body panel m-b-10 top-box-bg1"><div class="row"><div class="col-md-6"><div class="panel-heading panel-form border-none"><div class="row"><div class="col-md-12 text-center p-t-10"><h2 class="font-montser orange-text fontbold">Referrals</h2></div></div></div><div class="panel-body"><div class="chartjs-canvas-holder-third-row chart-height1"><canvas id="line" class="chart chart-line" chart-colors="referralLineColors" chart-data="referralDatas" chart-labels="referralLabels" chart-series="series" chart-click="changeData" chart-options="referralOptions"></canvas></div></div></div><div class="col-md-6"><div class="panel-heading panel-form border-none"><div class="row"><div class="col-md-12 text-center p-t-10"><h2 class="font-montser orange-text fontbold">Revenue for Referrals</h2></div></div></div><div class="panel-body"><div class="chartjs-canvas-holder-third-row chart-height1"><canvas id="line" class="chart chart-line" chart-colors="revenueLineColors" chart-data="revenueDatas" chart-labels="revenueLabels" chart-series="series" chart-click="changeData" chart-options="revenueOptions"></canvas></div></div></div></div></div><div class="panel-body panel m-b-10 top-box-bg2"><div class="row"><div class="col-md-4"><div class="panel-body"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" class="chart chart-doughnut" chart-options="genderoptions" chart-data="returnCustData" chart-colors="returnCustColors" chart-labels="returnCustLabels" chart-click="changeData"></canvas><div class="text-Cen l-43">100%</div></div><div class="text-center chart-bot-title1"><p>Locationwise - Distribution<br>of Visitors</p></div></div></div><div class="col-md-4"><div class="panel-body"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" class="chart chart-doughnut" chart-options="genderoptions" chart-data="returnCust1Data" chart-colors="returnCust1Colors" chart-labels="returnCust1Labels" chart-click="changeData"></canvas><div class="text-Cen l-43">100%</div></div><div class="text-center chart-bot-title1"><p>Locationwise - Distribution<br>of Referrals</p></div></div></div><div class="col-md-4"><div class="panel-body"><div class="chartjs-canvas-holder-first-row"><canvas id="bar" class="chart chart-horizontal-bar" chart-options="options2" chart-data="horzData" chart-labels="horzLabels" chart-colors="horzBarColors" chart-series="series" chart-click="changeData" chart-update="updateC"></canvas></div><div class="text-center chart-bot-title1"><p>Referral Vs Revenue</p></div></div></div></div></div><div class="panel-body p-t-0 p-b-0"><div class="row"><div class="col-md-12 bg-white"><div class="row"><div class="col-md-8"><p class="visitAll color-theme">ALL REFERRALS</p></div></div><div class="row"><div class="col-md-12 px-0"><div class="reviewMode report-table table-responsive"><table class="table bg-white font-montser table-striped-blue"><thead class="thead-bg"><tr><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="text-center p-0 pos-head" colspan="2">REFERRED TO</th><th class="text-center p-0 pos-head" colspan="2">REFERREE</th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th></tr><tr><th>OFFER NAME</th><th>OUTLET</th><th>LOCATION</th><th class="text-center">NAME</th><th class="text-center">MOBILE</th><th class="text-center">NAME</th><th class="text-center">MOBILE</th><th>ENQUIRY<br>DATE</th><th>STATUS</th></tr></thead><tbody><tr><td>Flat 15%</td><td>Tim Hortons</td><td>Najdo</td><td class="text-center">Imran</td><td class="text-center">742-12345-4578</td><td class="text-center">Desmond</td><td class="text-center">742-12345-0000</td><td>11/14/2017</td><td>Pending</td></tr><tr><td>Flat 15%</td><td>Tim Hortons</td><td>Najdo</td><td class="text-center">Sushil</td><td class="text-center">742-12345-4578</td><td class="text-center">Desmond</td><td class="text-center">742-12345-0000</td><td>11/14/2017</td><td>Redeemed</td></tr><tr><td>Flat 15%</td><td>Tim Hortons</td><td>Najdo</td><td class="text-center">Jerry</td><td class="text-center">742-12345-4578</td><td class="text-center">Desmond</td><td class="text-center">742-12345-0000</td><td>11/14/2017</td><td>Pending</td></tr><tr><td>Flat 15%</td><td>Tim Hortons</td><td>Najdo</td><td class="text-center">Jhon Cena</td><td class="text-center">742-12345-4578</td><td class="text-center">Desmond</td><td class="text-center">742-12345-0000</td><td>11/14/2017</td><td>Redeemed</td></tr><tr><td>Flat 15%</td><td>Tim Hortons</td><td>Najdo</td><td class="text-center">Lisa Ray</td><td class="text-center">742-12345-4578</td><td class="text-center">Desmond</td><td class="text-center">742-12345-0000</td><td>11/14/2017</td><td>Pending</td></tr><tr><td>Flat 15%</td><td>Tim Hortons</td><td>Najdo</td><td class="text-center">Charles</td><td class="text-center">742-12345-4578</td><td class="text-center">Desmond</td><td class="text-center">742-12345-0000</td><td>11/14/2017</td><td>Redeemed</td></tr></tbody></table></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></div></div>');
$templateCache.put('app/pages/report/visitors-report/visitors-report.html','<div class="panel-body panel m-b-5 top-box-bg"><div class="row"><div class="col-md-4"><h3 class="text-center orange-text"><span class="">5</span></h3><h6 class="text-center font-montser dark-text">TOTAL VISITORS</h6></div><div class="col-md-4"><h3 class="text-center orange-text"><span class="">500 AED</span> <span class="arr-pos"><i class="ion-arrow-up-c rating-icon-green"></i></span></h3><h6 class="text-center font-montser dark-text">REVENUE BY VISITORS</h6></div><div class="col-md-4"><h3 class="text-center orange-text"><span class="">200</span> <span class="arr-pos"><i class="ion-arrow-up-c rating-icon-green"></i></span></h3><h6 class="text-center font-montser dark-text">VISITORS VIA REFERRALS</h6></div></div></div><div class="dash-bg panel-warning change-bg m-b-5 m-t-5"><div class="panel-heading clearfix"><div class="row"><div class="col-md-7"><h3 class="panel-title p-t-10 f-18px">VISITORS REPORTS</h3></div><div class="col-md-3 pull-right tran-select"><div class="form-group font-montser"><div class="selectCust selectoutlets new height-var"><select id="" class="form-control border-sel" name="business"><option value="First Choice">7th Mar 2017 - 17th Apr 2017</option><option value="Second Choice">7th May 2017 - 17th June 2017</option><option value="Third Choice">7th June 2017 - 17th July 2017</option></select></div></div></div></div></div></div><div class="panel-body panel m-b-5 top-box-bg1"><div class="row"><div class="col-md-6"><div class="panel-heading panel-form border-none"><div class="row"><div class="col-md-12 text-center p-t-10"><h2 class="font-montser orange-text fontbold">Visitors</h2></div></div></div><div class="panel-body"><div class="chartjs-canvas-holder-third-row chart-height1"><canvas id="line" class="chart chart-line" chart-colors="visitorsLineColors" chart-data="visitorsDatas" chart-labels="visitorsLabels" chart-series="series" chart-click="changeData" chart-options="visitorsOptions"></canvas></div></div></div><div class="col-md-6"><div class="panel-heading panel-form border-none"><div class="row"><div class="col-md-12 text-center p-t-10"><h2 class="font-montser orange-text fontbold">Revenue From Visitors</h2></div></div></div><div class="panel-body"><div class="chartjs-canvas-holder-third-row chart-height1"><canvas id="line" class="chart chart-line" chart-colors="revenueLineColors" chart-data="revenueDatas" chart-labels="revenueLabels" chart-series="series" chart-click="changeData" chart-options="revenueOptions"></canvas></div></div></div></div></div><div class="panel-body panel m-b-5 top-box-bg2"><div class="row"><div class="col-md-6"><div class="panel-body"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" class="chart chart-doughnut" chart-options="genderoptions" chart-data="returnCustData" chart-colors="returnCustColors" chart-labels="returnCustLabels" chart-click="changeData"></canvas><div class="text-Cen">100%</div></div><div class="text-center chart-bot-title1"><p>Locationwise - Distribution<br>of Visitors</p></div></div></div><div class="col-md-6"><div class="panel-body"><div class="chartjs-canvas-holder-first-row"><canvas id="bar" class="chart chart-horizontal-bar" chart-options="options2" chart-data="horzData" chart-labels="horzLabels" chart-colors="horzBarColors" chart-series="series" chart-click="changeData" chart-update="updateC"></canvas></div><div class="text-center chart-bot-title1"><p>Visitors Vs Revenue</p></div></div></div></div></div><div class="panel-body m-tb-5 p-tb-5"><div class="row"><div class="col-md-12 bg-white"><div class="row"><div class="col-md-8"><p class="visitAll color-theme">ALL VISITORS</p></div></div><div class="row"><div class="col-md-12 px-0"><div class="reviewMode report-table table-responsive"><table class="table bg-white font-montser table-striped-blue"><thead class="thead-bg"><tr><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="text-center p-0 pos-head" colspan="2">REFERREE</th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th></tr><tr><th>VISITORS NAME</th><th>OUTLET</th><th>LOCATION</th><th>MOBILE</th><th>REFFERED</th><th class="text-center">NAME</th><th class="text-center">MOBILE</th><th>DATE</th><th>BILL AMOUNT</th></tr></thead><tbody><tr><td><b>Jerry</b></td><td>Tim Hortons</td><td>Najdo</td><td>742-12345-4578</td><td>No</td><td class="text-center">Desmond</td><td class="text-center">742-12345-0000</td><td>11/14/2017</td><td>200 AED</td></tr><tr><td><b>Jerry</b></td><td>Tim Hortons</td><td>Najdo</td><td>742-12345-4578</td><td>No</td><td class="text-center">Desmond</td><td class="text-center">742-12345-0000</td><td>11/14/2017</td><td>200 AED</td></tr><tr><td><b>Jerry</b></td><td>Tim Hortons</td><td>Najdo</td><td>742-12345-4578</td><td>No</td><td class="text-center">Desmond</td><td class="text-center">742-12345-0000</td><td>11/14/2017</td><td>200 AED</td></tr><tr><td><b>Jerry</b></td><td>Tim Hortons</td><td>Najdo</td><td>742-12345-4578</td><td>No</td><td class="text-center">Desmond</td><td class="text-center">742-12345-0000</td><td>11/14/2017</td><td>200 AED</td></tr><tr><td><b>Jerry</b></td><td>Tim Hortons</td><td>Najdo</td><td>742-12345-4578</td><td>No</td><td class="text-center">Desmond</td><td class="text-center">742-12345-0000</td><td>11/14/2017</td><td>200 AED</td></tr><tr><td><b>Jerry</b></td><td>Tim Hortons</td><td>Najdo</td><td>742-12345-4578</td><td>No</td><td class="text-center">Desmond</td><td class="text-center">742-12345-0000</td><td>11/14/2017</td><td>200 AED</td></tr></tbody></table></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></div></div>');
$templateCache.put('app/pages/reservation/overview/overview.html','<div class="panel dash-bg panel-info bootstrap-panel"><div class="panel-heading"><div class="col-md-6 pull-right text-right"><form class="row form-inline pull-right" style="margin-top: -11px"><label class="col-md-2 p-t-10">FROM</label><div class="form-group col-sm-3 col-xs-6 col-md-4"><p class="input-group tran-txt"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt1" is-open="opened1" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open1()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><label class="col-md-1 p-t-10">TO</label><div class="form-group col-md-4 col-sm-3 col-xs-6"><p class="input-group tran-txt"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt2" is-open="opened2" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></form></div></div><div class="panel-body"><div class="table-width"><h3 class="text-center rating-value"><span>14</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon"></i></span></h3><h6 class="text-center rating-line">POSITIVE REVIEWS</h6><p class="text-center">+12% Since Last Week</p></div><div class="table-width"><h3 class="text-center rating-value"><span>55514</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon"></i></span></h3><h6 class="text-center rating-line">TOTAL REVENUE</h6><p class="text-center">+12% Since Last Week</p></div><div class="table-width"><h3 class="text-center rating-value"><span>1664</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon-green"></i></span></h3><h6 class="text-center rating-line">REVENUE PER WEEK</h6><p class="text-center">+12% Since Last Week</p></div><div class="table-width"><h3 class="text-center rating-value"><span>18884</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon"></i></span></h3><h6 class="text-center rating-line">VISITOR THIS WEEK</h6><p class="text-center">+12% Since Last Week</p></div><div class="table-width p-r-20"><h3 class="text-center rating-value"><span>445314</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon-green"></i></span></h3><h6 class="text-center rating-line">NEGATIVE FEEDBACKS</h6><p class="text-center">+12% Since Last Week</p></div></div></div><div class="panel dash-bg panel-info bootstrap-panel"><div class="panel-body p-b-0" style="background-color: #b9b7b5"><div class="row"><div class="col-md-2 p-t-10"><span style="color: white;font-weight: bold;">SHOW REPORT FOR</span></div><div class="col-md-2 tran-select"><vouched-select label="Choose Outlet" selected-value="outletFilter" select-lists="outletFilterLists" display-field="value" is-label="false"></vouched-select></div><div class="col-md-6 pull-right text-right"><form class="row form-inline pull-right"><label class="col-md-2" style="color: white;font-weight: bold;">FROM</label><div class="form-group col-sm-3 col-xs-6 col-md-4"><p class="input-group tran-txt"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt3" is-open="opened3" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open3()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><label class="col-md-1" style="color: white;font-weight: bold;">TO</label><div class="form-group col-md-4 col-sm-3 col-xs-6"><p class="input-group tran-txt"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt4" is-open="opened4" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open4()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></form></div></div></div></div><div class="panel dash-bg panel-info bootstrap-panel"><div class="panel-heading panel-form"><div class="col-md-4 p-t-10">NUMBER OF RESERVATION BOOKED</div><div class="col-md-2 pull-right tran-select"><vouched-select label="Day" selected-value="outletFilter" select-lists="outletFilterLists" display-field="value" is-label="false" class="ng-isolate-scope"></vouched-select></div></div><div class="panel-body"><div class="chartjs-canvas-holder-third-row"><canvas id="bar" class="chart chart-bar" chart-data="data" chart-labels="labels" chart-series="series" chart-click="changeData" chart-update="updateC"></canvas></div></div></div><div class="row"><div class="col-md-6"><div class="panel dash-bg panel-info bootstrap-panel"><div class="panel-heading">Chart 1</div><div class="panel-heading"><form class="row form-inline" style="margin-top: -11px;"><div class="col-md-6 p-0"><label class="col-md-2 p-t-10">FROM</label><div class="form-group col-sm-3 col-xs-6 col-md-10"><p class="input-group tran-txt"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt5" is-open="opened5" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open5()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6 p-0"><label class="col-md-1 p-t-10">TO</label><div class="form-group col-md-10 col-sm-3 col-xs-6"><p class="input-group tran-txt"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt6" is-open="opened6" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open6()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></form></div><div class="panel-body"><div class="chartjs-canvas-holder-first-row"><canvas id="doughnut" class="chart chart-doughnut" chart-options="options1" chart-data="data1" chart-labels="labels1" chart-click="changeData"></canvas></div></div></div></div><div class="col-md-6"><div class="panel dash-bg panel-info bootstrap-panel"><div class="panel-heading">Chart 2</div><div class="panel-heading"><form class="row form-inline" style="margin-top: -11px;"><div class="col-md-6 p-0"><label class="col-md-2 p-t-10">FROM</label><div class="form-group col-sm-3 col-xs-6 col-md-10"><p class="input-group tran-txt"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt7" is-open="openedFrom" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openFrom()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6 p-0"><label class="col-md-1 p-t-10">TO</label><div class="form-group col-md-10 col-sm-3 col-xs-6"><p class="input-group tran-txt"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt8" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openTo()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></form></div><div class="panel-body"><div class="chartjs-canvas-holder-first-row"><canvas id="radar" class="chart chart-radar" chart-series="series" chart-data="data3" chart-labels="labels3" chart-click="changeData"></canvas></div></div></div></div></div>');
$templateCache.put('app/pages/tables/basic/tables.html','<div class="widgets"><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Hover Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/hoverRows.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Bordered Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/borderedTable.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Condensed Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/condensedTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Striped Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/stripedRows.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Contextual Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/contextualTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Responsive Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/responsiveTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/smart/tables.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Rows" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableRowTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Cells" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Smart Table With Filtering, Sorting And Pagination" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/smartTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/widgets/basicTable.html','<div class="horizontal-scroll"><table class="table"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Downloads</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">DAU</th><th class="table-arr"></th><th class="align-right">MAU</th><th class="table-arr"></th><th class="align-right">LTV</th><th class="table-arr"></th><th class="align-right">Users %</th><th class="table-arr"></th></tr></thead><tbody><tr><td><img src="img/chrome.svg" width="20" height="20"></td><td class="nowrap">Google Chrome</td><td class="align-right">10,392</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">3,822</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,214</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">899</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">7,098</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">178</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">45%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/firefox.svg" width="20" height="20"></td><td class="nowrap">Mozilla Firefox</td><td class="align-right">7,873</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">6,003</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,031</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">897</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">8,997</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">28%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/ie.svg" width="20" height="20"></td><td class="nowrap">Internet Explorer</td><td class="align-right">5,890</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,492</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">2,102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">27</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,039</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">99</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">17%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/safari.svg" width="20" height="20"></td><td class="nowrap">Safari</td><td class="align-right">4,001</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">2,039</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">1,001</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">104</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,983</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">209</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">14%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/opera.svg" width="20" height="20"></td><td class="nowrap">Opera</td><td class="align-right">1,833</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">983</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">83</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">19</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">1,099</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">103</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">5%</td><td class="table-arr"><i class="icon-up"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/borderedTable.html','<div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="align-right">Purchases</th><th class="align-right">%</th></tr></thead><tbody><tr ng-repeat="item in metricsTableData"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="align-right">{{item.purchases}}</td><td class="align-right">{{item.percent}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/condensedTable.html','<div class="horizontal-scroll"><table class="table table-condensed"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in peopleTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><button class="status-button btn btn-xs btn-{{item.status}}">{{item.status}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/contextualTable.html','<table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class="primary"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr class="success"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr class="warning"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr class="danger"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr class="info"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableRowTable.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUser()">Add row</button></div><table class="table table-bordered table-hover table-condensed"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat="user in users" class="editable-row"><td>{{$index}}</td><td><span editable-text="user.name" e-name="name" e-form="rowform" e-required="">{{ user.name || \'empty\' }}</span></td><td class="select-td"><span editable-select="user.status" e-name="status" e-form="rowform" e-selectpicker="" e-ng-options="s.value as s.text for s in statuses">{{ showStatus(user) }}</span></td><td class="select-td"><span editable-select="user.group" e-name="group" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.text for g in groups">{{ showGroup(user) }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser($index)">Delete</button></div></td></tr></table>');
$templateCache.put('app/pages/tables/widgets/editableTable.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="editableTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr></thead><tbody><tr ng-repeat="item in editableTableData" class="editable-tr-wrap"><td class="table-id">{{item.id}}</td><td><span editable-text="item.firstName" blur="cancel">{{item.firstName}}</span></td><td><span editable-text="item.lastName" blur="cancel">{{item.lastName}}</span></td><td><span editable-text="item.username" blur="cancel">{{item.username}}</span></td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><span editable-text="item.age" blur="cancel">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="12" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/hoverRows.html','<div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">%</th><th class="table-arr"></th></tr></thead><tbody><tr ng-repeat="item in metricsTableData" class="no-top-border"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }"></i></td><td class="align-right">{{item.purchases}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }"></i></td><td class="align-right">{{item.percent}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/responsiveTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/smartTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr><tr><th></th><th><input st-search="firstName" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastName" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="username" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" placeholder="Search Email" class="input-sm form-control search-input" type="search"></th><th><input st-search="age" placeholder="Search Age" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/stripedRows.html','<div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/alerts/alerts.html','<div class="widgets"><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info"><strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger"><strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Dismissible alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Well done!</strong> You successfully read this important alert message.</div><div class="alert bg-info closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class="alert bg-warning closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class="alert bg-danger closeable" role="alert"><button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button> <strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Links in alerts" ba-panel-class="with-scroll"><div><div class="alert bg-success"><strong>Well done!</strong> You successfully read <a href="" class="alert-link">this important alert message</a>.</div><div class="alert bg-info"><strong>Heads up!</strong> This <a href="" class="alert-link">alert needs your attention</a>, but it\'s not super important.</div><div class="alert bg-warning"><strong>Warning!</strong> Better check yourself, you\'re <a href="" class="alert-link">not looking too good</a>.</div><div class="alert bg-danger"><strong>Oh snap!</strong> <a href="" class="alert-link">Change a few things up</a> and try submitting again.</div></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Composite alerts" ba-panel-class="with-scroll"><div><div class="alert bg-warning"><h4>Warning!</h4><strong>Pay attention.</strong> Change a few things up and try submitting again.<div class="control-alert"><button type="button" class="btn btn-danger">Pay Attention</button> <button type="button" class="btn btn-primary">Ignore</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/buttons.html','<div class="widgets"><div class="row"><div class="col-md-3" ba-panel="" ba-panel-title="Flat Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Raised Buttons" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-raised">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-raised">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-raised">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-raised">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-raised">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Different sizes" ba-panel-class="with-scroll button-panel df-size-button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success btn-mm">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info btn-md">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning btn-xm">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div><div class="col-md-3" ba-panel="" ba-panel-title="Disabled" ba-panel-class="with-scroll button-panel"><div class="button-wrapper"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="button-wrapper"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="button-wrapper"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="button-wrapper"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="button-wrapper"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="button-wrapper"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Icon Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/iconButtons.html\'"></div></div><div ba-panel="" ba-panel-title="Large Buttons" ba-panel-class="with-scroll large-buttons-panel"><div ng-include="\'app/pages/ui/buttons/widgets/largeButtons.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Button Dropdowns" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/dropdowns.html\'"></div></div><div ba-panel="" ba-panel-title="Button Groups" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/buttonGroups.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Progress Buttons" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/buttons/widgets/progressButtons.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/grid/baseGrid.html','<h4 class="grid-h">Stacked to horizontal</h4><div class="row show-grid"><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div><div class="col-md-1"><div>.col-md-1</div></div></div><div class="row show-grid"><div class="col-md-8"><div>.col-md-8</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4"><div>.col-md-4</div></div></div><div class="row show-grid"><div class="col-md-6"><div>.col-md-6</div></div><div class="col-md-6"><div>.col-md-6</div></div></div><h4 class="grid-h">Mobile and desktop</h4><div class="row show-grid"><div class="col-xs-12 col-md-8"><div>xs-12 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div><div class="col-xs-6 col-md-4"><div>xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6"><div>.col-xs-6</div></div><div class="col-xs-6"><div>.col-xs-6</div></div></div><h4 class="grid-h">Mobile, tablet, desktop</h4><div class="row show-grid"><div class="col-xs-12 col-sm-6 col-md-8"><div>.col-xs-12 .col-sm-6 .col-md-8</div></div><div class="col-xs-6 col-md-4"><div>.col-xs-6 .col-md-4</div></div></div><div class="row show-grid"><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-4"><div>.col-xs-6 .col-sm-4</div></div></div><h4 class="grid-h">Column wrapping</h4><div class="row show-grid"><div class="col-xs-9"><div>.col-xs-9</div></div><div class="col-xs-4"><div>.col-xs-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous unit.</div></div><div class="col-xs-6"><div>.col-xs-6<br>Subsequent columns continue along the new line.</div></div></div><h4 class="grid-h">Responsive column resets</h4><div class="row show-grid"><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3<p>Resize your viewport or check it out on your phone for an example.</p></div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="clearfix visible-xs-block"></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div><div class="col-xs-6 col-sm-3"><div>.col-xs-6 .col-sm-3</div></div></div><h4 class="grid-h">Offsetting columns</h4><div class="row show-grid"><div class="col-md-4"><div>.col-md-4</div></div><div class="col-md-4 col-md-offset-4"><div>.col-md-4 .col-md-offset-4</div></div></div><div class="row show-grid"><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div><div class="col-md-3 col-md-offset-3"><div>.col-md-3 .col-md-offset-3</div></div></div><div class="row show-grid"><div class="col-md-6 col-md-offset-3"><div>.col-md-6 .col-md-offset-3</div></div></div><h4 class="grid-h">Grid options</h4><div class="table-responsive"><table class="table table-bordered table-striped"><thead><tr><th></th><th>Extra small devices <small>Phones (&lt;768px)</small></th><th>Small devices <small>Tablets (\u2265768px)</small></th><th>Medium devices <small>Desktops (\u2265992px)</small></th><th>Large devices <small>Desktops (\u22651200px)</small></th></tr></thead><tbody><tr><th class="text-nowrap" scope="row">Grid behavior</th><td>Horizontal at all times</td><td colspan="3">Collapsed to start, horizontal above breakpoints</td></tr><tr><th class="text-nowrap" scope="row">Container width</th><td>None (auto)</td><td>750px</td><td>970px</td><td>1170px</td></tr><tr><th class="text-nowrap" scope="row">Class prefix</th><td><code>.col-xs-</code></td><td><code>.col-sm-</code></td><td><code>.col-md-</code></td><td><code>.col-lg-</code></td></tr><tr><th class="text-nowrap" scope="row"># of columns</th><td colspan="4">12</td></tr><tr><th class="text-nowrap" scope="row">Column width</th><td class="text-muted">Auto</td><td>~62px</td><td>~81px</td><td>~97px</td></tr><tr><th class="text-nowrap" scope="row">Gutter width</th><td colspan="4">30px (15px on each side of a column)</td></tr><tr><th class="text-nowrap" scope="row">Nestable</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Offsets</th><td colspan="4">Yes</td></tr><tr><th class="text-nowrap" scope="row">Column ordering</th><td colspan="4">Yes</td></tr></tbody></table></div>');
$templateCache.put('app/pages/ui/grid/grid.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Inline Form" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/grid/baseGrid.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/icons/icons.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Kameleon SVG Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleon.html"></div></div><div ba-panel="" ba-panel-title="Socicon" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/socicon.html"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="Icons With Rounded Background" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/kameleonRounded.html"></div></div><div ba-panel="" ba-panel-title="ionicons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/ionicons.html"></div></div><div ba-panel="" ba-panel-title="Font Awesome Icons" ba-panel-class="with-scroll"><div include-with-scope="app/pages/ui/icons/widgets/fontAwesomeIcons.html"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modals.html','<div class="widgets"><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Modals" ba-panel-class="with-scroll"><div class="modal-buttons clearfix"><button type="button" class="btn btn-primary" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')">Default modal</button> <button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')">Large modal</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')">Small modal</button></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Message Modals" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-success" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/successModal.html\')">Success Message</button> <button type="button" class="btn btn-info" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')">Info Message</button> <button type="button" class="btn btn-warning" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')">Warning Message</button> <button type="button" class="btn btn-danger" data-toggle="modal" ng-click="open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')">Danger Message</button></div></div><div class="col-md-6" ba-panel="" ba-panel-title="Notifications" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/modals/notifications/notifications.html\'"></div></div></div><div class="row"><div class="col-md-6" ba-panel="" ba-panel-title="Progress dialogs" ba-panel-class="with-scroll"><div class="modal-buttons same-width clearfix"><button type="button" class="btn btn-info" data-toggle="modal" ng-click="openProgressDialog()">Progress dialog</button></div></div></div></div>');
$templateCache.put('app/pages/ui/notifications/notifications.html','<div ba-panel="" ba-panel-class="with-scroll notification-panel"><div class="row"><div class="col-md-3 col-sm-4"><div class="control"><label for="title">Title</label> <input ng-model="options.title" type="text" class="form-control" id="title" placeholder="Enter a title ..."></div><div class="control"><label for="message">Message</label> <textarea ng-model="options.msg" class="form-control" id="message" rows="3" placeholder="Enter a message ..."></textarea></div><div class="control-group"><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.closeButton" type="checkbox" id="closeButton"> <span>Close Button</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.allowHtml" type="checkbox" id="html"> <span>Allow html</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.progressBar" type="checkbox" id="progressBar"> <span>Progress bar</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventDuplicates" type="checkbox" id="preventDuplicates"> <span>Prevent duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.preventOpenDuplicates" type="checkbox" id="preventOpenDuplicates"> <span>Prevent open duplicates</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.tapToDismiss" type="checkbox" id="tapToDismiss"> <span>Tap to dismiss</span></label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.newestOnTop" type="checkbox" id="newestOnTop"> <span>Newest on top</span></label></div></div></div><div class="col-md-2 col-sm-3 toastr-radio-setup"><div id="toastTypeGroup"><div class="controls radio-controls"><label class="radio-header">Toast Type</label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="success"><span>Success</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="info"><span>Info</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="warning"><span>Warning</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.type" name="toasts" value="error"><span>Error</span></label></div></div><div id="positionGroup"><div class="controls radio-controls"><label class="radio-header position-header">Position</label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-right"> <span>Top Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-right"> <span>Bottom Right</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-left"> <span>Bottom Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-left"> <span>Top Left</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-full-width"> <span>Top Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-full-width"> <span>Bottom Full Width</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-top-center"> <span>Top Center</span></label> <label class="radio custom-radio"><input type="radio" ng-model="options.positionClass" name="positions" value="toast-bottom-center"> <span>Bottom Center</span></label></div></div></div><div class="col-md-2 col-sm-3"><div class="control"><label for="timeOut">Time out</label> <input type="text" class="form-control" id="timeOut" ng-model="options.timeOut" placeholder="ms"> <label class="sub-label" for="timeOut">If you set it to 0, it will stick</label></div><div class="control"><label for="extendedTimeOut">Extended time out</label> <input type="text" class="form-control" id="extendedTimeOut" ng-model="options.extendedTimeOut" placeholder="ms"></div><div class="control"><label for="maxOpened">Maximum number of toasts</label> <input type="text" class="form-control" id="maxOpened" ng-model="options.maxOpened" value="0"> <label for="maxOpened" class="sub-label">0 means no limit</label></div><div class="control"><label class="checkbox-inline custom-checkbox nowrap"><input ng-model="options.autoDismiss" type="checkbox" id="autoDismiss"> <span>Auto dismiss</span></label></div></div><div class="col-md-5 col-sm-12"><label>Result:</label><pre class="result-toastr" id="toastrOptions">{{optionsStr}}</pre></div></div><div class="row"><div class="col-md-12 button-row"><button ng-click="openToast()" class="btn btn-primary">Open Toast</button> <button ng-click="openRandomToast()" class="btn btn-primary">Random Toast</button> <button ng-click="clearToasts()" class="btn btn-danger">Clear Toasts</button> <button ng-click="clearLastToast()" class="btn btn-danger">Clear Last Toast</button></div></div></div>');
$templateCache.put('app/pages/ui/panels/panels.html','<h2>Default panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-class="xsmall-panel light-text">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac mi erat. Phasellus placerat, elit a laoreet semper, enim ipsum ultricies orci, ac tincidunt tellus massa eu est. Nam non porta purus, sed facilisis justo. Nam pulvinar sagittis quam.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header" ba-panel-class="xsmall-panel light-text">Phasellus maximus venenatis augue, et vestibulum neque aliquam ut. Morbi mattis libero vitae vulputate dignissim. Praesent placerat, sem non dapibus cursus, lacus nisi blandit quam, vitae porttitor lectus lacus non turpis. Donec suscipit consequat tellus.</div></div><div class="col-md-12 col-lg-4"><div ba-panel="" ba-panel-title="Panel with header & scroll" ba-panel-class="xsmall-panel with-scroll light-text"><p>Suspendisse nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Sed dapibus, purus vel hendrerit consectetur, lectus orci gravida massa, sed bibendum dui mauris et eros. Nulla dolor massa, posuere et dictum sit amet, dignissim quis odio. Fusce mollis finibus dignissim. Integer sodales augue erat. Pellentesque laoreet vestibulum urna at iaculis. Nulla libero augue, euismod at diam eget, aliquam condimentum ligula. Donec a leo eu est molestie lacinia hendrerit sed lorem. Duis id diam eu metus sodales consequat vel eu elit. Praesent dolor nibh, convallis eleifend feugiat a, finibus porttitor nibh. Ut non libero vel velit pulvinar scelerisque non vel lorem. Integer porta tempor nulla. Sed nibh erat, ultrices vel lorem eu, rutrum vehicula sem.</p><p>Donec nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum nec ligula egestas rhoncus. Sed dignissim, augue vel scelerisque vulputate, nisi ante posuere lorem, quis iaculis eros dolor eu nisl. Etiam sagittis, ipsum ac tempor iaculis, justo neque mattis ante, ac maximus sapien risus eu sapien. Morbi erat urna, varius et lectus vel, porta dictum orci. Duis bibendum euismod elit, et lobortis purus venenatis in. Mauris eget lacus enim. Cras quis sem et magna fringilla convallis. Proin hendrerit nulla vel gravida mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vestibulum consectetur quis purus vel aliquam.</p></div></div></div><h2>Bootstrap panels</h2><div class="row"><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-body"><p>A panel in bootstrap is a bordered box with some padding around its content.</p><p class="p-with-code">Panels are created with the <code>.panel</code> class, and content inside the panel has a <code>.panel-body</code> class. The <code>.panel-default .panel-primary .panel-danger</code> and other classes are used to style the color of the panel. See the next example on this page for more contextual classes.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel xsmall-panel"><div class="panel-heading">Panel Heading</div><div class="panel-body"><p class="p-with-code">The <code>.panel-heading</code> class adds a heading to the panel.Easily add a heading container to your panel with .panel-heading. You may also include any <code>h1-h6</code> with a <code>.panel-title</code> class to add a pre-styled heading.</p></div></div></div><div class="col-md-12 col-lg-4"><div class="panel panel-default bootstrap-panel"><div class="panel-body footer-panel"><p class="p-with-code">Wrap buttons or secondary text in <code>.panel-footer</code>. Note that panel footers do not inherit colors and borders when using contextual variations as they are not meant to be in the foreground.</p></div><div class="panel-footer">Panel Footer</div></div></div></div><h2>Panels with Contextual Classes</h2><div class="row"><div class="col-md-6 col-lg-4"><div class="panel panel-default contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-default class</div><div class="panel-body">To color the panel, use contextual classes. This is sample <code>.panel-default</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-primary contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-primary class</div><div class="panel-body">Sample <code>.panel-primary</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-success contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-success class</div><div class="panel-body">Sample <code>.panel-success</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-info contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-info class</div><div class="panel-body">Sample <code>.panel-info</code> panel</div><div class="panel-heading">Panel with panel-info class</div><div class="panel-body">Sample <code>.panel-info</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-warning contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-warning class</div><div class="panel-body">Sample <code>.panel-warning</code> panel</div></div></div><div class="col-md-6 col-lg-4"><div class="panel panel-danger contextual-example-panel bootstrap-panel"><div class="panel-heading">Panel with panel-danger class</div><div class="panel-body">Sample <code>.panel-danger</code> panel</div></div></div></div><div class="row"><div class="col-md-12"><h2>Panel Group</h2><div class="panel-group"><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 1</div><div class="panel-body"><p>To group many panels together, wrap a <code>&lt;div&gt;</code> with class <code>\n            .panel-group</code> around them.</p></div></div><div class="panel panel-default bootstrap-panel"><div class="panel-heading">Panel group 2</div><div class="panel-body"><p>The <code>.panel-group</code> class clears the bottom-margin of each panel.</p></div></div></div></div></div>');
$templateCache.put('app/pages/ui/progressBars/progressBars.html','<div class="widgets"><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-title="Basic" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/basic.html\'"></div></div><div ba-panel="" ba-panel-title="Striped" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/striped.html\'"></div></div></div><div class="col-md-6"><div ba-panel="" ba-panel-title="With label" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/label.html\'"></div></div><div ba-panel="" ba-panel-title="Animated" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/animated.html\'"></div></div></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Stacked" ba-panel-class="with-scroll"><div ng-include="\'app/pages/ui/progressBars/widgets/stacked.html\'"></div></div></div></div>');
$templateCache.put('app/pages/ui/slider/slider.html','<div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Ion Range Slider" ba-panel-class="with-scroll"><div class="slider-box"><h5>Basic</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="false"></ion-slider></div><div class="slider-box"><h5>With prefix</h5><ion-slider type="single" grid="true" min="100" max="1200" prefix="$" from="420" disable="false"></ion-slider></div><div class="slider-box"><h5>With postfix</h5><ion-slider type="single" grid="true" min="-90" max="90" postfix="\xB0" from="36" disable="false"></ion-slider></div><div class="slider-box"><h5>Two way range</h5><ion-slider type="double" grid="true" min="100" max="1200" from="420" to="900" disable="false"></ion-slider></div><div class="slider-box"><h5>With Steps</h5><ion-slider type="single" grid="true" min="0" max="1000" from="300" step="50" disable="false"></ion-slider></div><div class="slider-box"><h5>Decorating numbers</h5><ion-slider type="single" grid="true" min="0" max="1000000" from="300000" step="1000" prettify-separator="." prettify="true" disable="false"></ion-slider></div><div class="slider-box"><h5>Using custom values array</h5><ion-slider type="single" grid="true" from="5" step="1000" values="[\'January\', \'February\', \'March\', \'April\', \'May\', \'June\', \'July\', \'August\', \'September\', \'October\', \'November\', \'December\']" disable="false"></ion-slider></div><div class="slider-box"><h5>Disabled</h5><ion-slider type="single" grid="false" min="0" max="100" from="45" disable="true"></ion-slider></div></div></div></div>');
$templateCache.put('app/pages/ui/tabs/contextualAccordion.html','<uib-accordion><uib-accordion-group heading="Primary" panel-class="panel-primary bootstrap-panel accordion-panel">Primary <i class="ion-heart"></i></uib-accordion-group><uib-accordion-group heading="Success" panel-class="panel-success bootstrap-panel accordion-panel">Success <i class="ion-checkmark-round"></i></uib-accordion-group><uib-accordion-group heading="Info" panel-class="panel-info bootstrap-panel accordion-panel">Info <i class="ion-information-circled"></i></uib-accordion-group><uib-accordion-group heading="Warning" panel-class="panel-warning bootstrap-panel accordion-panel">Warning <i class="ion-alert"></i></uib-accordion-group><uib-accordion-group heading="Danger" panel-class="panel-danger bootstrap-panel accordion-panel">Danger <i class="ion-nuclear"></i></uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/mainTabs.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Start"><p>Take up one idea. Make that one idea your life--think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success.</p><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even become a self-fulfilling prophecy.</p><div class="text-center"><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Shop\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Programming\' | kameleonImg )}}"></div><div class="kameleon-icon with-round-bg primary inline-icon"><img ng-src="{{::( \'Dna\' | kameleonImg )}}"></div></div><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Getting Done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab ng-init="$dropdownTabActive = 1" class="with-dropdown"><uib-tab-heading uib-dropdown=""><a uib-dropdown-toggle="" ng-click="$event.stopPropagation()">Dropdown tab <i class="caret"></i></a><ul class="dropdown-menu" uib-dropdown-menu=""><li><a ng-click="$dropdownTabActive = 1; $tabSetStatus.activeTab = 3">Tab 1</a></li><li><a ng-click="$dropdownTabActive = 2; $tabSetStatus.activeTab = 3">Tab 2</a></li></ul></uib-tab-heading><div ng-show="$dropdownTabActive == 1"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></div><div ng-show="$dropdownTabActive == 2"><p class="text-center"><button class="btn btn-danger">I\'m just a dummy button</button></p></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/ui/tabs/sampleAccordion.html','<uib-accordion><uib-accordion-group is-open="true" heading="Static Header, initially expanded" panel-class="bootstrap-panel accordion-panel panel-default">This content is straight in the template.</uib-accordion-group><uib-accordion-group heading="Dynamic Body Content" panel-class="bootstrap-panel accordion-panel panel-default"><p>The body of the uib-accordion group grows to fit the contents</p><button type="button" class="btn btn-primary btn-sm">Add Item</button></uib-accordion-group><uib-accordion-group heading="Custom template" panel-class="bootstrap-panel accordion-panel panel-default">Hello</uib-accordion-group><uib-accordion-group panel-class="bootstrap-panel accordion-panel panel-default"><uib-accordion-heading>I can have markup, too! <i class="fa pull-right ion-settings"></i></uib-accordion-heading>This is just some content to illustrate fancy headings.</uib-accordion-group></uib-accordion>');
$templateCache.put('app/pages/ui/tabs/sideTabs.html','<div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-left"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg danger"><img ng-src="{{::( \'Key\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div><div ba-panel="" ba-panel-class="tabs-panel xsmall-panel with-scroll"><uib-tabset class="tabs-right"><uib-tab heading="Start"><p class="text-center">Take up one idea.</p><div class="kameleon-icon-tabs kameleon-icon with-round-bg warning"><img ng-src="{{::( \'Phone-Booth\' | kameleonImg )}}"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading="Get it done"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading="Achieve"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/ui/tabs/tabs.html','<div><div class="row"><div class="col-md-6"><div ba-panel="" ba-panel-class="with-scroll horizontal-tabs tabs-panel medium-panel"><div ng-include="\'app/pages/ui/tabs/mainTabs.html\'"></div></div></div><div class="col-md-6 tabset-group" ng-include="\'app/pages/ui/tabs/sideTabs.html\'"></div></div><div class="row accordions-row"><div class="col-md-6" ng-include="\'app/pages/ui/tabs/sampleAccordion.html\'"></div><div class="col-md-6" ng-include="\'app/pages/ui/tabs/contextualAccordion.html\'"></div></div></div>');
$templateCache.put('app/pages/ui/typography/typography.html','<div class="typography-document-samples row-fluid"><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll heading-widget" ba-panel-title="Text Size"><div class="section-block"><h1>H1. Heading 1</h1><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h2>H2. Heading 2</h2><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h3>H3. Heading 3</h3><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class="section-block"><h4>H4. Heading 4</h4><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra,.</p></div><div class="section-block"><h5>H5. Heading 5</h5><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll more-text-widget" ba-panel-title="Some more text"><div class="section-block light-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis.</p></div><div class="section-block regular-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id.</p></div><div class="section-block upper-text bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block bold-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullam-corper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class="section-block small-text"><p>Secondary text. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar,</p><p>lacinia scelerisque pharetra, placerat vestibulum eleifend</p><p>pellentesque, mi nam.</p></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll lists-widget" ba-panel-title="Lists"><div class="section-block"><h5 class="list-header">Unordered list:</h5><ul class="blur"><li>Lorem ipsum dolor sit amet</li><li>\u0421lacinia scelerisque pharetra<ul><li>Dui rhoncus quisque integer lorem<ul><li>Libero iaculis vestibulum eu vitae</li></ul></li></ul></li><li>Nisl lectus nibh habitasse suspendisse ut</li><li><span>Posuere cursus hac, vestibulum wisi nulla bibendum</span></li></ul><h5 class="list-header">Ordered Lists:</h5><ol class="blur"><li><span>Eu non nec cursus quis mollis, amet quam nec</span></li><li><span>Et suspendisse, adipiscing fringilla ornare sit ligula sed</span><ol><li><span>Interdum et justo nulla</span><ol><li><span>Magna amet, suscipit suscipit non amet</span></li></ol></li></ol></li><li><span>Metus duis eu non eu ridiculus turpis</span></li><li><span>Neque egestas id fringilla consectetuer justo curabitur, wisi magna neque commodo volutpat</span></li></ol><div class="accent">Important text fragment. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</div></div></div></div><div class="col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll color-widget" ba-panel-title="Text Color"><div class="section-block red-text"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p></div><div class="section-block yellow-text"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula ut id elit. In sed ornare nulla.</p></div><div class="section-block links"><p>Lorem ipsum <a href="">dolor</a> sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis <a href="">ullamcorper</a> ligula sodales at. Nulla tellus elit, varius non commodo eget, <a href="">mattis</a> vel eros. In sed ornare nulla.</p></div><div class="section-block links"><p><a href="">Active link \u2014 #209e91</a></p><p class="hovered"><a href="">Hover link \u2014 #17857a</a></p></div></div></div></div><div class="row-fluid"><div class="col-lg-12 col-sm-12 col-xs-12"><div ba-panel="" ba-panel-class="banner-column-panel"><div class="banner"><div class="large-banner-wrapper"><img ng-src="{{::( \'app/typography/banner.png\' | appImage )}}" alt=""></div><div class="banner-text-wrapper"><div class="banner-text"><h1>Simple Banner Text</h1><p>Lorem ipsum dolor sit amet</p><p>Odio amet viverra rutrum</p></div></div></div><div class="section"><h2>Columns</h2><div class="row"><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo03.png\' | appImage )}}" alt="" title=""></div><p>Vel elit, eros elementum, id lacinia, duis non ut ut tortor blandit. Mauris <a href="">dapibus</a> magna rutrum. Ornare neque suspendisse <a href="">phasellus wisi</a>, quam cras pede rutrum suspendisse, <a href="">felis amet eu</a>. Congue magna elit quisque quia, nullam justo sagittis, ante erat libero placerat, proin condimentum consectetuer lacus. Velit condimentum velit, sed penatibus arcu nulla.</p></div><div class="col-sm-6"><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo01.png\' | appImage )}}" alt="" title=""></div><p>Et suspendisse, adipiscing fringilla ornare sit ligula sed, vel nam. Interdum et justo nulla, fermentum lobortis purus ut eu, duis nibh dolor massa tristique elementum, nibh iste potenti risus fusce aliquet fusce, ullamcorper debitis primis arcu tellus vestibulum ac.</p></div></div><div class="separator"></div><div class="row"><div class="col-sm-4"><h4>Column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo04.png\' | appImage )}}" alt=""></div><p>Eget augue, lacus erat ante egestas scelerisque aliquam, metus molestie leo in habitasse magna maecenas</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Yet another column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo05.png\' | appImage )}}" alt=""></div><p>Augue massa et parturient, suspendisse orci nec scelerisque sit, integer nam mauris pede consequat in velit</p><a href="" class="learn-more">Lean more</a></div><div class="col-sm-4"><h4>Third column heading example</h4><div class="img-wrapper"><img ng-src="{{::( \'app/typography/typo06.png\' | appImage )}}" alt=""></div><p>Eget turpis, tortor lobortis porttitor, vestibulum nullam vehicula aliquam</p><a href="" class="learn-more">Lean more</a></div></div><div class="separator"></div></div></div></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><div class="menu-select"></div><span class="m-r-10"><img src="assets/images/{{ ::item.icon }}" class="menu-img"></span><span class="m-l-10">{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><span class="m-r-10"><img src="assets/images/{{ ::item.icon }}" class="menu-img"></span><span class="m-l-10">{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link"><div class="menu-select"></div>{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}"><div class="menu-select"></div>{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link"><div class="menu-select"></div>{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}"><div class="menu-select"></div>{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix m-t-10"><img src="assets/images/logo.png"></a><nav class="navbar m-t-5"><ul class="nav navbar-nav navbar-right lofin-admin"><li class="m-t-5"><a href="#" class="user_id"><span class="admin-logout">LOGOUT</span></a></li><li class="m-t-15 display-inlinfex"><img src="assets/images/myaccount-login.png" alt="myaccount-login" class="ml-15"><vouched-select label="My ACCOUNT" selected-value="outletFilter" select-lists="outletFilterLists" display-field="value" is-label="false" class="w-150 my-account-admin user_id my-account"></vouched-select></li></ul></nav></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');
$templateCache.put('app/theme/inputs/maps/maps.html','<div style="height:870px" id="googleMaps"></div>');
$templateCache.put('app/theme/inputs/radioButton/radioButton.html','<label for="select" ng-if="$ctrl.isLabel">{{$ctrl.label}}</label><div class="row" ng-if="$ctrl.isHorizontalForm"><div class="col-xs-{{$ctrl.xs}} col-lg-{{$ctrl.lg}}" ng-repeat="item in $ctrl.radioList track by $index"><input type="radio" name="inlineRadioOptions" value="{{item}}" ng-model="$ctrl.textValue" ng-disabled="$ctrl.isDisable"> <span>{{item}}</span></div></div><div ng-if="!$ctrl.isHorizontalForm"><div ng-repeat="item in $ctrl.radioList track by $index"><input type="radio" name="inlineRadioOptions" value="{{item}}" ng-model="$ctrl.textValue" ng-disabled="$ctrl.isDisable"> <span>{{item}}</span></div></div>');
$templateCache.put('app/theme/inputs/select/select.html','<label for="select" ng-if="$ctrl.isLabel">{{$ctrl.label | lowercase}}</label><div class="" ng-if="!$ctrl.isMultiple"><ui-select ng-model="$ctrl.selecetedValue" class="btn-group bootstrap-select form-control" ng-disabled="$ctrl.isDisable" append-to-body="true" search-enabled="$ctrl.isSearchable"><ui-select-match placeholder="{{$ctrl.label}}" class="text-capitalize"><span>{{$ctrl.selecetedValue[$ctrl.displayField]}}</span></ui-select-match><ui-select-choices repeat="item in $ctrl.selectLists | filter: $select.search"><span ng-bind-html="item[$ctrl.displayField]"></span></ui-select-choices></ui-select></div><div class="" ng-if="$ctrl.isMultiple"><ui-select multiple="" ng-model="selectpickerVm.multipleItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control"><ui-select-match placeholder="Multiple Select" class="text-capitalize">{{$item.label | lowercase }}</ui-select-match><ui-select-choices repeat="multipleItem in selectpickerVm.multipleSelectItems | filter: $select.search">{{multipleItem.label | lowercase}}</ui-select-choices></ui-select></div>');
$templateCache.put('app/theme/inputs/textArea/textArea.html','<label for="textarea">{{$ctrl.label}}</label><div class="form-group"><textarea placeholder="{{$ctrl.label}}" class="form-control" id="textarea" ng-model="$ctrl.textValue" rows="{{$ctrl.rows}}"></textarea></div>');
$templateCache.put('app/theme/inputs/textBox/textBox.html','<div class="form-horizontal" ng-if="$ctrl.isHorizontalForm"><div class="input-group row"><label class="col-sm-4" for="name" ng-if="$ctrl.isLabel">{{$ctrl.label}}</label><div class="col-sm-8"><input type="text" class="form-control text-cont" placeholder="{{$ctrl.label}}" ng-model="$ctrl.textValue"></div></div></div><div ng-if="!$ctrl.isHorizontalForm"><label for="name" ng-if="$ctrl.isLabel">{{$ctrl.label}}</label><div class="input-group"><input type="text" class="form-control text-cont" placeholder="{{$ctrl.label}}" ng-model="$ctrl.textValue"></div></div>');
$templateCache.put('app/pages/charts/amCharts/areaChart/areaChart.html','<div id="areaChart" class="admin-chart" ng-controller="AreaChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/funnelChart/funnelChart.html','<div id="funnelChart" class="admin-chart" ng-controller="FunnelChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/ganttChart/ganttChart.html','<div id="gnattChart" class="admin-chart" ng-controller="ganttChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/lineChart/lineChart.html','<div id="lineChart" class="admin-chart" ng-controller="LineChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/pieChart/pieChart.html','<div id="pieChart" class="admin-chart" ng-controller="PieChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/barChart/barChart.html','<div id="barChart" class="admin-chart" ng-controller="BarChartCtrl"></div>');
$templateCache.put('app/pages/charts/amCharts/combinedChart/combinedChart.html','<div id="zoomAxisChart" class="admin-chart" ng-controller="combinedChartCtrl"></div>');
$templateCache.put('app/pages/components/mail/composeBox/compose.html','<div class="compose-header"><span>New message</span> <span class="header-controls"><i class="ion-minus-round"></i> <i class="ion-arrow-resize"></i> <i ng-click="$dismiss()" class="ion-close-round"></i></span></div><div><input type="text" class="form-control compose-input default-color" placeholder="To" ng-model="boxCtrl.to"> <input type="text" class="form-control compose-input default-color" placeholder="Subject" ng-model="boxCtrl.subject"><div class="compose-container"><text-angular-toolbar ta-toolbar-class="toolbarMain" name="toolbarMain" ta-toolbar="[[\'h1\',\'h2\',\'h3\',\'bold\',\'italics\', \'underline\', \'justifyLeft\', \'justifyCenter\', \'justifyRight\', \'justifyFull\']]"></text-angular-toolbar><text-angular name="htmlcontent" ta-target-toolbars="toolbarMain,toolbarFooter" ng-model="boxCtrl.text"></text-angular></div></div><div class="compose-footer clearfix"><button type="button" ng-click="$dismiss()" class="btn btn-send">Send</button><text-angular-toolbar ta-toolbar-class="toolbarFooter" name="toolbarFooter" ta-toolbar="[[\'insertLink\', \'insertImage\', \'html\', \'quote\',\'insertVideo\']]"></text-angular-toolbar><div class="footer-controls"><i class="footer-control-first compose-footer-icon ion-arrow-down-b"></i> <i ng-click="$dismiss()" class="compose-footer-icon ion-android-delete"></i></div></div>');
$templateCache.put('app/pages/components/mail/detail/mailDetail.html','<div class="message-container" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="message"><div class="row"><div class="toggle-navigation-container detail-page"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><button ui-sref="components.mail.label({label : detailCtrl.label})" type="button" class="back-button btn btn-default btn-with-icon"><i class="ion-chevron-left"></i>Back</button></div><div class="person-info row"><div class="col-lg-4 col-md-12 no-padding"><img ng-src="{{detailCtrl.mail.name.split(\' \')[0] | profilePicture}}" class="human-picture"><div class="name"><h2 class="name-h">{{detailCtrl.mail.name.split(\' \')[0]}}</h2><h2 class="name-h second-name">{{detailCtrl.mail.name.split(\' \')[1]}}</h2><div><span class="mail-tag tag label {{detailCtrl.mail.tag}}">{{detailCtrl.mail.tag}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info phone-email"><div><i class="ion-iphone"></i> <span class="phone">777-777-7777</span></div><div><i class="ion-email"></i> <span class="email">{{detailCtrl.mail.email}}</span></div></div></div><div class="col-lg-4 col-md-6 col-xs-12 no-padding"><div class="contact-info position-address"><div><span class="position">{{detailCtrl.mail.position}}</span></div><div><span class="address">12 Nezavisimosti st. Vilnius, Lithuania</span></div></div></div></div><div class="row"></div><div class="line"></div><div class="message-details"><span class="subject">{{detailCtrl.mail.subject}}</span> <span class="date">\u2022 {{detailCtrl.mail.date | date : \'h:mm a MMMM d \'}}</span></div><div class="line"></div><div ng-bind-html="detailCtrl.mail.body" class="message-body"></div><div class="line"></div><div class="attachment" ng-show="detailCtrl.mail.attachment"><span class="file-links">1 Attachment - <a href="">View</a> | <a href="">Download</a></span><div><i class="file-icon ion-document"></i> <span class="file-name">{{detailCtrl.mail.attachment}}</span></div></div><div class="line" ng-show="detailCtrl.mail.attachment"></div><div class="answer-container"><button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,detailCtrl.mail.email,\'\')"><i class="ion-reply"></i>Reply</button> <button type="button" class="btn btn-with-icon" ng-click="tabCtrl.showCompose(detailCtrl.mail.subject,\'\',detailCtrl.mail.body)"><i class="ion-forward"></i>Forward</button> <button type="button" class="btn btn-with-icon"><i class="ion-printer"></i>Print</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-remove-circle"></i>Spam</button> <button type="button" class="btn btn-with-icon"><i class="ion-android-delete"></i>Delete</button></div></div><div ng-show="!detailCtrl.mail"><h5 ng-class="text-center">Nothing to show</h5></div></div>');
$templateCache.put('app/pages/components/mail/list/mailList.html','<div class="side-message-navigation" ng-class="{\'expanded\': tabCtrl.navigationCollapsed}"><div class="mail-messages-control side-message-navigation-item"><div class="toggle-navigation-container"><a href="" class="collapse-navigation-link ion-navicon" ng-click="tabCtrl.navigationCollapsed=!tabCtrl.navigationCollapsed"></a></div><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span class="select-all-label">Select All</span></label> <button type="button" class="btn btn-icon refresh-button"><i class="ion-refresh"></i></button><div class="btn-group" uib-dropdown=""><button type="button" class="btn more-button" uib-dropdown-toggle="">More <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="messages"><table><tr ng-repeat="m in listCtrl.messages track by m.id | orderBy:\'-date\'" class="side-message-navigation-item little-human shineHover {{m.tag}}"><td class="check-td"><div class="mail-checkbox"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox"> <span></span></label></div></td><td class="photo-td" ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><img ng-src="{{m.name.split(\' \')[0] | profilePicture}}" class="little-human-picture"></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="name-container"><div><span class="name">{{m.name}}</span></div><div><span class="tag label label-primary {{m.tag}}">{{m.tag}}</span></div></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="additional-info"><span class="subject">{{m.subject}}</span></div></td><td ui-sref="components.mail.detail({id: m.id, label: listCtrl.label})"><div class="mail-body-part">{{m.body | plainText}}</div></td><td class="date"><span>{{m.date | date : \'MMM d HH:mm\'}}</span></td></tr></table></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/checkboxesRadios.html','<div class="checkbox-demo-row"><div class="input-demo checkbox-demo row"><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox01" value="option1"> <span>Check 1</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox02" value="option2"> <span>Check 2</span></label></div><div class="col-md-4"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Check 3</span></label></div></div><div class="input-demo radio-demo row"><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Option 1</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2"> <span>Option 2</span></label></div><div class="col-md-4"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio3" value="option3"> <span>Option3</span></label></div></div></div><div><div class="checkbox disabled"><label class="custom-checkbox nowrap"><input type="checkbox" value="" disabled=""> <span>Checkbox is disabled</span></label></div><div class="radio disabled"><label class="custom-radio nowrap"><input type="radio" name="optionsRadios" id="optionsRadios3" value="option3" disabled=""> <span>Disabled option</span></label></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/inputGroups.html','<div class="input-group"><span class="input-group-addon input-group-addon-primary addon-left" id="basic-addon1">@</span> <input type="text" class="form-control with-primary-addon" placeholder="Username" aria-describedby="basic-addon1"></div><div class="input-group"><input type="text" class="form-control with-warning-addon" placeholder="Recipient\'s username" aria-describedby="basic-addon2"> <span class="input-group-addon input-group-addon-warning addon-right" id="basic-addon2">@example.com</span></div><div class="input-group"><span class="input-group-addon addon-left input-group-addon-success">$</span> <input type="text" class="form-control with-success-addon" aria-label="Amount (to the nearest dollar)"> <span class="input-group-addon addon-right input-group-addon-success">.00</span></div><div class="input-group"><input type="text" class="form-control with-danger-addon" placeholder="Search for..."> <span class="input-group-btn"><button class="btn btn-danger" type="button">Go!</button></span></div>');
$templateCache.put('app/pages/form/inputs/widgets/standardFields.html','<form><div class="form-group"><label for="input01">Text</label> <input type="text" class="form-control" id="input01" placeholder="Text"></div><div class="form-group"><label for="input02">Password</label> <input type="password" class="form-control" id="input02" placeholder="Password"></div><div class="form-group"><label for="input03">Rounded Corners</label> <input type="text" class="form-control form-control-rounded" id="input03" placeholder="Rounded Corners"></div><div class="form-group"><label for="input04">With help</label> <input type="text" class="form-control" id="input04" placeholder="With help"> <span class="help-block sub-little-text">A block of help text that breaks onto a new line and may extend beyond one line.</span></div><div class="form-group"><label for="input05">Disabled Input</label> <input type="text" class="form-control" id="input05" placeholder="Disabled Input" disabled=""></div><div class="form-group"><label for="textarea01">Textarea</label> <textarea placeholder="Default Input" class="form-control" id="textarea01"></textarea></div><div class="form-group"><input type="text" class="form-control input-sm" id="input2" placeholder="Small Input"></div><div class="form-group"><input type="text" class="form-control input-lg" id="input4" placeholder="Large Input"></div></form>');
$templateCache.put('app/pages/form/inputs/widgets/validationStates.html','<div class="form-group has-success"><label class="control-label" for="inputSuccess1">Input with success</label> <input type="text" class="form-control" id="inputSuccess1"></div><div class="form-group has-warning"><label class="control-label" for="inputWarning1">Input with warning</label> <input type="text" class="form-control" id="inputWarning1"></div><div class="form-group has-error"><label class="control-label" for="inputError1">Input with error</label> <input type="text" class="form-control" id="inputError1"></div><div class="has-success"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxSuccess" value="option1"> <span>Checkbox with success</span></label></div></div><div class="has-warning"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxWarning" value="option1"> <span>Checkbox with warning</span></label></div></div><div class="has-error"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox" id="checkboxError" value="option1"> <span>Checkbox with error</span></label></div></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputSuccess2">Input with success</label> <input type="text" class="form-control" id="inputSuccess2" aria-describedby="inputSuccess2Status"> <i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputSuccess2Status" class="sr-only">(success)</span></div><div class="form-group has-warning has-feedback"><label class="control-label" for="inputWarning2">Input with warning</label> <input type="text" class="form-control" id="inputWarning2" aria-describedby="inputWarning2Status"> <i class="ion-alert-circled form-control-feedback" aria-hidden="true"></i> <span id="inputWarning2Status" class="sr-only">(warning)</span></div><div class="form-group has-error has-feedback"><label class="control-label" for="inputError2">Input with error</label> <input type="text" class="form-control" id="inputError2" aria-describedby="inputError2Status"> <i class="ion-android-cancel form-control-feedback" aria-hidden="true"></i> <span id="inputError2Status" class="sr-only">(error)</span></div><div class="form-group has-success has-feedback"><label class="control-label" for="inputGroupSuccess1">Input group with success</label><div class="input-group"><span class="input-group-addon addon-left">@</span> <input type="text" class="form-control" id="inputGroupSuccess1" aria-describedby="inputGroupSuccess1Status"></div><i class="ion-checkmark-circled form-control-feedback" aria-hidden="true"></i> <span id="inputGroupSuccess1Status" class="sr-only">(success)</span></div>');
$templateCache.put('app/pages/form/layouts/widgets/basicForm.html','<form><div class="form-group"><label for="exampleInputEmail1">Email address</label> <input type="email" class="form-control" id="exampleInputEmail1" placeholder="Email"></div><div class="form-group"><label for="exampleInputPassword1">Password</label> <input type="password" class="form-control" id="exampleInputPassword1" placeholder="Password"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Check me out</span></label></div><button type="submit" class="btn btn-danger">Submit</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/blockForm.html','<div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">First Name</label> <input type="text" class="form-control" id="inputFirstName" placeholder="First Name"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputLastName">Last Name</label> <input type="text" class="form-control" id="inputLastName" placeholder="Last Name"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label for="inputFirstName">Email</label> <input type="email" class="form-control" id="inputEmail" placeholder="Email"></div></div><div class="col-sm-6"><div class="form-group"><label for="inputWebsite">Website</label> <input type="text" class="form-control" id="inputWebsite" placeholder="Website"></div></div></div><button type="submit" class="btn btn-primary">Submit</button>');
$templateCache.put('app/pages/form/layouts/widgets/formWithoutLabels.html','<form><div class="form-group"><input type="text" class="form-control" placeholder="Recipients"></div><div class="form-group"><input type="text" class="form-control" placeholder="Subject"></div><div class="form-group"><textarea class="form-control" placeholder="Message"></textarea></div><button type="submit" class="btn btn-success">Send</button></form>');
$templateCache.put('app/pages/form/layouts/widgets/horizontalForm.html','<form class="form-horizontal"><div class="form-group"><label for="inputEmail3" class="col-sm-2 control-label">Email</label><div class="col-sm-10"><input type="email" class="form-control" id="inputEmail3" placeholder="Email"></div></div><div class="form-group"><label for="inputPassword3" class="col-sm-2 control-label">Password</label><div class="col-sm-10"><input type="password" class="form-control" id="inputPassword3" placeholder="Password"></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div></div></div><div class="form-group"><div class="col-sm-offset-2 col-sm-10"><button type="submit" class="btn btn-warning">Sign in</button></div></div></form>');
$templateCache.put('app/pages/form/layouts/widgets/inlineForm.html','<form class="row form-inline"><div class="form-group col-sm-3 col-xs-6"><input type="text" class="form-control" id="exampleInputName2" placeholder="Name"></div><div class="form-group col-sm-3 col-xs-6"><input type="email" class="form-control" id="exampleInputEmail2" placeholder="Email"></div><div class="checkbox"><label class="custom-checkbox"><input type="checkbox"> <span>Remember me</span></label></div><button type="submit" class="btn btn-primary">Send invitation</button></form>');
$templateCache.put('app/pages/mangevendor/outlet/outletdetails/outletdetails.html','');
$templateCache.put('app/pages/mangevendor/outlet/outletmenu/outletmenu.html','');
$templateCache.put('app/pages/mangevendor/outlet/outletoffer/outletoffer.html','');
$templateCache.put('app/pages/mangevendor/outlet/outletsettings/outletsettings.html','<div class="row"><div class="col-md-12"><p>sdfsdfsadfsdf</p></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttonGroups.html','<div class="btn-group-example"><div class="btn-group" role="group" aria-label="Basic example"><button type="button" class="btn btn-danger">Left</button> <button type="button" class="btn btn-danger">Middle</button> <button type="button" class="btn btn-danger">Right</button></div></div><div class="btn-toolbar-example"><div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups"><div class="btn-group" role="group" aria-label="First group"><button type="button" class="btn btn-primary">1</button> <button type="button" class="btn btn-primary">2</button> <button type="button" class="btn btn-primary">3</button> <button type="button" class="btn btn-primary">4</button></div><div class="btn-group" role="group" aria-label="Second group"><button type="button" class="btn btn-primary">5</button> <button type="button" class="btn btn-primary">6</button> <button type="button" class="btn btn-primary">7</button></div><div class="btn-group" role="group" aria-label="Third group"><button type="button" class="btn btn-primary">8</button></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/buttons.html','<div class="basic-btns"><div class="row"><div class="col-md-2"><h5>Default button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-sm">Small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-sm">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-sm">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-sm">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-sm">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-sm">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-sm">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5 class="row-xs">Extra small button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary btn-xs">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default btn-xs">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success btn-xs">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info btn-xs">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning btn-xs">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger btn-xs">Danger</button></div></div></div></div><div class="row"><div class="col-md-2"><h5>Disabled button</h5></div><div class="col-md-10"><div class="row btns-row btns-same-width-md"><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-primary" disabled="disabled">Primary</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-default" disabled="disabled">Default</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-success" disabled="disabled">Success</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-info" disabled="disabled">Info</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-warning" disabled="disabled">Warning</button></div><div class="col-sm-2 col-xs-4"><button type="button" class="btn btn-danger" disabled="disabled">Danger</button></div></div></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/dropdowns.html','<div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary" uib-dropdown-toggle="">Primary <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success" uib-dropdown-toggle="">Success <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info" uib-dropdown-toggle="">Info <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default" uib-dropdown-toggle="">Default <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning" uib-dropdown-toggle="">Warning <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger" uib-dropdown-toggle="">Danger <span class="caret"></span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div><h5 class="panel-subtitle">Split button dropdowns</h5><div class="row btns-row"><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-primary">Primary</button> <button type="button" class="btn btn-primary" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-success">Success</button> <button type="button" class="btn btn-success" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-info">Info</button> <button type="button" class="btn btn-info" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default">Default</button> <button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-warning">Warning</button> <button type="button" class="btn btn-warning" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div><div class="col-sm-4 col-xs-6"><div class="btn-group" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-danger">Danger</button> <button type="button" class="btn btn-danger" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li><a href="">Action</a></li><li><a href="">Another action</a></li><li><a href="">Something else here</a></li><li role="separator" class="divider"></li><li><a href="">Separated link</a></li></ul></div></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/iconButtons.html','<ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-icon"><i class="ion-android-download"></i></button></li><li><button type="button" class="btn btn-default btn-icon"><i class="ion-stats-bars"></i></button></li><li><button type="button" class="btn btn-success btn-icon"><i class="ion-android-checkmark-circle"></i></button></li><li><button type="button" class="btn btn-info btn-icon"><i class="ion-information"></i></button></li><li><button type="button" class="btn btn-warning btn-icon"><i class="ion-android-warning"></i></button></li><li><button type="button" class="btn btn-danger btn-icon"><i class="ion-nuclear"></i></button></li></ul><h5 class="panel-subtitle">Buttons with icons</h5><ul class="btn-list clearfix"><li><button type="button" class="btn btn-primary btn-with-icon"><i class="ion-android-download"></i>Primary</button></li><li><button type="button" class="btn btn-default btn-with-icon"><i class="ion-stats-bars"></i>Default</button></li><li><button type="button" class="btn btn-success btn-with-icon"><i class="ion-android-checkmark-circle"></i>Success</button></li><li><button type="button" class="btn btn-info btn-with-icon"><i class="ion-information"></i>Info</button></li><li><button type="button" class="btn btn-warning btn-with-icon"><i class="ion-android-warning"></i>Warning</button></li><li><button type="button" class="btn btn-danger btn-with-icon"><i class="ion-nuclear"></i>Danger</button></li></ul>');
$templateCache.put('app/pages/ui/buttons/widgets/largeButtons.html','<div class="row btns-row btns-same-width-lg"><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-primary btn-lg">Primary</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-success btn-lg">Success</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-info btn-lg">Info</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-default btn-lg">Default</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-warning btn-lg">Warning</button></div><div class="col-sm-4 col-xs-6"><button type="button" class="btn btn-danger btn-lg">Danger</button></div></div>');
$templateCache.put('app/pages/ui/buttons/widgets/progressButtons.html','<div class="progress-buttons-container text-center default-text"><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">fill horizontal</span> <button progress-button="progressFunction()" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">fill vertical</span> <button progress-button="progressFunction()" pb-direction="vertical" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink horizontal</span> <button progress-button="progressFunction()" pb-style="shrink" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">shrink vertical</span> <button progress-button="progressFunction()" pb-style="shrink" pb-direction="vertical" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-bottom<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-bottom" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-top<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-top" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-angle-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-angle-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-down<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-down" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-up<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-up" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-left<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-left" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">rotate-side-right<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-side-right" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6 col-lg-3"><span class="button-title">rotate-back<br>perspective</span> <button progress-button="progressFunction()" pb-style="rotate-back" class="btn btn-success">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">flip-open<br>perspective</span> <button progress-button="progressFunction()" pb-style="flip-open" class="btn btn-danger">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">slide-down<br>horizontal</span> <button progress-button="progressFunction()" pb-style="slide-down" class="btn btn-warning">Submit</button></section><section class="col-md-6 col-lg-3"><span class="button-title">move-up<br>horizontal</span> <button progress-button="progressFunction()" pb-style="move-up" class="btn btn-info">Submit</button></section></div><div class="row"><section class="col-md-6"><span class="button-title">top-line<br>horizontal</span> <button progress-button="progressFunction()" pb-style="top-line" class="btn btn-success">Submit</button></section><section class="col-md-6"><span class="button-title">lateral-lines<br>vertical</span> <button progress-button="progressFunction()" pb-style="lateral-lines" class="btn btn-info">Submit</button></section></div></div>');
$templateCache.put('app/pages/ui/icons/widgets/fontAwesomeIcons.html','<div class="row icons-list success awesomeIcons"><div class="col-xs-2" ng-repeat="icon in icons.fontAwesomeIcons"><i class="fa {{icon}}"></i></div></div><a href="http://fortawesome.github.io/Font-Awesome/icons/" target="_blank" class="see-all-icons">See all Font Awesome icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/ionicons.html','<div class="row icons-list primary"><div class="col-xs-2" ng-repeat="icon in icons.ionicons"><i class="{{icon}}"></i></div></div><a href="http://ionicons.com/" target="_blank" class="see-all-icons">See all ionicons icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleon.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonIcons"><div class="kameleon-icon"><img ng-src="{{:: (icon.img | kameleonImg )}}"><span>{{icon.name}}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/kameleonRounded.html','<div class="row clearfix"><div class="kameleon-row" ng-repeat="icon in icons.kameleonRoundedIcons"><div class="kameleon-icon with-round-bg {{icon.color}}"><img ng-src="{{::( icon.img | kameleonImg )}}"><span>{{ icon.name }}</span></div></div></div><a href="http://www.kameleon.pics/" target="_blank" class="see-all-icons">See all Kamaleon icons</a>');
$templateCache.put('app/pages/ui/icons/widgets/socicon.html','<div class="row icons-list danger"><div class="col-xs-2" ng-repeat="icon in icons.socicon"><i class="socicon">{{ icon }}</i></div></div><a href="http://www.socicon.com/chart.php" target="_blank" class="see-all-icons">See all Socicon icons</a>');
$templateCache.put('app/pages/ui/modals/modalTemplates/basicModal.html','<div class="modal-content"><div class="modal-header"><div class="row"><div class="col-md-8"><h4 class="orange-text">ENQUIRY - PROCESSING</h4></div><div class="col-md-4"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div></div></div><div class="modal-body p-0"><uib-tabset active="$tabSetStatus.activeTab" class="enquireTabs one-tab account_informat"><uib-tab heading="STEP1 - ACCOUNT INFORMATION"><div class="row"><div class="col-md-12 accout-inf"><p class="f-18px">ACCOUNT INFORMATION</p></div></div><div class="dash-bg panel-warning change-bg m-b-5 ng-scope"><div class="panel-body top-box-bg p-0"><div class="row background-underdetails"><div class="col-sm-12"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>YOUR NAME</b></label> <input type="text" class="form-control pl-0 inputBorderBtm" id="inputLastName" placeholder=""></div></div><div class="col-sm-12"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>POSITION</b></label> <input type="text" class="form-control pl-0 inputBorderBtm" id="inputLastName"></div></div><div class="col-sm-12"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>MOBILE NUMBER</b></label> <input type="text" class="form-control pl-0 inputBorderBtm" id="inputLastName"></div></div><div class="col-sm-12"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>EMAIL ADDRESS</b></label> <input type="text" class="form-control pl-0 inputBorderBtm" id="inputLastName"></div></div><div class="col-sm-12"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>PASSWORD</b></label> <input type="text" class="form-control pl-0 inputBorderBtm" id="inputLastName"></div></div><div class="col-md-12 text-right"><a href="" class="font-montser changePass">CHANGE PASSWORD?</a></div></div></div></div><div class="row"><div class="col-md-12 accout-inf"><p class="f-18px">ORANGIZATION DETAILS</p></div></div><div class="dash-bg panel-warning change-bg m-b-5 ng-scope"><div class="panel-body top-box-bg p-0"><div class="row background-underdetails"><div class="col-sm-12"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>YOUR BAND / COMPANY NAME</b></label> <input type="text" class="form-control pl-0 inputBorderBtm" id="inputLastName" placeholder=""></div></div><div class="col-sm-12"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>ADDRESS</b></label> <input type="text" class="form-control pl-0 inputBorderBtm" id="inputLastName"></div></div><div class="col-sm-12"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>WEBSITE</b></label> <input type="text" class="form-control pl-0 inputBorderBtm" id="inputLastName"></div></div><div class="col-sm-12"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>EMAIL ADDRESS</b></label> <input type="text" class="form-control pl-0 inputBorderBtm" id="inputLastName"></div></div><div class="col-md-12"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>DRAG AND MARK YOUR CORPORATE OFFICE LOCATION ON THE MAP</b></label><div style="width: 100%"><iframe width="100%" height="400" src="https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=en&amp;q=1%20Grafton%20Street%2C%20Dublin%2C%20Ireland+(Voucher4U)&amp;ie=UTF8&amp;t=&amp;z=14&amp;iwloc=B&amp;output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"><a href="#"></a></iframe></div></div></div></div></div></div><div class="text-right"><button type="button" class="btn btn-primary modalBtn nextBtns next-tab" rel="1">NEXT</button></div></uib-tab><uib-tab heading="STEP2 - BUSINESS DETAILS"><div class="row"><div class="col-md-12 accout-inf"><p class="f-18px">PROVIDE BUSINESS DETAILS</p></div></div><div class="row background-underdetails font-montser"><div class="col-md-12"><p class="catorgriesDetails">CATEGORIES IN WHICH YOU DEAL IN:</p></div><div class="col-md-12"><div class="row mb-20"><div class="col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Food & Beverages</span></label></div><div class="col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Leisure & Attractions</span></label></div><div class="col-md-2"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Wellness & Beauty</span></label></div></div><div class="row pb-20"><div class="col-md-2"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Retail & Services</span></label></div></div></div></div><div class="input-demo inputDemos background-underdetails radio-demo row"><div class="col-md-12"><p class="catorgriesDetails">ORANGIZATION MODAL :</p></div><div class="col-md-12 font-montser"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span><b>Are you a Standalone Outlet?</b></span><p class="radioText">Select this option if you are a sing standalone/outlet and deals in brands or your own products.</p></label></div><div class="col-md-12 font-montser"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span><b>Are you a Brand with mulitple Outlets?</b></span><p class="radioText">Select this option if you are brand with multiple outlets. You can registrer all your outlets under your brand here.</p></label></div><div class="col-md-12 font-montser"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span><b>Are you a Collection of different Outlets?</b></span><p class="radioText">Select this option if you are a collection of multiple outlets. You can register all your outlets under your collection name here.</p></label></div><div class="col-md-12 font-montser"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span><b>Are you a group of Brands with multiple Outlets?</b></span><p class="radioText">Select this option if you are part of any chain of outlets. You can register your partner outlet here and connect it with your franchisor brand</p></label></div><div class="col-md-12 font-montser"><label class="radio-inline custom-radio nowrap"><input type="radio" name="othersRadio" id="watch-me" value="option1"> <span id=""><b>Other</b> <span><input type="text" class="othersInput" placeholder="Please specify"></span></span></label></div></div><div class="row background-underdetails font-montser pb-20 mt-20"><div class="col-md-12"><p class="catorgriesDetails">DOES ANY ONE OF YOUR OUTLET OPERATES UNDER FRANCHISE MODEL?</p></div><div class="col-md-2 font-montser"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="www" value="option1"> <span><b>YES</b></span></label></div><div class="col-md-2 font-montser"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1w" value="option1"> <span><b>NO</b></span></label></div></div><div class="row background-underdetails font-montser pb-20 mt-20"><div class="col-md-12"><p class="catorgriesDetails">BRANDS IN WHICH YOU DEAL IN</p></div><div class="col-md-6 font-montser"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="www" value="option1"> <span><b>Deals in Single Brand or own products?</b></span></label></div><div class="col-md-6 font-montser"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1w" value="option1"> <span><b>Deals in multiple brands?</b></span></label></div></div><div class="row font-montser textbrands"><div class="col-md-4"><p class="color-white"><b>BRANDS</b></p></div><div class="col-md-4 text-center"><p class="color-white"><b>NUMBER OF OUTLETS</b></p></div><div class="col-md-4 text-right"><p class="color-white"><b>EDIT/UPDATE</b></p></div></div><div class="row background-underdetails pb-20 p-t-0 p-l-0 font-montser ng-scope"><div class="col-md-12 p-0 mb-20"><table class="table abuDhai m-0"><thead><tr class="banner-bg"><th></th><th>Abu Dhabi Emirates<br>(incl Al-Din)</th><th>Sharjah</th><th>Dubai</th><th>Fujaria</th><th>Ras Al<br>Khamia</th><th>Umm All<br>Quwain</th><th>UAE Total</th><th></th></tr></thead><tbody><tr><td>Tim Hortons</td><td>10</td><td>6</td><td>4</td><td>1</td><td>4</td><td>5</td><td>30</td><td><img src="assets/images/edit_icon.png" alt="edit-icons" class="editIcons mr-10"> <img src="assets/images/close.png" alt="closeIcons"></td></tr><tr><td>Bu</td><td>10</td><td>6</td><td>4</td><td>1</td><td>4</td><td>5</td><td>30</td><td><img src="assets/images/edit_icon.png" alt="edit-icons" class="editIcons mr-10"> <img src="assets/images/close.png" alt="closeIcons"></td></tr></tbody></table></div><div class="col-md-3"><input type="text" class="form-control pl-0" placeholder="BRAND NAME"></div><div class="col-md-3"><div class="selectCust"><select class="form-control head-bg-w" id="sel1"><option>-- SELECT EMIRATE --</option><option value="1">EMIRATE</option><option value="2">EMIRATE</option><option value="3">EMIRATE</option></select></div></div><div class="col-md-3"><input type="text" class="form-control pl-0" placeholder="NUMBER OF OUTLETS"></div><div class="col-md-3"><div class="btn-group"><div class="btn-group uploadflo"><label class="btn fileUpload"><a href="" class="btn btn-default" style="border:0px">Upload Brand Logo</a> <img src="assets/images/uploads.png" alt="uploads" class="mr-4 float-r"> <input type="file" class="typeFiles" style="display: none;"></label></div></div><button class="btn btn-primary modalBtn addMoreFile addedBtn">ADD</button></div></div><div class="row font-montser"><div class="col-md-12 accout-inf"><p class="catorgriesDetails font-montser">MENU AND PRICES</p></div></div><div class="row background-underdetails bg-white pb-20 p-t-0 p-l-0 font-montser ng-scope"><div class="col-md-12 p-0"><table class="table ml-0 abuDhai"><thead class="headtable-bg"><tr class=""><th>ITEM</th><th>DETAILS</th><th>CUSINE</th><th>PRICE</th><th>MEAL TIME</th><th class="text-center">EDIT/UPDATE</th></tr></thead><tbody><tr><td><img src="assets/images/pp1.jpg" alt="chicken" class="itemImage"> <span>Fried chicken</span></td><td>Logo</td><td>AMERICA</td><td>10AED</td><td>Lunch</td><td class="text-center"><img src="assets/images/edit_icon.png" alt="edit-icons" class="editIcons mr-10"> <img src="assets/images/close.png" alt="closeIcons"></td></tr><tr><td><img src="assets/images/pp1.jpg" alt="chicken" class="itemImage"> <span>Fried chicken</span></td><td>Achoice of french fires or salad</td><td>AMERICA</td><td>10AED</td><td>Lunch</td><td class="text-center"><img src="assets/images/edit_icon.png" alt="edit-icons" class="editIcons mr-10"> <img src="assets/images/close.png" alt="closeIcons"></td></tr></tbody></table></div><div class="w-14 cols-md"><input type="text" class="form-control ml-15 pl-0" placeholder="ITEM NAME"></div><div class="w-14 cols-md"><input type="text" class="form-control ml-15 pl-0" placeholder="DETAILS"></div><div class="w-14 cols-md"><div class="selectCust"><select class="form-control" id="sel1"><option>CUISINE</option><option>2</option><option>3</option><option>4</option></select></div></div><div class="w-14 cols-md"><input type="text" class="form-control ml-15 pl-0" placeholder="PRICE IN AED"></div><div class="w-14 cols-md"><div class="selectCust"><select class="form-control" id="sel1"><option>MEAL TIME</option><option>2</option><option>3</option><option>4</option></select></div></div><div class="w-28 cols-md"><div class="btn-group"><div class="btn-group w-100"><label class="btn newimages w-100 text-left"><a href="" class="btn btn-default ulpData">Upload Image</a> <img src="assets/images/uploads.png" alt="uploads" class="float-r"> <input type="file" class="typeFiles" style="display: none;"></label></div></div><button class="btn btn-primary modalBtn addMoreFile addedBtn"><i class="fa fa-plus" aria-hidden="true"></i> ADD</button></div><div class="col-md-12"><p class="text-center mt-20 orText">OR</p></div><div class="col-md-8 text-right"><div class="btn-group ulpoad-cins"><div class="btn-group w-100"><label class="btn w-100 text-left"><a href="" class="btn btn-default ulpData bg-trans">Upload Menu Image</a> <img src="assets/images/uploads.png" alt="uploads" class="mr-4 float-r"> <input type="file" class="typeFiles" style="display: none;"></label></div></div></div><div class="col-md-4"><button class="btn btn-primary modalBtn border-Radus-none"><i class="fa fa-plus" aria-hidden="true"></i> ADD</button></div></div><div class="row font-montser"><div class="col-md-12 accout-inf"><p class="catorgriesDetails font-montser">ADDITIONAL INFORMATION</p></div><div class="col-md-12 p-0"><table class="table ml-0 abuDhai"><thead class="headtable-bg"><tr class=""><th>TITLE</th><th>DETAILS</th><th class="text-center">ATTACHEMEMT</th><th class="text-center">EDIT/UPDATE</th></tr></thead><tbody><tr><td>Logo</td><td>CORPORATE OFFICIAL LOGO</td><td class="text-center"><img src="assets/images/fileIcon.png" alt="fileIcon"></td><td class="text-center"><img src="assets/images/edit_icon.png" alt="edit-icons" class="editIcons mr-10"> <img src="assets/images/close.png" alt="closeIcons"></td></tr><tr><td>About us</td><td>ABOUT OUR CORPORATE</td><td class="text-center"><img src="assets/images/fileIcon.png" alt="fileIcon"></td><td class="text-center"><img src="assets/images/edit_icon.png" alt="edit-icons" class="editIcons mr-10"> <img src="assets/images/close.png" alt="closeIcons"></td></tr><tr><td>Promotional Photo</td><td>ABOUT OUR CORPORATE</td><td class="text-center"><img src="assets/images/fileIcon.png" alt="fileIcon"></td><td class="text-center"><img src="assets/images/edit_icon.png" alt="edit-icons" class="editIcons mr-10"> <img src="assets/images/close.png" alt="closeIcons"></td></tr></tbody></table></div></div><div class="row mt-20 font-montser"><div class="col-md-4"><input type="text" class="form-control ml-15 pl-0" placeholder="ADD TITLE"></div><div class="col-md-4"><input type="text" class="form-control pl-0" placeholder="ADD DETAILS"></div><div class="col-md-4"><div class="btn-group"><div class="btn-group uploadflo w-270"><label class="btn fileUpload w-100"><a href="" class="btn btn-default float-l" style="border:0px">Upload File</a> <img src="assets/images/uploads.png" alt="uploads" class="mr-4 float-r"> <input type="file" class="typeFiles" style="display: none;"></label></div></div><button class="btn btn-primary modalBtn addMoreFile addedBtn"><i class="fa fa-plus" aria-hidden="true"></i> ADD</button></div></div><div class="row"><div class="col-lg-12 text-right"><button type="button" class="btn btn-primary modalBtn mr-30">BACK</button> <button type="button" class="btn btn-primary modalBtn">NEXT</button></div></div></uib-tab><uib-tab heading="STEP3 - SUBMIT FOR REVIEW"><div class="row"><div class="col-md-12 accout-inf"><p class="f-18px pull-left p-t-10">CONFIRM DETAILS</p><button type="button" class="m-0 btn btn-primary modalBtn pull-right">SKIP</button></div></div><div class="row"><div class="col-md-7"><p class="orstand">ORANGIZATION MODEL: STANDALONE OUTLET</p></div><div class="col-md-5 text-right"><p class="orText m-0 f14 pt-20"><b>OUTLET CODE: V4UUAE0TM0001</b></p></div></div><div class="row mt-20 namedetais"><div class="col-md-12"><p class="catorgriesDetails">ACCOUNT INFORMATION</p></div><div class="col-md-4"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>NAME</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>PASSWORD</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>POSITION</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>MODAL TYPE</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>EMIRATE / REGION</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>STREET ADDRESS</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>PHONE NUMBER</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>EMAIL</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>OUTLET / BRAND WEBSITE</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div></div><div class="row background-underdetails font-montser"><div class="col-md-12"><p><b>CATEGORIES IN WHICH YOU DEAL IN:</b></p></div><div class="col-md-12"><div class="row mb-20"><div class="col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Food & Beverages</span></label></div><div class="col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Leisure & Attractions</span></label></div><div class="col-md-2"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Wellness & Beauty</span></label></div></div><div class="row pb-20"><div class="col-md-2"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Retail & Services</span></label></div></div></div></div><div class="row background-underdetails font-montser pb-20 mt-20 mb-20"><div class="col-md-12"><p><b>DOES YOUR OUTLET BUSINESS OPERATE UNDER FRANCHISE MODEL?</b></p></div><div class="col-md-2 font-montser"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="www" value="option1"> <span><b>YES</b></span></label></div><div class="col-md-2 font-montser"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1w" value="option1"> <span><b>NO</b></span></label></div></div><div class="row font-montser textbrands"><div class="col-md-6"><p class="color-white"><b>BRANDS</b></p></div><div class="col-md-6"><p class="color-white"><b>NUMBER OF OUTLETS</b></p></div></div><div class="row font-montser"><div class="col-md-12"><table class="table abuDhai"><thead><tr class=""><th></th><th>Abu Dhabi Emirates<br>(incl Al-Din)</th><th>Sharjah</th><th>Dubai</th><th>Fujaria</th><th>Ras Al<br>Khamia</th><th>Umm All<br>Quwain</th><th>UAE Total</th></tr></thead><tbody><tr><td>Tim Hortons</td><td>10</td><td>6</td><td>4</td><td>1</td><td>4</td><td>5</td><td>30</td></tr><tr><td>Bu</td><td>10</td><td>6</td><td>4</td><td>1</td><td>4</td><td>5</td><td>30</td></tr></tbody></table></div></div><div class="row font-montser"><div class="col-md-12"><p class="pt-30"><b>MENU AND PRICES</b></p></div><div class="col-md-12 p-0"><table class="table ml-0 abuDhai"><thead class="headtable-bg"><tr class=""><th>ITEM</th><th>DETAILS</th><th>CUISINE</th><th>PRICE</th><th>MEAL TIME</th></tr></thead><tbody><tr><td><img src="assets/images/pp1.jpg" alt="chicken" class="itemImage"> <span>Fried chicken</span></td><td>Achoice of french fires or salad</td><td>AMERICA</td><td>10AED</td><td>Lunch</td></tr><tr><td><img src="assets/images/pp1.jpg" alt="chicken" class="itemImage"> <span>Fried chicken</span></td><td>Achoice of french fires or salad</td><td>AMERICA</td><td>10AED</td><td>Lunch</td></tr></tbody></table></div><div class="col-md-12"><p class="pt-30"><b>MENU IMAGES</b></p></div><div class="col-md-12 mb-20"><label class="checkbox-inline custom-checkbox nowrap customCheck"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span><img src="assets/images/fileIcon.png" alt="images"> Menu_1.jpp</span></label></div><div class="col-md-12 mb-20"><label class="checkbox-inline custom-checkbox nowrap customCheck"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span><img src="assets/images/fileIcon.png" alt="images"> Menu_1.jpp</span></label></div></div><div class="row font-montser"><div class="col-md-12"><p class="pt-30"><b>ADDITIONAL INFORMATION</b></p></div><div class="col-md-12 p-0"><table class="table ml-0 abuDhai firstBold"><thead class="headtable-bg"><tr class=""><th>TITLE</th><th>DETAILS</th><th class="text-center">ATTACHEMEMT</th></tr></thead><tbody><tr><td>Logo</td><td>CORPORATE OFFICIAL LOGO</td><td class="text-center"><img src="assets/images/fileIcon.png" alt="fileIcon"></td></tr><tr><td>About us</td><td>ABOUT OUR CORPORTAE</td><td class="text-center"><img src="assets/images/fileIcon.png" alt="fileIcon"></td></tr><tr><td>Promotional Photo</td><td>RESTAURANT PHOTO</td><td class="text-center"><img src="assets/images/fileIcon.png" alt="fileIcon"></td></tr></tbody></table></div></div><div class="row"><div class="col-lg-12 text-right"><button type="button" class="btn btn-primary modalBtn mr-30" ng-click="showErrorMsg()">BACK</button> <button type="button" class="btn btn-primary modalBtn" ng-click="showSuccessMsg()">SUBMIT</button></div></div></uib-tab></uib-tabset></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/contractsignoff.html','<div class="container-fluid p-3"><div class="row"><div class="col-lg-12"><p class="visitAll color-theme">BRIEF CONTRACTS</p></div></div><div class="row namedetais brief-detials-infor bg-white m-10"><div class="col-md-12"><p class="orstand outsandart argee-text color-black pt-0">AN AGREEMENT BETWEEN VOUCHED4U AND TIM HORTONS</p></div></div><div class="row namedetais brief-detials-infor bg-white m-10"><div class="col-md-12"><p class="font-w color-black">ACCOUNT INFORMATION</p></div><div class="col-md-4"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>NAME</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder="Peter Sampras"></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>NUMBER OF OUTLETS</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder="10"></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>YOUR POSITION</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder="Owner"></div></div><div class="col-md-4"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>PHONE</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder="0175-253-1256-425"></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>EMAIL ID</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder="test@test.com"></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>OUTLET / BRAND / WEBSITE</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder="www.test.com"></div></div></div><div class="row namedetais brief-detials-infor bg-white m-10"><div class="col-md-12"><p class="font-w color-black">PAYMENT TERMS</p></div><div class="col-md-3"><div class="font-montser"><label for="inputLastName" class="color-black mt-15"><b>SELECT PAYMENT MODE</b></label></div></div><div class="col-md-3"><div class="form-group font-montser"><div class="selectCust selectoutlets h-48 height-var"><select id="" class="form-control mb-10 border-sel" name="business"><option value="First Choice">Yearly</option><option value="Second Choice">Monthly</option><option value="Third Choice">Weekly</option></select></div></div></div><div class="col-md-3"><div class="font-montser text-right"><label for="inputLastName" class="color-black mt-15"><b>CONTRACT TERM</b></label></div></div><div class="col-md-2"><div class="form-group font-montser"><div class="selectCust selectoutlets h-48 height-var"><select id="" class="form-control mb-10 border-sel" name="business"><option value="First Choice">1</option><option value="Second Choice">2</option><option value="Third Choice">3</option></select></div></div></div><div class="col-md-1"><div class="form-group font-montser"><p class="font-w mt-15 color-theme">years</p></div></div><div class="col-md-3"><div class="font-montser"><label for="inputLastName" class="color-black mt-15"><b>SELECT PAYMENT MODE</b></label></div></div><div class="col-md-3"><div class="form-group font-montser"><p class="col-md-3 input-group calendar-vendor"><input type="text" class="form-control w-100" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dtt" is-open="openedTo" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="openTo()"><img src="assets/images/calendar-icons.png" alt="calendar-icons"></button></span></p></div></div></div><div class="row namedetais brief-detials-infor bg-white m-10"><div class="col-md-12"><p class="font-w color-black">TERMS & CONDITIONS</p></div><div class="col-md-6"><p class="grer-color">1. The Terms & Conditions is valid for</p><p class="grer-color">2. All the terms are to be mutually ...</p></div></div><div class="row namedetais brief-detials-infor bg-white m-10 mb30"><div class="col-md-12"><p class="font-w color-black">ANY OTHER CONTRACT INFORMATION</p></div><div class="col-md-12"><p class="grer-color">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p><p class="color-black">Can even upload prepared the contract here.. <a href="#"><img src="assets/images/uploads.png" class="ml-15"></a></p></div></div><div class="row pull-right"><div class="col-lg-12 mt-20 mb30"><button type="button" class="b-rad-30 boder-radu btn vendor-btn btn-info btn-with-icon mr-20">PREVIEW</button> <button type="button" class="b-rad-30 boder-radu btn vendor-btn btn-info btn-with-icon mr-20">SAVE CONTRACT</button></div></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/customersectionmodal.html','<div class="container-fluid"><div class="row white-bg"><div class="col-md-12"><h5 class="cust-sec">CUSTOMER SECTION</h5><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="CUSTOMER DETAILS" ui-sref="ui.modals.modelTemplates"><h5 class="cust-sec">ACCOUNT INFORMATION</h5><div class="row f-m bg-grey7 p-30"><div class="col-md-2 mb-25"><p class="mt-b-10">FIRST NAME:</p></div><div class="col-md-10 mb-25"><input type="text" class="form-control" id="pwd" placeholder="Desmond"></div><div class="col-md-2 mb-25"><p class="mt-b-10">LAST NAME:</p></div><div class="col-md-10 mb-25"><input type="text" class="form-control" id="pwd" placeholder="Mensah"></div><div class="col-md-2 mb-25"><p class="mt-b-10">MOBILE NUMBER:</p></div><div class="col-md-10 mb-25"><input type="text" class="form-control" id="pwd" placeholder="0175-253-2456-125"></div><div class="col-md-2 mb-25"><p class="mt-b-10">EMAIL ADDRESS:</p></div><div class="col-md-10 mb-25"><input type="text" class="form-control" id="pwd" placeholder="test@test.com"></div><div class="col-md-2 mb-25"><p class="mt-b-10">DATE OF BIRTH :</p></div><div class="col-md-10 mb-25"><input type="text" class="form-control" id="pwd" placeholder="12/7/1951"></div><div class="col-md-2 mb-25"><p class="mt-b-10">NATIONALITY :</p></div><div class="col-md-10 mb-25"><input type="text" class="form-control" id="pwd" placeholder="American"></div><div class="col-md-2 mb-25"><p class="mt-b-10">GENDER:</p></div><div class="col-md-10 mb-25"><input type="text" class="form-control" id="pwd" placeholder="Male"></div><div class="col-md-2 mb-25"><p class="mt-b-10">ADDRESS:</p></div><div class="col-md-10 mb-25"><input type="text" class="form-control" id="pwd" placeholder="123, Burj Kalifa"></div><div class="col-md-2 mb-25"><p class="mt-b-10"></p></div><div class="col-md-10 mb-25"><input type="text" class="form-control" id="pwd" placeholder="Adu Dhabi"></div><div class="col-md-2 mb-25"><p class="mt-b-10"></p></div><div class="col-md-10 mb-25"><input type="text" class="form-control" id="pwd" placeholder="United Arab Emirates"></div></div><div class="row"><div class="col-md-12 pad-cust bg-grey7"><h5 class="cust-sec grey-bg mb-25">CUSTOMER PREFERENCES</h5><div class="col-md-12 mar-bot pl-30"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span class="send-nam">Send Push Notification</span></label></div><div class="col-md-12 mar-bot pl-30"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span class="send-nam">Send Push Notification</span></label></div></div></div><div class="row"><div class="col-md-12 pad-cust bg-grey7"><h5 class="cust-sec grey-bg">CUSTOMER PIN</h5></div></div><div class="row cust-pin"><div class="col-md-2 pl-30"><span class="send-nam">Customer App Pin</span></div><div class="col-md-2 marg-top"><input type="text" class="form-control txt-center" id="pwd" placeholder="***"></div><div class="col-md-2 pos-top"><button type="button" class="btn btn-info float-r" style="font-family:bebas;">RESET PIN</button></div><div class="col-md-6"></div></div><div class="row"><div class="col-md-12 pad-cust bg-grey7"><h5 class="cust-sec grey-bg">CUSTOMER PIN</h5></div></div><div class="row cust-pin"><div class="col-md-3 pl-30"><span class="send-nam">Total Available Credits &nbsp; : &nbsp; 300</span></div><div class="col-md-2 pos-top"><button type="button" class="btn btn-info float-r" style="font-family:bebas;">CHANGE CREDITS</button></div><div class="col-md-2 pos-top"><button type="button" class="btn btn-info float-r" style="font-family:bebas;">ADD CREDITS</button></div><div class="col-md-5"></div></div><div class="row mar-top"><div class="pull-right mar-bot"><button type="button" class="btn square-but btn-success btn-raised m-r-30 bor-radius-round" style="font-family:bebas;">CANCEL</button> <button type="button" class="btn square-but btn-success btn-raised m-r-30 bor-radius-round" style="font-family:bebas;">SUSPEND ACCOUNT</button> <button type="button" class="btn square-but btn-success btn-raised m-r-30 bor-radius-round" style="font-family:bebas;">UPDATE DETAILS</button></div></div></uib-tab><uib-tab heading="CUSTOMER TRANSACTION" ui-sref="ui.modals.modelTemplates"><div class="container-fluid mt20"><div class="row bg-white"><div class="col-xs-6 opp-con">CREDITS EARNED = 95 CREDITS</div><div class="col-xs-6 opp-con text-right">* 1 CREDIT = 1 AED</div></div><div class="row customer-sec"><div class="col-md-12 categ"><table class="table new-bran1 tab-pad"><thead class="thead-bg"><tr><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="text-center tab-headpad p-l-0" colspan="2">REFERRED TO</th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th></tr><tr><th>CREDITS</th><th>DATE - TIME</th><th class="text-center">NAME</th><th class="text-center">MOBILE</th><th>BILL AMOUNT</th><th>BILL NUMBER</th><th>REF NUMBER</th><th>OUTLET</th><th>LOCATION</th></tr></thead><tbody><tr><td>25</td><td>14-03-2017 - 07:15 PM</td><td>Imran</td><td>0147-256-7852-567</td><td>300 AED</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>Tim Hortons</td><td>najda</td></tr><tr><td>25</td><td>14-03-2017 - 07:15 PM</td><td>Imran</td><td>0147-256-7852-567</td><td>300 AED</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>Tim Hortons</td><td>najda</td></tr><tr><td>25</td><td>14-03-2017 - 07:15 PM</td><td>Imran</td><td>0147-256-7852-567</td><td>300 AED</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>Tim Hortons</td><td>najda</td></tr></tbody></table></div></div><div class="row bg-white mt10 customer-sec"><div class="col-xs-6 opp-con">CREDITS AVAILED = 95 CREDITS &nbsp;&nbsp;&nbsp;&nbsp; CREDITS LEFT = 0 CREDITS</div><div class="col-xs-6 opp-con text-right">* 1 CREDIT = 1 AED</div></div><div class="row customer-sec"><div class="col-md-12 categ"><table class="table new-bran1 tab-pad"><thead class="brand-bgcol"><tr><th>CREDITS</th><th>DATE - TIME</th><th>BILL NUMBER</th><th>REF NUMBER</th><th>BILL AMOUNT</th><th>OUTLET</th><th>LOCATION</th></tr></thead><tbody><tr><td>25</td><td>14-03-2017 - 07:15 PM</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>300 AED</td><td>Tim Hortons</td><td>najda</td></tr><tr><td>25</td><td>14-03-2017 - 07:15 PM</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>300 AED</td><td>Tim Hortons</td><td>najda</td></tr><tr><td>25</td><td>14-03-2017 - 07:15 PM</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>300 AED</td><td>Tim Hortons</td><td>najda</td></tr></tbody></table></div></div><div class="row bg-white mt10 customer-sec"><div class="col-xs-6 opp-con">REFERRALS SENT</div></div><div class="row customer-sec"><div class="col-md-12 categ"><table class="table new-bran1 tab-pad"><thead class="thead-bg"><tr><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="text-center tab-headpad p-l-0" colspan="2">REFERRED TO</th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th></tr><tr><th>OFFER NAME</th><th>OUTLET</th><th>LOCATION</th><th class="text-center">NAME</th><th class="text-center">MOBILE</th><th>DATE</th><th>STATUS</th></tr></thead><tbody><tr><td>Flat 15%</td><td>Tim Hortons</td><td>najda</td><td>Imran</td><td>0147-256-7852-567</td><td>14-03-2017</td><td>Pending</td></tr><tr><td>Flat 15%</td><td>Tim Hortons</td><td>najda</td><td>Sushil</td><td>0147-256-7852-567</td><td>15-03-2017</td><td>Redeemed</td></tr><tr><td>Flat 15%</td><td>Tim Hortons</td><td>najda</td><td>Jerry</td><td>0147-256-7852-567</td><td>16-03-2017</td><td>Pending</td></tr></tbody></table></div></div><div class="row bg-white mt10 customer-sec"><div class="col-xs-6 opp-con">CREDITS EARNED = 95 CREDITS</div><div class="col-xs-6 opp-con text-right">* 1 CREDIT = 1 AED</div></div><div class="row customer-sec"><div class="col-md-12 categ"><table class="table new-bran1 tab-pad"><thead class="thead-bg"><tr><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="text-center tab-headpad p-l-0" colspan="2">REFERRED BY</th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th><th class="p-0" colspan="1"></th></tr><tr><th>OFFER NAME</th><th>DATE - TIME</th><th class="text-center">NAME</th><th class="text-center">MOBILE</th><th>BILL AMOUNT</th><th>BILL NUMBER</th><th>REF NUMBER</th><th>NET AMOUNT PAID</th><th>OUTLET</th><th>LOCATION</th></tr></thead><tbody><tr><td>Flat 15%</td><td>14-03-2017 - 07:15 PM</td><td>Imran</td><td>0147-256-7852-567</td><td>300 AED</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>255 AED</td><td>Tim Hortons</td><td>najda</td></tr><tr><td>Flat 15%</td><td>14-03-2017 - 07:15 PM</td><td>Imran</td><td>0147-256-7852-567</td><td>300 AED</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>255 AED</td><td>Tim Hortons</td><td>najda</td></tr><tr><td>Flat 15%</td><td>14-03-2017 - 07:15 PM</td><td>Imran</td><td>0147-256-7852-567</td><td>300 AED</td><td>ST-345-768-T</td><td>REF-234456-TR</td><td>255 AED</td><td>Tim Hortons</td><td>najda</td></tr></tbody></table></div></div></div></uib-tab></uib-tabset></div></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/infoModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Information</span></div><div class="modal-body text-center">You\'ve got a new email!</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/invoice-payments-new.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title record_pop">REVIEW PAYMENTS DUE</h4></div><div class="container-fluid"><div class="row"><div class="col-lg-12"><p class="due-title mb-20">PAYMENTS DUE APRIL 2017</p></div><div class="col-md-3 mb-20"><p><b class="color-black">Vendors Name:</b> Tim Hortons</p><p><b class="color-black">Number Of Outlets:</b> 6</p></div></div><div class="row"><div class="col-lg-12"><p class="red-underline">Outlet Wise Payments</p></div></div><div class="row"><div class="col-md-12 px-0"><div class="reviewMode table-responsive"><table class="table bg-white font-montser table-striped-blue color-black"><thead class="thead-bg pop"><tr><th>OUTLET<br>NAME</th><th>OUTLET<br>LOCATION</th><th>PROMO<br>FEE</th><th>OFFER<br>FEE</th><th>SUBSCRIPTION<br>PAYMENT (A)</th><th>TOTAL CREDITS<br>AVAILED (B)</th><th>PAYMENTS AGAINTS<br>CREDITS (C-5% of B)<br>*1 CREDIT = 1 AED</th><th>PREVIOUS<br>PENDING (D)</th><th>TOTAL PAYMENTS<br>(A+C+D)</th></tr></thead><tbody><tr><td><b>Tim Hortons</b></td><td>Nadja</td><td class="text-center">300 AED</td><td class="text-center">300 AED</td><td class="text-center">1000</td><td class="text-center">100</td><td class="text-center">5 AED</td><td class="text-center">0 AED</td><td class="text-center">1005 AED</td></tr><tr><td><b>Tim Hortons</b></td><td>Sharja</td><td class="text-center">200 AED</td><td class="text-center">200 AED</td><td class="text-center">1000</td><td class="text-center">80</td><td class="text-center">4 AED</td><td class="text-center">10 AED</td><td class="text-center">94 AED</td></tr><tr><td><b>Tim Hortons</b></td><td>Mall Road</td><td class="text-center">100 AED</td><td class="text-center">100 AED</td><td class="text-center">1000</td><td class="text-center">80</td><td class="text-center">4 AED</td><td class="text-center">10 AED</td><td class="text-center">1006 AED</td></tr><tr><td><b>Tim Hortons</b></td><td>Street 10</td><td class="text-center">300 AED</td><td class="text-center">300 AED</td><td class="text-center">1000</td><td class="text-center">80</td><td class="text-center">4 AED</td><td class="text-center">10 AED</td><td class="text-center">94 AED</td></tr><tr><td><b>Tim Hortons</b></td><td>YY Mail</td><td class="text-center">100 AED</td><td class="text-center">100 AED</td><td class="text-center">1000</td><td class="text-center">80</td><td class="text-center">4 AED</td><td class="text-center">10 AED</td><td class="text-center">1006 AED</td></tr></tbody></table></div></div></div><div class="row"><div class="col-lg-12 mb-20 border-line"><p class="due-title text-right m-0">NET PAYMENTS DUE = AED 3205</p></div></div><div class="row"><div class="col-lg-5 pull-right mt5"><div class="row"><div class="col-lg-6"><button type="button" class="btn btn-block btn-info myofferBtns f-18px">CANCEL</button></div><div class="col-lg-6"><button type="button" class="btn btn-block btn-info myofferBtns f-18px">SAVE CHANGES</button></div></div></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/invoice-payments.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title record_pop">INVOICE</h4></div><div class="container-fluid"><div class="row"><div class="col-lg-12"><p class="due-title mb-20">INVOICE FOR THE PAYMENTS FOR THE MONTH OF APRIL 2017</p></div><div class="col-md-3 mb-20"><p><b class="color-black">In Name of:</b> Tim Hortons</p><p><b class="color-black">Number Of Outlets:</b> 6</p></div><div class="col-md-3 mb-20"><p><b class="color-black">Issued By:</b> Vouched4U</p><p><b class="color-black">Issued Date:</b> 8 April 2017</p></div><div class="col-md-5 mb-20 pull-right"><div class="row"><div class="col-md-3"><p><b class="color-black">Address:</b></p></div><div class="col-md-6 pl-0"><p>No.3, 2nd Avenue, Sheikh Mohammed bin Rahid Blvd, Dubai, UAE.</p></div></div></div></div><div class="row"><div class="col-lg-12"><p class="red-underline">Outlet Wise Payments</p></div></div><div class="row"><div class="col-md-12 px-0"><div class="reviewMode table-responsive"><table class="table bg-white font-montser table-striped-blue color-black"><thead class="thead-bg pop"><tr><th>OUTLET<br>NAME</th><th>OUTLET<br>LOCATION</th><th>PROMO<br>FEE</th><th>OFFER<br>FEE</th><th>SUBSCRIPTION<br>PAYMENT (A)</th><th>TOTAL CREDITS<br>AVAILED (B)</th><th>PAYMENTS AGAINTS<br>CREDITS (C=5% of B)<br>*1 CREDIT = 1 AED</th><th>PREVIOUS<br>PENDING (D)</th><th>TOTAL PAYMENTS<br>(A+B*C+D)</th></tr></thead><tbody><tr><td><b>Tim Hortons</b></td><td>Nadja</td><td class="text-center">300 AED</td><td class="text-center">300 AED</td><td class="text-center">1000</td><td class="text-center">100</td><td class="text-center">5 AED</td><td class="text-center">0 AED</td><td class="text-center">1005 AED</td></tr><tr><td><b>Tim Hortons</b></td><td>Sharja</td><td class="text-center">100 AED</td><td class="text-center">100 AED</td><td class="text-center">1000</td><td class="text-center">80</td><td class="text-center">4 AED</td><td class="text-center">10 AED</td><td class="text-center">94 AED</td></tr><tr><td><b>Tim Hortons</b></td><td>Mall Road</td><td class="text-center">200 AED</td><td class="text-center">200 AED</td><td class="text-center">1000</td><td class="text-center">80</td><td class="text-center">4 AED</td><td class="text-center">10 AED</td><td class="text-center">1006 AED</td></tr><tr><td><b>Tim Hortons</b></td><td>Street 10</td><td class="text-center">300 AED</td><td class="text-center">300 AED</td><td class="text-center">1000</td><td class="text-center">80</td><td class="text-center">4 AED</td><td class="text-center">10 AED</td><td class="text-center">94 AED</td></tr><tr><td><b>Tim Hortons</b></td><td>YY Mail</td><td class="text-center">100 AED</td><td class="text-center">100 AED</td><td class="text-center">1000</td><td class="text-center">80</td><td class="text-center">4 AED</td><td class="text-center">10 AED</td><td class="text-center">1006 AED</td></tr></tbody></table></div></div></div><div class="row"><div class="col-lg-12 mb-20 border-line"><p class="due-title text-right m-0 dark_grey">NET PAYMENTS DUE = AED 3205</p></div></div><div class="row"><div class="col-lg-12"><p class="text-center bebas dark_grey">AMOUNT PAYABLE = AED 3505</p></div><div class="col-lg-12"><p class="disclaimer"><i>This is digitally generated invoice by VOUCHED4U has taken care in the calculations of the due payments. You can write us at sales@vouched4u.com if you have any concern for the calculated payments.</i></p></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/largeModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/mangevendormodal.html','<div class="modal-content" id="manage-vendor"><div class="modal-header p-0"><button type="button" class="close custom-close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body p-0"><uib-tabset active="$tabSetStatus.activeTab" class="enquireTabs one-tab account_informat"><uib-tab heading="TIM HORTONS - VENDOR OUTLETS DETAILS"><div class="container-fluid"><div class="row mangeVend-box"><div class="col-md-12"><p class="pt-20 totl-outlet">TOTAL OUTLET: 10</p></div><div class="col-md-4"><p class="p-10 color-theme"><b>SELECT OUTLET TO CHECK DETAILS</b></p></div><div class="col-md-3"><vouched-select label="Tim Hortons" selected-value="outletFilter" select-lists="sortBy" class="w-100" display-field="value" is-label="false"></vouched-select></div><div class="col-md-3"><div class="row"><div class="col-md-4"><label for="" class="p-10 color-theme font-montser">LOCATION</label></div><div class="col-md-8"><vouched-select label="Najda" selected-value="outletFilter" select-lists="sortBy" class="w-100" display-field="value" is-label="false"></vouched-select></div></div></div><div class="col-md-2"><button type="button" class="btn btn-info btn-with-icon"><i class="fa fa-plus" aria-hidden="true"></i> ADD NEW OUTLET</button></div></div><div class="row"><div class="col-md-12 adjustWit"><uib-tabset><uib-tab heading="OUTLET DETAILS"><div class="col-md-12"><div class="row namedetais"><div class="col-md-12 text-right mb-20"><img src="assets/images/edit_icon.png" class="w-22 mr-20" alt=""> <span class="f-18px font-mont bod-bot-red"><a href="">EDIT / UPDATE DETAILS</a></span></div><div class="col-md-4"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>OUTLET NAME</b></label> <input type="text" class="form-control pl-0" id="" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>STREET ADDRESS</b></label> <input type="text" class="form-control pl-0" id="" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>CITY</b></label> <input type="text" class="form-control pl-0" id="" placeholder=""></div></div><div class="col-md-12"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>LAND MARK</b></label> <input type="text" class="form-control pl-0" id="" placeholder=""></div></div><div class="col-md-12"><p><b>OUTLET LOCATION ON THE MAP</b></p><iframe width="100%" height="250" src="https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=en&amp;q=1%20Grafton%20Street%2C%20Dublin%2C%20Ireland+(Voucher4U)&amp;ie=UTF8&amp;t=&amp;z=14&amp;iwloc=B&amp;output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"><a href="#"></a></iframe></div><div class="col-md-6 mt-20"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>OUTLET PHONE NUMBER</b></label> <input type="text" class="form-control pl-0" id="" placeholder=""></div></div><div class="col-md-6 mt-20"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>OUTLET WEBSITE URL</b></label> <input type="text" class="form-control pl-0" id="" placeholder=""></div></div><div class="col-md-6"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>CATEGORY</b></label><div class="selectCust"><select class="outletNames form-control" id="sel1"><option>Food & Beverages</option><option>2</option><option>3</option><option>4</option></select></div></div></div></div><div class="row background-underdetails font-montser"><div class="col-md-12"><p><b>OUTLET FEATURES:</b></p></div><div class="col-md-12"><div class="row mb-20"><div class="col-md-2 mb-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="Dining" value=""> <span>All Dining</span></label></div><div class="col-md-2 mb-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="Parking" value=""> <span>Parking</span></label></div><div class="col-md-2 mb-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="Lunch" value=""> <span>Lunch</span></label></div><div class="col-md-6 mb-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="creditcard" value=""> <span>Credit Cards Accepted</span></label></div><div class="col-md-2 mb-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="dinner" value=""> <span>Dinner</span></label></div><div class="col-md-2 mb-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="cafe" value=""> <span>Cafe</span></label></div><div class="col-md-2 mb-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="pets" value="option3"> <span>Pets Allowed</span></label></div><div class="col-md-6 mb-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="debitcard" value=""> <span>Debit Cards Accepted</span></label></div></div></div></div><div class="row bg-grey"><div class="col-md-12"><p class="tagTitle"><b>TAGS</b></p></div><div class="col-md-12"><p class="tags"><span>Live Music</span> <span>Free Parking</span> <span>Outdoor Seating</span></p></div></div><div class="row bg-grey"><div class="col-md-12"><p class="tagTitle"><b>CUISINES</b></p></div><div class="col-md-12"><p class="tags"><span>Afghani</span> <span>Chinese</span> <span>Continental</span></p></div></div><div class="row bg-grey"><div class="col-md-12"><p class="tagTitle"><b>TIMINGS</b></p></div><div class="col-md-12"><div class="row timingDetails"><div class="col-md-2"><p>Monday</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div><div class="col-md-2"><p>Happy Hours</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div></div><div class="row timingDetails"><div class="col-md-2"><p>Tuesday</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div><div class="col-md-2"><p>Happy Hours</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div></div><div class="row timingDetails"><div class="col-md-2"><p>Wednesday</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div><div class="col-md-2"><p>Happy Hours</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div></div><div class="row timingDetails"><div class="col-md-2"><p>Thursday</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div><div class="col-md-2"><p>Happy Hours</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div></div><div class="row timingDetails"><div class="col-md-2"><p>Friday</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div><div class="col-md-2"><p>Happy Hours</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div></div><div class="row timingDetails"><div class="col-md-2"><p>Saturday</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div><div class="col-md-2"><p>Happy Hours</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div></div><div class="row timingDetails"><div class="col-md-2"><p>Sunday</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div><div class="col-md-2"><p>Happy Hours</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div></div></div></div><div class="row bg-grey"><div class="col-md-12"><p class="tagTitle"><b>ADDITIONAL INFORMATION</b></p></div><div class="col-md-12"><p class="timingDetails lite-color bb-0 pb-0">Facebook: https//www.facebook.com/timhortans</p><p class="timingDetails lite-color bb-0 pb-0">Twitter: https//www.twitter.com/timhortans</p><p class="timingDetails lite-color bb-0 pb-0">Other Details: We Prove top class services and multi-cusines</p></div><div class="col-md-12 text-right"><img src="assets/images/edit_icon.png" class="w-22 mr-20" alt=""> <span class="f14 font-mont"><a href="">EDIT / UPDATE DETAILS</a></span></div></div></div></uib-tab><uib-tab heading="OUTLET OFFERS"><div class="col-md-12"><div class="row"><div class="col-xs-12"><span class="bebas float-l offerVendor">OFFERS</span> <button type="button" class="btn btn-info new-bran" style="font-family:bebas;">+ ADD NEW OFFERS</button></div><div class="col-md-12 reviewMode"><table class="table new-bran1 tab-pad"><thead class="brand-bgcol"><tr><th>OFFER</th><th>DISCOUNT</th><th>OUTLET</th><th>LOCATION</th><th>COUNTRY</th><th>OFFER TYPE</th><th>DETAILS</th></tr></thead><tbody><tr><td>Flat 15%</td><td>15%</td><td><a href="" class="text-underline">Tim Hortons</a></td><td>Najdo</td><td>Abu Dhabi</td><td>Introductory Referral</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"> <i class="fa fa-times-circle close-rm" aria-hidden="true"></i></td></tr><tr><td>Flat 15%</td><td>15%</td><td><a href="" class="text-underline">Tim Hortons</a></td><td>Najdo</td><td>Abu Dhabi</td><td>Introductory Referral</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"> <i class="fa fa-times-circle close-rm" aria-hidden="true"></i></td></tr><tr><td>Flat 15%</td><td>15%</td><td><a href="" class="text-underline">Tim Hortons</a></td><td>Najdo</td><td>Abu Dhabi</td><td>Introductory Referral</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"> <i class="fa fa-times-circle close-rm" aria-hidden="true"></i></td></tr><tr><td>Flat 15%</td><td>15%</td><td><a href="" class="text-underline">Tim Hortons</a></td><td>Najdo</td><td>Abu Dhabi</td><td>Introductory Referral</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"> <i class="fa fa-times-circle close-rm" aria-hidden="true"></i></td></tr><tr><td>Flat 15%</td><td>15%</td><td><a href="" class="text-underline">Tim Hortons</a></td><td>Najdo</td><td>Abu Dhabi</td><td>Introductory Referral</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"> <i class="fa fa-times-circle close-rm" aria-hidden="true"></i></td></tr><tr><td>Flat 15%</td><td>15%</td><td><a href="" class="text-underline">Tim Hortons</a></td><td>Najdo</td><td>Abu Dhabi</td><td>Introductory Referral</td><td><img src="assets/images/edit_icon.png" class="editTab" alt="edit_icon"> <i class="fa fa-times-circle close-rm" aria-hidden="true"></i></td></tr></tbody></table></div><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></uib-tab><uib-tab heading="MENU & PRICES"><div class="col-md-12"><div class="row font-montser"><div class="col-md-12"><p class="pt-30 color-theme"><b>MENU AND PRICES</b></p><p class="color-theme text-underline"><b>SELECT FROM ALREADY ADDED ITEMS</b></p></div><div class="col-md-12 p-0"><table class="table ml-0 abuDhai"><thead class="headtable-bg"><tr class=""><th><label class="bg-added checkbox-inline custom-checkbox"><input type="checkbox" id="inlineCheckbox03ss" value="a"> <span></span></label></th><th>ITEM</th><th>DETAILS</th><th>CUISINE</th><th>PRICE</th><th>MEAL TIME</th></tr></thead><tbody><tr><td><label class="checkbox-inline custom-checkbox"><input type="checkbox" id="inlineCheckbox03ss" value="a"> <span></span></label></td><td><img src="assets/images/pp1.jpg" alt="chicken" class="itemImage"> <span>Fried chicken</span></td><td>Achoice of french fires or salad</td><td>AMERICA</td><td>10AED</td><td>Lunch</td></tr><tr><td><label class="checkbox-inline custom-checkbox nowrap customCheck"><input type="checkbox" id="inlineCheckbox03ss" value="a"> <span></span></label></td><td><img src="assets/images/pp1.jpg" alt="chicken" class="itemImage"> <span>Fried chicken</span></td><td>Achoice of french fires or salad</td><td>AMERICA</td><td>10AED</td><td>Lunch</td></tr></tbody></table></div><div class="col-md-12"><p class="pt-30"><b>MENU IMAGES</b></p></div><div class="col-md-12 mb-20"><label class="checkbox-inline custom-checkbox nowrap customCheck"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span><img src="assets/images/fileIcon.png" alt="images"> Menu_1.jpp</span></label></div><div class="col-md-12 mb-20"><label class="checkbox-inline custom-checkbox nowrap customCheck"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span><img src="assets/images/fileIcon.png" alt="images"> Menu_1.jpp</span></label></div></div><div class="row font-montser"><div class="col-md-12"><p class="pt-30 catorgriesDetails">ADD MORE ITEMS</p></div><div class="col-md-12 p-0"><table class="table ml-0 abuDhai"><thead class="headtable-bg"><tr class=""><th>ITEM</th><th>DETAILS</th><th>CUSINE</th><th>PRICE</th><th>MEAL TIME</th><th class="text-center">EDIT/UPDATE</th></tr></thead><tbody><tr><td><img src="assets/images/pp1.jpg" alt="chicken" class="itemImage"> <span>Fried chicken</span></td><td>Achoice of french fires or salad</td><td>AMERICA</td><td>10AED</td><td>Lunch</td><td class="text-center"><img src="assets/images/edit_icon.png" alt="edit-icons" class="editIcons mr-10"> <img src="assets/images/close.png" alt="closeIcons"></td></tr><tr><td><img src="assets/images/pp1.jpg" alt="chicken" class="itemImage"> <span>Fried chicken</span></td><td>Achoice of french fires or salad</td><td>AMERICA</td><td>10AED</td><td>Lunch</td><td class="text-center"><img src="assets/images/edit_icon.png" alt="edit-icons" class="editIcons mr-10"> <img src="assets/images/close.png" alt="closeIcons"></td></tr></tbody></table></div><div class="w-14 cols-md"><input type="text" class="form-control ml-15 pl-0" placeholder="ITEM NAME"></div><div class="w-14 cols-md"><input type="text" class="form-control ml-15 pl-0" placeholder="DETAILS"></div><div class="w-14 cols-md"><div class="selectCust"><select class="form-control" id="sel1"><option>--CUISINE--</option><option>2</option><option>3</option><option>4</option></select></div></div><div class="w-14 cols-md"><input type="text" class="form-control ml-15 pl-0" placeholder="PRICE IN AED"></div><div class="w-14 cols-md"><div class="selectCust"><select class="form-control" id="sel1"><option>MEAL TIME</option><option>2</option><option>3</option><option>4</option></select></div></div><div class="w-28 cols-md"><div class="btn-group"><div class="btn-group w-100"><label class="btn newimages w-100 text-left"><a href="" class="btn btn-default ulpData">Upload Image</a> <img src="assets/images/uploads.png" alt="uploads" class="float-r"> <input type="file" class="typeFiles" style="display: none;"></label></div></div><button class="btn btn-primary modalBtn addMoreFile addedBtn"><i class="fa fa-plus" aria-hidden="true"></i> ADD</button></div><div class="col-md-12"><p class="text-center mt-20 orText">OR</p></div><div class="col-md-8 text-right"><div class="btn-group ulpoad-cins"><div class="btn-group w-100"><label class="btn w-100 text-left"><a href="" class="btn btn-default ulpData">Upload Menu Image</a> <img src="assets/images/uploads.png" alt="uploads" class="mr-4 float-r"> <input type="file" class="typeFiles" style="display: none;"></label></div></div></div><div class="col-md-4"><button class="btn btn-primary modalBtn border-Radus-none"><i class="fa fa-plus" aria-hidden="true"></i> ADD</button></div></div><div class="row"><div class="col-md-12"><p class="pt-30 catorgriesDetails">MENU IMAGES</p></div><div class="col-md-6"><p><span><b>Menu_1</b></span> <span class="float-r"><img src="assets/images/edit_icon.png" alt="edit-icons" class="mb-10 editIcons mr-10"> <i class="fa fa-times-circle close-rm" aria-hidden="true"></i></span></p><div class="menu_img"><img src="assets/images/chicken.jpg" class="w-100 canfullscreen" id="theImage" alt="Menu images"> <img src="assets/images/enlarge.png" class="enlargeImg" alt="enlarge"></div></div><div class="col-md-6"><p><span><b>Menu_2</b></span> <span class="float-r"><img src="assets/images/edit_icon.png" alt="edit-icons" class="mb-10 editIcons mr-10"> <i class="fa fa-times-circle close-rm" aria-hidden="true"></i></span></p><div class="menu_img"><img src="assets/images/Nutella.jpg" class="w-100" alt="Menu images"> <img src="assets/images/enlarge.png" class="enlargeImg" alt="enlarge"></div></div><div class="col-md-12 text-right m-t-20"><button type="button" class="btn square-but btn-success btn-raised bor-radius-round" style="font-family:bebas;">CLOSE</button></div></div></div></uib-tab><uib-tab heading="OUTLET SETTINGS"><div class="col-md-12"><div class="row"><div class="col-md-12"><p class="color-theme pt-20 f-500">VENDOR PIN</p></div><div class="col-md-2"><p class="f-500">Vendor PIN</p></div><div class="col-md-1"><p class="pin">****</p></div><div class="col-md-6"><img src="assets/images/edit_icon.png" alt="edit-icons" class="editIcons mr-10"> <span class="f-500 color-theme text-underline font-montser">Change PIN</span></div></div><div class="row font-montser"><div class="col-md-12 accout-inf"><p class="catorgriesDetails font-montser">MEMBERS PERMISSIONS</p></div><div class="col-md-12 textbrands"><p class="color-white text-center"><b>PERMISSION</b></p></div></div><div class="row font-montser"><div class="col-md-12 mb-20"><table class="table abuDhai"><thead><tr class=""><th>User</th><th class="text-center">Full</th><th class="text-center">Edit/Update Outlet</th><th class="text-center">Read only</th><th class="text-center">Revoke Access</th></tr></thead><tbody><tr><td><span><img src="assets/images/profiles.png" class="profileimg" alt="profiles"></span> <span>Users</span></td><td class="text-center"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="" value="option3"> <span></span></label></td><td class="text-center"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="" value="option3"> <span></span></label></td><td class="text-center"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="" value="option3"> <span></span></label></td><td class="text-center"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="" value="option3"> <span></span></label></td></tr><tr><td><span><img src="assets/images/profiles.png" class="profileimg" alt="profiles"></span> <span>Users</span></td><td class="text-center"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="" value="option3"> <span></span></label></td><td class="text-center"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="" value="option3"> <span></span></label></td><td class="text-center"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="" value="option3"> <span></span></label></td><td class="text-center"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="" value="option3"> <span></span></label></td></tr></tbody></table></div><div class="col-md-12 text-right mb-20"><button class="btn btn-primary modalBtn addMoreFile addedBtn">UPDATE PERMISSION</button></div></div><div class="row font-montser"><div class="col-md-12 accout-inf"><p class="catorgriesDetails font-montser">ADDITIONAL INFORMATION</p></div><div class="col-md-12 mb-20"><table class="table abuDhai"><thead class="headtable-bg"><tr class=""><th></th><th>Abu Dhabi Emirates (incl Al-Din)</th><th>Sharjah</th><th>Dubai</th><th>Fujaria</th><th>Ras Al Khamia</th><th>Umm All Quwain</th><th>UAE Total</th><th></th></tr></thead><tbody><tr><td>Tim Hortons</td><td>10</td><td>6</td><td>4</td><td>1</td><td>4</td><td>5</td><td>30</td><td><img src="assets/images/edit_icon.png" alt="edit-icons" class="editIcons mr-10"> <img src="assets/images/close.png" alt="closeIcons"></td></tr><tr><td>Bu</td><td>10</td><td>6</td><td>4</td><td>1</td><td>4</td><td>5</td><td>30</td><td><img src="assets/images/edit_icon.png" alt="edit-icons" class="editIcons mr-10"> <img src="assets/images/close.png" alt="closeIcons"></td></tr></tbody></table></div><div class="col-md-3"><input type="text" class="form-control pl-0" placeholder="BRAND NAME"></div><div class="col-md-3"><div class="selectCust"><select class="form-control" id="sel1"><option>1</option><option>2</option><option>3</option><option>4</option></select></div></div><div class="col-md-3"><input type="text" class="form-control pl-0" placeholder="NUMBER OF OUTLETS"></div><div class="col-md-3"><div class="btn-group"><div class="btn-group uploadflo"><label class="btn fileUpload"><a href="" class="btn btn-default" style="border:0px">Upload File</a> <img src="assets/images/uploads.png" alt="uploads" class="mr-4 float-r"> <input type="file" class="typeFiles" style="display: none;"></label></div></div><button class="btn btn-primary modalBtn addMoreFile addedBtn">ADD</button></div><br><div class="col-md-12 text-right m-t-20"><button type="button" class="btn square-but btn-success btn-raised bor-radius-round" style="font-family:bebas;">CLOSE</button></div></div></div></uib-tab></uib-tabset></div></div></div></uib-tab><uib-tab heading="VENDOR DETAILS"><div class="container-fluid"><div class="row bg-white"><div class="col-md-7"><p class="orstand outsandart">ORANGIZATION MODEL: STANDALONE OUTLET</p></div><div class="col-md-5 text-right"><p class="pr-80 f14 pt-20"><b>OUTLET CODE: <span class="vouchercode">V4UUAE0TM0001</span></b></p></div></div><div class="row namedetais acc-infomations bg-white"><div class="col-md-12"><p class="catorgriesDetails">ACCOUNT INFORMATION</p></div><div class="col-md-4"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>NAME</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>PASSWORD</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>POSITION</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>MODAL TYPE</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>EMIRATE / REGION</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>STREET ADDRESS</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>PHONE NUMBER</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>EMAIL</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>OUTLET / BRAND WEBSITE</b></label> <input type="text" class="form-control pl-0" id="inputLastName" placeholder=""></div></div></div><div class="row mt-20"><div class="col-md-12 col-sm-12 col-xs-12 px-0"><div class="panel-group"><div class="panel panel-danger bootstrap-panel"><div class="panel-body"><div class="row"><div class="col-md-12 yourBands"><div class="orange-text font-bebas font-s16px p-t-10" style="font-weight:500">YOUR BRAND / COMPANY LEGAL STRUCTURE</div><span><button type="submit" class="btn btn-block btn-md btn-info orange-text yourBrandAdd">+ Add</button></span></div><div class="col-xs-3 mb-15"><vouched-select class="f-weight box-shadows" label="Select Outlet" selected-value="outletFilter" select-lists="outletFilterLists" display-field="value" is-label="false" is-horizontal-form="false"></vouched-select></div><div class="col-xs-5 mb-15"><vouched-select class="f-weight box-shadows" label="Select your brand company legal structure" selected-value="outletFilter" select-lists="outletFilterLists" display-field="value" is-label="false" is-horizontal-form="false"></vouched-select></div><div class="col-xs-4 mb-15"><p class="col-xs-8 pt-10">Tax Registration Number:</p><p class="col-xs-4"><input type="text" class="form-control" value="1234"></p></div><div class="col-xs-6"><div class="btn-group w-100"><div class="btn-group w-100" style="border:1px dotted #ccc;border-radius: 5px;"><img src="assets/images/clips.png" alt="clips" class="clips-Icons"> <a href="" class="btn btn-default p-t-15 p-b-15 f-m" style="border:0px"><b>Attach Trade License</b></a> <img src="assets/images/view-files-theme.png" alt="view-files-theme" class="fileAttachedView"> <label class="btn float-r" style="font-size:33px;float:right"><img src="assets/images/uploads.png" class="float-r" alt="uploads"> <input type="file" style="display: none;"></label></div></div></div><div class="col-xs-6"><div class="btn-group w-100"><div class="btn-group w-100" style="border:1px dotted #ccc;border-radius: 5px;"><img src="assets/images/clips.png" alt="clips" class="clips-Icons"> <a href="" class="btn btn-default p-t-15 p-b-15 f-m" style="border:0px"><b>Attach Tax Registration Document</b></a> <img src="assets/images/view-files-theme.png" alt="view-files-theme" class="fileAttachedView"> <label class="btn float-r" style="font-size:33px;float:right"><img src="assets/images/uploads.png" class="float-r" alt="uploads"> <input type="file" style="display: none;"></label></div></div></div></div></div></div></div></div></div><div class="row mt-1 bg-white background-underdetails font-montser"><div class="col-md-12"><p><b>CATEGORIES IN WHICH YOU DEAL IN:</b></p></div><div class="col-md-12"><div class="row mb-20"><div class="col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Food & Beverages</span></label></div><div class="col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Leisure & Attractions</span></label></div><div class="col-md-2"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Wellness & Beauty</span></label></div></div><div class="row pb-20"><div class="col-md-2"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Retail & Services</span></label></div></div></div></div><div class="row font-montser textbrands"><div class="col-md-6"><p class="color-white"><b>BRANDS</b></p></div><div class="col-md-6"><p class="color-white"><b>NUMBER OF OUTLETS</b></p></div></div><div class="row font-montser bg-white"><div class="col-md-12"><table class="table abuDhai vendrorTab"><thead><tr class=""><th></th><th>Abu Dhabi Emirates (incl Al-Din)</th><th>Sharjah</th><th>Dubai</th><th>Fujaria</th><th>Ras Al Khamia</th><th>Umm All Quwain</th><th>UAE Total</th></tr></thead><tbody><tr><td>Tim Hortons</td><td>10</td><td>6</td><td>4</td><td>1</td><td>4</td><td>5</td><td>30</td></tr><tr><td>Bu</td><td>10</td><td>6</td><td>4</td><td>1</td><td>4</td><td>5</td><td>30</td></tr></tbody></table></div></div><div class="row font-montser bg-white"><div class="col-md-12"><p class="pt-30"><b>MENU AND PRICES <span class="red-text">(Not at this time)</span></b></p></div><div class="col-md-12 p-0"><table class="table ml-0 vendrorTab abuDhai"><thead class="headtable-bg"><tr class=""><th>ITEM</th><th>DETAILS</th><th>CUISINE</th><th>PRICE</th><th>MEAL TIME</th></tr></thead><tbody><tr><td><img src="assets/images/pp1.jpg" alt="chicken" class="itemImage"> <span>Fried chicken</span></td><td>Achoice of french fires or salad</td><td>AMERICA</td><td>10AED</td><td>Lunch</td></tr><tr><td><img src="assets/images/pp1.jpg" alt="chicken" class="itemImage"> <span>Fried chicken</span></td><td>Achoice of french fires or salad</td><td>AMERICA</td><td>10AED</td><td>Lunch</td></tr></tbody></table></div><div class="col-md-12"><p class="pt-30"><b>MENU IMAGES</b></p></div><div class="col-md-12 mb-20"><span><img src="assets/images/fileIcon.png" alt="images"> Menu_1.jpg</span></div><div class="col-md-12 mb-20"><span><img src="assets/images/fileIcon.png" alt="images"> Menu_2.jpg</span></div></div><div class="row font-montser bg-white"><div class="col-md-12"><p class="pt-30"><b>ADDITIONAL INFORMATION</b></p></div><div class="col-md-12 p-0"><table class="table ml-0 abuDhai firstBold"><thead class="headtable-bg"><tr class=""><th>TITLE</th><th>DETAILS</th><th class="text-center">ATTACHEMEMT</th></tr></thead><tbody><tr><td>Logo</td><td>CORPORATE OFFICIAL LOGO</td><td class="text-center"><img src="assets/images/fileIcon.png" alt="fileIcon"></td></tr><tr><td>About us</td><td>ABOUT OUR CORPORATE</td><td class="text-center"><img src="assets/images/fileIcon.png" alt="fileIcon"></td></tr><tr><td>Promotional Photo</td><td>ABOUT OUR CORPORATE</td><td class="text-center"><img src="assets/images/fileIcon.png" alt="fileIcon"></td></tr></tbody></table></div></div><div class="col-md-12 text-right m-t-20"><button type="button" class="btn square-but btn-success btn-raised bor-radius-round" style="font-family:bebas;">CLOSE</button></div></div></uib-tab><uib-tab heading="REWARD SETUP"><div class="panel panel-default bootstrap-panel"><div class="panel-heading panel-form no-b-b"><div class="row"><div class="col-md-6 p-t-10"><h4>FIRST VISIT DISCOUNT BY PERCENTAGE</h4></div></div></div><div class="panel-body p-0"><div class="table-responsive m-0"><table class="reward table list-table"><thead class="thead-bg"><tr class="sortable"><th class="p-l-15">OUTLET<br>NAME</th><th>CODE<br>NAME</th><th>DISCOUNT<br>PERCENTAGE</th><th>STATUS</th><th>DURATION<br>APPLIED</th><th>LOCATION<br>APPLIED</th><th class="text-center">EDIT</th></tr></thead><tbody><tr><td><p class="dark-text1">Tim Hortons</p></td><td><p class="dark-text1">CODE P15</p></td><td><p class="dark-text1">15%</p></td><td><p class="dark-text1"><span class="re-active"></span>In Use</p></td><td class="col-md-5"><div class="row"><div class="col-md-6"><div class="col-md-3 p-0"><label class="dark-text1">FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt1" is-open="opened1" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open1()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="col-md-3"><label class="dark-text1">TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt2" is-open="opened2" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open2()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></td><td><p class="dark-text1">Abu Dhabi</p></td><td class="text-center"><i class="fa fa-pencil-square-o f-22" aria-hidden="true"></i> <i class="fa fa-times-circle rating-icon ml-15 f-22" aria-hidden="true"></i></td></tr><tr><td><p class="dark-text1">Tim Hortons</p></td><td><p class="dark-text1">CODE P35</p></td><td><p class="dark-text1">20%</p></td><td><p class="dark-text1"><span class="re-active"></span>In Use</p></td><td class="col-md-5"><div class="row"><div class="col-md-6"><div class="col-md-3 p-0"><label class="dark-text1">FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt3" is-open="opened3" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open3()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="col-md-3"><label class="dark-text1">TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt4" is-open="opened4" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open4()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></td><td><p class="dark-text1">Dhubai</p></td><td class="text-center"><i class="fa fa-pencil-square-o f-22" aria-hidden="true"></i> <i class="fa fa-times-circle rating-icon ml-15 f-22" aria-hidden="true"></i></td></tr><tr><td><p class="lite-text1">Tim Hortons</p></td><td><p class="lite-text1">CODE P35</p></td><td><p class="lite-text1">20%</p></td><td><p class="lite-text1"><span class="re-lite"></span>In Use</p></td><td class="col-md-5"><div class="row"><div class="col-md-6"><div class="col-md-3 p-0"><label class="lite-text1">FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt5" is-open="opened5" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open5()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="col-md-3"><label class="lite-text1">TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt6" is-open="opened6" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open6()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></td><td><p class="lite-text1">Dhubai</p></td><td class="text-center"><i class="fa fa-pencil-square-o f-22" aria-hidden="true"></i> <i class="fa fa-times-circle rating-icon ml-15 f-22" aria-hidden="true"></i></td></tr></tbody></table></div></div><div class="panel-heading panel-form head-bg-w">ADD NEW CODE BY PERCENTAGE</div><div class="lite-bg panel p-l-15 panel-body"><div class="row"><div class="col-md-12 p-0"><div class="col-md-4"><vouched-text-box label="Code Name" text-value="codename" is-label="true"></vouched-text-box></div><div class="col-md-4"><vouched-text-box label="Discount Percentage" text-value="value" is-label="true"></vouched-text-box></div><div class="col-md-4"><vouched-select label="Select Location to Apply" selected-value="outletFilter" select-lists="outletFilterLists" display-field="value"></vouched-select></div></div></div><div class="row"><div class="col-md-12 p-0"><div class="col-md-4"><div class="col-md-5 dark-text p-t-10 p-r-0 p-l-0">Duration Applied</div><div class="col-md-7"><div class="col-md-12 p-0"><div class="col-md-6 p-l-0"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="All Time"> <span class="dark-text">All Time</span></label></div><div class="col-md-6 p-0 text-right"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="From"> <span class="dark-text">From</span></label></div></div></div></div><div class="col-md-4"><div class="col-md-5 p-0"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt7" is-open="opened7" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open7()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div><div class="col-md-2 text-center"><label class="dark-text">TO</label></div><div class="col-md-5 p-0"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt8" is-open="opened8" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open8()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-4"><vouched-select label="Yearly" selected-value="outletFilter" select-lists="durationList" display-field="value" is-label="false"></vouched-select></div></div></div><div class="col-md-12 push-middle"><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised" style="font-family:bebas;">ADD CODE</button></div></div></div><div class="panel-heading panel-form cre-text no-b-b"><div class="row"><div class="col-md-6 pt-10"><h4>REFERRER\'S REWARD FOR EACH SUCCESSFULL REFERRAL</h4></div><div class="col-md-6"><p class="m-0"><span class="red-star">*</span> Credits earned from 1st January to 30th June will expire after 31st December same year.</p><p class="m-0">Credits earned from 1st July to 31st December will expire after 3oth June the following year.</p></div><div class="clearfix"></div></div></div><div class="panel-body p-0"><div class="m-0"><table class="reward table list-table"><thead class="thead-bg"><tr class="sortable"><th class="p-l-15">OUTLET<br>NAME</th><th>CODE<br>NAME</th><th>REFERRER\'S<br>REWARD</th><th>STATUS</th><th>DURATION APPLIED <span class="red-star">*</span></th><th>LOCATION<br>APPLIED</th><th class="text-center">EDIT</th></tr></thead><tbody><tr><td><p class="dark-text1">Tim Hortons</p></td><td><p class="dark-text1">CODE P15</p></td><td><p class="dark-text1">50 AED</p></td><td><p class="dark-text1"><span class="re-active"></span>In Use</p></td><td class="col-md-5"><div class="row"><div class="col-md-6"><div class="col-md-3 p-0"><label class="dark-text1">FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt9" is-open="opened9" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open9()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="col-md-3"><label class="dark-text1">TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt10" is-open="opened10" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open10()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></td><td><p class="dark-text1">Abu Dhabi</p></td><td class="text-center"><i class="fa fa-pencil-square-o f-22" aria-hidden="true"></i> <i class="fa fa-times-circle rating-icon ml-15 f-22" aria-hidden="true"></i></td></tr><tr><td><p class="dark-text1">Tim Hortons</p></td><td><p class="dark-text1">CODE P35</p></td><td><p class="dark-text1">20 AED</p></td><td><p class="dark-text1"><span class="re-active"></span>In Use</p></td><td class="col-md-5"><div class="row"><div class="col-md-6"><div class="col-md-3 p-0"><label class="dark-text1">FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt11" is-open="opened11" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open11()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="col-md-3"><label class="dark-text1">TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt12" is-open="opened12" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open12()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></td><td><p class="dark-text1">Dhubai</p></td><td class="text-center"><i class="fa fa-pencil-square-o f-22" aria-hidden="true"></i> <i class="fa fa-times-circle rating-icon ml-15 f-22" aria-hidden="true"></i></td></tr><tr><td><p class="lite-text1">Tim Hortons</p></td><td><p class="lite-text1">CODE P35</p></td><td><p class="lite-text1">AED</p></td><td><p class="lite-text1"><span class="re-lite"></span>In Use</p></td><td class="col-md-5"><div class="row"><div class="col-md-6"><div class="col-md-3 p-0"><label class="lite-text1">FROM</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt13" is-open="opened13" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open13()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-6"><div class="col-md-3"><label class="lite-text1">TO</label></div><div class="col-md-9"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt14" is-open="opened14" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open14()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></td><td><p class="lite-text1">Dhubai</p></td><td class="text-center"><i class="fa fa-pencil-square-o f-22" aria-hidden="true"></i> <i class="fa fa-times-circle rating-icon ml-15 f-22" aria-hidden="true"></i></td></tr></tbody></table></div></div><div class="row panel-body p-0"><div class="col-md-12 p-t-20"><div class="col-md-6 p-0"><div class="col-md-6 p-t-30"><label>Credit Per successful Referral</label></div><div class="col-md-6 p-t-25"><vouched-select label="" selected-value="outletFilter" select-lists="outletFilterLists" display-field="value"></vouched-select></div></div><div class="col-md-6"><div class="col-md-6"><vouched-text-box label="Customs Amount" text-value="value" is-label="true"></vouched-text-box></div><div class="col-md-5 p-t-20"><div class="button-wrapper"><button type="button" class="btn btn-success btn-raised" style="font-family:bebas;">ADD REWARDS</button></div></div></div></div></div><div class="panel-heading panel-form head-bg-w">CREDIT/DISCOUNT EXPIRY DATE</div><div class="panel-body p-0"><div class="table-responsive m-t-0"><table class="table list-table"><thead class="thead-bg"><tr class="sortable"><th class="p-l-15">EARN PERIOD</th><th>EXPIRING DATE</th></tr></thead><tbody><tr><td class="p-l-15"><div class=""><div class="col-md-12 p-0"><div class="col-md-4 p-0"><div class="col-md-4 p-0"><label class="">FROM</label></div><div class="col-md-8"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt15" is-open="opened15" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open15()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-4"><div class="col-md-4"><label class="">TO</label></div><div class="col-md-8"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt16" is-open="opened16" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open16()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></div></td><td><div class="row"><div class="col-md-10"><div class="col-md-1 p-0"><label class="">On</label></div><div class="col-md-8"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt17" is-open="opened17" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open17()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></td></tr><tr class="border-bot-line"><td class="p-l-15"><div class=""><div class="col-md-12 p-0"><div class="col-md-4 p-0"><div class="col-md-4 p-0"><label class="">FROM</label></div><div class="col-md-8"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt18" is-open="opened18" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open18()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div><div class="col-md-4"><div class="col-md-4"><label class="">TO</label></div><div class="col-md-8"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt19" is-open="opened19" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open19()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></div></td><td><div class="row"><div class="col-md-10"><div class="col-md-1 p-0"><label class="">On</label></div><div class="col-md-8"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt20" is-open="opened20" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open20()"><i class="glyphicon glyphicon-calendar"></i></button></span></p></div></div></div></td></tr></tbody></table></div><p class="p-l-15 p-t-30">* This section is for your information only VOUCHED4u authorized Admin can change these date</p></div><div class="panel-heading panel-form head-bg-w">CONDITION OF USE</div><div class="panel-body p-l-15 dark-text"><ul class="termsCond"><li>Minimum total spend of AED 30 by Referee</li><li>Referrer entitled to the credit when his/her referrer validates unexpired links</li><li>Those accompanying referee can be validated to referrer so long as on average all parties minimum spending of 30 AED</li><li>Earned credits can be used to purchase Offers provided the credit does not exceed 50% of the total offer value</li><li>Earned credits for use any day within the expiry date</li><li>Earned credits is on beverage in participating outlets</li><li>One credit one Dirham</li></ul></div><div class="clearfix"></div></div></uib-tab><uib-tab heading="PIN MANAGEMENT"><div class="container-fluid"><div class="row"><div class="col-md-12 bg-white"><div class="row"><div class="col-md-8"></div><div class="col-md-4 text-right"><div class="form-group searchVend m-0 p-t-10 font-montser"><input type="text" class="form-control" id="input01s" placeholder="Search vendor"> <i style="top:20px; right:15px;" class="fa fa-search" aria-hidden="true"></i></div></div></div><div class="row"><div class="col-md-12 px-0"><div class="reviewMode table-responsive"><table class="table bg-white font-montser table-striped-blue"><thead class="thead-bg"><tr><th>VENDOR NAME</th><th>OUTLET NAME</th><th>LOCATION</th><th>PIN NUMBER</th><th>EMPLOYEE COUNT</th><th>ACTION</th></tr></thead><tbody><tr><td>John Cena</td><td>Tim Horstons</td><td>Najdo</td><td>#1235</td><td>200</td><td><img src="assets/images/view-files.png" alt="view-files" class="mr-20"> <span><a href="" class="orange-text text-underline f-500 selectpin">Generate Pin</a></span></td></tr><tr><td>John Cena</td><td>Tim Horstons</td><td>Najdo</td><td>#1235</td><td>200</td><td><img src="assets/images/view-files.png" alt="view-files" class="mr-20"> <span><a href="" class="orange-text text-underline f-500 selectpin">Generate Pin</a></span></td></tr><tr><td>John Cena</td><td>Tim Horstons</td><td>Najdo</td><td>#1235</td><td>200</td><td><img src="assets/images/view-files.png" alt="view-files" class="mr-20"> <span><a href="" class="orange-text text-underline f-500 selectpin">Generate Pin</a></span></td></tr><tr><td>John Cena</td><td>Tim Horstons</td><td>Najdo</td><td>#1235</td><td>200</td><td><img src="assets/images/view-files.png" alt="view-files" class="mr-20"> <span><a href="" class="orange-text text-underline f-500">Generate Pin</a></span></td></tr><tr><td>John Cena</td><td>Tim Horstons</td><td>Najdo</td><td>#1235</td><td>200</td><td><img src="assets/images/view-files.png" alt="view-files" class="mr-20"> <span><a href="" class="orange-text text-underline f-500">Generate Pin</a></span></td></tr><tr><td>John Cena</td><td>Tim Horstons</td><td>Najdo</td><td>#1235</td><td>200</td><td><img src="assets/images/view-files.png" alt="view-files" class="mr-20"> <span><a href="" class="orange-text text-underline f-500">Generate Pin</a></span></td></tr><tr><td>John Cena</td><td>Tim Horstons</td><td>Najdo</td><td>#1235</td><td>200</td><td><img src="assets/images/view-files.png" alt="view-files" class="mr-20"> <span><a href="" class="orange-text text-underline f-500">Generate Pin</a></span></td></tr></tbody></table></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></div></div></uib-tab><uib-tab heading="VENDOR MESSAGES"><div class="container-fluid"><div class="row"><div class="col-xs-12"><div class="row bg-white"><div class="col-md-12"><p class="msg-details color-theme"><b>MESSAGE DETAILS</b></p></div><div class="col-md-6 messagevenedars"><p><b>NAME:</b> <span>Tom Hanks</span></p><p><b>POSITION:</b> <span>Sale Head</span></p><p><b>EMAIL:</b> <span>test@yopmail.com</span></p><p><b>PHONE:</b> <span>999-465-8757</span></p></div><div class="col-md-6 email-sents"><p><b>EMAIL SENT:</b> <span>5</span></p><p><b>EMAIL RECEIVED:</b> <span>12</span></p><p><b>SMS SENT:</b> <span>6</span></p></div></div><div class="row mt-10"><div class="col-md-12 bg-white"><div class="row"><div class="col-md-5"><p class="msg-details color-theme"><b>MESSAGE HISTORY</b></p></div><div class="col-md-7 text-right p-t-10"><div class="form-group searchVend font-montser"><input type="text" class="form-control" id="input01s" placeholder="Search vendor"> <i class="fa fa-search" aria-hidden="true"></i></div><button type="button" class="btn btn-info btn-with-icon"><i class="fa fa-plus" aria-hidden="true"></i> ADD NEW MESSAGES</button></div></div><div class="row"><div class="col-md-12 px-0"><div class="reviewMode vendorContd mb-20 table-responsive"><table class="table bg-white font-montser"><thead class="thead-bg"><tr><th>DATE</th><th>MESSAGE TYPE</th><th>SEND / RECEIVE</th><th>DETAILS</th><th>COMMENTS</th></tr></thead><tbody><tr><td>10/10/2017</td><td>Email</td><td>Sent</td><td>Admin sent the mail Sales Head of Time Horstons to send the required details for Outlet at Najda</td><td></td></tr><tr><td>10/10/2017</td><td>Email</td><td>Sent</td><td>Admin sent the mail Sales Head of Time Horstons to send the required details for Outlet at Najda</td><td>Vendor was asked to review and change the details in contract</td></tr><tr><td>10/10/2017</td><td>Email</td><td>Sent</td><td>Admin sent the mail Sales Head of Time Horstons to send the required details for Outlet at Najda</td><td></td></tr></tbody></table></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div></div></div></div></div></div></uib-tab></uib-tabset></div></div><div class="modal-content bg-white" id="pin-management"><div class="modal-header pin-header"><div class="row"><div class="col-md-8"><h4 class="orange-text">TIM HORTONS</h4></div><div class="col-md-4"><button type="button" class="close closePin"><em class="ion-ios-close-empty sn-link-close"></em></button></div></div></div><div class="modal-body p-0"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="row mt5"><div class="col-md-6"><img class="pin_img" src="assets/images/pinper.png"> <button type="button" class="btn square-but btn-success btn-raised post-button bebas">CHANGE PICTURE</button></div><div class="col-md-6 pin_border"><button class="orange-text">PIN 21281233</button><p><label>Name :</label> JOHN DECLAND</p><p><label>Location :</label> Al Wahda Mall</p><p><label>Phone :</label> +00 123 2121 212</p><p><label>Email :</label> john@timhortons.com</p><p><label>Date Employed :</label> January 4th 2016</p><p><label>Workshift :</label> Monday to Saturday - 17:00 To 22:00 - Sunday Off</p></div></div><div class="row pt15 font-montser"><div class="w-20"><h3 class="text-center orange-text rating-value"><span>14</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon"></i></span></h3><h6 class="text-center dark-text rating-line font-montser f-16px">POSITIVE REVIEWS</h6><p class="text-center">+12% Since Last Week</p></div><div class="w-20"><h3 class="text-center orange-text rating-value"><span>55514</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon"></i></span></h3><h6 class="text-center dark-text rating-line font-montser f-16px">TOTAL REVENUE</h6><p class="text-center">+12% Since Last Week</p></div><div class="w-20"><h3 class="text-center orange-text rating-value"><span>1664</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon-green"></i></span></h3><h6 class="text-center dark-text rating-line font-montser f-16px">REVENUE PER WEEK</h6><p class="text-center">+12% Since Last Week</p></div><div class="w-20"><h3 class="text-center orange-text rating-value"><span>18884</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon"></i></span></h3><h6 class="text-center dark-text rating-line font-montser f-16px">VISITOR THIS WEEK</h6><p class="text-center">+12% Since Last Week</p></div><div class="w-20"><h3 class="text-center orange-text rating-value"><span>445314</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon-green"></i></span></h3><h6 class="text-center dark-text rating-line font-montser f-16px">NEGATIVE FEEDBACKS</h6><p class="text-center">+12% Since Last Week</p></div><div class="col-md-12 text-right mt-20"><button type="button" class="btn square-but btn-success btn-raised p-l-10 p-r-10 offer-add-btn bebas"><i class="fa fa-plus" aria-hidden="true"></i> ADD</button></div></div></div><div class="panel-body p-0"><div class="table-responsive"><table class="table new-bran1 table-striped-blue tab-pad"><thead class="thead-bg"><tr class="table-header"><th>VENDOR<br>NAME</th><th>OUTLET<br>NAME</th><th>ACTIVITY</th><th>PIN<br>NUMBER</th><th>PIN<br>VALIDATION NAME</th><th>DATE</th><th>GROSS<br>SALE</th><th>DISCOUNT<br>VALUE</th><th>NET AMOUNT<br>PAID</th><th>CREDIT USED</th><th>ACTION</th></tr></thead><tbody><tr><td class="dark-text">John Cena</td><td class="dark-text">Tim hortons</td><td>Offer Purchase, tim hortons Al washa</td><td>#1123</td><td>Jack D</td><td>12/12/2017</td><td>15%</td><td>15%</td><td>123 AED</td><td>#1133</td><td class="color-theme text-underline">Generate Pin</td></tr><tr><td class="dark-text">John Cena</td><td class="dark-text">Tim hortons</td><td>Offer Purchase, tim hortons Al washa</td><td>#1123</td><td>Jack D</td><td>12/12/2017</td><td>15%</td><td>15%</td><td>123 AED</td><td>#1133</td><td class="color-theme text-underline">Generate Pin</td></tr><tr><td class="dark-text">John Cena</td><td class="dark-text">Tim hortons</td><td>Offer Purchase, tim hortons Al washa</td><td>#1123</td><td>Jack D</td><td>12/12/2017</td><td>15%</td><td>15%</td><td>123 AED</td><td>#1133</td><td class="color-theme text-underline">Generate Pin</td></tr></tbody></table></div><div class="row m-0"><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats p-t-10"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right paginats p-t-10"><span class="mr-15">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div><div class="panel-footer"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/offer-modal.html','<uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="OFFERS" ui-sref="ui.modals.modelTemplates"><div class="panel-body"><form><div class="row"><div class="col-md-6"><img class="img-responsive" ng-src="assets/images/img.png" alt=""> <button type="button" class="btn square-but btn-success btn-raised post-button" style="font-family:bebas;">CHANGE PICTURE</button></div><div class="col-md-6"><h3 class="orange-text m-b-20">MORNING APPETITE</h3><p class="f-500"><u class="text-dark p-t-30 outlet-line-heigh">It\'s the perfect partnership of Outstanding hospitality and exquisite food in an iconic setting in New York City that makes Eleven Madison Park the No.1 in the World\'s 50 Best Restaurants</u></p><p class="p-b-10 f-500"><u class="text-dark p-t-30">Co-Owners Will Guidara and Daniel Hummm have put Their lives into breaking down the walls between dining room and kitchen, making sure the customer experience in harmonious from to finish</u></p><div class="row"><div class="col-lg-6"><h3 class="orange-text">REDEEMTION QUANTITY</h3><div class="form-group font-montserrat"><select class="form-control vendor-status" id="sel1"><option>5 Times</option><option>2 Times</option><option>3 Times</option></select></div></div><div class="col-lg-6"><h3 class="orange-text">EXPECTED QUANTITY TO SELL</h3><div class="form-group font-montserrat"><input type="text" class="form-control" id="input04" placeholder="50"></div></div></div><div class="row"><div class="col-lg-6"><h3 class="orange-text f-18px">CREDIT TO EARN PER UNIT PUCHASED</h3><div class="col-lg-4 p-l-0"><div class="form-group font-montserrat"><input type="text" class="form-control" id="input04" placeholder="3 AED"></div></div><div class="col-lg-8"><div class="form-group font-montserrat"><input type="text" class="form-control" id="input04" placeholder="20% CREDIT BACK"></div></div></div><div class="col-lg-6"></div></div></div></div><div class="row panel-body"><div class="col-lg-6 p-l-0"><div class="row"><div class="col-lg-3"><label class="text-lab f-16">Category</label></div><div class="col-lg-9 p-l-0"><div class="form-group font-montserrat"><select class="form-control vendor-status" id="sel"><option>Food and Beverages</option><option>2 Times</option><option>3 Times</option></select></div></div></div><div class="row"><div class="col-lg-6"><div class="row"><div class="col-lg-5"><label class="text-lab f-16">original price</label></div><div class="col-lg-7"><div class="form-group font-montserrat"><input type="text" class="form-control" id="input04" placeholder="15 AED"></div></div></div></div><div class="col-lg-6"><div class="row"><div class="col-lg-7"><label class="text-lab f-16">offer price</label></div><div class="col-lg-5"><div class="form-group font-montserrat"><input type="text" class="form-control" id="input04" placeholder="15 AED"></div></div></div></div></div><div class="row"><div class="col-lg-6"><div class="row"><div class="col-lg-5"><label class="text-lab f-16">code</label></div><div class="col-lg-7"><div class="form-group font-montserrat"><input type="text" class="form-control" id="input04" placeholder="TIM120"></div></div></div></div><div class="col-lg-6"><div class="row"><div class="col-lg-7"><label class="text-lab f-16">value description</label></div><div class="col-lg-5"><div class="form-group font-montserrat"><input type="text" class="form-control" id="input04" placeholder="SAVE 15%"></div></div></div></div></div></div><div class="col-lg-1"></div><div class="col-lg-5 radio-customise"><div class="row"><label class="radio-inline custom-radio nowrap font-montserrat"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span class="color-black">Remove offer when expected quantity is purchased</span><p></p></label></div><div class="row"><label class="radio-inline custom-radio nowrap font-montserrat"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span class="color-black">Remove offer when expected quantity is purchased</span><p></p></label></div><div class="row"><label class="radio-inline custom-radio nowrap font-montserrat"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span class="color-black">Remove offer when expected quantity is purchased</span><p></p></label></div></div></div><hr><div class="row"><div class="col-md-5 p-0 m-t-5"><label class="col-xs-3 orange-text" style="font-family:bebas;">VALID FROM</label><div class="col-xs-2 col-sm-4 col-md-4 col-lg-4" ng-controller="datepickerpopupCtrl"><p class="input-group m-b-0 calendar-box-shad"><input type="text" class="box-shad-none vendor-status form-control p-6" uib-datepicker-popup="{{format}}" placeholder="04/12/2018" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="box-shad-none btn btn-default" ng-click="open()"><img src="assets/images/calender_icon.png" alt="calender_icon" class="w-18"></button></span></p></div><label class="col-xs-1 col-sm-1 col-lg-1 orange-text" style="font-family:bebas;">TO</label><div class="col-xs-2 col-sm-4 col-md-4 col-lg-4" ng-controller="datepickerpopupCtrl"><p class="input-group m-b-0 calendar-box-shad"><input type="text" class="box-shad-none form-control p-6" uib-datepicker-popup="{{format}}" placeholder="04/12/2017" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="box-shad-none btn btn-default" ng-click="open()"><img src="assets/images/calender_icon.png" alt="calender_icon" class="w-18"></button></span></p></div></div><div class="col-md-4 col-lg-6 p-0"><label class="col-xs-12 col-sm-2 col-lg-3 orange-text p-t-5 text-right" style="font-family:bebas;">DAY VALID</label><div class="col-md-9 p-0" style="display: inline-flex;"><div class="dark-text ng-scope __web-inspector-hide-shortcut__ p-l-15"><label class="radio-inline custom-radio nowrap font-montserrat"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span><b>Mon</b></span><p></p></label></div><div class="dark-text ng-scope __web-inspector-hide-shortcut__ p-l-15"><label class="radio-inline custom-radio nowrap font-montserrat"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span><b>Tue</b></span><p></p></label></div><div class="dark-text ng-scope __web-inspector-hide-shortcut__ p-l-15"><label class="radio-inline custom-radio nowrap font-montserrat"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span><b>Wed</b></span><p></p></label></div><div class="dark-text ng-scope __web-inspector-hide-shortcut__ p-l-15"><label class="radio-inline custom-radio nowrap font-montserrat"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span><b>Thu</b></span><p></p></label></div><div class="dark-text ng-scope __web-inspector-hide-shortcut__ p-l-15"><label class="radio-inline custom-radio nowrap font-montserrat"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span><b>Fri</b></span><p></p></label></div><div class="dark-text ng-scope __web-inspector-hide-shortcut__ p-l-15"><label class="radio-inline custom-radio nowrap font-montserrat"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span><b>Sat</b></span><p></p></label></div><div class="dark-text ng-scope __web-inspector-hide-shortcut__ p-l-15"><label class="radio-inline custom-radio nowrap font-montserrat"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span><b>Sun</b></span><p></p></label></div></div></div></div><div class="row p-t-10"><div class="col-lg-2"><label for="" class="orange-text" style="font-family:bebas;">TIME VALID FROM</label></div><div class="col-lg-2"><div class="form-group font-montserrat"><select class="form-control vendor-status" id="sel5"><option>All</option><option>Single</option></select></div></div><div class="col-lg-2"><div class="form-group font-montserrat"><select class="form-control vendor-status" id="sel4"><option>12.00 AM</option><option>05.00 PM</option><option>07.00 PM</option></select></div></div><div class="col-lg-1 text-center"><label for="" class="orange-text">TO</label></div><div class="col-lg-2"><div class="form-group font-montserrat"><select class="form-control vendor-status" id="sel6"><option>12.00 AM</option><option>05.00 PM</option><option>07.00 PM</option></select></div></div></div><hr><div class="col-lg-12 check-pop dark-text p-l-20"><div class="checkbox"><label class="custom-checkbox font-montserrat p-b-20"><input type="checkbox" id="checkboxSuccess" value="option1"> <span>This offer is applicable for Outlet Referral Reward programme.</span></label></div></div><div class="orange-text p-b-20"><h3>TERMS & CONDITIONS <span class="pull-right"><button type="button" class="btn square-but btn-success btn-raised p-l-10 p-r-10 offer-add-btn bebas"><i class="fa fa-plus" aria-hidden="true"></i> ADD</button></span></h3></div><div class="col-md-12 bg-gray-term radio-customise radiot-btn dark-text"><div class="row p-l-20 p-t-15 pt-10"><label class="radio-inline custom-radio nowrap font-montserrat line-h20"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Offer not vaild in conjunction with any other disscount or promotion</span></label></div><div class="row p-l-20 pt-10"><label class="radio-inline custom-radio nowrap font-montserrat line-h20"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Offer not vaild on public holidays and special occasions (i.e Eid Al Fitr, Eid Al Adha, UAE NAtional Day, Martyr\'s Day, New Year\'s Day,<br>Valentine\'s Day, New Year\'s Eve, Christmas Eve, Christmas Day, and all other holidays announced by the government)</span></label></div><div class="row p-l-20 pt-10"><label class="radio-inline custom-radio nowrap font-montserrat line-h20"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Prior booking/reservation mandatory and suject to availability. Reserve through vouched4u reservation</span></label></div><div class="row p-l-20 pt-10"><label class="radio-inline custom-radio nowrap font-montserrat line-h20"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Offer vaild on dine in and takeaway only</span></label></div><div class="row p-l-20 pt-10"><label class="radio-inline custom-radio nowrap font-montserrat line-h20"><input type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1"> <span>Vouched4u credit balance cannot be used to purchase this offer</span></label></div></div><div class="row"><div class="col-md-3 p-b-20 p-t-10"><div class="form-group font-montserrat dark-text"><select class="form-control vendor-status" id="sel"><option>Status</option><option>form</option></select></div></div><div class="col-md-9"></div></div><div class="row"><div class="col-md-6"><div class="row"><div class="col-md-2"><p class="grey-text offer-text font-bebas">M</p></div><div class="col-md-10"><p class="orange-text text-merchant">Merchant</p><p class="text-muted font-montserrat text-style-it">Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus reprehenderit incidunt doloribus voluptate nam voluptas modi unde porro accusantium.</p><p class="grey-text offer-dates font-montser">March 23 at 12.45 pm</p></div></div><div class="row"><div class="col-md-12"><textarea placeholder="Admin Comments comes here" class="form-control textarea-offerMng boder-radius-0" id="textarea01"></textarea></div></div></div><div class="col-md-6"></div></div><br><div class="col-md-12 p-t-20"><div class="pull-right"><button type="button" class="btn square-but btn-success btn-raised m-r-30 bor-radius-round" style="font-family:bebas;">SUBMIT</button> <button type="button" class="btn square-but btn-success btn-raised bor-radius-round" style="font-family:bebas;">CLOSE</button></div><br><p class="text-center m-t-40" style="color:#b1b1b1;">Confirm and submit offer to V4U for review</p></div></form></div></uib-tab><uib-tab heading="CONTRACTS" ui-sref="ui.modals.modelTemplates"><div class="container-fluid"><div class="row plr-40"><div class="col-lg-12"><div class="row"><div class="col-lg-12"><button type="login" class="mar-l-0 btn_generate">GENERATE CONTRACT</button> <button type="login" class="btn_upload">UPLOAD CONTRACT</button><div class="offer">OFFER INFORMATION</div></div></div><div class="row"><div class="col-xs-12 form_pad font"><div class="form-group"><label for="input04" class="dark-text">OFFER NAME</label> <input type="text" class="form-control" id="input04" placeholder="John Cena"></div></div><div class="col-xs-12 form_pad font"><div class="form-group"><label for="input04" class="dark-text">OUTLET NAME</label> <input type="text" class="form-control" id="input04" placeholder="Tim Hortans"></div></div><div class="col-xs-12 form_pad font"><div class="form-group"><label for="input04" class="dark-text">LOCATION</label> <input type="text" class="form-control" id="input04" placeholder="Al-wahda"></div></div><div class="col-xs-12 form_pad font"><div class="form-group"><label for="input04" class="dark-text">CATEGORY</label> <input type="text" class="form-control" id="input04" placeholder="Food and Beverages"></div></div><div class="col-xs-12 form_pad font"><div class="form-group"><label for="input04" class="dark-text">PRICE</label> <input type="text" class="form-control" id="input04" placeholder="15 AED"></div></div><div class="col-xs-12 form_pad font"><div class="form-group"><label for="input04" class="dark-text">OFFER CODE</label> <input type="text" class="form-control" id="input04" placeholder="tom@gmail.com"></div></div><div class="col-md-12 form_pad font"><p class="dark-text">OFFER VALIDITY</p></div><div class="col-xs-3 form_pad"><div class="form-group from_to"><div class="row"><div class="col-sm-6 flo_rit"><span class="from font_beb">FROM:</span> <span>10/03/2018</span></div><div class="col-sm-6"><span class="from font_beb">TO:</span> <span>10/03/2019</span></div></div></div></div><div class="col-xs-3 form_pad"><div class="form-group from_to"><div class="row"><div class="col-sm-5 flo_rit"><span class="from font_beb">VALID DAYS:</span></div><div class="col-sm-7"><span>Monday, Tuesday</span></div></div></div></div><div class="col-xs-3 form_pad"><div class="form-group from_to"><div class="row"><div class="col-sm-5 flo_rit"><span class="from font_beb">VALID TIME:</span></div><div class="col-sm-7"><span>1:00 AM - 06:30 AM</span></div></div></div></div><div class="col-xs-12 form_pad font"><div class="form-group"><label for="input04" class="dark-text">DESCRIPTION</label> <input type="text" class="form-control" id="input04" placeholder="Save 15%"></div></div><div class="col-xs-12 form_pad font"><div class="form-group"><label for="input04" class="dark-text offer_pad">TERMS & CONDITIONS</label><div text-angular="text-angular" name="htmlcontent" ng-model="htmlcontent" ta-disabled="disabled" class="text-area"></div></div></div><div class="col-xs-12 form_pad font"><div class="form-group font"><label for="input04" class="dark-text font offer_pad">ANY OTHER CONTRACT INFORMATION</label><h6 class="font offer_pad">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text.</h6><h5 class="font offer_pad">Can even embed the contract here..</h5></div></div></div><div class="modal-footer"><button type="button" class="offer-btn" ng-click="$dismiss()">PRINT</button> <button type="button" class="offer-btn" ng-click="$dismiss()">SAVE</button></div><p class="review_off">Confirm and submit offer to V4U for review</p></div></div></div></uib-tab></uib-tabset>');
$templateCache.put('app/pages/ui/modals/modalTemplates/pin-modal.html','<div class="modal-content bg-white"><div class="modal-header pin-header"><div class="row"><div class="col-md-8"><h4 class="orange-text">TIM HORTONS</h4></div><div class="col-md-4"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div></div></div><div class="modal-body p-0"><div class="panel panel-default bootstrap-panel"><div class="panel-body"><div class="row mt5"><div class="col-md-6"><img class="pin_img" src="assets/images/pinper.png"> <button type="button" class="btn square-but btn-success btn-raised post-button bebas">CHANGE PICTURE</button></div><div class="col-md-6 pin_border"><button class="orange-text">PIN 21281233</button><p><label>Name :</label> JOHN DECLAND</p><p><label>Location :</label> Al Wahda Mall</p><p><label>Phone :</label> +00 123 2121 212</p><p><label>Email :</label> john@timhortons.com</p><p><label>Date Employed :</label> January 4th 2016</p><p><label>Workshift :</label> Monday to Saturday - 17:00 To 22:00 - Sunday Off</p></div></div><div class="row pt15 font-montser"><div class="w-20"><h3 class="text-center orange-text rating-value"><span>14</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon"></i></span></h3><h6 class="text-center dark-text rating-line font-montser f-16px">POSITIVE REVIEWS</h6><p class="text-center">+12% Since Last Week</p></div><div class="w-20"><h3 class="text-center orange-text rating-value"><span>55514</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon"></i></span></h3><h6 class="text-center dark-text rating-line font-montser f-16px">TOTAL REVENUE</h6><p class="text-center">+12% Since Last Week</p></div><div class="w-20"><h3 class="text-center orange-text rating-value"><span>1664</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon-green"></i></span></h3><h6 class="text-center dark-text rating-line font-montser f-16px">REVENUE PER WEEK</h6><p class="text-center">+12% Since Last Week</p></div><div class="w-20"><h3 class="text-center orange-text rating-value"><span>18884</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon"></i></span></h3><h6 class="text-center dark-text rating-line font-montser f-16px">VISITOR THIS WEEK</h6><p class="text-center">+12% Since Last Week</p></div><div class="w-20"><h3 class="text-center orange-text rating-value"><span>445314</span><span class="pull-right"><i class="ion-arrow-down-c rating-icon-green"></i></span></h3><h6 class="text-center dark-text rating-line font-montser f-16px">NEGATIVE FEEDBACKS</h6><p class="text-center">+12% Since Last Week</p></div><div class="col-md-12 text-right mt-20"><button type="button" class="btn square-but btn-success btn-raised p-l-10 p-r-10 offer-add-btn bebas"><i class="fa fa-plus" aria-hidden="true"></i> ADD</button></div></div></div><div class="panel-body p-0"><div class="table-responsive"><table class="table new-bran1 table-striped-blue tab-pad"><thead class="thead-bg"><tr class="table-header"><th>VENDOR<br>NAME</th><th>OUTLET<br>NAME</th><th>ACTIVITY</th><th>PIN<br>NUMBER</th><th>PIN<br>VALIDATION NAME</th><th>DATE</th><th>GROSS<br>SALE</th><th>DISCOUNT<br>VALUE</th><th>NET AMOUNT<br>PAID</th><th>CREDIT USED</th><th>ACTION</th></tr></thead><tbody><tr><td class="dark-text">John Cena</td><td class="dark-text">Tim hortons</td><td>Offer Purchase, tim hortons Al washa</td><td>#1123</td><td>Jack D</td><td>12/12/2017</td><td>15%</td><td>15%</td><td>123 AED</td><td>#1133</td><td class="color-theme text-underline">Generate Pin</td></tr><tr><td class="dark-text">John Cena</td><td class="dark-text">Tim hortons</td><td>Offer Purchase, tim hortons Al washa</td><td>#1123</td><td>Jack D</td><td>12/12/2017</td><td>15%</td><td>15%</td><td>123 AED</td><td>#1133</td><td class="color-theme text-underline">Generate Pin</td></tr><tr><td class="dark-text">John Cena</td><td class="dark-text">Tim hortons</td><td>Offer Purchase, tim hortons Al washa</td><td>#1123</td><td>Jack D</td><td>12/12/2017</td><td>15%</td><td>15%</td><td>123 AED</td><td>#1133</td><td class="color-theme text-underline">Generate Pin</td></tr></tbody></table></div><div class="row m-0"><div class="col-md-6 font-montser"><div class="color-black pb-20 paginats"><span><i class="fa fa-angle-double-left" aria-hidden="true"></i> FIRST</span> <span class="px-10"><i class="fa fa-angle-left" aria-hidden="true"></i> PREV</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span> <span class="px-10">NEXT <i class="fa fa-angle-right" aria-hidden="true"></i></span> <span>LAST <i class="fa fa-angle-double-right" aria-hidden="true"></i></span></div></div><div class="col-md-6 font-montser"><div class="color-black pb-20 text-right"><span class="show-pag">SHOW</span> <span><div class="selectCust paginations-Steps"><select id="" class="form-control" name="business"><option value="1">1</option><option value="2">2</option><option value="3">3</option><option value="4">4</option></select></div></span></div></div></div><div class="panel-footer"></div></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/record.html','<div class="modal-content p-30"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title record-text">RECORD</h4><hr class="bord-hr"></div><div class="modal-body"><div class="row"><div class="col-lg-1"><p class="dark-text outlet-line-heigh">Status</p></div><div class="col-lg-1 text-center"><p class="dark-text outlet-line-heigh">:</p></div><div class="col-lg-4"><div class="form-group font-montser"><div class="selectCust selectoutlets new height-var"><select id="" class="form-control mb-10 border-sel p-0 mb-20" name="business"><option value="First Choice">Open</option><option value="Second Choice">Closed</option></select></div></div></div></div><div class="row"><div class="col-lg-1"><p class="dark-text outlet-line-heigh">Issue</p></div><div class="col-lg-1 text-center"><p class="dark-text outlet-line-heigh">:</p></div><div class="col-lg-10"><p class="outlet-line-heigh">Mobile app is crashing on sending referrals</p></div></div><div class="row"><div class="col-lg-12"><p class="dark-text outlet-line-heigh record-text pt-20">Comment</p><textarea placeholder="This is the sample text which has to be modified later.." class="form-control font-montser" id="textarea01"></textarea></div></div></div><div class="modal-footer"><button type="button" class="btn btn-success btn-raised" style="font-family:bebas;">SUBMIT</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/review-enquire.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button></div><div class="modal-body p-0"><uib-tabset active="$tabSetStatus.activeTab" class="enquireTabs one-tab account_informat"><uib-tab heading="REVIEW DETAILS"><div class="row"><div class="col-md-12"><p class="reviewDeta"><b>ORANGIZATION MODEL: STANDALONE OUTLET</b></p></div></div><div class="row font-montser background-underdetails"><div class="col-md-12"><p><b>ACCOUNT INFORMATION:</b></p></div><div class="col-md-12 inforamation-details"><label for="">Name: Peter Sampars</label> <label for="">Your Position: Owner</label> <label for="">Phone: 0175-253-1258-245</label> <label for="">Email: test@test.com</label> <label for="">Outlet / Brand Website: http://www.test.com</label></div></div><div class="row background-underdetails font-montser"><div class="col-md-12"><p><b>CATEGORIES IN WHICH YOU DEAL IN:</b></p></div><div class="col-md-12"><div class="row mb-20"><div class="col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Food & Beverages</span></label></div><div class="col-md-3"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Leisure & Attractions</span></label></div><div class="col-md-2"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Wellness & Beauty</span></label></div></div><div class="row pb-20"><div class="col-md-2"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="inlineCheckbox03" value="option3"> <span>Retail & Services</span></label></div></div></div></div><div class="row background-underdetails font-montser pb-20 mt-20"><div class="col-md-12"><p><b>DOES ANY ONE OF YOUR OUTLET OPERATES UNDER FRANCHISE MODEL?</b></p></div><div class="col-md-2 font-montser"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="www" value="option1"> <span><b>YES</b></span></label></div><div class="col-md-2 font-montser"><label class="radio-inline custom-radio nowrap"><input type="radio" name="inlineRadioOptions" id="inlineRadio1w" value="option1"> <span><b>NO</b></span></label></div></div><div class="row font-montser textbrands"><div class="col-md-4"><p class="color-white"><b>BRANDS</b></p></div><div class="col-md-4 text-center"><p class="color-white"><b>NUMBER OF OUTLETS</b></p></div></div><div class="row font-montser"><div class="col-md-12 mb-20 p-0"><table class="table reve_data review_data"><thead><tr class=""><th></th><th>Abu Dhabi Emirates<br>(incl Al-Din)</th><th>Sharjah</th><th>Dubai</th><th>Fujaria</th><th>Ras Al<br>Khamia</th><th>Umm All<br>Quwain</th><th>UAE Total</th></tr></thead><tbody><tr><td>Tim Hortons</td><td>10</td><td>6</td><td>4</td><td>1</td><td>4</td><td>5</td><td>30</td></tr><tr><td>Bu</td><td>10</td><td>6</td><td>4</td><td>1</td><td>4</td><td>5</td><td>30</td></tr></tbody></table></div></div><div class="row font-montser"><div class="col-md-12"><p class="pt-30"><b>MENU AND PRICES</b></p></div><div class="col-md-12 p-0"><table class="table ml-0 review_data menu_process"><thead class="headtable-bg reviewDatas"><tr class=""><th>ITEM</th><th>DETAILS</th><th>CUSINE</th><th>PRICE</th><th>MEAL TIME</th></tr></thead><tbody><tr><td><img src="assets/images/pp1.jpg" alt="chicken" class="itemImage"> <span>Fried chicken</span></td><td>Achoice of french fires or salad</td><td>AMERICA</td><td>10AED</td><td>Lunch</td></tr><tr><td><img src="assets/images/pp1.jpg" alt="chicken" class="itemImage"> <span>Fried chicken</span></td><td>Achoice of french fires or salad</td><td>AMERICA</td><td>10AED</td><td>Lunch</td></tr></tbody></table></div><div class="col-md-12 mt-20"><p><b>MENU IMAGES</b></p></div><div class="col-md-12"><div class="mb-20"><img src="assets/images/fileIcon.png" alt="fileIcon"> <span><b>Menu_1.jpg</b></span></div><div class="mb-20"><img src="assets/images/fileIcon.png" alt="fileIcon"> <span><b>Menu_2.jpg</b></span></div></div></div><div class="row font-montser"><div class="col-md-12"><p class="pt-30"><b>ADDITIONAL INFORMATION</b></p></div><div class="col-md-12 p-0"><table class="table ml-0 abuDhai"><thead class="headtable-bg"><tr class=""><th>TITLE</th><th>DETAILS</th><th class="text-center">ATTACHEMEMT</th></tr></thead><tbody><tr><td>Logo</td><td>CORPORATE OFFICAL LOGO</td><td class="text-center"><img src="assets/images/fileIcon.png" alt="fileIcon"></td></tr><tr><td>About us</td><td>ABOUT OUR CORPORATE</td><td class="text-center"><img src="assets/images/fileIcon.png" alt="fileIcon"></td></tr><tr><td>Promotional Photo</td><td>RESTAURANT PHOTO</td><td class="text-center"><img src="assets/images/fileIcon.png" alt="fileIcon"></td></tr></tbody></table></div></div><div class="row"><div class="col-md-3 col-sm-offset-9 text-center"><button type="button" class="btn btn-primary modalBtn">NEXT</button><br><div class="mt-20 font-montser"><a href="" class="view-detals catorgriesDetails">SEND BACK FOR PROCESSING</a></div></div></div></uib-tab><uib-tab heading="REVIEW OUTLETS DETAILS"><div class="row selectCheck font-montser"><div class="col-md-3"><label for="business" class="pt-20 catorgriesDetails">SELECT OUTLET TO CHECK DETAILS</label></div><div class="col-md-3"><div class="selectCust selectoutlets"><select id="" class="form-control" name="business"><option value="First Choice">Tim Hortan</option><option value="Second Choice">Second Choice</option><option value="Third Choice">Third Choice</option><option value="Fourth Choice">Fourth Choice</option></select></div></div><div class="col-md-1"><label for="business" class="pt-20 catorgriesDetails">LOCATION:</label></div><div class="col-md-3"><div class="selectCust selectoutlets"><select id="" class="form-control" name="business"><option value="First Choice">Najda</option><option value="Second Choice">Second Choice</option><option value="Third Choice">Third Choice</option><option value="Fourth Choice">Fourth Choice</option></select></div></div></div><div class="row mt-20 namedetais"><div class="col-md-12"><p class="catorgriesDetails">OUTLET DETAILS</p></div><div class="col-md-4"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>OUTLET NAME</b></label> <input type="text" class="form-control pl-0" id="" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>STREET ADDRESS</b></label> <input type="text" class="form-control pl-0" id="" placeholder=""></div></div><div class="col-md-4"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>CITY</b></label> <input type="text" class="form-control pl-0" id="" placeholder=""></div></div><div class="col-md-12"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>LAND MARK</b></label> <input type="text" class="form-control pl-0" id="" placeholder=""></div></div><div class="col-md-12"><p><b>OUTLET LOCATION ON THE MAP</b></p><iframe width="100%" height="250" src="https://maps.google.com/maps?width=100%&amp;height=600&amp;hl=en&amp;q=1%20Grafton%20Street%2C%20Dublin%2C%20Ireland+(Voucher4U)&amp;ie=UTF8&amp;t=&amp;z=14&amp;iwloc=B&amp;output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"><a href="#"></a></iframe></div><div class="col-md-6 mt-20"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>OUTLET PHONE NUMBER</b></label> <input type="text" class="form-control pl-0" id="" placeholder=""></div></div><div class="col-md-6 mt-20"><div class="form-group font-montser afterBroder"><label for="inputLastName" class="color-black"><b>OUTLET WEBSITE URL</b></label> <input type="text" class="form-control pl-0" id="" placeholder=""></div></div><div class="col-md-6"><div class="form-group font-montser"><label for="inputLastName" class="color-black"><b>CATEGORY</b></label><div class="selectCust"><select class="outletNames form-control" id="sel1"><option>Food & Beverages</option><option>2</option><option>3</option><option>4</option></select></div></div></div></div><div class="row background-underdetails font-montser"><div class="col-md-12"><p><b>OUTLET FEATURES:</b></p></div><div class="col-md-12"><div class="row mb-20"><div class="col-md-2 mb-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="Dining" value=""> <span>All Dining</span></label></div><div class="col-md-2 mb-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="Parking" value=""> <span>Parking</span></label></div><div class="col-md-2 mb-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="Lunch" value=""> <span>Lunch</span></label></div><div class="col-md-6 mb-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="creditcard" value=""> <span>Credit Cards Accepted</span></label></div><div class="col-md-2 mb-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="dinner" value=""> <span>Dinner</span></label></div><div class="col-md-2 mb-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="cafe" value=""> <span>Cafe</span></label></div><div class="col-md-2 mb-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="pets" value="option3"> <span>Pets Allowed</span></label></div><div class="col-md-6 mb-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="debitcard" value=""> <span>Debit Cards Accepted</span></label></div></div></div></div><div class="row bg-grey"><div class="col-md-12"><p class="tagTitle"><b>TAGS</b></p></div><div class="col-md-12"><p class="tags"><span>Live Music</span> <span>Free Parking</span> <span>Outdoor Seating</span></p></div></div><div class="row bg-grey"><div class="col-md-12"><p class="tagTitle"><b>CUISINES</b></p></div><div class="col-md-12"><p class="tags"><span>Afghani</span> <span>Chinese</span> <span>Continental</span></p></div></div><div class="row bg-grey"><div class="col-md-12"><p class="tagTitle"><b>TIMINGS</b></p></div><div class="col-md-12"><div class="row timingDetails"><div class="col-md-2"><p>Monday</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div><div class="col-md-2"><p>Happy Hours</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div></div><div class="row timingDetails"><div class="col-md-2"><p>Tuesday</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div><div class="col-md-2"><p>Happy Hours</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div></div><div class="row timingDetails"><div class="col-md-2"><p>Wednesday</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div><div class="col-md-2"><p>Happy Hours</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div></div><div class="row timingDetails"><div class="col-md-2"><p>Thursday</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div><div class="col-md-2"><p>Happy Hours</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div></div><div class="row timingDetails"><div class="col-md-2"><p>Friday</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div><div class="col-md-2"><p>Happy Hours</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div></div><div class="row timingDetails"><div class="col-md-2"><p>Saturday</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div><div class="col-md-2"><p>Happy Hours</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div></div><div class="row timingDetails"><div class="col-md-2"><p>Sunday</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div><div class="col-md-2"><p>Happy Hours</p></div><div class="col-md-2"><p>06.00AM - 12.00AM</p></div><div class="col-md-2"><p>Open</p></div></div></div></div><div class="row bg-grey"><div class="col-md-12"><p class="tagTitle"><b>ADDITIONAL INFORMATION</b></p></div><div class="col-md-12"><p class="timingDetails lite-color bb-0 pb-0">Facebook: https//www.facebook.com/timhortans</p><p class="timingDetails lite-color bb-0 pb-0">Twitter: https//www.twitter.com/timhortans</p><p class="timingDetails lite-color bb-0 pb-0">Other Details: We Prove top class services and multi-cusines</p></div></div><div class="row font-montser"><div class="col-md-12"><p class="pt-30 catorgriesDetails">MENU AND PRICES</p></div><div class="col-md-12 p-0"><table class="table ml-0 review_data menu_process"><thead class="headtable-bg reviewDatas"><tr class=""><th>ITEM</th><th>DETAILS</th><th>CUSINE</th><th>PRICE</th><th>MEAL TIME</th></tr></thead><tbody><tr><td><img src="assets/images/pp1.jpg" alt="chicken" class="itemImage"> <span>Fried chicken</span></td><td>Achoice of french fires or salad</td><td>AMERICA</td><td>10AED</td><td>Lunch</td></tr><tr><td><img src="assets/images/pp1.jpg" alt="chicken" class="itemImage"> <span>Fried chicken</span></td><td>Achoice of french fires or salad</td><td>AMERICA</td><td>10AED</td><td>Lunch</td></tr></tbody></table></div></div><div class="row"><div class="col-md-12"><p class="pt-30 catorgriesDetails">MENU IMAGES</p></div><div class="col-md-6"><p><b>Menu_1</b></p><div class="menu_img"><img src="assets/images/chicken.jpg" class="w-100 canfullscreen" id="theImage" alt="Menu images"> <img src="assets/images/enlarge.png" class="enlargeImg" alt="enlarge"></div></div><div class="col-md-6"><p><b>Menu_2</b></p><div class="menu_img"><img src="assets/images/Nutella.jpg" class="w-100" alt="Menu images"> <img src="assets/images/enlarge.png" class="enlargeImg" alt="enlarge"></div></div></div><div class="row font-montser"><div class="col-md-12"><p class="pt-30 catorgriesDetails">ADDITIONAL INFORMATION</p></div><div class="col-md-12 p-0"><table class="table ml-0 abuDhai"><thead class="headtable-bg"><tr class=""><th>TITLE</th><th>DETAILS</th><th class="text-center">ATTACHEMEMT</th></tr></thead><tbody><tr><td>Logo</td><td>CORPORATE OFFICIAL LOGO</td><td class="text-center"><img src="assets/images/fileIcon.png" alt="fileIcon"></td></tr><tr><td>About us</td><td>ABOUT OUR CORPORATE</td><td class="text-center"><img src="assets/images/fileIcon.png" alt="fileIcon"></td></tr><tr><td>Promotional Photo</td><td>ABOUT OUR CORPORATE</td><td class="text-center"><img src="assets/images/fileIcon.png" alt="fileIcon"></td></tr></tbody></table></div></div><div class="row"><div class="col-lg-11 text-right"><button type="button" class="btn btn-primary modalBtn mr-30">BACK</button> <button type="button" class="btn btn-primary modalBtn">NEXT</button><br><div class="mt-20 font-montser"><a href="" class="view-detals catorgriesDetails">SEND BACK FOR PROCESSING</a></div></div></div></uib-tab><uib-tab heading="CONFIRM"><div class="row font-montser m-0"><div class="col-md-12"><p class="mt-20 p-b-10"><b>CONFIRM FOR SUBMISSION FOR INITIATION OF CONTRACT SIGN OFF</b></p></div><div class="col-md-12"><textarea name="message" class="w-100 enterCom pt-10" rows="10" cols="30" placeholder="Enter Comments"></textarea></div><div class="col-md-12 mt-20"><label class="checkbox-inline custom-checkbox nowrap"><input type="checkbox" id="" value="option3"> <span>Vendor fulfils all requirements to be a part of Vouched4U</span></label></div></div><div class="row"><div class="col-lg-11 text-right"><button type="button" class="btn btn-primary modalBtn mr-30">BACK</button> <button type="button" class="btn btn-primary modalBtn">NEXT</button><br><div class="mt-20 font-montser"><a href="" class="view-detals catorgriesDetails">SEND BACK FOR PROCESSING</a></div></div></div></uib-tab></uib-tabset></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/review-payments.html','<div class="modal-content bg-changes-tra"><div class="modal-header border-b bg-white"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title record_pop">ROY JOYCE</h4></div><div class="container-fluid"><div class="row overallSects"><div class="col-md-6"><img src="assets/images/1.png" class="w-100" alt="hotel"></div><div class="col-md-6"><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">OUTLET NAME</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="TIM HORTONS"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">LOCATION</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="DEIRA"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">JOINED DATE</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="12-07-17"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">CREATED DATE</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="15-07-17"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">AMOUNT PAID</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="1500 AED"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">LAST TRANSACTION</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="17 MAR 2018, 12:30 PM"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">PAYMENT DUE</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="500 AED"></div></div></div></div><div class="row overallSects"><div class="col-md-6"><img src="assets/images/2.png" class="w-100" alt="hotel"></div><div class="col-md-6"><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">OUTLET NAME</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="TIM HORTONS"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">LOCATION</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="DEIRA"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">JOINED DATE</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="12-07-17"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">CREATED DATE</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="15-07-17"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">AMOUNT PAID</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="1500 AED"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">LAST TRANSACTION</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="17 MAR 2018, 12:30 PM"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">PAYMENT DUE</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="500 AED"></div></div></div></div><div class="row overallSects mb-0"><div class="col-md-6"><img src="assets/images/3.png" class="w-100" alt="hotel"></div><div class="col-md-6"><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">OUTLET NAME</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="TIM HORTONS"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">LOCATION</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="DEIRA"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">JOINED DATE</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="12-07-17"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">CREATED DATE</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="15-07-17"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">AMOUNT PAID</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="1500 AED"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">LAST TRANSACTION</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="17 MAR 2018, 12:30 PM"></div></div><div class="row leftName"><div class="col-md-5"><p class="color-theme fw-500 f-18px bebas">PAYMENT DUE</p></div><div class="col-md-7"><input type="text" name="" id="" placeholder="500 AED"></div></div></div></div></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/reviewModal.html','<div class="modal-content p-50 font-montser"><div class="modal-header mar-bot"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title record_pop">RECORD 1</h4></div><div class="container-fluid"><div class="row mar-bot"><div class="col-md-3"><p class="out-nam">Outlet Name <span class="semi-col">:</span></p></div><div class="col-md-3"><p class="out-nam1">Tim Hortans</p></div><div class="col-md-3"><p class="out-nam">Date & Time <span class="semi-col">:</span></p></div><div class="col-md-3"><p class="out-nam1">March 05,10:00 AM</p></div></div><div class="row mar-bot"><div class="col-md-3"><p class="out-nam">Location <span class="semi-col">:</span></p></div><div class="col-md-3"><p class="out-nam1">Dubai</p></div><div class="col-md-3"><p class="out-nam">Rating <span class="semi-col">:</span></p></div><div class="col-md-3"><p class="out-nam1"><span class="fa fa-star checked"></span> <span class="fa fa-star checked"></span> <span class="fa fa-star checked"></span> <span class="fa fa-star"></span> <span class="fa fa-star"></span></p></div></div><div class="row mar-bot"><div class="col-md-3"><p class="out-nam">Customer <span class="semi-col">:</span></p></div><div class="col-md-3"><p class="out-nam1">Tom</p></div><div class="col-md-3"><p class="out-nam">Status <span class="semi-col">:</span></p></div><div class="col-md-3"><div class="dropdown"><button class="btn btn-primary dropdown-toggle allow-drop" type="button" data-toggle="dropdown">Allow <span class="caret"></span></button></div></div></div><div class="row"><div class="col-md-3"><p class="out-nam">Email <span class="semi-col">:</span></p></div><div class="col-md-3"><p class="out-nam1">Tom@hotmail.com</p></div><div class="col-md-3"><p class="out-nam">Report Spam <span class="semi-col">:</span></p></div><div class="col-md-3"><div class="dropdown"><button class="btn btn-primary dropdown-toggle allow-drop" type="button" data-toggle="dropdown">No <span class="caret"></span></button></div></div></div></div><div class="marg-bott pb-0"><div class="form-group"><label for="comment" class="record-com">Comment:</label> <textarea class="form-control" rows="5" id="comment" placeholder="This is the sample text which has to be modified later..."></textarea></div></div><div class="col-md-12 text-right m-t-20"><button type="button" class="btn square-but btn-success btn-raised bor-radius-round" style="font-family:bebas;">SUBMIT</button></div><div class="clearfix"></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/smallModal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title">Modal title</h4></div><div class="modal-body">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$dismiss()">Save changes</button></div></div>');
$templateCache.put('app/pages/ui/modals/modalTemplates/successModal.html','<div class="modal-content"><div class="modal-header bg-success"><i class="ion-checkmark modal-icon"></i><span>Success</span></div><div class="modal-body text-center">Your information has been saved successfully</div><div class="modal-footer"><button type="button" class="btn btn-success" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/ui/modals/progressModal/progressModal.html','<div class="modal-content" ng-controller="ProgressModalCtrl"><div class="modal-body"><progress-bar-round></progress-bar-round></div><div class="modal-footer"></div></div>');
$templateCache.put('app/pages/ui/modals/notifications/notifications.html','<div class="modal-buttons same-width clearfix" ng-controller="NotificationsCtrl"><button type="button" class="btn btn-success" ng-click="showSuccessMsg()">Success Notification</button> <button type="button" class="btn btn-info" ng-click="showInfoMsg()">Info Notification</button> <button type="button" class="btn btn-warning" ng-click="showWarningMsg()">Warning Notification</button> <button type="button" class="btn btn-danger" ng-click="showErrorMsg()">Danger Notification</button></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/animated.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped active" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped active" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/basic.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/label.html','<div class="progress"><div class="progress-bar progress-bar-success" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%">40% Complete (success)</div></div><div class="progress"><div class="progress-bar progress-bar-info" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%">20% Complete</div></div><div class="progress"><div class="progress-bar progress-bar-warning" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%">60% Complete (warning)</div></div><div class="progress"><div class="progress-bar progress-bar-danger" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%">80% Complete (danger)</div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/stacked.html','<div class="progress"><div class="progress-bar progress-bar-success" style="width: 35%"><span class="sr-only">35% Complete (success)</span></div><div class="progress-bar progress-bar-warning progress-bar-striped" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div><div class="progress-bar progress-bar-danger" style="width: 10%"><span class="sr-only">10% Complete (danger)</span></div><div class="progress-bar progress-bar-info progress-bar-striped active" style="width: 20%"><span class="sr-only">20% Complete (warning)</span></div></div>');
$templateCache.put('app/pages/ui/progressBars/widgets/striped.html','<div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="40" aria-valuemin="0" aria-valuemax="100" style="width: 40%"><span class="sr-only">40% Complete (success)</span></div></div><div class="progress"><div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style="width: 20%"><span class="sr-only">20% Complete</span></div></div><div class="progress"><div class="progress-bar progress-bar-warning progress-bar-striped" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%"><span class="sr-only">60% Complete (warning)</span></div></div><div class="progress"><div class="progress-bar progress-bar-danger progress-bar-striped" role="progressbar" aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style="width: 80%"><span class="sr-only">80% Complete (danger)</span></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSelect/select.html','<div ng-controller="OldSelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><select class="form-control selectpicker" selectpicker="" title="Standard Select" ng-model="selectpickerVm.standardSelected" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"></select></div><div class="form-group"><select class="form-control selectpicker with-search" data-live-search="true" title="Select With Search" selectpicker="" ng-model="selectpickerVm.searchSelectedItem" ng-options="item as item.label for item in selectpickerVm.selectWithSearchItems"></select></div><div class="form-group"><select class="form-control selectpicker" title="Option Types" selectpicker=""><option>Standard option</option><option data-subtext="option subtext">Option with subtext</option><option disabled="">Disabled Option</option><option data-icon="glyphicon-heart">Option with cion</option></select></div><div class="form-group"><select class="form-control selectpicker" disabled="" title="Disabled Select" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Option Groups" selectpicker="" ng-model="selectpickerVm.groupedSelectedItem" ng-options="item as item.label group by item.group for item in selectpickerVm.groupedSelectItems"></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Select with Divider" selectpicker=""><option>Group 1 - Option 1</option><option>Group 1 - Option 2</option><option data-divider="true"></option><option>Group 2 - Option 1</option><option>Group 2 - Option 2</option></select></div></div></div><div class="form-group"><select class="form-control" title="Multiple Select" multiple="" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="form-group"><select class="form-control" title="Multiple Select with Limit" multiple="" data-max-options="2" selectpicker="" ng-model="selectpickerVm.multipleSelectedItems2" ng-options="item as item.label for item in selectpickerVm.standardSelectItems"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class="row"><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Primary Select" data-style="btn-primary" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Success Select" data-style="btn-success" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Warning Select" data-style="btn-warning" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div><div class="col-sm-6"><div class="form-group"><select class="form-control" title="Info Select" data-style="btn-info" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Danger Select" data-style="btn-danger" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class="form-group"><select class="form-control" title="Inverse Select" data-style="btn-inverse" data-container="body" selectpicker=""><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/datePickers/datePickers.html','<div class="datepicker row"><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerCtrl"><h4>Inline</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><div class="uib-datepicker-wrap"><uib-datepicker ng-model="dt" datepicker-options="options"></uib-datepicker></div></div><div class="col-xlg-6 col-md-12 col-sm-6" ng-controller="datepickerpopupCtrl"><h4>Popup</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{format}}" datepicker-options="options" ng-model="dt" is-open="opened" ng-required="true" close-text="Close" alt-input-formats="altInputFormats" show-button-bar="false"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="open()"><i class="glyphicon glyphicon-calendar"></i></button></span></p><label>Format: <span class="muted-text">(manual alternate <em>{{altInputFormats[0]}}</em>)</span></label><select class="form-control" ng-model="format" ng-options="f for f in formats"><option></option></select></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/switches/switch.html','<div ng-controller="SwitchDemoPanelCtrl as vm"><ba-switcher switcher-style="primary" switcher-value="vm.switches.s1"></ba-switcher><ba-switcher switcher-style="success" switcher-value="vm.switches.s2"></ba-switcher><ba-switcher switcher-style="warning" switcher-value="vm.switches.s3"></ba-switcher><ba-switcher switcher-style="danger" switcher-value="vm.switches.s4"></ba-switcher><ba-switcher switcher-style="info" switcher-value="vm.switches.s5"></ba-switcher></div>');
$templateCache.put('app/pages/form/inputs/widgets/select/select.html','<div class="ng-cloak" ng-controller="SelectpickerPanelCtrl as selectpickerVm"><div class="form-group"><ui-select ng-model="selectpickerVm.selectedItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Standard Select"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="standardItem in selectpickerVm.standardSelectItems | filter: $select.search"><span ng-bind-html="standardItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.withSearchItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Search">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="withSearchItem in selectpickerVm.selectWithSearchItems | filter: $select.search"><span ng-bind-html="withSearchItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.disableItem.selected" class="btn-group bootstrap-select form-control" ng-disabled="true" append-to-body="true" search-enabled="false"><ui-select-match placeholder="Disabled Selection"><span>{{$select.selected.label}}</span></ui-select-match><ui-select-choices repeat="disableItem in selectpickerVm.disableItems | filter: $select.search"><span ng-bind-html="disableItem.label"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat="groupedItems in selectpickerVm.groupedSelectItems | groupSelectpickerOptions: {label: $select.search}" group-by="\'group\'"><span ng-bind-html="groupedItems.label | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select ng-model="selectpickerVm.groupedByItems.selected" class="btn-group bootstrap-select form-control" ng-disabled="false" append-to-body="true" search-enabled="true"><ui-select-match placeholder="Select With Option Groups Function">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="groupedByItems in selectpickerVm.groupedBySelectItems | filter: $select.search" group-by="selectpickerVm.someGroupFn"><span ng-bind-html="groupedByItems.name | highlight: $select.search"></span></ui-select-choices></ui-select></div><div class="form-group"><ui-select multiple="" ng-model="selectpickerVm.multipleItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control"><ui-select-match placeholder="Multiple Select">{{$item.label}}</ui-select-match><ui-select-choices repeat="multipleItem in selectpickerVm.multipleSelectItems | filter: $select.search">{{multipleItem.label}}</ui-select-choices></ui-select></div><div class="form-group"><div class="input-group"><ui-select multiple="" ng-model="selectpickerVm.withDeleteItem.selected" ng-disabled="false" search-enabled="true" append-to-body="true" class="form-control form-control"><ui-select-match placeholder="Select With Clear Button">{{$item.label}}</ui-select-match><ui-select-choices repeat="withDeleteItem in selectpickerVm.withDeleteSelectItems | filter: $select.search">{{withDeleteItem.label}}</ui-select-choices></ui-select><span class="input-group-btn"><button type="button" ng-click="selectpickerVm.withDeleteItem.selected = undefined" class="btn btn-danger"><span class="glyphicon glyphicon-trash"></span></button></span></div></div></div>');
$templateCache.put('app/pages/form/inputs/widgets/oldSwitches/switch.html','<div ng-controller="OldSwitchPanelCtrl as switchPanelVm" class="switches clearfix"><switch color="primary" ng-model="switchPanelVm.switcherValues.primary"></switch><switch color="warning" ng-model="switchPanelVm.switcherValues.warning"></switch><switch color="danger" ng-model="switchPanelVm.switcherValues.danger"></switch><switch color="info" ng-model="switchPanelVm.switcherValues.info"></switch><switch color="success" ng-model="switchPanelVm.switcherValues.success"></switch></div>');
$templateCache.put('app/pages/form/inputs/widgets/tagsInput/tagsInput.html','<div class="form-group"><div class="form-group"><input type="text" tag-input="primary" value="Amsterdam,Washington,Sydney,Beijing,Cairo" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="warning" value="Minsk,Prague,Vilnius,Warsaw" data-role="tagsinput" placeholder="Add Tag"></div><div class="form-group"><input type="text" tag-input="danger" value="London,Berlin,Paris,Rome,Munich" data-role="tagsinput" placeholder="Add Tag"></div></div>');}]);